import { createAction, createSlice, createSelector } from '@reduxjs/toolkit';
import produce$1, { current, produce } from 'immer';
import moment from 'moment';
import * as React from 'react';
import React__default, { Component, useRef, useState, useEffect } from 'react';
import _, { isEqual, debounce, throttle, range } from 'lodash';
import { takeLatest, put, select, call, all, takeEvery } from 'redux-saga/effects';
import { connect, useDispatch, useSelector, Provider } from 'react-redux';
import { Tooltip, Paper, Typography, Grid, InputLabel, IconButton, Box, CircularProgress, List, ListSubheader, ListItem, ListItemText, Dialog, DialogTitle, DialogContent, DialogContentText, TextField, DialogActions, Button, MenuItem, FormControl, LinearProgress, InputAdornment, ListItemSecondaryAction, ListItemIcon, Checkbox, Switch, Slider, FormControlLabel, Popover, useMediaQuery, useTheme, SliderThumb } from '@mui/material';
import { ToolButton, ToolContainerDraggable, TooltipSelect, AlertIcon, sliderStyles, tooltipContainerStyles, CustomSlider, ToggleMenu, ManagerButton, EnableButton, AlertBanner, ManagerDeleteButton, CustomToggleButton, useIsMounted } from '@opengeoweb/shared';
import { Pause, Play, Cached, Add, Copy, Flag, DragHandle as DragHandle$1, Filter, Close, Search, Clear, ChevronLeft, ChevronRight, Edit, Delete, Home, Minus, Layers, Equalizer, Sort, Link, LinkOff, AutoUpdateActive, AutoUpdateInActive, TextIcon, FastForward, Options, SliderThumb as SliderThumb$1, List as List$1, ThemeWrapper, lightTheme } from '@opengeoweb/theme';
import makeStyles from '@mui/styles/makeStyles';
import { legendImageStore, WMImageEventType, getLegendGraphicURLForLayer, WMGetServiceFromStore, LayerType as LayerType$1, getMapImageStore, WMBBOX, debug, DebugType, WMJSMap, WMLayer } from '@opengeoweb/webmap';
import { Sortable, ReactSortable } from 'react-sortablejs';
import createStyles from '@mui/styles/createStyles';
import { FixedSizeList } from 'react-window';
import withStyles from '@mui/styles/withStyles';
import { debounce as debounce$1 } from 'throttle-debounce';
import cloneDeep from 'lodash.clonedeep';
import proj4 from 'proj4';
import * as turf from '@turf/turf';
import { createStore, DynamicModuleLoader } from 'redux-dynamic-modules';
import { getSagaExtension } from 'redux-dynamic-modules-saga';

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = o[Symbol.iterator]();
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */
var LayerType;

(function (LayerType) {
  LayerType["mapLayer"] = "mapLayer";
  LayerType["baseLayer"] = "baseLayer";
  LayerType["overLayer"] = "overLayer";
})(LayerType || (LayerType = {}));

var LayerStatus;

(function (LayerStatus) {
  LayerStatus["default"] = "default";
  LayerStatus["error"] = "error";
})(LayerStatus || (LayerStatus = {}));

var LayerActionOrigin;

(function (LayerActionOrigin) {
  LayerActionOrigin["layerManager"] = "layerManager";
  LayerActionOrigin["wmsLoader"] = "WMSLayerTreeConnect";
  LayerActionOrigin["ReactMapViewParseLayer"] = "ReactMapViewParseLayer";
  LayerActionOrigin["setLayerDimensionSaga"] = "setLayerDimensionSaga";
  LayerActionOrigin["toggleAutoUpdateSaga"] = "toggleAutoUpdateSaga";
})(LayerActionOrigin || (LayerActionOrigin = {}));

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */
var Scale;

(function (Scale) {
  Scale[Scale["Minutes5"] = 0] = "Minutes5";
  Scale[Scale["Hour"] = 1] = "Hour";
  Scale[Scale["Hours3"] = 2] = "Hours3";
  Scale[Scale["Hours6"] = 3] = "Hours6";
  Scale[Scale["Day"] = 4] = "Day";
  Scale[Scale["Week"] = 5] = "Week";
  Scale[Scale["Month"] = 6] = "Month";
  Scale[Scale["Year"] = 7] = "Year";
  Scale[Scale["DataScale"] = 8] = "DataScale";
})(Scale || (Scale = {}));

var MapActionOrigin;

(function (MapActionOrigin) {
  MapActionOrigin["map"] = "map";
})(MapActionOrigin || (MapActionOrigin = {}));

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */
var dateFormat = 'YYYY-MM-DDTHH:mm:ss[Z]';
var generatedLayerIds = 0;
var generateLayerId = function generateLayerId() {
  generatedLayerIds += 1;
  return "layerid_".concat(generatedLayerIds);
};
var generatedMapIds = 0;
var generateMapId = function generateMapId() {
  generatedMapIds += 1;
  return "mapid_".concat(generatedMapIds);
};
var generatedTimesliderIds = 0;
var generateTimesliderId = function generateTimesliderId() {
  generatedTimesliderIds += 1;
  return "timesliderid_".concat(generatedTimesliderIds);
};
/**
 * Map for registering wmlayers with their id's
 */

var registeredWMLayersForReactLayerId = {};
/**
 * Registers a WMJSLayer in a lookuptable with a layerId
 * @param {WMLayer} wmLayer
 * @param {string} layerId
 */

var registerWMLayer = function registerWMLayer(wmLayer, layerId) {
  registeredWMLayersForReactLayerId[layerId] = wmLayer;
};
/**
 * Get the WMLayer from the lookuptable with layerId
 * @param {string} layerId
 */

var getWMLayerById = function getWMLayerById(layerId) {
  return registeredWMLayersForReactLayerId[layerId];
};
/**
 * Map for registering wmlayers with their id's
 */

var registeredWMMapForReactMapId = {};
/**
 * Registers a WMJSMap in a lookuptable with a wmjsMapId
 * @param {WMJSMap} wmjsMap
 * @param {string} wmjsMapId
 */

var registerWMJSMap = function registerWMJSMap(wmjsMap, wmjsMapId) {
  registeredWMMapForReactMapId[wmjsMapId] = wmjsMap;
};
/**
 * Get the wmjsMap from the lookuptable with wmjsMapId
 * @param {string} wmjsMapId
 */

var getWMJSMapById = function getWMJSMapById(wmjsMapId) {
  return registeredWMMapForReactMapId[wmjsMapId];
};
/**
 * Returns the WMJSDimension object for given layerId and dimension name
 * @param layerId The layerId
 * @param dimensionName The dimension to lookup
 */

var getWMJSDimensionForLayerAndDimension = function getWMJSDimensionForLayerAndDimension(layerId, dimensionName) {
  var wmLayer = getWMLayerById(layerId);

  if (!wmLayer || !dimensionName) {
    return null;
  }

  var wmjsDimension = wmLayer.getDimension(dimensionName);

  if (!wmjsDimension) {
    return null;
  }

  return wmjsDimension;
};
/**
 * Returns the list of dimensions without the time dimension
 * @param dimensions Dimension[]
 */

var filterNonTimeDimensions = function filterNonTimeDimensions(dimensions) {
  return dimensions && dimensions.length ? dimensions.filter(function (dim) {
    return dim.name !== 'time';
  }) : [];
};
/**
 * Gets the WMJSTimeDimension for given activeLayerId and dimensions list
 * @param layerId: The layer id to search the WMJSDimension for
 * @return: The WMJSDimension if found, otherwise null
 */

var getWMJSTimeDimensionForLayerId = function getWMJSTimeDimensionForLayerId(layerId) {
  var wmLayer = getWMLayerById(layerId);

  if (!wmLayer) {
    return null;
  }

  return wmLayer.getDimension('time');
};
/**
 * Get the previous step for this layerid
 * @param layerId The layerId to get the previous timestep for
 */

var getPreviousTimeStepForLayerId = function getPreviousTimeStepForLayerId(layerId) {
  var wmjsTimeDim = getWMJSTimeDimensionForLayerId(layerId);
  if (!wmjsTimeDim) return null;
  var currentIndex = wmjsTimeDim.getIndexForValue(wmjsTimeDim.currentValue, false);
  if (currentIndex < 0 || currentIndex - 1 < 0) return wmjsTimeDim.getClosestValue(wmjsTimeDim.currentValue, true);
  return wmjsTimeDim.getValueForIndex(currentIndex - 1);
};
/**
 * Get the next step for this layerid
 * @param layerId The layerId to get the next timestep for
 */

var getNextTimeStepForLayerId = function getNextTimeStepForLayerId(layerId) {
  var wmjsTimeDim = getWMJSTimeDimensionForLayerId(layerId);
  if (!wmjsTimeDim) return null;
  var currentIndex = wmjsTimeDim.getIndexForValue(wmjsTimeDim.currentValue, false);
  if (currentIndex < 0 || currentIndex + 1 >= wmjsTimeDim.size()) return wmjsTimeDim.getClosestValue(wmjsTimeDim.currentValue, true);
  return wmjsTimeDim.getValueForIndex(currentIndex + 1);
};
/**
 * Get the first time step for this layerid
 * @param layerId The layerId to get the first timestep for
 */

var getFirstTimeStepForLayerId = function getFirstTimeStepForLayerId(layerId) {
  var wmjsTimeDim = getWMJSTimeDimensionForLayerId(layerId);
  if (!wmjsTimeDim) return null;
  return wmjsTimeDim.getFirstValue();
};
/**
 * Get the last time step for this layerid
 * @param layerId The layerId to get the last timestep for
 */

var getLastTimeStepForLayerId = function getLastTimeStepForLayerId(layerId) {
  var wmjsTimeDim = getWMJSTimeDimensionForLayerId(layerId);
  if (!wmjsTimeDim) return null;
  return wmjsTimeDim.getLastValue();
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */

var types$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get Scale () { return Scale; },
  get MapActionOrigin () { return MapActionOrigin; },
  get LayerType () { return LayerType; },
  get LayerStatus () { return LayerStatus; },
  get LayerActionOrigin () { return LayerActionOrigin; }
});

var defaultAnimationDelayAtStart = 250;
var defaultDelay = 1000; // [ms]

var defaultTimeStep = 5;
var speedFactors = [0.1, 0.2, 0.5, 1, 2, 4, 8, 16]; // Declares available animation speed multipliers for default delay

/**
 * Returns speed delay for given speedFactor. For options, see defined above in "speedFactors"
 */

var getSpeedDelay = function getSpeedDelay(speedFactor) {
  return defaultDelay / speedFactor;
};
var getSpeedFactor = function getSpeedFactor(speedDelay) {
  return defaultDelay / speedDelay;
};
/**
 * Returns time bounds from the given dimension. If no time dimension given, current time is returned as default
 */

var getTimeBounds = function getTimeBounds(dimensions) {
  var defaultStartEnd = moment.utc().set({
    second: 0,
    millisecond: 0
  }).unix();
  var timeDimension = dimensions ? dimensions.find(function (dim) {
    return dim.name === 'time';
  }) : null;
  var startTime = timeDimension && timeDimension.minValue ? moment.utc(timeDimension.minValue).unix() : defaultStartEnd;
  var endTime = timeDimension && timeDimension.maxValue ? moment.utc(timeDimension.maxValue).unix() : defaultStartEnd;
  var currentValueIsValid = timeDimension && timeDimension.currentValue && moment.utc(timeDimension.currentValue).isValid();
  var selectedTime = currentValueIsValid ? moment.utc(timeDimension.currentValue).unix() : moment.utc().unix();
  return {
    selectedTime: selectedTime,
    startTime: startTime,
    endTime: endTime
  };
};
/**
 * Returns time bounds as *Moment* time instances from the given dimension. If no time dimension given, current time is returned as default
 */

var getMomentTimeBounds = function getMomentTimeBounds(dimensions) {
  var _getTimeBounds = getTimeBounds(dimensions),
      selectedTime = _getTimeBounds.selectedTime,
      startTime = _getTimeBounds.startTime,
      endTime = _getTimeBounds.endTime;

  return {
    selectedTime: moment.unix(selectedTime),
    startTime: moment.unix(startTime),
    endTime: moment.unix(endTime)
  };
};
var scalingCoefficient = function scalingCoefficient(end, start, width) {
  return width / (end - start);
};
var timestampToPixelEdges = function timestampToPixelEdges(timestamp, start, end, width) {
  return (timestamp - start) * scalingCoefficient(end, start, width);
};
var timestampToPixel = function timestampToPixel(timestamp, centerTime, widthPx, secondsPerPx) {
  return widthPx / 2 - (centerTime - timestamp) / secondsPerPx;
};
var pixelToTimestamp = function pixelToTimestamp(timePx, centerTime, widthPx, secondsPerPx) {
  return centerTime - (widthPx / 2 - timePx) * secondsPerPx;
};
var onSetNewDateDebouncer;
var onsetNewDateDebounced = function onsetNewDateDebounced(dateToSet, onSetNewDate) {
  /* Debounce the dateToSet with a simple timeout */
  if (onSetNewDateDebouncer === undefined) {
    onSetNewDateDebouncer = dateToSet;
    onSetNewDate(dateToSet);
    window.setTimeout(function () {
      if (onSetNewDateDebouncer !== undefined && onSetNewDateDebouncer !== dateToSet) {
        onSetNewDate(onSetNewDateDebouncer);
      }

      onSetNewDateDebouncer = undefined;
    }, 10);
  } else {
    onSetNewDateDebouncer = dateToSet;
  }
};
var roundWithTimeStep = function roundWithTimeStep(unixTime, timeStep, type) {
  var adjustedTimeStep = timeStep * 60;

  if (!type || type === 'round') {
    return Math.round(unixTime / adjustedTimeStep) * adjustedTimeStep;
  }

  if (type === 'floor') {
    return Math.floor(unixTime / adjustedTimeStep) * adjustedTimeStep;
  }

  if (type === 'ceil') {
    return Math.ceil(unixTime / adjustedTimeStep) * adjustedTimeStep;
  }

  return undefined;
};
var setNewRoundedTime = function setNewRoundedTime(x, centerTime, width, secondsPerPx, timeStep, dataStartTime, dataEndTime, onSetNewDate) {
  var unixTime = pixelToTimestamp(x, centerTime, width, secondsPerPx);
  var roundedTime = roundWithTimeStep(unixTime, timeStep);
  var selectedTimeString = moment.unix(Math.min(Math.max(roundedTime, dataStartTime), dataEndTime)).toISOString();
  onsetNewDateDebounced(selectedTimeString, onSetNewDate);
};
var getDataLimitsFromLayers = function getDataLimitsFromLayers(layers) {
  return layers.reduce(function (_ref, layer) {
    var _ref2 = _slicedToArray(_ref, 2),
        start = _ref2[0],
        end = _ref2[1];

    var dimension = getWMJSTimeDimensionForLayerId(layer.id);

    if (dimension) {
      var lastValue = moment(dimension.getLastValue()).unix();
      var firstValue = moment(dimension.getFirstValue()).unix();
      var newLast = lastValue > end ? lastValue : end;
      var newFirst = firstValue < start ? firstValue : start;
      return [newFirst, newLast];
    }

    return [start, end];
  },
  /* Using the maximum 32-bit value and 0 as starting points
   * bigger values like Number.MAX_VALUE or Number.MAX_SAFE_INTEGER
   * cause weird behaviour as timestamps break at 32bit limit (year 2038)
   */
  [2147483647, 0]);
};
var getNextTimeStepvalue = function getNextTimeStepvalue(value, max) {
  var newValue = value + 1;
  return newValue > max ? max : newValue;
};
var getPreviousTimeStepvalue = function getPreviousTimeStepvalue(value, min) {
  var newValue = value - 1;
  return newValue < min ? min : newValue;
};
var getValueFromKeyboardEvent = function getValueFromKeyboardEvent(event, value, min, max) {
  var supportFourDirectionNavigation = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  if (!supportFourDirectionNavigation) {
    if (event.ctrlKey || event.metaKey) {
      switch (event.key) {
        case 'ArrowDown':
          return getPreviousTimeStepvalue(value, min);

        case 'ArrowUp':
          return getNextTimeStepvalue(value, max);

        default:
          return null;
      }
    }
  } else {
    // currently supportFourDirectionNavigation (left/right/up/down) is only used in horizontal slider TimeSliderScaleSlider
    switch (event.key) {
      case 'ArrowDown':
      case 'ArrowLeft':
        return getPreviousTimeStepvalue(value, min);

      case 'ArrowUp':
      case 'ArrowRight':
        return getNextTimeStepvalue(value, max);

      default:
        return null;
    }
  }

  return null;
};
var getTimeStepFromDataInterval = function getTimeStepFromDataInterval(timeInterval) {
  switch (timeInterval.isRegularInterval) {
    case false:
      switch (timeInterval.year) {
        case 0:
          // month
          return 30 * 24 * 60;

        default:
          return timeInterval.year * 365 * 24 * 60;
      }

    case true:
      if (timeInterval.day !== 0) {
        return timeInterval.day * 24 * 60;
      }

      if (timeInterval.hour !== 0) {
        return timeInterval.hour * 60;
      }

      if (timeInterval.minute !== 0) {
        return timeInterval.minute;
      }

      if (timeInterval.second !== 0) {
        return timeInterval.second / 60.0;
      }

      return 5;

    default:
      return 5;
  }
};
var getActiveLayerTimeStep = function getActiveLayerTimeStep(timeDimension) {
  return (timeDimension === null || timeDimension === void 0 ? void 0 : timeDimension.timeInterval) ? getTimeStepFromDataInterval(timeDimension.timeInterval) : null;
};
/**
 * This function calculates a suitable secondsPerpx value,
 * when a data scale is selected. secondsPerPx is different for every data set
 * and is calculated here with a function getDataLimitsfromLayers.
 * There in the function the largest time range of all layers is selected.
 * @param layers
 * @returns secondsPerPx for data sets of layers calculated 60*2*3,
 * where 3 is found by trying how to get the whole data range
 * to fit in the time slider
 */

var getScaleToSecondsPerPxForDataScale = function getScaleToSecondsPerPxForDataScale(layers) {
  var _getDataLimitsFromLay = getDataLimitsFromLayers(layers),
      _getDataLimitsFromLay2 = _slicedToArray(_getDataLimitsFromLay, 2),
      dataStartTime = _getDataLimitsFromLay2[0],
      dataEndTime = _getDataLimitsFromLay2[1];

  var dataRegionInSeconds = dataEndTime - dataStartTime;
  return Math.floor(dataRegionInSeconds / 360); // 60 * 2 * 3, 3 is a hand shake value
};
/**
 * In this Map collection all fundamental scales
 * (Scale.Minutes5 ... Scale.Year) are mapped with their corresponding
 * secondsPerPx numbers. A Scale.DataScale is not included since its
 * secondsPerPx number is different for every data set.
 * @returns a Map including information explained above
 */

var secondsPerPxToScale = new Map([[2.5, Scale.Minutes5], [30, Scale.Hour], [3 * 30, Scale.Hours3], [6 * 30, Scale.Hours6], [24 * 30, Scale.Day], [7 * 24 * 30, Scale.Week], [30 * 24 * 30, Scale.Month], [365 * 24 * 30, Scale.Year]]);
/**
 * Here secondsPerPxToScale is converted to an iterator object and
 * then keys are turned to values and values turned to keys
 * to make it easier in some parts GeoWeb to fetch a secondsPerpx for
 * a certain fundamental scale (Scale.Minutes5 ... Scale.year)
 * @returns an Object, where names are fundamental scale values (0 - 7) and
 * values are their corresponding secondsPerPx numbers.
 */

var scaleToSecondsPerPx = _toConsumableArray(secondsPerPxToScale.entries()).reduce(function (acc, _ref3) {
  var _ref4 = _slicedToArray(_ref3, 2),
      k = _ref4[0],
      v = _ref4[1];

  return Object.assign(Object.assign({}, acc), _defineProperty({}, v, Number(k)));
}, {});
/**
 * This function creates and returns an array where there is secondsPerPx
 * number of the data set added for a data scale (dataScaleToSecondsPerPx)
 * to secondsPerPxToScale.
 * @param dataScaleToSecondsPerPx
 * @returns an array containing secondsPerPx numbers.
 * The secondsPerPx number for a data scale is included
 * contrary to secondsPerPxToScale.
 */

var secondsPerPxValues = function secondsPerPxValues(dataScaleToSecondsPerPx) {
  var sortedSecondsPerPx = _toConsumableArray(secondsPerPxToScale).map(function (value) {
    return Number(value[0]);
  });

  var full = [].concat(_toConsumableArray(sortedSecondsPerPx), [dataScaleToSecondsPerPx]);
  return full;
};
var defaultDataScaleToSecondsPerPx = 43200;
var getNewCenterOfFixedPointZoom = function getNewCenterOfFixedPointZoom(fixedTimePoint, oldSecondsPerPx, newSecondsPerPx, oldCenterTime) {
  var centerToFixedPointPx = (fixedTimePoint - oldCenterTime) / oldSecondsPerPx;
  return fixedTimePoint - centerToFixedPointPx * newSecondsPerPx;
};
/**
 * Move the time slider such that a given time point (timePoint)
 * is at a given pixel width (timePointPx).
 * @returns a new center time for the resulting position
 */

var moveRelativeToTimePoint = function moveRelativeToTimePoint(timePoint, timePointPx, secondsPerPx, canvasWidth) {
  return timePoint - secondsPerPx * (timePointPx - canvasWidth / 2);
};
/** This reusable custom hook tells whether given pointer event targets current canvas node.
 * Example:
 *
 * const [isAllowedCanvasNodePointed, nodeRef] = useCanvasTarget('mousedown', false);
 *  ...
 * return isAllowedCanvasNodePointed ? (<CanvasComponent ref={nodeRef}>Component with ref</CanvasComponent>) : (<CanvasComponent>Component with NO ref</CanvasComponent>);
 *  ...
 */

var useCanvasTarget = function useCanvasTarget(eventType) {
  var nodeRef = React__default.useRef(null);

  var _React$useState = React__default.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isTargetNode = _React$useState2[0],
      setTargetNode = _React$useState2[1]; // Check if pointer event targets current node element


  var pointerEventListener = React__default.useCallback(function (e) {
    setTargetNode(nodeRef.current.canvas ? nodeRef.current.canvas.isEqualNode(e.target) : false);
  }, [nodeRef]);
  React__default.useEffect(function () {
    document.addEventListener(eventType, pointerEventListener);
    return function () {
      return document.removeEventListener(eventType, pointerEventListener);
    };
  }, [eventType, pointerEventListener]); // Only add/remove event listener when listener really changes, that is, NOT necessarily between every re-render.

  return [isTargetNode, nodeRef];
};
var needleGeom = {
  smallWidth: 126,
  largeWidth: 167,
  height: 24,
  cornerRadius: 5,
  lineWidth: 1
};
var AUTO_MOVE_AREA_PADDING = 1;
var getAutoMoveAreaWidth = function getAutoMoveAreaWidth(scale) {
  return (scale === Scale.Year ? needleGeom.largeWidth : needleGeom.smallWidth) / 2 + AUTO_MOVE_AREA_PADDING;
};

var createMap = function createMap(_ref) {
  var id = _ref.id,
      _ref$isAnimating = _ref.isAnimating,
      isAnimating = _ref$isAnimating === void 0 ? false : _ref$isAnimating,
      _ref$animationStartTi = _ref.animationStartTime,
      animationStartTime = _ref$animationStartTi === void 0 ? moment.utc(moment().unix() * 1000).subtract(5, 'h').format(dateFormat) : _ref$animationStartTi,
      _ref$animationEndTime = _ref.animationEndTime,
      animationEndTime = _ref$animationEndTime === void 0 ? moment.utc(moment().unix() * 1000).subtract(10, 'm').format(dateFormat) : _ref$animationEndTime,
      _ref$isAutoUpdating = _ref.isAutoUpdating,
      isAutoUpdating = _ref$isAutoUpdating === void 0 ? false : _ref$isAutoUpdating,
      _ref$bbox = _ref.bbox,
      bbox = _ref$bbox === void 0 ? {
    left: -19000000,
    bottom: -19000000,
    right: 19000000,
    top: 19000000
  } : _ref$bbox,
      _ref$srs = _ref.srs,
      srs = _ref$srs === void 0 ? 'EPSG:3857' : _ref$srs,
      _ref$baseLayers = _ref.baseLayers,
      baseLayers = _ref$baseLayers === void 0 ? [] : _ref$baseLayers,
      _ref$overLayers = _ref.overLayers,
      overLayers = _ref$overLayers === void 0 ? [] : _ref$overLayers,
      _ref$mapLayers = _ref.mapLayers,
      mapLayers = _ref$mapLayers === void 0 ? [] : _ref$mapLayers,
      _ref$featureLayers = _ref.featureLayers,
      featureLayers = _ref$featureLayers === void 0 ? [] : _ref$featureLayers,
      _ref$dimensions = _ref.dimensions,
      dimensions = _ref$dimensions === void 0 ? [] : _ref$dimensions,
      _ref$activeLayerId = _ref.activeLayerId,
      activeLayerId = _ref$activeLayerId === void 0 ? '' : _ref$activeLayerId,
      _ref$timeSliderScale = _ref.timeSliderScale,
      timeSliderScale = _ref$timeSliderScale === void 0 ? Scale.Hour : _ref$timeSliderScale,
      _ref$timeStep = _ref.timeStep,
      timeStep = _ref$timeStep === void 0 ? 5 : _ref$timeStep,
      _ref$animationDelay = _ref.animationDelay,
      animationDelay = _ref$animationDelay === void 0 ? defaultAnimationDelayAtStart : _ref$animationDelay,
      _ref$timeSliderCenter = _ref.timeSliderCenterTime,
      timeSliderCenterTime = _ref$timeSliderCenter === void 0 ? moment.utc().unix() : _ref$timeSliderCenter,
      _ref$timeSliderSecond = _ref.timeSliderSecondsPerPx,
      timeSliderSecondsPerPx = _ref$timeSliderSecond === void 0 ? 30 : _ref$timeSliderSecond,
      _ref$timeSliderDataSc = _ref.timeSliderDataScaleToSecondsPerPx,
      timeSliderDataScaleToSecondsPerPx = _ref$timeSliderDataSc === void 0 ? defaultDataScaleToSecondsPerPx : _ref$timeSliderDataSc,
      _ref$isTimestepAuto = _ref.isTimestepAuto,
      isTimestepAuto = _ref$isTimestepAuto === void 0 ? true : _ref$isTimestepAuto,
      _ref$isTimeSliderHove = _ref.isTimeSliderHoverOn,
      isTimeSliderHoverOn = _ref$isTimeSliderHove === void 0 ? false : _ref$isTimeSliderHove,
      _ref$isTimeSliderVisi = _ref.isTimeSliderVisible,
      isTimeSliderVisible = _ref$isTimeSliderVisi === void 0 ? true : _ref$isTimeSliderVisi,
      _ref$activeMapPresetI = _ref.activeMapPresetId,
      activeMapPresetId = _ref$activeMapPresetI === void 0 ? null : _ref$activeMapPresetI,
      _ref$displayMapPin = _ref.displayMapPin,
      displayMapPin = _ref$displayMapPin === void 0 ? false : _ref$displayMapPin,
      _ref$disableMapPin = _ref.disableMapPin,
      disableMapPin = _ref$disableMapPin === void 0 ? false : _ref$disableMapPin,
      _ref$shouldShowZoomCo = _ref.shouldShowZoomControls,
      shouldShowZoomControls = _ref$shouldShowZoomCo === void 0 ? true : _ref$shouldShowZoomCo;
  return {
    id: id,
    isAnimating: isAnimating,
    animationStartTime: animationStartTime,
    animationEndTime: animationEndTime,
    isAutoUpdating: isAutoUpdating,
    srs: srs,
    bbox: bbox,
    baseLayers: baseLayers,
    overLayers: overLayers,
    mapLayers: mapLayers,
    featureLayers: featureLayers,
    dimensions: dimensions,
    activeLayerId: activeLayerId,
    timeSliderScale: timeSliderScale,
    timeStep: timeStep,
    animationDelay: animationDelay,
    timeSliderCenterTime: timeSliderCenterTime,
    timeSliderSecondsPerPx: timeSliderSecondsPerPx,
    timeSliderDataScaleToSecondsPerPx: timeSliderDataScaleToSecondsPerPx,
    isTimestepAuto: isTimestepAuto,
    isTimeSliderHoverOn: isTimeSliderHoverOn,
    isTimeSliderVisible: isTimeSliderVisible,
    activeMapPresetId: activeMapPresetId,
    displayMapPin: displayMapPin,
    disableMapPin: disableMapPin,
    shouldShowZoomControls: shouldShowZoomControls
  };
};
var checkValidLayersPayload = function checkValidLayersPayload(layers, mapId) {
  /* Check for duplicate ids */
  var layerIds = [];

  for (var i = 0; i < layers.length; i += 1) {
    if (layers[i].id) {
      /* Check if layer is already added to a different map */
      if (layers[i].mapId && mapId && layers[i].mapId !== mapId) {
        return false;
      }
      /* Check duplicate */


      if (!layerIds[layers[i].id]) {
        layerIds[layers[i].id] = true;
      } else {
        return false;
      }
    }
  }

  return true;
};
/**
 * This will get the map from the map draftstate.
 * If the mapId is not found, it registers one and returns it.
 * @param mapId The mapID
 * @param draft Draft map state
 */

var getDraftMapById = function getDraftMapById(mapId, draft) {
  var map = draft.byId[mapId];
  if (map) return map;

  if (!draft.allIds.includes(mapId)) {
    draft.byId[mapId] = createMap({
      id: mapId
    });
    draft.allIds.push(mapId);
  }

  return draft.byId[mapId];
};
/**
 * Sets the map dimension in the state.
 * It will add dimensions to the map if they are missing.
 * If will update the existing dimensions if overwriteCurrentValue is set to true
 * @param draft The map draft state
 * @param mapId The mapId to update the dimensions for
 * @param dimensionFromAction  The dimension from the action
 * @param overwriteCurrentValue True to overwrite existing value. False to add a new dimension if one is not there yet.
 */

var produceDraftStateSetWebMapDimension = function produceDraftStateSetWebMapDimension(draft, mapId, dimensionFromAction, overwriteCurrentValue) {
  var map = getDraftMapById(mapId, draft);

  if (dimensionFromAction) {
    if (!map.dimensions) map.dimensions = [];
    var dimensions = map.dimensions;
    var mapDim = dimensions.find(function (dim) {
      return dim.name === dimensionFromAction.name;
    });

    if (mapDim) {
      if (overwriteCurrentValue) {
        mapDim.currentValue = dimensionFromAction.currentValue;
      }
    } else {
      dimensions.push({
        name: dimensionFromAction.name,
        currentValue: dimensionFromAction.currentValue
      });
    }
  }
};
/**
 * Find the mapId belonging to a layerId
 * @param draft The WebMapState containing the state of all maps.
 * @param layerId The layer Id to find in the maps
 */

var findMapIdFromLayerId = function findMapIdFromLayerId(draft, layerId) {
  for (var i = 0; i < draft.allIds.length; i += 1) {
    var mapId = draft.allIds[i];
    var layerIds = draft.byId[mapId].mapLayers;

    for (var l = 0; l < layerIds.length; l += 1) {
      var layerIdFromMap = layerIds[l];

      if (layerIdFromMap === layerId) {
        return mapId;
      }
    }
  }

  return null;
};
/*
    When a layer dimension is changed, it can affect the map dimension if the layer dimension is linked with the map.
    We need to find out from the layerId to which map it is coupled, and then adjust the map dimension
  */

var produceDraftStateSetMapDimensionFromLayerChangeDimension = function produceDraftStateSetMapDimensionFromLayerChangeDimension(draft, layerId, dimension) {
  var wmjsDimension = getWMJSDimensionForLayerAndDimension(layerId, dimension.name);

  if (!wmjsDimension) {
    return;
  }
  /* If the layer dimension is not linked with the map, we should not update the map dimension */


  if (!wmjsDimension.linked) {
    return;
  }

  var mapId = findMapIdFromLayerId(draft, layerId);

  if (!mapId) {
    return;
  }

  produceDraftStateSetWebMapDimension(draft, mapId, dimension, true);
};
/**
 * Returns array with new order of swapped elements
 * @param array Array with ids
 * @param oldIndex Old index of element in array
 * @param newIndex New index of element in array
 */

function moveArrayElements(array, oldIndex, newIndex) {
  var newArray = _toConsumableArray(array);

  var indexNew = newIndex >= newArray.length ? newArray.length - 1 : newIndex;
  newArray.splice(indexNew, 0, newArray.splice(oldIndex, 1)[0]);
  return newArray;
}

var utils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  createMap: createMap,
  checkValidLayersPayload: checkValidLayersPayload,
  getDraftMapById: getDraftMapById,
  produceDraftStateSetWebMapDimension: produceDraftStateSetWebMapDimension,
  findMapIdFromLayerId: findMapIdFromLayerId,
  produceDraftStateSetMapDimensionFromLayerChangeDimension: produceDraftStateSetMapDimensionFromLayerChangeDimension,
  moveArrayElements: moveArrayElements
});

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */
/**
 * Sets a dimension value for a layer in the state. If the dimension does not exist it is added to the layer.
 * @param draft The draft layerstate
 * @param layerId The layerId
 * @param dimensionValueToUpdate The dimension with values to update in the layer.
 */

var produceLayerDimensionDraftState = function produceLayerDimensionDraftState(draft, layerId, dimensionValueToUpdate) {
  if (!draft.byId[layerId].dimensions) draft.byId[layerId].dimensions = [];
  var existingLayerDimIndex = draft.byId[layerId].dimensions.findIndex(function (layerDim) {
    return layerDim.name === dimensionValueToUpdate.name;
  });

  if (existingLayerDimIndex < 0) {
    draft.byId[layerId].dimensions.push(Object.assign({}, dimensionValueToUpdate));
  } else {
    if (dimensionValueToUpdate.currentValue) {
      draft.byId[layerId].dimensions[existingLayerDimIndex].currentValue = dimensionValueToUpdate.currentValue;
    }

    if (dimensionValueToUpdate.synced !== undefined) {
      draft.byId[layerId].dimensions[existingLayerDimIndex].synced = dimensionValueToUpdate.synced;
    }

    if (dimensionValueToUpdate.validSyncSelection !== undefined) {
      draft.byId[layerId].dimensions[existingLayerDimIndex].validSyncSelection = dimensionValueToUpdate.validSyncSelection;
    }
  }
};

var isActionLayerSynced = function isActionLayerSynced(state, layerIdFromAction, dimension) {
  if (dimension.synced !== undefined) return dimension.synced;
  var actionLayer = state.byId[layerIdFromAction];
  if (!actionLayer) return false;
  var layerDimensionIndex = actionLayer.dimensions.findIndex(function (layerDim) {
    return layerDim.name === dimension.name;
  });
  if (layerDimensionIndex < 0) return false;
  return actionLayer.dimensions[layerDimensionIndex].synced === true;
};
var produceDimensionActionForMapLayer = function produceDimensionActionForMapLayer(layerDim, wmjsDimension, newDimension) {
  // If new value does not occur in the wmjsdimension - do not update the value but set the validSyncSelection to false
  if (wmjsDimension.getIndexForValue(newDimension.currentValue) === -1) {
    return Object.assign(Object.assign({}, layerDim), {
      name: newDimension.name,
      units: newDimension.units,
      currentValue: layerDim.currentValue,
      validSyncSelection: false
    });
  } // Otherwise, update to new value and set validSyncSelection to true


  return Object.assign(Object.assign({}, layerDim), {
    name: newDimension.name,
    units: newDimension.units,
    currentValue: newDimension.currentValue,
    validSyncSelection: true
  });
};
/**
 * For the given dimension, it creates a new draft state for all other (linked or synced) layers inside the map.
 * @param draft
 * @param dimension
 * @param mapId
 */

var produceDraftStateForAllLayersForDimensionWithinMap = function produceDraftStateForAllLayersForDimensionWithinMap(draft, dimension, mapId, layerIdFromAction
/* Layer ID or null if not known */
) {
  if (!mapId) return;
  var actionLayerSynced = isActionLayerSynced(draft, layerIdFromAction, dimension);

  for (var li = 0; li < draft.allIds.length; li += 1) {
    var layerId = draft.allIds[li];
    var layer = draft.byId[layerId];

    if (layer && layer.mapId === mapId) {
      var wmjsDimension = getWMJSDimensionForLayerAndDimension(layerId, dimension.name);

      if (wmjsDimension && wmjsDimension.linked && wmjsDimension.name === 'reference_time') {
        wmjsDimension.linked = false;
      }

      if (layerIdFromAction === layerId || wmjsDimension && wmjsDimension.linked) {
        var dimensionValueToUpdate = Object.assign(Object.assign({
          name: dimension.name,
          units: dimension.units,
          currentValue: wmjsDimension ? wmjsDimension.getClosestValue(dimension.currentValue, true) : dimension.currentValue
        }, dimension.synced !== undefined ? {
          synced: dimension.synced
        } : {}), {
          validSyncSelection: true
        });
        /* Set the dimension value for this layer */

        produceLayerDimensionDraftState(draft, layerId, dimensionValueToUpdate);
      } else if (actionLayerSynced) {
        // Check to see if we need to update layer based on being synced
        var layerDimensionIndex = layer.dimensions.findIndex(function (layerDim) {
          return layerDim.name === dimension.name;
        });

        if (layerDimensionIndex !== -1) {
          var layerDim = layer.dimensions[layerDimensionIndex];

          if (layerDim.synced === true) {
            var _dimensionValueToUpdate = produceDimensionActionForMapLayer(layerDim, wmjsDimension, dimension);
            /* Set the dimension value for this layer */


            produceLayerDimensionDraftState(draft, layerId, _dimensionValueToUpdate);
          }
        }
      }
    }
  }
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2022 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2022 - Finnish Meteorological Institute (FMI)
 * */
/**
 * These actions causes circular dependency if they are defined in the reducer.ts file.
 * Therefor they are instead added to this file
 * https://redux-toolkit.js.org/usage/usage-guide#exporting-and-using-slices
 */

var mapChangeDimension = createAction('MAP_CHANGE_DIMENSION');
var setMapPreset = createAction('SET_MAP_PRESET');

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */
/**
 * Generic action to set the time.
 *
 * @param payload: SetTimePayload;
 *   {
 *     sourceId: string; // Source where the new time value originates from
 *     value: string;    // ISO 8601 string time value like "2010-10-01T00:00:00Z"
 *   }
 */

var setTime = createAction('GENERIC_SETTIME');
/**
 * Generic action to set the bounding box.
 *
 * @param payload: SetBboxPayload;
 *
 * {
 *   sourceId: string;  // Source where the new time value originates from
 *   bbox: {            // Bbbox object
 *     left: number;
 *     bottom: number;
 *     right: number;
 *     top: number;
 *   };
 *   srs: string;       // Projection string according to EPSG, e.g. (EPSG:3857 ==  Mercator)
 * }
 */

var setBbox = createAction('GENERIC_SETBBOX');

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */
/**
 * These actions are fired by the generic/saga.ts, based on generic actions and the synchronizationGroup state.
 *
 * These actions should not be used by components directly. Components should only use the generic actions.
 */

var setTimeSync = createAction('GENERIC_SYNC_SETTIME', function (payload, targets, groups) {
  return {
    payload: {
      source: setTime(payload),
      groups: groups,
      targets: targets
    }
  };
});
var setBboxSync = createAction('GENERIC_SYNC_SETBBOX', function (payload, targets, groups) {
  return {
    payload: {
      source: setBbox(payload),
      groups: groups,
      targets: targets
    }
  };
});
var setLayerActionSync = createAction('GENERIC_SYNC_SETLAYERACTIONS', function (payload, targets, type) {
  return {
    payload: {
      source: {
        type: type,
        payload: payload
      },
      targets: targets
    }
  };
});

var createLayer = function createLayer(_a) {
  var id = _a.id,
      _a$opacity = _a.opacity,
      opacity = _a$opacity === void 0 ? 1 : _a$opacity,
      _a$enabled = _a.enabled,
      enabled = _a$enabled === void 0 ? true : _a$enabled,
      _a$layerType = _a.layerType,
      layerType = _a$layerType === void 0 ? 'mapLayer' : _a$layerType,
      _a$status = _a.status,
      status = _a$status === void 0 ? 'default' : _a$status,
      props = __rest(_a, ["id", "opacity", "enabled", "layerType", "status"]);

  var wmjsLayer = getWMLayerById(id);
  var dimensions = props.dimensions || (wmjsLayer ? wmjsLayer.getDimensions() : []).map(function (dim) {
    return {
      name: dim.name,
      currentValue: dim.currentValue,
      units: dim.units
    };
  });
  return Object.assign(Object.assign({}, props), {
    dimensions: dimensions,
    id: id,
    opacity: opacity,
    enabled: enabled,
    layerType: layerType,
    status: status
  });
};
var initialState$5 = {
  byId: {},
  allIds: [],
  availableBaseLayers: {
    byId: {},
    allIds: []
  }
};
var slice$5 = createSlice({
  initialState: initialState$5,
  name: 'layerReducer',
  reducers: {
    addLayer: function addLayer(draft, action) {
      var _action$payload = action.payload,
          layer = _action$payload.layer,
          layerId = _action$payload.layerId,
          mapId = _action$payload.mapId;

      if (!checkValidLayersPayload([layer], mapId)) {
        return;
      }

      if (!draft.byId[layerId]) {
        // TODO: (Sander de Snaijer, 2020-03-19) remove layerIds from the layer utils
        draft.byId[layerId] = createLayer(Object.assign(Object.assign({}, layer), {
          id: layerId,
          mapId: mapId
        }));
        draft.allIds.push(layerId);
      }
    },
    layerChangeDimension: function layerChangeDimension(draft, action) {
      var _action$payload2 = action.payload,
          layerIdFromAction = _action$payload2.layerId,
          dimension = _action$payload2.dimension;
      var layerFromAction = draft.byId[layerIdFromAction];
      if (!layerFromAction) return;
      var mapId = layerFromAction.mapId;
      produceDraftStateForAllLayersForDimensionWithinMap(draft, dimension, mapId, layerIdFromAction);
    },
    layerChangeEnabled: function layerChangeEnabled(draft, action) {
      var _action$payload3 = action.payload,
          layerId = _action$payload3.layerId,
          enabled = _action$payload3.enabled;

      if (draft.byId[layerId]) {
        draft.byId[layerId].enabled = enabled;
      }
    },
    layerChangeOpacity: function layerChangeOpacity(draft, action) {
      var _action$payload4 = action.payload,
          layerId = _action$payload4.layerId,
          opacity = _action$payload4.opacity;

      if (draft.byId[layerId]) {
        draft.byId[layerId].opacity = opacity;
      }
    },
    layerChangeStyle: function layerChangeStyle(draft, action) {
      var _action$payload5 = action.payload,
          layerId = _action$payload5.layerId,
          style = _action$payload5.style;

      if (draft.byId[layerId]) {
        draft.byId[layerId].style = style;
      }
    },
    layerChangeName: function layerChangeName(draft, action) {
      var _action$payload6 = action.payload,
          layerId = _action$payload6.layerId,
          name = _action$payload6.name;

      if (draft.byId[layerId]) {
        draft.byId[layerId].name = name;
      }
    },
    layerChangeGeojson: function layerChangeGeojson(draft, action) {
      var _action$payload7 = action.payload,
          layerId = _action$payload7.layerId,
          geojson = _action$payload7.geojson;

      if (draft.byId[layerId]) {
        draft.byId[layerId].geojson = geojson;
      }
    },
    layerDelete: function layerDelete(draft, action) {
      var layerId = action.payload.layerId;

      if (draft.byId[layerId]) {
        draft.allIds = draft.allIds.filter(function (id) {
          return id !== layerId;
        });
        delete draft.byId[layerId];
      }
    },
    layerError: function layerError(draft, action) {
      var layerId = action.payload.layerId;

      if (draft.byId[layerId]) {
        draft.byId[layerId].status = LayerStatus.error;
      }
    },
    baseLayerDelete: function baseLayerDelete(draft, action) {
      var layerId = action.payload.layerId;
      if (draft.byId[layerId].layerType !== LayerType.baseLayer && draft.byId[layerId].layerType !== LayerType.overLayer) return;

      if (draft.byId[layerId]) {
        draft.allIds = draft.allIds.filter(function (id) {
          return id !== layerId;
        });
        delete draft.byId[layerId];
      }
    },
    setLayers: function setLayers(draft, action) {
      var _action$payload8 = action.payload,
          layers = _action$payload8.layers,
          mapId = _action$payload8.mapId;

      if (!checkValidLayersPayload(layers, mapId)) {
        return;
      }
      /*
          All layer id's for the specified mapId should be removed.
          This is done by clearing the allId object, and then adding back the layer ids for the other maps we want to keep.
          At the same time the byId object is synchronized.
        */


      var state = current(draft);
      draft.allIds = [];
      state.allIds.forEach(function (layerId) {
        if (state.byId[layerId] && state.byId[layerId].layerType !== LayerType.baseLayer && state.byId[layerId].layerType !== LayerType.overLayer && state.byId[layerId].mapId === mapId) {
          delete draft.byId[layerId];
        } else {
          draft.allIds.push(layerId);
        }
      });
      /*
          Here we set the layers for the mapId from the action. byId and allIds is updated.
        */

      layers.forEach(function (layer) {
        draft.byId[layer.id] = createLayer(Object.assign({
          id: layer.id,
          mapId: mapId
        }, layer));
        draft.allIds.push(layer.id);
      });
    },
    setBaseLayers: function setBaseLayers(draft, action) {
      var _action$payload9 = action.payload,
          layers = _action$payload9.layers,
          mapId = _action$payload9.mapId;
      var filtererdBaseLayers = layers.filter(function (layer) {
        return layer.layerType === LayerType.baseLayer || layer.layerType === LayerType.overLayer;
      }); // filter for unique layerTypes

      var layerTypes = [];
      filtererdBaseLayers.forEach(function (layer) {
        if (layer.layerType !== LayerType.baseLayer && layer.layerType !== LayerType.overLayer) return;
        if (!layerTypes.includes(layer.layerType)) layerTypes.push(layer.layerType);
      });
      var state = current(draft); // remove current layers with same type as one of the passed layers

      state.allIds.forEach(function (layerId) {
        if (state.byId[layerId] && layerTypes.includes(state.byId[layerId].layerType) && state.byId[layerId].mapId === mapId) {
          delete draft.byId[layerId];
          var index = draft.allIds.indexOf(layerId);
          draft.allIds.splice(index, 1);
        }
      }); // set over and base layers

      filtererdBaseLayers.forEach(function (layer) {
        draft.byId[layer.id] = createLayer(Object.assign({
          id: layer.id,
          layerType: layer.layerType,
          mapId: mapId
        }, layer));
        draft.allIds.push(layer.id);
      });
    },
    addBaseLayer: function addBaseLayer(draft, action) {
      var layer = action.payload.layer;
      if (layer.layerType !== LayerType.baseLayer && layer.layerType !== LayerType.overLayer) return;

      if (!draft.byId[layer.id]) {
        draft.byId[layer.id] = createLayer(Object.assign({
          id: layer.id,
          layerType: layer.layerType
        }, layer));
        draft.allIds.push(layer.id);
      }
    },
    layerSetDimensions: function layerSetDimensions(draft, action) {
      var _action$payload10 = action.payload,
          dimensions = _action$payload10.dimensions,
          layerId = _action$payload10.layerId;

      if (draft.byId[layerId]) {
        draft.byId[layerId].dimensions = dimensions;
      }
    },
    addAvailableBaseLayer: function addAvailableBaseLayer(draft, action) {
      var layer = action.payload.layer;
      if (layer.layerType !== LayerType.baseLayer && layer.layerType !== LayerType.overLayer || !layer.mapId) return;

      if (!draft.availableBaseLayers.byId[layer.id]) {
        draft.availableBaseLayers.byId[layer.id] = createLayer(Object.assign({
          id: layer.id,
          layerType: layer.layerType
        }, layer));
        draft.availableBaseLayers.allIds.push(layer.id);
      }
    },
    addAvailableBaseLayers: function addAvailableBaseLayers(draft, action) {
      var layers = action.payload.layers; // add new available baselayers

      layers.forEach(function (layer) {
        if (layer.layerType !== LayerType.baseLayer || draft.availableBaseLayers.byId[layer.id] || !layer.mapId) return;
        draft.availableBaseLayers.byId[layer.id] = createLayer(Object.assign({
          id: layer.id,
          layerType: layer.layerType
        }, layer));
        draft.availableBaseLayers.allIds.push(layer.id);
      });
    },
    onUpdateLayerInformation: function onUpdateLayerInformation(draft, action) {
      var _action$payload11 = action.payload,
          layerStyle = _action$payload11.layerStyle,
          layerDimensions = _action$payload11.layerDimensions;
      var layerStyleAction = layerActions.layerChangeStyle(layerStyle);
      var state = current(draft);
      var intermediateState = layerStyle === null ? state : reducer$5(state, layerStyleAction);
      var dimensionsAction = layerActions.layerSetDimensions(layerDimensions);
      var newState = layerDimensions === null ? intermediateState : reducer$5(intermediateState, dimensionsAction);
      return newState;
    }
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(setTimeSync, function (draft, action) {
      var _action$payload12 = action.payload,
          targetsFromAction = _action$payload12.targets,
          source = _action$payload12.source;
      /* Because we want backwards compatibility with the previous code, we also need to listen to the original source action */

      var targets = [{
        targetId: source.payload.sourceId,
        value: source.payload.value
      }];
      /* And then append the targets form the action */

      targets.push.apply(targets, _toConsumableArray(targetsFromAction));
      targets.forEach(function (payload) {
        var targetId = payload.targetId,
            value = payload.value;
        var dimension = {
          name: 'time',
          currentValue: value
        };
        produceDraftStateForAllLayersForDimensionWithinMap(draft, dimension, targetId, null);
      });
    }).addCase(setLayerActionSync, function (draft, action) {
      /*
       * This GENERIC_SYNC_SETLAYERACTIONS action is generated by the syncgroup saga.
       * It has multiple targets (Layers) in its payload.
       * These targets can be used as payloads in new Layer actions.
       * These actions are here handled via the layer reducer, as it is the same logic
       */
      var _action$payload13 = action.payload,
          targets = _action$payload13.targets,
          source = _action$payload13.source;
      var state = current(draft);
      return targets.reduce(function (prevState, target) {
        var action = {
          payload: target,
          type: source.type
        };
        /* Handle the Layer action with the same logic, using the same reducer */

        return reducer$5(prevState, action);
      }, state);
    }).addCase(setMapPreset, function (draft, action) {
      var mapId = action.payload.mapId;
      var layers = draft.allIds.map(function (id) {
        return draft.byId[id];
      }).filter(function (layer) {
        return layer && layer.mapId === mapId;
      });
      layers.forEach(function (layer) {
        delete draft.byId[layer.id];
        var index = draft.allIds.indexOf(layer.id);
        draft.allIds.splice(index, 1);
      });
    }).addCase(mapChangeDimension, function (draft, action) {
      var mapId = action.payload.mapId;
      produceDraftStateForAllLayersForDimensionWithinMap(draft, action.payload.dimension, mapId, null);
    });
  }
});
var reducer$5 = slice$5.reducer;
var layerActions = slice$5.actions;

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */
var initialState$4 = {
  byId: {},
  allIds: []
};
var slice$4 = createSlice({
  initialState: initialState$4,
  name: 'serviceReducer',
  reducers: {
    serviceSetLayers: function serviceSetLayers(draft, action) {
      var id = action.payload.id;
      draft.byId[id] = Object.assign({}, action.payload);
      if (!draft.allIds.includes(id)) draft.allIds.push(id);
    },
    mapStoreRemoveService: function mapStoreRemoveService(draft, action) {
      var foundServiceIndex = draft.allIds.findIndex(function (id) {
        return draft.byId[id].serviceUrl === action.payload.serviceUrl;
      });

      if (foundServiceIndex !== -1) {
        var serviceId = draft.allIds[foundServiceIndex];
        draft.allIds = draft.allIds.filter(function (id) {
          return id !== serviceId;
        });
        delete draft.byId[serviceId];
      }
    }
  },
  extraReducers: function extraReducers(builder) {
    return builder.addCase(layerActions.onUpdateLayerInformation, function (draft, action) {
      var serviceLayers = action.payload.serviceLayers;
      if (serviceLayers === null) return draft;
      var mapAction = serviceActions.serviceSetLayers(serviceLayers);
      var newState = reducer$4(draft, mapAction);
      return newState;
    });
  }
});
var reducer$4 = slice$4.reducer;
var serviceActions = slice$4.actions;

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2022 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2022 - Finnish Meteorological Institute (FMI)
 * */
var selectorMemoizationOptions = {
  memoizeOptions: {
    maxSize: 1000,
    resultEqualityCheck: isEqual
  }
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */

var servicesStore = function servicesStore(store) {
  return store && store.services ? store.services : null;
};
/**
 * Retrieves all serviceIds
 *
 * Example: serviceIds = getServiceIds(store)
 * @param {object} store store: object - object from which the service state will be extracted
 * @returns {array} returnType: array - an array of all serviceIds
 */


createSelector(servicesStore, function (serviceState) {
  return serviceState ? serviceState.allIds : [];
}, selectorMemoizationOptions);
/**
 * Gets map services
 *
 * Example: services = getServices(store)
 * @param {object} store store: object - Store object
 * @returns {object} returnType: ServiceState
 */

var getServices = createSelector(servicesStore, function (store) {
  return store ? store.byId : {};
}, selectorMemoizationOptions);
/**
 * Gets the service object by its url
 *
 * Example: service = getServiceByName(store, 'serviceName')
 * @param {object} store store: object - Store object
 * @returns {ReduxService} returnType: Service
 */

var getServiceByName = createSelector([servicesStore, function (state, serviceUrl) {
  return serviceUrl;
}], function (serviceState, serviceUrl) {
  var foundServiceIndex = serviceState.allIds.findIndex(function (id) {
    return serviceState.byId[id].serviceUrl === serviceUrl;
  });
  /* Add the service based on a url */

  var id = foundServiceIndex !== -1 ? serviceState.allIds[foundServiceIndex] : null;

  if (serviceState && serviceState.byId && serviceState.byId[id]) {
    return serviceState.byId[id];
  }

  return null;
}, selectorMemoizationOptions);
/**
 * Gets the layer from the store using the serviceUrl and layerName
 *
 * Example: layers = getLayersFromService(store, 'https://geoservices.knmi.nl/...')
 * @param {object} store store: object - object from which the layers state will be extracted
 * @param {string}  serviceUrl serviceUrl: string - Url of the service where the layer belongs to
 * @returns {array} returnType: ServiceLayer[] - All layers within the service object.
 */

var getLayersFromService$1 = createSelector(getServiceByName, function (service) {
  return service && service.layers || null;
}, selectorMemoizationOptions);
/**
 * Gets the layer from the store using the serviceUrl and layerName
 *
 * Example: layer = getLayerFromService(store, 'https://geoservices.knmi.nl/...', 'radar')
 * @param {object} store store: object - The application store
 * @param {string}  serviceUrl serviceUrl: string - Url of the service where the layer belongs to
 * @param {string}  layerName layerName: string - Name of the layer in the service
 * @returns {ServiceLayer} returnType: ServiceLayer - The layer from the service object.
 */

var getLayerFromService = createSelector(function (store, serviceUrl) {
  return getLayersFromService$1(store, serviceUrl);
}, function (store, serviceUrl) {
  return serviceUrl;
}, function (store, serviceUrl, layerName) {
  return layerName;
}, function (layers, serviceUrl, layerName) {
  if (!layers) return null;
  var index = layers.findIndex(function (serviceLayer) {
    return serviceLayer.name === layerName;
  });

  if (index === -1) {
    return null;
  }

  return layers[index];
}, selectorMemoizationOptions);
/**
 * Gets the layers stylelist from the servicestore using the serviceUrl and layerName
 *
 * Example: layerStyles = getLayerStyles(store, layerService, layerName);
 * @param {object} store store: object - store from which the layers state will be extracted
 * @param {string}  serviceUrl serviceUrl: string - Url of the service where the layer belongs to
 * @param {string}  layerName layerName: string - Name of the layer in the service
 * @returns {array} returnType: Style[] - array containing layer styles
 */

var getLayerStyles = createSelector(getLayerFromService, function (layer) {
  return layer && layer.styles ? layer.styles : [];
}, selectorMemoizationOptions);
/**
 * Gets services and maps them into an array
 *
 * Example: services = getServices(store)
 * @param {object} store store: object - Store object
 * @returns {array} returnType: [] - array containing services
 */

var getServicesInArray = createSelector(servicesStore, function (store) {
  var services = store ? store.byId : {};
  var arrayOfServiceObjects = Object.keys(services).map(function (key) {
    return {
      name: services[key].name,
      serviceUrl: services[key].serviceUrl
    };
  });
  return arrayOfServiceObjects;
}, selectorMemoizationOptions);

var moveToTop = function moveToTop(list, element) {
  var filteredList = list.filter(function (item) {
    return item !== element;
  });
  var newOrder = [element].concat(_toConsumableArray(filteredList));
  return newOrder;
};
var createUIDialogElement = function createUIDialogElement(_ref) {
  var activeMapId = _ref.activeMapId,
      type = _ref.type,
      setOpen = _ref.setOpen,
      _ref$source = _ref.source,
      source = _ref$source === void 0 ? 'app' : _ref$source;
  return {
    activeMapId: activeMapId,
    isOpen: setOpen,
    type: type,
    source: source
  };
};
var initialState$3 = {
  order: [],
  dialogs: {},
  activeWindowId: undefined
};
var slice$3 = createSlice({
  initialState: initialState$3,
  name: 'uiReducer',
  reducers: {
    registerDialog: function registerDialog(draft, action) {
      var type = action.payload.type;
      var activeMapId = action.payload.mapId ? action.payload.mapId : '';
      var setOpen = action.payload.setOpen ? action.payload.setOpen : false;
      var source = action.payload.source ? action.payload.source : 'app';

      if (!Object.keys(draft.dialogs).includes(type)) {
        draft.dialogs[type] = createUIDialogElement({
          activeMapId: activeMapId,
          type: type,
          setOpen: setOpen,
          source: source
        });
      } // register dialog to order


      if (!draft.order.includes(type)) {
        draft.order.push(type);
      }
    },
    unregisterDialog: function unregisterDialog(draft, action) {
      var type = action.payload.type;

      if (draft.dialogs[type]) {
        delete draft.dialogs[type];
        draft.order = draft.order.filter(function (item) {
          return item !== type;
        });
      }
    },
    setActiveMapIdForDialog: function setActiveMapIdForDialog(draft, action) {
      var _action$payload = action.payload,
          type = _action$payload.type,
          mapId = _action$payload.mapId,
          source = _action$payload.source;

      if (!draft.dialogs[type]) {
        return;
      }

      var isOpen = action.payload.setOpen !== undefined ? action.payload.setOpen : draft.dialogs[type].isOpen;
      draft.dialogs[type].activeMapId = mapId;
      draft.dialogs[type].isOpen = isOpen;
      draft.dialogs[type].source = source;

      if (isOpen) {
        draft.order = moveToTop(draft.order, type);
      }
    },
    setToggleOpenDialog: function setToggleOpenDialog(draft, action) {
      var _action$payload2 = action.payload,
          type = _action$payload2.type,
          setOpen = _action$payload2.setOpen;

      if (!draft.dialogs[type]) {
        return;
      }

      draft.dialogs[type].isOpen = setOpen;

      if (setOpen) {
        draft.order = moveToTop(draft.order, type);
      }
    },
    orderDialog: function orderDialog(draft, action) {
      var type = action.payload.type;
      draft.order = moveToTop(draft.order, type);
    },
    setActiveWindowId: function setActiveWindowId(draft, action) {
      var activeWindowId = action.payload.activeWindowId;
      draft.activeWindowId = activeWindowId;
    }
  }
});
var reducer$3 = slice$3.reducer;
var uiActions = slice$3.actions;

var addBaseLayer = layerActions.addBaseLayer,
    addLayer$1 = layerActions.addLayer,
    baseLayerDelete = layerActions.baseLayerDelete,
    layerChangeDimension$1 = layerActions.layerChangeDimension,
    layerDelete$1 = layerActions.layerDelete,
    onUpdateLayerInformation = layerActions.onUpdateLayerInformation,
    setBaseLayers$1 = layerActions.setBaseLayers,
    setLayers = layerActions.setLayers;
/**
 * Checks if the layer id is already taken in one of the maps.
 * @param state The WebMapState
 * @param layerIdToCheck The layerId to check
 * @returns true if the layerId is already taken somewhere else.
 */

var checkIfMapLayerIdIsAlreadyTaken = function checkIfMapLayerIdIsAlreadyTaken(state, layerId) {
  return state.allIds.some(function (mapId) {
    var map = state.byId[mapId];

    var doesLayeridExist = function doesLayeridExist(layers) {
      return layers && layers.some(function (id) {
        return id === layerId;
      });
    };

    return doesLayeridExist(map.mapLayers) || doesLayeridExist(map.overLayers) || doesLayeridExist(map.baseLayers) || doesLayeridExist(map.featureLayers);
  });
};
/**
 * Addes id's to the layer object. All layers need to have an id for referring.
 * @param layers
 */

var createLayersWithIds = function createLayersWithIds(state, layers) {
  if (!layers) return layers;
  return produce(layers, function (draft) {
    for (var j = 0; j < draft.length; j += 1) {
      var layer = draft[j];

      if (!layer.id) {
        layer.id = generateLayerId();
      } else if (checkIfMapLayerIdIsAlreadyTaken(state, layer.id)) {
        console.warn("Warning: Layer id ".concat(layer.id, " was already taken: Generating new one."));
        layer.id = generateLayerId();
      }
    }
  });
};

var initialState$2 = {
  byId: {},
  allIds: []
};
var slice$2 = createSlice({
  initialState: initialState$2,
  name: 'mapReducer',
  reducers: {
    registerMap: function registerMap(draft, action) {
      var mapId = action.payload.mapId;

      if (!draft.allIds.includes(mapId)) {
        draft.byId[mapId] = createMap({
          id: mapId
        });
        draft.allIds.push(mapId);
      }
    },
    unregisterMap: function unregisterMap(draft, action) {
      var mapId = action.payload.mapId;
      var mapIndex = draft.allIds.indexOf(mapId);

      if (mapIndex !== -1) {
        delete draft.byId[mapId];
        draft.allIds.splice(mapIndex, 1);
      }
    },
    setBbox: function setBbox(draft, action) {
      var _action$payload = action.payload,
          mapId = _action$payload.mapId,
          bbox = _action$payload.bbox;

      if (!draft.byId[mapId]) {
        return;
      }

      var srs = action.payload.srs || null;
      draft.byId[mapId].bbox = bbox;
      if (srs) draft.byId[mapId].srs = srs;
    },
    mapUpdateAllMapDimensions: function mapUpdateAllMapDimensions(draft, action) {
      var _action$payload2 = action.payload,
          mapId = _action$payload2.mapId,
          dimensions = _action$payload2.dimensions;

      if (!draft.byId[mapId]) {
        return;
      }

      draft.byId[mapId].dimensions.length = 0;
      dimensions.forEach(function (dimension) {
        return produceDraftStateSetWebMapDimension(draft, mapId, dimension, true);
      });
    },
    mapStartAnimation: function mapStartAnimation(draft, action) {
      var mapId = action.payload.mapId;

      if (!draft.byId[mapId]) {
        return;
      }

      draft.byId[mapId].isAnimating = true;

      if (action.payload.start) {
        draft.byId[mapId].animationStartTime = action.payload.start;
      }

      if (action.payload.end) {
        draft.byId[mapId].animationEndTime = action.payload.end;
      }

      if (action.payload.interval && action.payload.interval !== draft.byId[mapId].timeStep) {
        draft.byId[mapId].timeStep = action.payload.interval;
        draft.byId[mapId].isTimestepAuto = false;
      }
    },
    mapStopAnimation: function mapStopAnimation(draft, action) {
      var mapId = action.payload.mapId;

      if (!draft.byId[mapId]) {
        return;
      }

      draft.byId[mapId].isAnimating = false;
    },
    setTimeSliderScale: function setTimeSliderScale(draft, action) {
      var _action$payload3 = action.payload,
          mapId = _action$payload3.mapId,
          timeSliderScale = _action$payload3.timeSliderScale;

      if (!draft.byId[mapId]) {
        return;
      }

      draft.byId[mapId].timeSliderScale = timeSliderScale;
      var scaleToSecPerPx = timeSliderScale === Scale.DataScale ? draft.byId[mapId].timeSliderDataScaleToSecondsPerPx : scaleToSecondsPerPx[timeSliderScale];
      draft.byId[mapId].timeSliderSecondsPerPx = scaleToSecPerPx;
    },
    setTimeStep: function setTimeStep(draft, action) {
      var _action$payload4 = action.payload,
          mapId = _action$payload4.mapId,
          timeStep = _action$payload4.timeStep;

      if (!draft.byId[mapId]) {
        return;
      }

      draft.byId[mapId].timeStep = timeStep;
    },
    setAnimationStartTime: function setAnimationStartTime(draft, action) {
      var _action$payload5 = action.payload,
          mapId = _action$payload5.mapId,
          animationStartTime = _action$payload5.animationStartTime;

      if (!draft.byId[mapId]) {
        return;
      }

      draft.byId[mapId].animationStartTime = animationStartTime;
    },
    setAnimationEndTime: function setAnimationEndTime(draft, action) {
      var _action$payload6 = action.payload,
          mapId = _action$payload6.mapId,
          animationEndTime = _action$payload6.animationEndTime;

      if (!draft.byId[mapId]) {
        return;
      }

      draft.byId[mapId].animationEndTime = animationEndTime;
    },
    setSelectedFeature: function setSelectedFeature(draft, action) {
      var _action$payload7 = action.payload,
          mapId = _action$payload7.mapId,
          selectedFeatureIndex = _action$payload7.selectedFeatureIndex;

      if (!draft.byId[mapId]) {
        return;
      }

      draft.byId[mapId].selectedFeatureIndex = selectedFeatureIndex;
    },
    setAnimationDelay: function setAnimationDelay(draft, action) {
      var _action$payload8 = action.payload,
          mapId = _action$payload8.mapId,
          animationDelay = _action$payload8.animationDelay;

      if (!draft.byId[mapId]) {
        return;
      }

      draft.byId[mapId].animationDelay = animationDelay;
    },
    setAnimationInterval: function setAnimationInterval(draft, action) {
      var _action$payload9 = action.payload,
          mapId = _action$payload9.mapId,
          interval = _action$payload9.interval;

      if (!draft.byId[mapId]) {
        return;
      }

      draft.byId[mapId].timeStep = interval;
    },
    layerMoveLayer: function layerMoveLayer(draft, action) {
      var _action$payload10 = action.payload,
          oldIndex = _action$payload10.oldIndex,
          newIndex = _action$payload10.newIndex,
          mapId = _action$payload10.mapId;

      if (!draft.byId[mapId]) {
        return;
      }

      draft.byId[mapId].mapLayers = moveArrayElements(draft.byId[mapId].mapLayers, oldIndex, newIndex);
    },
    setActiveLayerId: function setActiveLayerId(draft, action) {
      var _action$payload11 = action.payload,
          mapId = _action$payload11.mapId,
          layerId = _action$payload11.layerId;

      if (!draft.byId[mapId]) {
        return;
      }

      draft.byId[mapId].activeLayerId = layerId;
    },
    setTimeSliderCenterTime: function setTimeSliderCenterTime(draft, action) {
      var _action$payload12 = action.payload,
          mapId = _action$payload12.mapId,
          timeSliderCenterTime = _action$payload12.timeSliderCenterTime;

      if (!draft.byId[mapId]) {
        return;
      }

      draft.byId[mapId].timeSliderCenterTime = timeSliderCenterTime;
    },
    setTimeSliderSecondsPerPx: function setTimeSliderSecondsPerPx(draft, action) {
      var _action$payload13 = action.payload,
          mapId = _action$payload13.mapId,
          timeSliderSecondsPerPx = _action$payload13.timeSliderSecondsPerPx;

      if (!draft.byId[mapId]) {
        return;
      }

      var secondsPerPxToScaleValue = secondsPerPxToScale.get(timeSliderSecondsPerPx);
      var scale = secondsPerPxToScaleValue === undefined ? Scale.DataScale : secondsPerPxToScale.get(timeSliderSecondsPerPx);
      draft.byId[mapId].timeSliderSecondsPerPx = timeSliderSecondsPerPx;
      draft.byId[mapId].timeSliderScale = scale;
    },
    setTimeSliderDataScaleToSecondsPerPx: function setTimeSliderDataScaleToSecondsPerPx(draft, action) {
      var _action$payload14 = action.payload,
          mapId = _action$payload14.mapId,
          timeSliderDataScaleToSecondsPerPx = _action$payload14.timeSliderDataScaleToSecondsPerPx;

      if (!draft.byId[mapId]) {
        return;
      }

      draft.byId[mapId].timeSliderDataScaleToSecondsPerPx = timeSliderDataScaleToSecondsPerPx;
    },
    toggleAutoUpdate: function toggleAutoUpdate(draft, action) {
      var _action$payload15 = action.payload,
          mapId = _action$payload15.mapId,
          shouldAutoUpdate = _action$payload15.shouldAutoUpdate;

      if (!draft.byId[mapId]) {
        return;
      }

      draft.byId[mapId].isAutoUpdating = shouldAutoUpdate;
    },
    toggleTimestepAuto: function toggleTimestepAuto(draft, action) {
      var _action$payload16 = action.payload,
          mapId = _action$payload16.mapId,
          timestepAuto = _action$payload16.timestepAuto;

      if (!draft.byId[mapId]) {
        return;
      }

      draft.byId[mapId].isTimestepAuto = timestepAuto;
    },
    toggleTimeSliderHover: function toggleTimeSliderHover(draft, action) {
      var _action$payload17 = action.payload,
          mapId = _action$payload17.mapId,
          isTimeSliderHoverOn = _action$payload17.isTimeSliderHoverOn;

      if (!draft.byId[mapId]) {
        return;
      }

      draft.byId[mapId].isTimeSliderHoverOn = isTimeSliderHoverOn;
    },
    toggleTimeSliderIsVisible: function toggleTimeSliderIsVisible(draft, action) {
      var _action$payload18 = action.payload,
          mapId = _action$payload18.mapId,
          isTimeSliderVisible = _action$payload18.isTimeSliderVisible;

      if (!draft.byId[mapId]) {
        return;
      }

      draft.byId[mapId].isTimeSliderVisible = isTimeSliderVisible;
    },
    toggleZoomControls: function toggleZoomControls(draft, action) {
      var _action$payload19 = action.payload,
          mapId = _action$payload19.mapId,
          shouldShowZoomControls = _action$payload19.shouldShowZoomControls;

      if (!draft.byId[mapId]) {
        return;
      }

      draft.byId[mapId].shouldShowZoomControls = shouldShowZoomControls;
    },
    setMapPinLocation: function setMapPinLocation(draft, action) {
      var _action$payload20 = action.payload,
          mapId = _action$payload20.mapId,
          mapPinLocation = _action$payload20.mapPinLocation;

      if (!draft.byId[mapId]) {
        return;
      }

      draft.byId[mapId].mapPinLocation = mapPinLocation;
    },
    setDisableMapPin: function setDisableMapPin(draft, action) {
      var _action$payload21 = action.payload,
          mapId = _action$payload21.mapId,
          disableMapPin = _action$payload21.disableMapPin;

      if (!draft.byId[mapId]) {
        return;
      }

      draft.byId[mapId].disableMapPin = disableMapPin;
    },
    toggleMapPinIsVisible: function toggleMapPinIsVisible(draft, action) {
      var _action$payload22 = action.payload,
          mapId = _action$payload22.mapId,
          displayMapPin = _action$payload22.displayMapPin;

      if (!draft.byId[mapId]) {
        return;
      }

      draft.byId[mapId].displayMapPin = displayMapPin;
    },
    setActiveMapPresetId: function setActiveMapPresetId(draft, action) {
      var _action$payload23 = action.payload,
          mapId = _action$payload23.mapId,
          presetId = _action$payload23.presetId;

      if (!draft.byId[mapId]) {
        return;
      }

      draft.byId[mapId].activeMapPresetId = presetId;
    },
    setIsMapPresetLoading: function setIsMapPresetLoading(draft, action) {
      var _action$payload24 = action.payload,
          mapId = _action$payload24.mapId,
          isLoading = _action$payload24.isLoading;

      if (!draft.byId[mapId]) {
        return;
      }

      draft.byId[mapId].isMapPresetLoading = isLoading;
    },
    setHasMapPresetChanges: function setHasMapPresetChanges(draft, action) {
      var _action$payload25 = action.payload,
          mapId = _action$payload25.mapId,
          hasChanges = _action$payload25.hasChanges;

      if (!draft.byId[mapId]) {
        return;
      }

      draft.byId[mapId].hasMapPresetChanges = hasChanges;
    },
    setMapPresetError: function setMapPresetError(draft, action) {
      var _action$payload26 = action.payload,
          mapId = _action$payload26.mapId,
          error = _action$payload26.error;

      if (!draft.byId[mapId]) {
        return;
      }

      draft.byId[mapId].mapPresetError = error;
    }
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(addLayer$1, function (draft, action) {
      var _action$payload27 = action.payload,
          layerId = _action$payload27.layerId,
          mapId = _action$payload27.mapId;

      if (!draft.byId[mapId]) {
        return;
      }

      if (checkIfMapLayerIdIsAlreadyTaken(draft, layerId)) {
        console.warn("Warning: Layer id ".concat(layerId, " was already taken"));
        return;
      }

      if (!draft.byId[mapId].mapLayers.length) {
        draft.byId[mapId].activeLayerId = layerId;
      }

      draft.byId[mapId].mapLayers.unshift(layerId);
    }).addCase(addBaseLayer, function (draft, action) {
      var _action$payload28 = action.payload,
          layer = _action$payload28.layer,
          layerId = _action$payload28.layerId,
          mapId = _action$payload28.mapId;

      if (!draft.byId[mapId]) {
        return;
      }

      if (checkIfMapLayerIdIsAlreadyTaken(draft, layerId)) {
        console.warn("Warning: Layer id ".concat(layerId, " was already taken"));
        return;
      }

      if (layer.layerType === LayerType.baseLayer) {
        draft.byId[mapId].baseLayers.unshift(layerId);
        return;
      }

      if (layer.layerType === LayerType.overLayer) {
        draft.byId[mapId].overLayers.unshift(layerId);
      }
    }).addCase(setLayers, function (draft, action) {
      var mapId = action.payload.mapId;
      var layersWithIds = createLayersWithIds(draft, action.payload.layers);
      var layerIds = layersWithIds.map(function (_ref) {
        var id = _ref.id;
        return id;
      });

      var _layerIds = _slicedToArray(layerIds, 1),
          activeLayerId = _layerIds[0];

      if (draft.byId[mapId]) {
        draft.byId[mapId].mapLayers = layerIds;
        draft.byId[mapId].activeLayerId = activeLayerId;
        var webmapInstance = getWMJSMapById(mapId);

        if (webmapInstance) {
          var mapDims = webmapInstance.getDimensionList();

          if (mapDims) {
            draft.byId[mapId].dimensions = mapDims.map(function (dim) {
              return {
                name: dim.name,
                currentValue: dim.currentValue,
                units: dim.units
              };
            });
          }
        }
      }
    }).addCase(setBaseLayers$1, function (draft, action) {
      var _action$payload29 = action.payload,
          layers = _action$payload29.layers,
          mapId = _action$payload29.mapId; // Split into base and overlayers

      var baseLayers = [];
      var overLayers = [];
      layers.forEach(function (layer) {
        if (layer.layerType === LayerType.overLayer) {
          overLayers.push(layer);
        } else if (layer.layerType === LayerType.baseLayer) {
          baseLayers.push(layer);
        }
      });
      var baseLayersWithIds = createLayersWithIds(draft, baseLayers);
      var overLayersWithIds = createLayersWithIds(draft, overLayers);
      var baseLayerIds = baseLayersWithIds.map(function (_ref2) {
        var id = _ref2.id;
        return id;
      });
      var overLayerIds = overLayersWithIds.map(function (_ref3) {
        var id = _ref3.id;
        return id;
      });

      if (draft.byId[mapId]) {
        if (baseLayerIds.length !== 0) draft.byId[mapId].baseLayers = baseLayerIds;
        if (overLayerIds.length !== 0) draft.byId[mapId].overLayers = overLayerIds;
      }
    }).addCase(layerDelete$1, function (draft, action) {
      var _action$payload30 = action.payload,
          mapId = _action$payload30.mapId,
          layerId = _action$payload30.layerId;

      if (!draft.byId[mapId]) {
        return;
      }

      draft.byId[mapId].mapLayers = draft.byId[mapId].mapLayers.filter(function (id) {
        return id !== layerId;
      }); // if activeLayer is deleted, change activeLayerId

      if (draft.byId[mapId].activeLayerId === layerId && draft.byId[mapId].mapLayers.length) {
        var _draft$byId$mapId$map = _slicedToArray(draft.byId[mapId].mapLayers, 1),
            activeLayerId = _draft$byId$mapId$map[0];

        draft.byId[mapId].activeLayerId = activeLayerId;
      }

      if (!draft.byId[mapId].mapLayers.length) {
        draft.byId[mapId].activeLayerId = '';
      }
    }).addCase(baseLayerDelete, function (draft, action) {
      var _action$payload31 = action.payload,
          mapId = _action$payload31.mapId,
          layerId = _action$payload31.layerId;

      if (!draft.byId[mapId]) {
        return;
      }

      draft.byId[mapId].baseLayers = draft.byId[mapId].baseLayers.filter(function (id) {
        return id !== layerId;
      });
      draft.byId[mapId].overLayers = draft.byId[mapId].overLayers.filter(function (id) {
        return id !== layerId;
      });
    }).addCase(layerChangeDimension$1, function (draft, action) {
      var _action$payload32 = action.payload,
          layerId = _action$payload32.layerId,
          dimension = _action$payload32.dimension;
      produceDraftStateSetMapDimensionFromLayerChangeDimension(draft, layerId, dimension);
    }).addCase(setTimeSync, function (draft, action) {
      var _action$payload33 = action.payload,
          targetsFromAction = _action$payload33.targets,
          source = _action$payload33.source;
      /* Because we want backwards compatibility with the previous code, we also need to listen to the original source action */

      var targets = [{
        targetId: source.payload.sourceId,
        value: source.payload.value
      }];
      /* And then append the targets form the action */

      targets.push.apply(targets, _toConsumableArray(targetsFromAction));
      targets.forEach(function (target) {
        var targetId = target.targetId,
            value = target.value;

        if (draft.byId[targetId]) {
          var dimension = {
            name: 'time',
            currentValue: value
          };
          produceDraftStateSetWebMapDimension(draft, targetId, dimension, true);
          produceDraftStateSetMapDimensionFromLayerChangeDimension(draft, targetId, dimension);
        }
      });
    }).addCase(setBboxSync, function (draft, action) {
      var _action$payload34 = action.payload,
          targetsFromAction = _action$payload34.targets,
          source = _action$payload34.source;
      /* Because we want backwards compatibility with the previous code, we also need to listen to the original source action */

      var targets = [{
        targetId: source.payload.sourceId,
        bbox: source.payload.bbox,
        srs: source.payload.srs
      }];
      /* And then append the targets form the action */

      targets.push.apply(targets, _toConsumableArray(targetsFromAction));
      targets.forEach(function (payload) {
        var targetId = payload.targetId,
            bbox = payload.bbox,
            srs = payload.srs;

        if (draft.byId[targetId]) {
          if (bbox) {
            draft.byId[targetId].bbox = bbox;
          }

          if (srs) draft.byId[targetId].srs = srs;
        }
      });
    }).addCase(setLayerActionSync, function (draft, action) {
      /*
       * This GENERIC_SYNC_SETLAYERACTIONS action is generated by the syncgroup saga.
       * It has multiple targets (Layers) in its payload.
       * These targets can be used as payloads in new Layer actions.
       * These actions are here handled via the layer reducer, as it is the same logic
       */
      var _action$payload35 = action.payload,
          targets = _action$payload35.targets,
          source = _action$payload35.source;
      return targets.reduce(function (prevState, target) {
        var action = {
          payload: target,
          type: source.type
        };
        /* Handle the Layer action with the same logic, using the same reducer */

        return reducer$2(prevState, action);
      }, draft);
    }).addCase(onUpdateLayerInformation, function (draft, action) {
      var mapDimensions = action.payload.mapDimensions;
      if (mapDimensions === null) return draft;
      var mapAction = mapActions$1.mapUpdateAllMapDimensions(mapDimensions);
      return reducer$2(draft, mapAction);
    }).addCase(mapChangeDimension, function (draft, action) {
      var _action$payload36 = action.payload,
          mapId = _action$payload36.mapId,
          dimensionFromAction = _action$payload36.dimension;
      produceDraftStateSetWebMapDimension(draft, mapId, dimensionFromAction, true);
    }).addCase(setMapPreset, function (draft, action) {
      var mapId = action.payload.mapId;

      if (!draft.byId[mapId]) {
        return;
      } // reset preset state (currently setMapPreset saga is firing actions and these are setting values)


      draft.byId[mapId].baseLayers = [];
      draft.byId[mapId].mapLayers = [];
      draft.byId[mapId].overLayers = [];
      draft.byId[mapId].hasMapPresetChanges = false;
      draft.byId[mapId].isAutoUpdating = false;
      draft.byId[mapId].isAnimating = false;
      draft.byId[mapId].isTimeSliderVisible = true;
      draft.byId[mapId].isTimestepAuto = true;
      draft.byId[mapId].displayMapPin = false;
      draft.byId[mapId].shouldShowZoomControls = true;
      draft.byId[mapId].timeStep = defaultTimeStep;
      draft.byId[mapId].animationDelay = defaultAnimationDelayAtStart;
    }).addCase(uiActions.registerDialog, function (draft, action) {
      var _action$payload37 = action.payload,
          mapId = _action$payload37.mapId,
          type = _action$payload37.type;

      if (!draft.byId[mapId]) {
        return;
      }

      draft.byId[mapId].legendId = type;
    });
  }
});
var mapActions$1 = Object.assign(Object.assign({}, slice$2.actions), {
  setMapPreset: setMapPreset,
  mapChangeDimension: mapChangeDimension
});
var reducer$2 = slice$2.reducer;

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */

var layerStore = function layerStore(store) {
  return store && store.layers ? store.layers : null;
};
/**
 * Gets a layer from the layers part of the store by its Id
 *
 * Example: layer = getLayerById(store, 'layerId')
 * @param {object} store object from which the layer state will be extracted
 * @param {string} layerId Id of the layer
 * @returns {object} object containing layer information (service, name, style, enabled etc.)
 */


var getLayerById = function getLayerById(store, layerId) {
  if (store && store.layers && store.layers.byId[layerId]) {
    return store.layers.byId[layerId];
  }

  return null;
};
/**
 * Retrieves all layers indexed by layerId
 *
 * Example: layers = getLayersById(store)
 * @param {object} store store: object - object from which the layers state will be extracted
 * @returns {object} returnType: object - an object of all layers containing layer information (service, name, style, enabled etc.) indexed by layerId
 */

var getLayersById = createSelector(layerStore, function (store) {
  return store ? store.byId : null;
}, selectorMemoizationOptions);
/**
 * Retrieves all layerIds
 *
 * Example: layerIds = getLayersIds(store)
 * @param {object} store store: object - object from which the layers state will be extracted
 * @returns {array} returnType: array - an array of all layerIds
 */

var getLayersIds = createSelector(layerStore, function (store) {
  return store ? store.allIds : [];
}, selectorMemoizationOptions);
/**
 * Retrieves all layers (including base layers and overlayers)
 *
 * Example: layers = getAllLayers(store)
 * @param {object} store store: object - object from which the layers state will be extracted
 * @returns {array} returnType: array - an array of all layers containing layer information (service, name, style, enabled etc.)
 */

var getAllLayers = createSelector(getLayersIds, getLayersById, function (ids, layers) {
  return ids.map(function (layerId) {
    return layers[layerId];
  });
}, selectorMemoizationOptions);
/**
 * Retrieves all layers that aren't base layers and aren't overlayers
 *
 * Example: layers = getLayers(store)
 * @param {object} store store: object - object from which the layers state will be extracted
 * @returns {array} returnType: array - an array of all non-baselayers containing layer information (service, name, style, enabled etc.)
 */

createSelector(getAllLayers, function (layers) {
  return layers.filter(function (layer) {
    return layer.layerType !== LayerType.baseLayer && layer.layerType !== LayerType.overLayer;
  });
}, selectorMemoizationOptions);
/**
 * Retrieves all baselayers
 *
 * Example: layers = getBaseLayers(store)
 * @param {object} store store: object - object from which the layers state will be extracted
 * @returns {array} returnType: array - an array of all baselayers containing layer information (service, name, style, enabled etc.)
 */

createSelector(getAllLayers, function (layers) {
  return layers.filter(function (layer) {
    return layer.layerType === LayerType.baseLayer;
  });
}, selectorMemoizationOptions);
/**
 * Retrieves all overLayers
 *
 * Example: layers = getOverLayers(store)
 * @param {object} store store: object - object from which the layers state will be extracted
 * @returns {array} returnType: array - an array of all overLayers containing layer information (service, name, style, enabled etc.)
 */

createSelector(getAllLayers, function (layers) {
  return layers.filter(function (layer) {
    return layer.layerType === LayerType.overLayer;
  });
}, selectorMemoizationOptions);
/**
 * Gets dimensions of the passed layer
 *
 * Example: layerDimensions = getLayerDimensions(store, 'layerId_1')
 * @param {object} store store: object - object from which the layers state will be extracted
 * @param {string} layerId layerId: string - Id of the layer
 * @returns {array} returnType: Dimension[] - array containing layer dimensions
 */

var getLayerDimensions = createSelector(getLayerById, function (layer) {
  return layer && layer.dimensions ? layer.dimensions : [];
}, selectorMemoizationOptions);
/**
 * Gets dimensions of the passed layer, excluding the time dimension
 *
 * Example: layerNonTimeDimensions = getLayerNonTimeDimensions(store, 'layerId_1')
 * @param {object} store store: object - object from which the layers state will be extracted
 * @param {string} layerId layerId: string - Id of the layer
 * @returns {array} returnType: Dimension[] - array containing layer dimensions, excluding the time dimension
 */

var getLayerNonTimeDimensions = createSelector(getLayerDimensions, function (dimensions) {
  return filterNonTimeDimensions(dimensions);
}, selectorMemoizationOptions);
/**
 * Gets time dimension of the passed layer
 *
 * Example: timeDimension = getLayerTimeDimension(store, 'layerId_1')
 * @param {object} store store: object - object from which the layers state will be extracted
 * @param {string} layerId layerId: string - Id of the layer
 * @returns {object} returnType: object - object of layer time dimension
 */

var getLayerTimeDimension = createSelector(getLayerDimensions, function (dimensions) {
  return dimensions && dimensions.length ? dimensions.find(function (dimension) {
    return dimension.name === 'time';
  }) : {};
}, selectorMemoizationOptions);
/**
 * Gets specified dimension of the passed layer
 *
 * Example: dimension = getLayerDimension(store, 'layerId_1', 'elevation')
 * @param {object} store store: object - object from which the layers state will be extracted
 * @param {string} layerId layerId: string - Id of the layer
 * @param {string} dimensionName dimensionName: string - name of dimension you want to retrieve the dimension data for
 * @returns {object} returnType: object - object of layer dimension
 */

var getLayerDimension = createSelector(getLayerDimensions, function (_store, _layerId, dimensionName) {
  return dimensionName;
}, function (dimensions, dimensionName) {
  return dimensions && dimensions.length ? dimensions.find(function (dimension) {
    return dimension.name === dimensionName;
  }) : {};
}, selectorMemoizationOptions);
/**
 * Gets opacity of the passed layer
 *
 * Example: layerOpacity = getLayerOpacity(store, 'layerId_1')
 * @param {object} store store: object - object from which the layers state will be extracted
 * @param {string} layerId layerId: string - Id of the layer
 * @returns {number} returnType: number - opacity as a number (between 0 and 1)
 */

var getLayerOpacity = createSelector(getLayerById, function (layer) {
  return layer && layer.opacity ? layer.opacity : 0;
});
/**
 * Gets whether a layer is enabled or disabled
 *
 * Example: isLayerEnabled = getLayerEnabled(store, 'layerId_1')
 * @param {object} store store: object - object from which the layers state will be extracted
 * @param {string} layerId layerId: string - Id of the layer
 * @returns {boolean} returnType: boolean -  true if enabled, false if disabled
 */

var getLayerEnabled = createSelector(getLayerById, function (layer) {
  return layer && layer.enabled ? layer.enabled : false;
});
/**
 * Gets layer name
 *
 * Example: layerName = getLayerName(store, 'layerId_1')
 * @param {object} store store: object - object from which the layers state will be extracted
 * @param {string} layerId layerId: string - Id of the layer
 * @returns {string} returnType: string -  layer name
 */

var getLayerName = createSelector(getLayerById, function (layer) {
  return layer && layer.name && layer.name.length > 0 ? layer.name : '';
});
/**
 * Gets layer service
 *
 * Example: layerService = getLayerService(store, 'layerId_1')
 * @param {object} store store: object - object from which the layers state will be extracted
 * @param {string} layerId layerId: string - Id of the layer
 * @returns {string} returnType: string -  layer service
 */

var getLayerService = createSelector(getLayerById, function (layer) {
  return layer && layer.service ? layer.service : '';
});
/**
 * Gets selected style of the passed layer
 *
 * Example: layerStyle = getLayerStyle(store, 'layerId_1')
 * @param {object} store store: object - object from which the layers state will be extracted
 * @param {string} layerId layerId: string - Id of the layer
 * @returns {string} returnType: string - style that is currently selected
 */

var getLayerStyle = createSelector(getLayerById, function (layer) {
  return layer && layer.style ? layer.style : '';
});
/**
 * Gets layer status
 *
 * Example: layerService = getLayerStatus(store, 'layerId_1')
 * @param {object} store store: object - object from which the layers state will be extracted
 * @param {string} layerId layerId: string - Id of the layer
 * @returns {string} returnType: LayerStatus
 */

createSelector(getLayerById, function (layer) {
  return layer && layer.status ? layer.status : LayerStatus["default"];
});
/**
 * Gets all available base layers for a map
 *
 * Example: availableBaseLayers = getAvailableBaseLayersForMap(store)
 * @param {object} store store: object - object from which the layer state will be extracted
 * @param {string} mapId mapId: string - Id of the map we want to retrieve the available baselayers for
 * @returns {array} returnType: array - array containing all available base layers
 */

var getAvailableBaseLayersForMap = createSelector(layerStore, function (_store, _mapId) {
  return _mapId;
}, function (layerStore, mapId) {
  if (layerStore && layerStore.availableBaseLayers) {
    var availableBaseLayers = layerStore.availableBaseLayers;
    return availableBaseLayers.allIds.reduce(function (list, layerId) {
      if (availableBaseLayers.byId[layerId].mapId === mapId) {
        return list.concat(availableBaseLayers.byId[layerId]);
      }

      return list;
    }, []);
  }

  return [];
}, selectorMemoizationOptions);

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */
var getUiStore = function getUiStore(store) {
  if (store && store.ui) {
    return store.ui;
  }

  return null;
};
/**
 * Gets the active map Id and wether a dialog is open or closed
 *
 * Example: getDialogDetailsByType(store, 'legend')
 * @param {object} store store object from which the ui state wll be extracted
 * @param {string} dialogType type of the dialog 'legend' | 'layerManager' | 'dimensionSelect-elevation'
 * @returns {array} [string, boolean] first element gives the active map id, second element whether the dialog is open
 */

var getDialogDetailsByType = function getDialogDetailsByType(store, dialogType) {
  if (store && store.ui && store.ui.dialogs && store.ui.dialogs[dialogType]) {
    return store.ui.dialogs[dialogType];
  }

  return null;
};
/**
 * For a given ui component: gets wether the dialog is open or closed
 *
 * @param {object} store store object from which the ui state wll be extracted
 * @param {string} dialogType type of the dialog 'legend' | 'layerManager' | 'dimensionSelect-elevation'
 * @returns {boolean} returnType: boolean
 */

var getisDialogOpen = createSelector(getDialogDetailsByType, function (details) {
  if (details) {
    return details.isOpen;
  }

  return false;
});
/**
 *For a given ui component: gets the active map Id
 *
 * @param {object} store store object from which the ui state wll be extracted
 * @param {string} dialogType type of the dialog 'legend' | 'layerManager' | 'dimensionSelect-elevation'
 * @returns {string} returnType: string - the active map id
 */

var getDialogMapId = createSelector(getDialogDetailsByType, function (details) {
  if (details) {
    return details.activeMapId;
  }

  return '';
});
/**
 *For a given ui component: gets the order of visible dialog
 *
 * @param {object} store store object from which the ui state wll be extracted
 * @param {DialogType} dialogType type of the dialog 'legend' | 'layerManager' | 'dimensionSelect-elevation' | dimensionSelect-ensemble_member
 * @returns {number} the higher the order number the higher the zIndex
 */

var getDialogOrder = createSelector(function (store, dialogType) {
  if (store && store.ui && store.ui.order) {
    var order = store.ui.order;
    var visibleOrder = order.filter(function (orderedDialogType) {
      return store.ui.dialogs[orderedDialogType].isOpen;
    });

    if (!visibleOrder.includes(dialogType)) {
      return 0;
    }

    return visibleOrder.length - visibleOrder.indexOf(dialogType);
  }

  return 0;
}, function (order) {
  return order;
});
/**
 *For a given ui component: returns if ordered on top
 *
 * @param {object} store store object from which the ui state wll be extracted
 * @param {DialogType} dialogType type of the dialog 'legend' | 'layerManager' | 'dimensionSelect-elevation' | dimensionSelect-ensemble_member
 * @returns {boolean}
 */

var getDialogIsOrderedOnTop = createSelector(function (store, dialogType) {
  if (store && store.ui && store.ui.order) {
    var order = store.ui.order;
    return order.includes(dialogType) && order.indexOf(dialogType) === 0;
  }

  return false;
}, function (isOrderedOnTop) {
  return isOrderedOnTop;
});
var getDialogSource = createSelector(getDialogDetailsByType, function (details) {
  if (details && details.source) {
    return details.source;
  }

  return 'app';
});
/**
 * Get the active window that should receive keyboard shortcuts
 *
 * Example: getActiveWindowId(store)
 * @param {object} store store object from which the window state will be extracted
 * @returns {string} active window id
 */

var getActiveWindowId = function getActiveWindowId(store) {
  var _a;

  return (_a = store === null || store === void 0 ? void 0 : store.ui) === null || _a === void 0 ? void 0 : _a.activeWindowId;
};

var selectors$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getUiStore: getUiStore,
  getDialogDetailsByType: getDialogDetailsByType,
  getisDialogOpen: getisDialogOpen,
  getDialogMapId: getDialogMapId,
  getDialogOrder: getDialogOrder,
  getDialogIsOrderedOnTop: getDialogIsOrderedOnTop,
  getDialogSource: getDialogSource,
  getActiveWindowId: getActiveWindowId
});

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */

/* Type constants */
var SYNCGROUPS_TYPE_SETTIME = 'SYNCGROUPS_TYPE_SETTIME';
var SYNCGROUPS_TYPE_SETBBOX = 'SYNCGROUPS_TYPE_SETBBOX';
var SYNCGROUPS_TYPE_SETLAYERACTIONS = 'SYNCGROUPS_TYPE_SETLAYERACTIONS';
var SYNCGROUPS_SET_VIEW_STATE = 'SYNCGROUPS_SET_VIEW_STATE';

var constants = /*#__PURE__*/Object.freeze({
  __proto__: null,
  SYNCGROUPS_TYPE_SETTIME: SYNCGROUPS_TYPE_SETTIME,
  SYNCGROUPS_TYPE_SETBBOX: SYNCGROUPS_TYPE_SETBBOX,
  SYNCGROUPS_TYPE_SETLAYERACTIONS: SYNCGROUPS_TYPE_SETLAYERACTIONS,
  SYNCGROUPS_SET_VIEW_STATE: SYNCGROUPS_SET_VIEW_STATE
});

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */

/**
 * The removeInPlace() method modifies an array in place, by removing elements that pass the test implemented by the provided function.
 *
 * NOTE: This should only be used on draft properties as provided by the immer produce library, as modifying elements in place is bad practice on non draft variables.
 *
 * @param inDraftArray The draft array to filter, will be modified in place.
 * @param condition Function to check each element in the array
 */
var removeInPlace = function removeInPlace(inDraftArray, condition) {
  var j = 0;
  inDraftArray.forEach(function (e, i) {
    if (!condition(e)) {
      // eslint-disable-next-line no-param-reassign
      if (i !== j) inDraftArray[j] = e;
      j += 1;
    }
  }); // eslint-disable-next-line no-param-reassign

  inDraftArray.length = j;
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */
var initialState$1 = {
  sources: {
    byId: {},
    allIds: []
  },
  groups: {
    byId: {},
    allIds: []
  },
  viewState: {
    timeslider: {
      groups: [],
      sourcesById: []
    },
    zoompane: {
      groups: [],
      sourcesById: []
    },
    level: {
      groups: [],
      sourcesById: []
    }
  }
};
var slice$1 = createSlice({
  initialState: initialState$1,
  name: 'synchronizationGroupsReducer',
  reducers: {
    syncGroupAddSource: function syncGroupAddSource(draft, action) {
      var _action$payload = action.payload,
          id = _action$payload.id,
          payloadType = _action$payload.type,
          defaultPayload = _action$payload.defaultPayload;

      if (!draft.sources.byId[id]) {
        draft.sources.byId[id] = {
          types: payloadType,
          payloadByType: {
            SYNCGROUPS_TYPE_SETTIME: defaultPayload,
            SYNCGROUPS_TYPE_SETBBOX: defaultPayload,
            SYNCGROUPS_TYPE_SETLAYERACTIONS: defaultPayload
          }
        };
        draft.sources.allIds.push(id);
      }
      /* Now try to initialize with the correct values from the state */


      draft.groups.allIds.forEach(function (groupId) {
        var syncronizationGroup = draft.groups.byId[groupId];
        /* Check if the source is in the target list of the synchonizationGroup */

        var source = syncronizationGroup.targets.byId[id];
        var type = syncronizationGroup.type;
        /* If the source is part of the target list, and is linked, continue syncing the other targets */

        if (source && source.linked) {
          draft.sources.byId[id].payloadByType[type] = syncronizationGroup.payloadByType && syncronizationGroup.payloadByType[type] || defaultPayload;
        }
      });
    },
    syncGroupRemoveSource: function syncGroupRemoveSource(draft, action) {
      var id = action.payload.id;

      if (draft.sources.byId[id]) {
        delete draft.sources.byId[id];
        removeInPlace(draft.sources.allIds, function (_id) {
          return _id === id;
        });
      }
    },
    syncGroupAddTarget: function syncGroupAddTarget(draft, action) {
      var state = current(draft);
      var _action$payload2 = action.payload,
          groupId = _action$payload2.groupId,
          targetId = _action$payload2.targetId,
          linked = _action$payload2.linked;

      if (!draft.groups.byId[groupId]) {
        console.warn("SYNCGROUPS_ADD_TARGET: Group ".concat(groupId, " does not exist."));
        return;
      }

      if (!targetId) {
        console.warn("SYNCGROUPS_ADD_TARGET: targetId is not defined.");
        return;
      }

      if (draft.groups.byId[groupId].targets.allIds.includes(targetId)) {
        return;
      }

      draft.groups.byId[groupId].targets.allIds.push(targetId);
      draft.groups.byId[groupId].targets.byId[targetId] = {
        linked: linked !== false
      };
      /* Now try to initialize with the correct values from the state */

      var syncronizationGroup = state.groups.byId[groupId];
      /* Check if the source is in the target list of the synchonizationGroup */

      var source = state.groups.byId[groupId].targets.byId[targetId];
      /* If the source is part of the target list, and is linked, continue syncing the other targets */

      if (source && source.linked) {
        var type = syncronizationGroup.type;
        draft.sources.byId[targetId].payloadByType[type] = syncronizationGroup.payloadByType[type];
      }
    },
    syncGroupRemoveTarget: function syncGroupRemoveTarget(draft, action) {
      var _action$payload3 = action.payload,
          groupId = _action$payload3.groupId,
          targetId = _action$payload3.targetId;
      if (!draft.groups.byId[groupId]) return;
      if (!draft.groups.byId[groupId].targets.allIds.includes(targetId)) return;
      delete draft.groups.byId[groupId].targets.byId[targetId];
      removeInPlace(draft.groups.byId[groupId].targets.allIds, function (_id) {
        return _id === targetId;
      });
    },
    syncGroupLinkTarget: function syncGroupLinkTarget(draft, action) {
      var _action$payload4 = action.payload,
          groupId = _action$payload4.groupId,
          targetId = _action$payload4.targetId,
          linked = _action$payload4.linked;

      if (!draft.groups.byId[groupId] || !draft.groups.byId[groupId].targets.byId[targetId]) {
        return;
      }

      draft.groups.byId[groupId].targets.byId[targetId].linked = linked;
    },
    syncGroupAddGroup: function syncGroupAddGroup(draft, action) {
      var _action$payload5 = action.payload,
          groupId = _action$payload5.groupId,
          type = _action$payload5.type,
          title = _action$payload5.title;

      if (draft.groups.byId[groupId]) {
        return;
      }

      draft.groups.byId[groupId] = {
        title: title,
        type: type,
        payloadByType: {
          SYNCGROUPS_TYPE_SETTIME: null,
          SYNCGROUPS_TYPE_SETBBOX: null
        },
        targets: {
          allIds: [],
          byId: {}
        }
      };
      draft.groups.allIds.push(groupId);
    },
    syncGroupRemoveGroup: function syncGroupRemoveGroup(draft, action) {
      var groupId = action.payload.groupId;

      if (!draft.groups.byId[groupId]) {
        return;
      }

      delete draft.groups.byId[groupId];
      removeInPlace(draft.groups.allIds, function (_groupId) {
        return _groupId === groupId;
      });
    },
    syncGroupClear: function syncGroupClear() {
      return initialState$1;
    },
    syncGroupSetViewState: function syncGroupSetViewState(draft, action) {
      var viewState = action.payload.viewState;
      draft.viewState = viewState;
    }
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(setTimeSync, function (draft, action) {
      return setBboxOrTimeSync(draft, action);
    }).addCase(setBboxSync, function (draft, action) {
      return setBboxOrTimeSync(draft, action);
    });
  }
});

var setBboxOrTimeSync = function setBboxOrTimeSync(state, action) {
  return produce(state, function (draft) {
    var _action$payload6 = action.payload,
        targets = _action$payload6.targets,
        source = _action$payload6.source,
        groups = _action$payload6.groups;

    var getPayLoadKey = function getPayLoadKey(type) {
      switch (type) {
        case setTimeSync.type:
          return SYNCGROUPS_TYPE_SETTIME;

        case setBboxSync.type:
          return SYNCGROUPS_TYPE_SETBBOX;

        default:
          return null;
      }
    };

    var payloadKey = getPayLoadKey(action.type);

    if (!source.payload || !payloadKey) {
      console.warn('Wrong sync action: ', action);
      return;
    }

    if (draft.sources.byId[source.payload.sourceId]) {
      if (!draft.sources.byId[source.payload.sourceId].payloadByType) {
        draft.sources.byId[source.payload.sourceId].payloadByType = {};
      }

      draft.sources.byId[source.payload.sourceId].payloadByType[payloadKey] = source.payload;
    }
    /* Update all targets */


    targets.forEach(function (target) {
      if (draft.sources.byId[target.targetId]) {
        if (!draft.sources.byId[target.targetId].payloadByType) {
          draft.sources.byId[target.targetId].payloadByType = {};
        }

        draft.sources.byId[target.targetId].payloadByType[payloadKey] = source.payload;
      }
    });
    /* Set the value in the group */

    groups.forEach(function (group) {
      if (draft.groups.byId[group]) {
        draft.groups.byId[group].payloadByType[payloadKey] = source.payload;
      }
    });
  });
};

var _slice$actions = slice$1.actions,
    syncGroupAddGroup = _slice$actions.syncGroupAddGroup,
    syncGroupAddSource = _slice$actions.syncGroupAddSource,
    syncGroupAddTarget = _slice$actions.syncGroupAddTarget;
    _slice$actions.syncGroupClear;
    var syncGroupLinkTarget = _slice$actions.syncGroupLinkTarget,
    syncGroupRemoveGroup = _slice$actions.syncGroupRemoveGroup,
    syncGroupRemoveSource = _slice$actions.syncGroupRemoveSource,
    syncGroupRemoveTarget = _slice$actions.syncGroupRemoveTarget,
    syncGroupSetViewState = _slice$actions.syncGroupSetViewState;
var actions = slice$1.actions,
    reducer$1 = slice$1.reducer;

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */
var SyncGroupTypeList = [SYNCGROUPS_TYPE_SETBBOX, SYNCGROUPS_TYPE_SETTIME];
var SyncGroupActionOrigin;

(function (SyncGroupActionOrigin) {
  SyncGroupActionOrigin["delete"] = "ORIGIN_GENERIC_SYNCHRONIZATIONGROUP_UTILS_DELETEACTION";
  SyncGroupActionOrigin["layerActions"] = "ORIGIN_GENERIC_SYNCHRONIZATIONGROUP_UTILS_LAYERACTIONS";
  SyncGroupActionOrigin["move"] = "ORIGIN_GENERIC_SYNCHRONIZATIONGROUP_UTILS_MOVEACTION";
  SyncGroupActionOrigin["add"] = "ORIGIN_GENERIC_SYNCHRONIZATIONGROUP_UTILS_ADDACTION";
  SyncGroupActionOrigin["activateLayerId"] = "ORIGIN_GENERIC_SYNCHRONIZATIONGROUP_UTILS_ACTIVELAYERIDACTION";
})(SyncGroupActionOrigin || (SyncGroupActionOrigin = {}));

var types$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  SyncGroupTypeList: SyncGroupTypeList,
  get SyncGroupActionOrigin () { return SyncGroupActionOrigin; }
});

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  actions: actions,
  constants: constants,
  types: types$1,
  initialState: initialState$1
});

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */

var synchronizationGroupStore = function synchronizationGroupStore(store) {
  return store && store.syncronizationGroupStore ? store.syncronizationGroupStore : null;
};

var getSynchronizationGroupStore = createSelector(synchronizationGroupStore, function (store) {
  return store;
});
/**
 * Returns the synchronization source by id
 * @param store The app store
 * @param id The source id to find
 */

var getSyncSourceBySourceId = function getSyncSourceBySourceId(state, id) {
  if (state && state.sources) {
    var sources = state.sources;

    if (sources.byId[id]) {
      return sources.byId[id];
    }
  }

  return null;
};

var getTime = createSelector(getSyncSourceBySourceId, function (store) {
  return store && store.payloadByType && store.payloadByType[SYNCGROUPS_TYPE_SETTIME] ? store.payloadByType[SYNCGROUPS_TYPE_SETTIME].value : null;
});

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2022 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2022 - Finnish Meteorological Institute (FMI)
 * */
var genericActions = Object.assign(Object.assign({}, actions), {
  setTime: setTime,
  setBbox: setBbox
});

/**
 * Gets the map state by mapId
 *
 * Example: getMapById(store, 'mapid_1')
 * @param {object} store store object from which the map state wll be extracted
 * @param {string} mapId Id of the map
 * @returns {object} object containing map state (isAnimating, bbox, baseLayers, layers etc.)
 */

var getMapById = function getMapById(store, mapId) {
  if (store && store.webmap && store.webmap.byId[mapId]) {
    return store.webmap.byId[mapId];
  }

  return null;
};
/**
 * Gets all mapIds
 *
 * Example: getAllMapIds(store)
 * @param {object} store store object from which the map state wll be extracted
 * @returns {array} array containing all map ids
 */

var getAllMapIds = function getAllMapIds(store) {
  if (store && store.webmap && store.webmap.allIds) {
    return store.webmap.allIds;
  }

  return [];
};
/**
 * Gets the map state of the first map in the store
 *
 * Example: getFirstMap(store)
 * @param {object} store store object from which the map state wll be extracted
 * @returns {object} object containing map state (isAnimating, bbox, baseLayers, layers etc.)
 */

var getFirstMap = createSelector(getAllMapIds, function (store) {
  return store && store.webmap && store.webmap.byId ? store.webmap.byId : {};
}, function (allMapIds, mapsById) {
  return allMapIds[0] && mapsById[allMapIds[0]] ? mapsById[allMapIds[0]] : null;
}, selectorMemoizationOptions);
/**
 * Gets the id of first map in store
 *
 * Example: getFirstMapId(store)
 * @param {object} store store: object from which the map state wll be extracted
 * @returns {string} returnType:string - map id
 */

var getFirstMapId = createSelector(getFirstMap, function (map) {
  return map ? map.id : '';
});
/**
 * Determines if map is present
 *
 * @param {object} store store: object - store object
 * @param {string} mapId mapId: string - Id of the map
 * @returns {boolean} returnType:boolean - true if map is present
 */

var getIsMapPresent = createSelector(function (store, mapId) {
  if (store && store.webmap && store.webmap.byId[mapId]) {
    return true;
  }

  return false;
}, function (isPresent) {
  return isPresent;
});
/**
 * Gets all layerIds for a map that aren't baselayers or overlayers
 *
 * Example: layerIds = getLayerIds(store, 'mapid_1')
 * @param {object} store store: object - store object
 * @param {string} mapId mapId: string - Id of the map
 * @returns {array} returnType: array -  array containing all layerIds
 */

var getLayerIds = createSelector(getMapById, function (store) {
  return store ? store.mapLayers : [];
}, selectorMemoizationOptions);
/**
 * Gets all layer states for a map
 *
 * Example: layers = getMapLayers(store, 'mapid_1')
 * @param {object} store store: object - store object
 * @param {string} mapId mapId: string - Id of the map
 * @returns {array} returnType: array -  array containing all layer states for the map
 */

var getMapLayers = createSelector(getLayerIds, getLayersById, function (layerIds, layers) {
  return layerIds.map(function (layerId) {
    return layers[layerId];
  });
}, selectorMemoizationOptions);
/**
 * Gets an array of baselayers ids for a map
 *
 * Example: baseLayersId = getMapBaseLayersIds(store, 'mapid_1')
 * @param {object} store store: object - store object
 * @param {string} mapId mapId: string - Id of the map
 * @returns {array} returnType: array -  array containing an array of baselayers ids
 */

var getMapBaseLayersIds = createSelector(getMapById, function (store) {
  return store ? store.baseLayers : [];
}, selectorMemoizationOptions);
/**
 * Gets all baselayers for a map
 *
 * Example: baseLayers = getMapBaseLayers(store, 'mapid_1')
 * @param {object} store store: object - store object
 * @param {string} mapId mapId: string - Id of the map
 * @returns {array} returnType: array -  array containing all baselayers for the map
 */

var getMapBaseLayers = createSelector(getMapBaseLayersIds, getLayersById, function (layerIds, layers) {
  return layerIds.map(function (layerId) {
    return layers[layerId];
  });
}, selectorMemoizationOptions);
/**
 * Gets and array of overLayers ids for a map
 *
 * Example: overLayersId = getMapOverLayersIds(store, 'mapid_1')
 * @param {object} store store: object - store object
 * @param {string} mapId mapId: string - Id of the map
 * @returns {array} returnType: array -  array containing an array of overLayers ids
 */

var getMapOverLayersIds = createSelector(getMapById, function (store) {
  return store ? store.overLayers : [];
}, selectorMemoizationOptions);
/**
 * Gets all overLayers for a map
 *
 * Example: overLayers = getMapOverLayers(store, 'mapid_1')
 * @param {object} store store: object - store object
 * @param {string} mapId mapId: string - Id of the map
 * @returns {array} returnType: array -  array containing all overLayers for the map
 */

var getMapOverLayers = createSelector(getMapOverLayersIds, getLayersById, function (layerIds, layers) {
  return layerIds.map(function (layerId) {
    return layers[layerId];
  });
}, selectorMemoizationOptions);
/**
 * Gets map dimensions
 *
 * Example: mapDimensions = getMapDimensions(store, 'mapid_1')
 * @param {object} store store: object - store object
 * @param {string} mapId mapId: string - Id of the map
 * @returns {array} returnType: array - array containing map dimensions
 */

var getMapDimensions = createSelector(getMapById, function (store) {
  return store ? store.dimensions : [];
}, selectorMemoizationOptions);
/**
 * Gets the map dimension requested
 *
 * Example: mapDimensions = getMapDimension(store, 'mapid_1', 'elevation')
 * @param {object} store store: object - store object
 * @param {string} mapId mapId: string - Id of the map
 * @param {string} dimensionName dimensionName: string - name of the dimension
 * @returns {object} returnType: object - object containing the map dimension details
 */

var getMapDimension = createSelector(getMapById, function (_store, _mapId, dimensionName) {
  return dimensionName;
}, function (store, dimensionName) {
  if (store && store.dimensions) {
    return store.dimensions.find(function (dim) {
      return dim.name === dimensionName;
    });
  }

  return undefined;
}, selectorMemoizationOptions);
/**
 * Gets map srs
 *
 * Example: mapSrs = getSrs(store, 'mapid_1')
 * @param {object} store store: object - store object
 * @param {string} mapId mapId: string - Id of the map
 * @returns {string} returnType: string -  string containing srs
 */

var getSrs = createSelector(getMapById, function (store) {
  return store ? store.srs : '';
});
/**
 * Gets map bounding box
 *
 * Example: mapBbox = getBbox(store, 'mapid_1')
 * @param {object} store store: object - store object
 * @param {string} mapId mapId: string - Id of the map
 * @returns {object} returnType: object -  boundingbox object {left: number, bottom: number, right:number, top: number}
 */

var getBbox = createSelector(getMapById, function (store) {
  return store ? store.bbox : {};
}, selectorMemoizationOptions);
/**
 * Gets if map is animating
 *
 * Example: mapIsAnimating = isAnimating(store, 'mapid_1')
 * @param {object} store store: object - store object
 * @param {string} mapId mapId: string - Id of the map
 * @returns {boolean} returnType: boolean
 */

var isAnimating = createSelector(getMapById, function (store) {
  return store ? store.isAnimating : false;
});
/**
 * Gets if any linked map is animating
 *
 * Example: linkedMapIsAnimating = linkedMapAnimationInfo(store, 'mapid_1')
 * @param {object} store store: object - store object
 * @param {string} mapId mapId: string - Id of the map
 * @returns {object} returnType: object - object containing isAnimating boolean and id string
 */

var linkedMapAnimationInfo = createSelector(function (store, mapId) {
  var animationInfo = {
    isAnimating: isAnimating(store, mapId),
    id: mapId
  };
  getSynchronizationGroupStore(store).groups.allIds.forEach(function (groupId) {
    if (getSynchronizationGroupStore(store).groups.byId[groupId].targets.byId[animationInfo.id] && getSynchronizationGroupStore(store).groups.byId[groupId].targets.byId[animationInfo.id].linked) {
      getSynchronizationGroupStore(store).groups.byId[groupId].targets.allIds.forEach(function (id) {
        if (isAnimating(store, id) === true) {
          animationInfo.isAnimating = true;
          animationInfo.id = id;
        }
      });
    }
  });
  return animationInfo;
}, function (animationInfo) {
  return animationInfo;
});
/**
 * Gets start time of animation
 *
 * Example: endTimeOfAnimetion = getAnimationStartTime(store, 'mapid_1')
 * @param {object} store store: object - store object
 * @param {string} mapId mapId: string - Id of the map
 * @returns {string} returnType: string
 */

var getAnimationStartTime = createSelector(getMapById, function (store) {
  return store ? store.animationStartTime : moment.utc().subtract(6, 'h').format(dateFormat);
});
/**
 * Gets end time of animation
 *
 * Example: endTimeOfAnimation = getAnimationEndTime(store, 'mapid_1')
 * @param {object} store store: object - store object
 * @param {string} mapId mapId: string - Id of the map
 * @returns {string} returnType: string
 */

var getAnimationEndTime = createSelector(getMapById, function (store) {
  return store ? store.animationEndTime : moment.utc().subtract(10, 'm').format(dateFormat);
});
/**
 * Returns map is auto updating
 *
 * Example: isAutoUpdating = isAutoUpdating(store, 'mapid_1')
 * @param {object} store store: object - store object
 * @param {string} mapId mapId: string - Id of the map
 * @returns {boolean} returnType: boolean
 */

var isAutoUpdating = createSelector(getMapById, function (store) {
  return store ? store.isAutoUpdating : false;
});
/**
 * Gets activeLayerId for map
 *
 * example: activeLayerId = getActiveLayerId(store, 'mapid_1')
 * @param {object} store store: object - store object
 * @param {string} mapId mapId: string - Id of the map
 */

var getActiveLayerId = createSelector(getMapById, function (store) {
  return store ? store.activeLayerId : '';
});
/**
 * Gets scale of a time slider of a map
 *
 * Example: scale = getScale(store, 'mapid_1')
 * @param {object} store store: object - store object
 * @param {string} mapId mapId: string - Id of the map
 * @returns {Scale} returnType: Scale -  scale as an enum
 */

var getMapTimeSliderScale = createSelector(getMapById, function (store) {
  return store ? store.timeSliderScale : Scale.Hour;
});
/**
 * Gets time step of a map
 *
 * Example: timeStep = getTimeStep(store, 'mapid_1')
 * @param {object} store store: object - store object
 * @param {string} mapId mapId: string - Id of the map
 * @returns {number} returnType: number - time step as a number
 */

var getMapTimeStep = createSelector(getMapById, function (store) {
  return store ? store.timeStep : defaultTimeStep;
});
/**
 * Returns the speed of animation
 *
 * Example: speed = getSpeed(store, 'mapid_1')
 * @param {object} store store: object - store object
 * @param {string} mapId mapId: string - Id of the map
 * @returns {number} returnType: number - speed as a number
 */

var getMapAnimationDelay = createSelector(getMapById, function (store) {
  return store ? store.animationDelay : defaultAnimationDelayAtStart;
});
/**
 * Returns the center time of time slider
 *
 * Example: centerTime = getCenterTime(store, 'mapid_1')
 * @param {object} store store: object - store object
 * @param {string} mapId mapId: string - Id of the map
 * @returns {number} returnType: number - center time as a unix timestamp
 */

var getMapTimeSliderCenterTime = createSelector(getMapById, function (store) {
  return store ? store.timeSliderCenterTime : moment().unix();
});
/**
 * Returns the number of seconds per pixel on the time slider
 *
 * Example: secondsPerPx = getSecondsPerPx(store, 'mapid_1')
 * @param {object} store store: object - store object
 * @param {string} mapId mapId: string - Id of the map
 * @returns {number} returnType: number - the number of seconds per pixel
 */

var getMapTimeSliderSecondsPerPx = createSelector(getMapById, function (store) {
  return store ? store.timeSliderSecondsPerPx : 60;
});
/**
 * Returns the number of scale to seconds pixel on the time slider
 *
 * Example: dataScaleToSecondsPerPx = getMapTimeSliderDataScaleToSecondsPerPx(store, 'mapid_1')
 * @param {object} store store: object - store object
 * @param {string} mapId mapId: string - Id of the map
 * @returns {number} returnType: number - the number of scaleto seconds pixel
 */

var getMapTimeSliderDataScaleToSecondsPerPx = createSelector(getMapById, function (store) {
  return store ? store.timeSliderDataScaleToSecondsPerPx : defaultDataScaleToSecondsPerPx;
});
/**
 * Returns map is timestep auto
 *
 * Example: isTimestepAuto = isTimestepAuto(store, 'mapid_1')
 * @param {object} store store: object - store object
 * @param {string} mapId mapId: string - Id of the map
 * @returns {boolean} returnType: boolean
 */

var isTimestepAuto = createSelector(getMapById, function (store) {
  return store ? store.isTimestepAuto : false;
});
/**
 * Returns map is time slider hover
 *
 * Example: isTimeSliderHoverOn = isTimeSliderHoverOn(store, 'mapid_1')
 * @param {object} store store: object - store object
 * @param {string} mapId mapId: string - Id of the map
 * @returns {boolean} returnType: boolean
 */

var isTimeSliderHoverOn = createSelector(getMapById, function (store) {
  return store ? store.isTimeSliderHoverOn : false;
});
/**
 * Returns map if zoomcontrols are visible
 *
 * Example: isZoomControlsVisible = isZoomControlsVisible(store, 'mapid_1')
 * @param {object} store store: object - store object
 * @param {string} mapId mapId: string - Id of the map
 * @returns {boolean} returnType: boolean
 */

var isZoomControlsVisible = createSelector(getMapById, function (store) {
  return store ? store.shouldShowZoomControls : true;
});
/**
 * Returns map is time slider visible
 *
 * Example: isTimeSliderHoverOn = isTimeSliderVisible(store, 'mapid_1')
 * @param {object} store store: object - store object
 * @param {string} mapId mapId: string - Id of the map
 * @returns {boolean} returnType: boolean
 */

var isTimeSliderVisible = createSelector(getMapById, function (store) {
  return store ? store.isTimeSliderVisible : true;
});
/**
 * Returns is layer is active layer
 *
 * Example: isLayerActiveLayer = getIsLayerActiveLayer(store, 'mapid_1', 'layer_1)
 * @param {object} store store: object - store object
 * @param {string} mapId mapId: string - Id of the map
 * @param {string} mapId layerId: string - Id of the layer
 * @returns {boolean} returnType: boolean
 */

var getIsLayerActiveLayer = createSelector(getActiveLayerId, function (_store, _mapId, layerId) {
  return layerId;
}, function (activeLayerId, layerId) {
  return activeLayerId === layerId;
});
/**
 * Returns the mapId for given layerId
 *
 * Example const mapId = getMapIdFromLayerId(store 'layerId-A');
 * @param {object} store store: object - store object
 * @param {string} layerId layerId: string - Id of the layer
 * @returns {string} returnType: string - the mapId, or null if not found
 */

var getMapIdFromLayerId$1 = createSelector(function (store) {
  return store && store.webmap ? store.webmap : null;
}, function (_store, layerId) {
  return layerId;
}, findMapIdFromLayerId, selectorMemoizationOptions);
/**
 * Returns the layerId for given layerName
 *
 * Example const layerId = getLayerIdByLayerName(store, 'mapid-1', 'precipitation');
 * @param {object} store store: object - store object
 * @param {string} mapId mapId: string - Id of the map
 * @param {string} layerId layerId: string - Id of the layer
 * @returns {string} returnType: string - the layerId, or null if not found
 */

var getLayerIdByLayerName = createSelector(getMapLayers, function (_store, _mapId, layerName) {
  return layerName;
}, function (layers, layerName) {
  var layer = layers.find(function (layer) {
    return layer.name === layerName;
  });

  if (layer) {
    return layer.id;
  }

  return null;
}, selectorMemoizationOptions);
/**
 * Returns the layerIndex in the map for given layerId
 *
 * Example const layerIndex = getLayerIndexByLayerId(store, 'mapid-1', 'precipitation');
 * @param {object} store store: object - store object
 * @param {string} mapId mapId: string - Id of the map
 * @param {string} layerId layerId: string - Id of the layer
 * @returns {number} returnType: index number or -1 if not found
 */

var getLayerIndexByLayerId$1 = createSelector(getMapLayers, function (_store, _mapId, layerId) {
  return layerId;
}, function (layers, layerId) {
  return layers.findIndex(function (layer) {
    return layer.id === layerId;
  });
}, selectorMemoizationOptions);
/**
 * Returns the Layer in the map for given layerIndex
 *
 * Example const layer = getLayerByLayerIndex(store, 'mapid-1', 0);
 * @param {object} store store: object - store object
 * @param {string} mapId mapId: string - Id of the map
 * @param {number} layerIndex layerId: number - Index of the layer in the map
 * @returns {object} returnType: layer, or null if not found
 */

var getLayerByLayerIndex$1 = createSelector(getMapLayers, function (_store, _mapId, layerIndex) {
  return layerIndex;
}, function (layers, layerIndex) {
  if (layerIndex >= 0 && layerIndex < layers.length) {
    return layers[layerIndex];
  }

  return null;
}, selectorMemoizationOptions);
/**
 * Returns name of all unique dimensions present in all maps
 *
 * Example getAllUniqueDimensions(store);
 * @param {object} store store: object - store object
 * @returns {array} returnType: array of dimension names
 */

var getAllUniqueDimensions = createSelector(getAllMapIds, function (store) {
  return store;
}, function (mapIds, store) {
  return mapIds.reduce(function (list, mapId) {
    var mapDimensions = getMapDimensions(store, mapId);
    var uniqueMapDims = mapDimensions.reduce(function (array, dimension) {
      if (dimension && dimension.name && array.indexOf(dimension.name) === -1) {
        return array.concat(dimension.name);
      }

      return array;
    }, list);
    return uniqueMapDims;
  }, []);
}, selectorMemoizationOptions);
/**
 * Returns the mapPinLocation for the current map
 *
 * Example getPinLocation(store);
 * @param {object} store store: object - store object
 * @param {string} mapId mapId: string - Id of the map
 * @returns {object} returnType: latitude and longitude of pin
 */

var getPinLocation = createSelector(getMapById, function (store) {
  return store ? store.mapPinLocation : undefined;
}, selectorMemoizationOptions);
/**
 * Returns the disable map pin boolean for the current map
 *
 * Example getDisableMapPin(store);
 * @param {object} store store: object - store object
 * @param {string} mapId mapId: string - Id of the map
 * @returns {boolean} returnType: boolean
 */

var getDisableMapPin = createSelector(getMapById, function (store) {
  return store ? store.disableMapPin : false;
});
/**
 * Returns the diplay map pin boolean for the current map
 *
 * Example getDisplayMapPin(store);
 * @param {object} store store: object - store object
 * @param {string} mapId mapId: string - Id of the map
 * @returns {boolean} returnType: boolean
 */

var getDisplayMapPin = createSelector(getMapById, function (store) {
  return store ? store.displayMapPin : false;
});
/**
 * Returns the selected geojson feature for the given map
 *
 * Example const selectedFeature = getSelectedFeature(store, 'mapId1')
 * @param {object} store store: object - store object
 * @param {string} mapId mapId: string - Id of the map
 * @returns {number} selectedFeatureIndex: the index of the selected geojson feature
 */

var getSelectedFeatureIndex = createSelector(getMapById, function (store) {
  return store === null || store === void 0 ? void 0 : store.selectedFeatureIndex;
});
/**
 * Returns the active map preset id
 *
 * Example getActiveMapPresetId(store, mapId);
 * @param {object} store store: object - store object
 * @param {string} mapId mapId: string - Id of the map
 * @returns {boolean} returnType: boolean or undefined
 */

var getActiveMapPresetId = createSelector(getMapById, function (store) {
  return store ? store.activeMapPresetId : undefined;
});
/**
 * Returns the legend id
 *
 * Example getLegendId(store, mapId);
 * @param {object} store store: object - store object
 * @param {string} mapId mapId: string - Id of the map
 * @returns {boolean} returnType: id or undefined
 */

var getLegendId = createSelector(getMapById, function (store) {
  return store ? store.legendId : undefined;
});
/**
 * Creates a MapPreset from mapId
 *
 * Example getMapPreset(store, mapId);
 * @param {object} store store: object - store object
 * @param {string} mapId mapId: string - Id of the map
 * @returns {MapPreset} returnType: MapPreset
 */

var getMapPreset = createSelector(getMapLayers, getMapBaseLayers, getMapOverLayers, getBbox, getSrs, getActiveLayerId, isAnimating, isAutoUpdating, isTimeSliderVisible, getDisplayMapPin, isZoomControlsVisible, getMapTimeStep, getMapAnimationDelay, isTimestepAuto, getLegendId, getUiStore, function (mapLayers, baseLayers, overLayers, bbox, srs, activeLayerId, isAnimating, isAutoUpdating, isTimeSliderVisible, displayMapPin, isZoomControlsVisible, mapTimeStep, mapAnimationDelay, isTimestepAuto, legendId, uiStore) {
  var _a;

  var allLayers = [].concat(_toConsumableArray(baseLayers), _toConsumableArray(overLayers), _toConsumableArray(mapLayers)).map(function (_a) {
    _a.mapId;
        var layer = __rest(_a, ["mapId"]);

    if (layer.dimensions !== undefined) {
      // Filter out (reference) time dimension as these should not be part of the preset for now
      var dimensions = layer.dimensions.filter(function (dimension) {
        return dimension.name !== 'time' && dimension.name !== 'reference_time';
      });
      return Object.assign(Object.assign({}, layer), {
        dimensions: dimensions
      });
    }

    return layer;
  });
  var animationPayload = {
    interval: mapTimeStep,
    speed: getSpeedFactor(mapAnimationDelay)
  };
  var shouldShowLegend = (_a = uiStore === null || uiStore === void 0 ? void 0 : uiStore.dialogs[legendId]) === null || _a === void 0 ? void 0 : _a.isOpen;
  return Object.assign({
    layers: allLayers,
    activeLayerId: activeLayerId,
    proj: {
      bbox: bbox,
      srs: srs
    },
    shouldAnimate: isAnimating,
    shouldAutoUpdate: isAutoUpdating,
    showTimeSlider: isTimeSliderVisible,
    displayMapPin: displayMapPin,
    shouldShowZoomControls: isZoomControlsVisible,
    animationPayload: animationPayload,
    toggleTimestepAuto: isTimestepAuto
  }, shouldShowLegend !== undefined && {
    shouldShowLegend: shouldShowLegend
  });
}, selectorMemoizationOptions);
/**
 * Returns the loading state of the map preset
 *
 * Example getIsMapPresetLoading(store, mapId);
 * @param {object} store store: object - store object
 * @param {string} mapId mapId: string - Id of the map
 * @returns {boolean} returnType: boolean
 */

var getIsMapPresetLoading = createSelector(getMapById, function (store) {
  return store && store.isMapPresetLoading ? store.isMapPresetLoading : false;
});
/**
 * Returns the has changes state of the map preset
 *
 * Example getHasMapPresetChanges(store, mapId);
 * @param {object} store store: object - store object
 * @param {string} mapId mapId: string - Id of the map
 * @returns {boolean} returnType: boolean
 */

var getHasMapPresetChanges = createSelector(getMapById, function (store) {
  return store && store.hasMapPresetChanges ? store.hasMapPresetChanges : false;
});
/**
 * Returns the error state of the map preset
 *
 * Example getMapPresetError(store, mapId);
 * @param {object} store store: object - store object
 * @param {string} mapId mapId: string - Id of the map
 * @returns {Error} returnType: string
 */

var getMapPresetError = createSelector(getMapById, function (store) {
  return store === null || store === void 0 ? void 0 : store.mapPresetError;
});

var selectors = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getMapById: getMapById,
  getAllMapIds: getAllMapIds,
  getFirstMap: getFirstMap,
  getFirstMapId: getFirstMapId,
  getIsMapPresent: getIsMapPresent,
  getLayerIds: getLayerIds,
  getMapLayers: getMapLayers,
  getMapBaseLayersIds: getMapBaseLayersIds,
  getMapBaseLayers: getMapBaseLayers,
  getMapOverLayersIds: getMapOverLayersIds,
  getMapOverLayers: getMapOverLayers,
  getMapDimensions: getMapDimensions,
  getMapDimension: getMapDimension,
  getSrs: getSrs,
  getBbox: getBbox,
  isAnimating: isAnimating,
  linkedMapAnimationInfo: linkedMapAnimationInfo,
  getAnimationStartTime: getAnimationStartTime,
  getAnimationEndTime: getAnimationEndTime,
  isAutoUpdating: isAutoUpdating,
  getActiveLayerId: getActiveLayerId,
  getMapTimeSliderScale: getMapTimeSliderScale,
  getMapTimeStep: getMapTimeStep,
  getMapAnimationDelay: getMapAnimationDelay,
  getMapTimeSliderCenterTime: getMapTimeSliderCenterTime,
  getMapTimeSliderSecondsPerPx: getMapTimeSliderSecondsPerPx,
  getMapTimeSliderDataScaleToSecondsPerPx: getMapTimeSliderDataScaleToSecondsPerPx,
  isTimestepAuto: isTimestepAuto,
  isTimeSliderHoverOn: isTimeSliderHoverOn,
  isZoomControlsVisible: isZoomControlsVisible,
  isTimeSliderVisible: isTimeSliderVisible,
  getIsLayerActiveLayer: getIsLayerActiveLayer,
  getMapIdFromLayerId: getMapIdFromLayerId$1,
  getLayerIdByLayerName: getLayerIdByLayerName,
  getLayerIndexByLayerId: getLayerIndexByLayerId$1,
  getLayerByLayerIndex: getLayerByLayerIndex$1,
  getAllUniqueDimensions: getAllUniqueDimensions,
  getPinLocation: getPinLocation,
  getDisableMapPin: getDisableMapPin,
  getDisplayMapPin: getDisplayMapPin,
  getSelectedFeatureIndex: getSelectedFeatureIndex,
  getActiveMapPresetId: getActiveMapPresetId,
  getLegendId: getLegendId,
  getMapPreset: getMapPreset,
  getIsMapPresetLoading: getIsMapPresetLoading,
  getHasMapPresetChanges: getHasMapPresetChanges,
  getMapPresetError: getMapPresetError
});

var initialState = {
  filters: {
    searchFilter: '',
    activeServices: {
      byId: {},
      allIds: []
    },
    keywords: {
      byId: {},
      allIds: []
    }
  }
};
var slice = createSlice({
  initialState: initialState,
  name: 'layerSelect',
  reducers: {
    setSearchFilter: function setSearchFilter(draft, action) {
      var filterText = action.payload.filterText;
      draft.filters.searchFilter = filterText;
    },
    addKeywordsAndActiveServices: function addKeywordsAndActiveServices(draft, action) {
      var _action$payload = action.payload,
          serviceId = _action$payload.serviceId,
          serviceName = _action$payload.serviceName,
          serviceUrl = _action$payload.serviceUrl,
          keywords = _action$payload.keywords;

      if (!draft.filters.activeServices.byId[serviceId]) {
        draft.filters.activeServices.byId[serviceId] = {};

        var _iterator = _createForOfIteratorHelper(keywords),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var keyword = _step.value;

            if (!draft.filters.keywords.byId[keyword]) {
              draft.filters.keywords.byId[keyword] = {
                id: keyword,
                amount: 1,
                amountVisible: 1,
                checked: true
              };
              draft.filters.keywords.allIds.push(keyword);
            } else {
              draft.filters.keywords.byId[keyword].amount += 1;
              draft.filters.keywords.byId[keyword].amountVisible += 1;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      draft.filters.activeServices.byId[serviceId].serviceName = serviceName;
      draft.filters.activeServices.byId[serviceId].serviceUrl = serviceUrl;
      draft.filters.activeServices.byId[serviceId].enabled = true;
      draft.filters.activeServices.byId[serviceId].keywordsPerService = keywords;
      if (!draft.filters.activeServices.allIds.includes(serviceId)) draft.filters.activeServices.allIds.push(serviceId);
    },
    layerSelectServiceRemoved: function layerSelectServiceRemoved(draft, action) {
      var serviceId = action.payload.serviceId; // 1. Find a service that is to be removed

      var foundService = draft.filters.activeServices.byId[serviceId]; // 2. Go through all keywords for removed service, and decrement the amount of all found keywords

      var _iterator2 = _createForOfIteratorHelper(foundService.keywordsPerService),
          _step2;

      try {
        var _loop = function _loop() {
          var keyword = _step2.value;
          var foundObject = draft.filters.keywords.byId[keyword];

          if (foundObject && foundObject.amount) {
            foundObject.amount -= 1;
            foundObject.amountVisible -= 1;
          }

          if (foundObject && foundObject.amount === 0) {
            delete draft.filters.keywords.byId[keyword];
            draft.filters.keywords.allIds = draft.filters.keywords.allIds.filter(function (serviceId) {
              return serviceId !== keyword;
            });
          }
        };

        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          _loop();
        } // Finally remove object from activeServices, so if the service is added again later on, new object and keywords will be re-added

      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      delete draft.filters.activeServices.byId[serviceId];
      draft.filters.activeServices.allIds = draft.filters.activeServices.allIds.filter(function (id) {
        return id !== serviceId;
      });
    },
    enableActiveService: function enableActiveService(draft, action) {
      var _action$payload2 = action.payload,
          serviceId = _action$payload2.serviceId,
          keywords = _action$payload2.keywords;
      draft.filters.activeServices.byId[serviceId].enabled = true;

      var _iterator3 = _createForOfIteratorHelper(keywords),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var keyword = _step3.value;
          draft.filters.keywords.byId[keyword].amountVisible += 1;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    },
    disableActiveService: function disableActiveService(draft, action) {
      var _action$payload3 = action.payload,
          serviceId = _action$payload3.serviceId,
          keywords = _action$payload3.keywords;
      draft.filters.activeServices.byId[serviceId].enabled = false;

      var _iterator4 = _createForOfIteratorHelper(keywords),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var keyword = _step4.value;
          draft.filters.keywords.byId[keyword].amountVisible -= 1;
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    },
    toggleKeywords: function toggleKeywords(draft, action) {
      var keywords = action.payload.keywords;

      var _iterator5 = _createForOfIteratorHelper(keywords),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var keyword = _step5.value;
          draft.filters.keywords.byId[keyword].checked = !draft.filters.keywords.byId[keyword].checked;
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    },
    enableOnlyOneKeyword: function enableOnlyOneKeyword(draft, action) {
      var keyword = action.payload.keyword;
      draft.filters.keywords.allIds.forEach(function (serviceId) {
        draft.filters.keywords.byId[serviceId].checked = false;
      });
      draft.filters.keywords.byId[keyword].checked = true;
    }
  }
});
var reducer = slice.reducer;
var layerSelectActions = slice.actions;

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */

var layerSelectStore = function layerSelectStore(store) {
  return store && store.layerSelect ? store.layerSelect : null;
};
/**
 * Returns search filter string
 *
 * Example getSearchFilter(store);
 * @param {object} store store: object - store object
 * @returns {array} returnType: string
 */


var getSearchFilter = createSelector(layerSelectStore, function (store) {
  return store ? store.filters.searchFilter : '';
});
/**
 * Returns active services array
 *
 * Example getActiveServices(store);
 * @param {object} store store: object - store object
 * @returns {object} returnType: object of active services
 */

var getActiveServices = createSelector(layerSelectStore, function (store) {
  var _a;

  return store ? (_a = store === null || store === void 0 ? void 0 : store.filters) === null || _a === void 0 ? void 0 : _a.activeServices.byId : {};
}, selectorMemoizationOptions);
/**
 * Returns all ids of enabled services
 *
 * Example getEnabledServiceIds(store);
 * @param {object} store store: object - store object
 * @returns {array} returnType: array of service ids that are enabled
 */

var getEnabledServiceIds = createSelector(layerSelectStore, function (store) {
  var _a, _b;

  var enabledServices = (_b = (_a = store === null || store === void 0 ? void 0 : store.filters) === null || _a === void 0 ? void 0 : _a.activeServices.allIds.filter(function (serviceId) {
    var _a;

    return (_a = store === null || store === void 0 ? void 0 : store.filters) === null || _a === void 0 ? void 0 : _a.activeServices.byId[serviceId].enabled;
  })) !== null && _b !== void 0 ? _b : [];
  return enabledServices;
}, selectorMemoizationOptions);
/**
 * Returns all ids of checked keywords
 *
 * Example getCheckedKeywordIds(store);
 * @param {object} store store: object - store object
 * @returns {array} returnType: array of keyword ids that are checked
 */

var getCheckedKeywordIds = createSelector(layerSelectStore, function (store) {
  var _a, _b;

  var checkedKeywords = (_b = (_a = store === null || store === void 0 ? void 0 : store.filters) === null || _a === void 0 ? void 0 : _a.keywords.allIds.filter(function (keyword) {
    var _a;

    return (_a = store === null || store === void 0 ? void 0 : store.filters) === null || _a === void 0 ? void 0 : _a.keywords.byId[keyword].checked;
  })) !== null && _b !== void 0 ? _b : [];
  return checkedKeywords.map(function (keyword) {
    var _a;

    return (_a = store === null || store === void 0 ? void 0 : store.filters) === null || _a === void 0 ? void 0 : _a.keywords.byId[keyword].id;
  });
}, selectorMemoizationOptions);
/**
 * Returns ids of all keywords
 *
 * Example getAllKeywordIds(store);
 * @param {object} store store: object - store object
 * @returns {array} returnType: array of all keyword ids
 */

var getAllKeywordIds = createSelector(layerSelectStore, function (store) {
  var _a, _b;

  return (_b = (_a = store === null || store === void 0 ? void 0 : store.filters) === null || _a === void 0 ? void 0 : _a.keywords.allIds) !== null && _b !== void 0 ? _b : [];
}, selectorMemoizationOptions);
/**
 * Returns if all keywords are checked
 *
 * Example isAllKeywordsChecked(store);
 * @param {object} store store: object - store object
 * @returns {array} returnType: boolean if all keywords are checked
 */

var isAllKeywordsChecked = createSelector(layerSelectStore, function (store) {
  var _a, _b;

  return (_b = (_a = store === null || store === void 0 ? void 0 : store.filters) === null || _a === void 0 ? void 0 : _a.keywords) === null || _b === void 0 ? void 0 : _b.allIds.every(function (keyword) {
    var _a, _b;

    return (_b = (_a = store === null || store === void 0 ? void 0 : store.filters) === null || _a === void 0 ? void 0 : _a.keywords) === null || _b === void 0 ? void 0 : _b.byId[keyword].checked;
  });
});
/**
 * Gets a KeywordObject by its id
 *
 * Example: keywordObject = getKeywordObjectById(store, 'keywordId')
 * @param {object} store object from which the keyword state will be extracted
 * @param {string} keywordId Id of the keyword
 * @returns {object} object containing keyword information (id, amount, amountVisible, checked)
 */

var getKeywordObjectById = function getKeywordObjectById(store, keywordId) {
  var _a, _b, _c, _d;

  return (_d = (_c = (_b = (_a = store === null || store === void 0 ? void 0 : store.layerSelect) === null || _a === void 0 ? void 0 : _a.filters) === null || _b === void 0 ? void 0 : _b.keywords) === null || _c === void 0 ? void 0 : _c.byId[keywordId]) !== null && _d !== void 0 ? _d : {};
};

var types = /*#__PURE__*/Object.freeze({
  __proto__: null
});

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */
var syncGroupStore = function syncGroupStore(store) {
  return store.syncronizationGroupStore || null;
};
/**
 * Gets synchronization group state
 *
 * Example: synchronizationGroupState = getSynchronizationGroupState(store)
 * @param {object} store store: object - Store object
 * @returns {object} returnType: SynchronizationGroupState
 */

createSelector(syncGroupStore, function (store) {
  return store || [];
});
var getSynchronizationGroup = function getSynchronizationGroup(state, id) {
  return syncGroupStore(state).groups.byId[id];
};
var getTargets = function getTargets(state, payload, actionType) {
  var actionPayloads = [];
  var targetsInActionPayload = {};
  var syncronizationGroupStore = syncGroupStore(state);
  /* All the groups the source is member of */

  if (syncronizationGroupStore && payload) {
    /* Backwards compatibility, if there are no groups, connect everything */
    if (syncronizationGroupStore.groups.allIds.length === 0) {
      syncronizationGroupStore.sources.allIds.forEach(function (targetId) {
        // Only add if should react to this action
        if (syncronizationGroupStore.sources.byId[targetId].types.includes(actionType)) {
          /* Remember that we have already added this target in the action payloads, prevents adding it twice */
          targetsInActionPayload[targetId] = true;
          /* Compose the payload */

          var newPayload = Object.assign({
            targetId: targetId
          }, payload);
          actionPayloads.push(newPayload);
        }
      });
    }

    syncronizationGroupStore.groups.allIds.forEach(function (id) {
      var syncronizationGroup = syncronizationGroupStore.groups.byId[id];

      if (actionType === syncronizationGroup.type) {
        /* Check if the source is in the target list of the synchonizationGroup */
        var source = syncronizationGroup.targets.byId[payload.sourceId];
        /* If the source is part of the target list, and is linked, continue syncing the other targets */

        if (source && source.linked) {
          syncronizationGroup.targets.allIds.forEach(function (targetId) {
            var target = syncronizationGroup.targets.byId[targetId];

            if (target.linked && !targetsInActionPayload[targetId]) {
              /* Remember that we have already added this target in the action payloads, prevents adding it twice */
              targetsInActionPayload[targetId] = true;
              /* Compose the payload */

              var newPayload = Object.assign({
                targetId: targetId
              }, payload);
              actionPayloads.push(newPayload);
            }
          });
        }
      }
    });
  }

  return actionPayloads;
};
var getTargetGroups = function getTargetGroups(state, payload, actionType) {
  var syncronizationGroupStore = syncGroupStore(state);
  var groups = syncronizationGroupStore.groups.allIds.reduce(function (list, groupId) {
    var syncronizationGroup = syncronizationGroupStore.groups.byId[groupId];

    if (actionType === syncronizationGroup.type) {
      /* Check if the source is in the target list of the synchronizationGroup */
      var source = syncronizationGroup.targets.byId[payload.sourceId];
      /* If the source is part of the target list, and it linked, continue syncin the other targets */

      if (source && source.linked) {
        return list.concat(groupId);
      }
    }

    return list;
  }, []);
  return groups;
};
var syncGroupGetViewState = createSelector(syncGroupStore, function (store) {
  return store.viewState;
});

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */
var getLayerByLayerIndex = getLayerByLayerIndex$1,
    getMapIdFromLayerId = getMapIdFromLayerId$1,
    getLayerIndexByLayerId = getLayerIndexByLayerId$1;
/**
 * Tries to find the layerId's in the other map based on the payload of the action. It works for all layer actions.
 * @param state
 * @param mapId
 * @param targetMapId
 * @param payload
 * @returns
 */

var getTargetLayerIdFromPayload = function getTargetLayerIdFromPayload(state, mapId, targetMapId, payload) {
  if (!payload) return null;
  /* Try to find the layer for the DeleteLayerPayload, it uses layerIndex to reference the layer */

  if ('layerIndex' in payload) {
    var targetLayer = getLayerByLayerIndex(state, targetMapId, payload.layerIndex);
    return !targetLayer ? null : targetLayer.id;
  }
  /* Try to find the layer for the LayerActionsWithLayerIds, it uses layerId to reference the layer */


  if ('layerId' in payload) {
    var _targetLayer = getLayerByLayerIndex(state, targetMapId, getLayerIndexByLayerId(state, mapId, payload.layerId));

    return !_targetLayer ? null : _targetLayer.id;
  }
  /* This payload probably does not reference to a layerId */


  return null;
};
/**
 * Local helper function used by getLayerDeleteActionsTargets, getLayerActionsTargets, getAddLayerActionsTargets, getTargetLayerIdFromPayload to find the targets
 * @param state
 * @param payload
 * @param actionType
 * @param sourceMapId
 * @returns The found targets
 */

var findTargets = function findTargets(state, payload, actionType, sourceMapId) {
  var actionPayloads = [];
  var targetsInActionPayload = {};
  var syncronizationGroupStore = syncGroupStore(state);

  if (syncronizationGroupStore && payload) {
    syncronizationGroupStore.groups.allIds.forEach(function (id) {
      var syncronizationGroup = syncronizationGroupStore.groups.byId[id];

      if (actionType === syncronizationGroup.type) {
        /* Check if the source is in the target list of the synchonizationGroup */
        var source = syncronizationGroup.targets.byId[sourceMapId];
        /* If the source is part of the target list, and is linked, continue syncing the other targets */

        if (source && source.linked) {
          syncronizationGroup.targets.allIds.forEach(function (targetId) {
            var target = syncronizationGroup.targets.byId[targetId];

            if (targetId !== sourceMapId && target.linked && !targetsInActionPayload[targetId]) {
              /* Remember that we have already added this target in the action payloads, prevents adding it twice */
              targetsInActionPayload[targetId] = true;
              var otherLayerId = getTargetLayerIdFromPayload(state, sourceMapId, targetId, payload);
              actionPayloads.push({
                payload: payload,
                targetId: targetId,
                layerId: otherLayerId
              });
            }
          });
        }
      }
    });
  }

  return actionPayloads;
};
/**
 * These targets are found for layer actions that work with a layerId like: SetLayerName, SetLayerEnabled, SetLayerOpacity, SetLayerDimension and SetLayerStyle
 * @param state
 * @param payload
 * @param actionType
 * @returns
 */

var getLayerActionsTargets = function getLayerActionsTargets(state, payload, actionType) {
  var mapId = getMapIdFromLayerId(state, payload.layerId);
  var foundTargets = findTargets(state, payload, actionType, mapId);
  return foundTargets.map(function (target) {
    var payload = target.payload;
    return Object.assign(Object.assign({}, payload), {
      layerId: target.layerId,
      origin: SyncGroupActionOrigin.layerActions,
      mapId: payload.mapId
    });
  });
};
/**
 * These targets are found for the layer/map action AddLayer. AddLayer does not have a layerId (because it's new)
 * @param state
 * @param payload
 * @param actionType
 * @returns
 */

var getAddLayerActionsTargets = function getAddLayerActionsTargets(state, payload, actionType) {
  var foundTargets = findTargets(state, payload, actionType, payload.mapId);
  return foundTargets.map(function (_ref) {
    var payload = _ref.payload,
        targetId = _ref.targetId;
    var layer = payload.layer;

    layer.id;
        var layerWithoutId = __rest(layer, ["id"]);

    return Object.assign(Object.assign({}, payload), {
      layer: layerWithoutId,
      layerId: generateLayerId(),
      mapId: targetId,
      origin: SyncGroupActionOrigin.add
    });
  });
};
/**
 * These targets are found for the layer/map action DeleteLayer. The layer is already gone, so there is no layerId anymore. Using layerIndex instead.
 * @param state
 * @param payload
 * @param actionType
 * @returns
 */

var getLayerDeleteActionsTargets = function getLayerDeleteActionsTargets(state, payload, actionType) {
  var foundTargets = findTargets(state, payload, actionType, payload.mapId);
  return foundTargets.map(function (target) {
    return Object.assign(Object.assign({}, target.payload), {
      mapId: target.targetId,
      layerId: target.layerId,
      origin: SyncGroupActionOrigin["delete"]
    });
  });
};
/**
 * These targets are found for the layer/map action MoveLayer. Here layers are referenced by newIndex and oldIndex.
 * @param state
 * @param payload
 * @param actionType
 * @returns
 */

var getLayerMoveActionsTargets = function getLayerMoveActionsTargets(state, payload, actionType) {
  var foundTargets = findTargets(state, payload, actionType, payload.mapId);
  return foundTargets.map(function (target) {
    return Object.assign(Object.assign({}, target.payload), {
      mapId: target.targetId,
      origin: SyncGroupActionOrigin.move
    });
  });
};
/**
 * These targets are found for the layer/map action SetActiveLayerId. It needs both a target mapId and layerId
 * @param state
 * @param payload
 * @param actionType
 * @returns
 */

var getSetActiveLayerIdActionsTargets = function getSetActiveLayerIdActionsTargets(state, payload, actionType) {
  var sourceMapId = getMapIdFromLayerId(state, payload.layerId);
  var foundTargets = findTargets(state, payload, actionType, sourceMapId);
  return foundTargets.map(function (target) {
    return {
      mapId: target.targetId,
      layerId: target.layerId,
      origin: SyncGroupActionOrigin.activateLayerId
    };
  });
};
/**
 * These targets are found for baselayer actions that work with a mapId like: setBaseLayers
 * @param state
 * @param payload
 * @param actionType
 * @returns
 */

var getMapBaseLayerActionsTargets = function getMapBaseLayerActionsTargets(state, payload, actionType) {
  var foundTargets = findTargets(state, payload, actionType, payload.mapId);
  return foundTargets.map(function (target) {
    return {
      layers: payload.layers.map(function (layer) {
        return Object.assign(Object.assign({}, layer), {
          id: generateLayerId()
        });
      }),
      mapId: target.targetId,
      origin: SyncGroupActionOrigin.layerActions
    };
  });
};

var _marked$4 = /*#__PURE__*/regeneratorRuntime.mark(setTimeSaga),
    _marked2$4 = /*#__PURE__*/regeneratorRuntime.mark(setBBoxSaga),
    _marked3$4 = /*#__PURE__*/regeneratorRuntime.mark(layerActionsSaga),
    _marked4$2 = /*#__PURE__*/regeneratorRuntime.mark(addLayerActionsSaga),
    _marked5$2 = /*#__PURE__*/regeneratorRuntime.mark(deleteLayerActionsSaga),
    _marked6$1 = /*#__PURE__*/regeneratorRuntime.mark(moveLayerActionsSaga),
    _marked7$1 = /*#__PURE__*/regeneratorRuntime.mark(setActiveLayerIdActionsSaga),
    _marked8$1 = /*#__PURE__*/regeneratorRuntime.mark(mapBaseLayerActionsSaga),
    _marked9$1 = /*#__PURE__*/regeneratorRuntime.mark(rootSaga$4);
var setBaseLayers = layerActions.setBaseLayers,
    addLayer = layerActions.addLayer,
    layerChangeDimension = layerActions.layerChangeDimension,
    layerChangeEnabled = layerActions.layerChangeEnabled,
    layerChangeName = layerActions.layerChangeName,
    layerChangeOpacity = layerActions.layerChangeOpacity,
    layerChangeStyle = layerActions.layerChangeStyle,
    layerDelete = layerActions.layerDelete;
var setTimeValidatorRexexp = new RegExp('^(19|20)\\d\\d-(0[1-9]|1[012])-([012]\\d|3[01])T([01]\\d|2[0-3]):([0-5]\\d):([0-5]\\d)Z$');
function setTimeSaga(_ref) {
  var payload, value, origin, targets, groups;
  return regeneratorRuntime.wrap(function setTimeSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          payload = _ref.payload;
          value = payload.value, origin = payload.origin;
          /* Test if the value is according to the expected time format */

          if (setTimeValidatorRexexp.test(value)) {
            _context.next = 6;
            break;
          }

          console.error("setTime value ".concat(value, " does not conform to format [YYYY-MM-DDThh:mm:ssZ]. It was triggered by ").concat(origin));
          _context.next = 14;
          break;

        case 6:
          _context.next = 8;
          return select(getTargets, payload, SYNCGROUPS_TYPE_SETTIME);

        case 8:
          targets = _context.sent;
          _context.next = 11;
          return select(getTargetGroups, payload, SYNCGROUPS_TYPE_SETTIME);

        case 11:
          groups = _context.sent;
          _context.next = 14;
          return put(setTimeSync(payload, targets, groups));

        case 14:
        case "end":
          return _context.stop();
      }
    }
  }, _marked$4);
}
function setBBoxSaga(_ref2) {
  var payload, targets, groups;
  return regeneratorRuntime.wrap(function setBBoxSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _ref2.payload;
          _context2.next = 3;
          return select(getTargets, payload, SYNCGROUPS_TYPE_SETBBOX);

        case 3:
          targets = _context2.sent;
          _context2.next = 6;
          return select(getTargetGroups, payload, SYNCGROUPS_TYPE_SETBBOX);

        case 6:
          groups = _context2.sent;
          _context2.next = 9;
          return put(setBboxSync(payload, targets, groups));

        case 9:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2$4);
}
function layerActionsSaga(_ref3) {
  var payload, type, targets;
  return regeneratorRuntime.wrap(function layerActionsSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _ref3.payload, type = _ref3.type;

          if (!(payload && payload.origin === LayerActionOrigin.ReactMapViewParseLayer)) {
            _context3.next = 3;
            break;
          }

          return _context3.abrupt("return");

        case 3:
          _context3.next = 5;
          return select(getLayerActionsTargets, payload, SYNCGROUPS_TYPE_SETLAYERACTIONS);

        case 5:
          targets = _context3.sent;

          if (!(targets && targets.length > 0)) {
            _context3.next = 9;
            break;
          }

          _context3.next = 9;
          return put(setLayerActionSync(payload, targets, type));

        case 9:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3$4);
}
function addLayerActionsSaga(_ref4) {
  var payload, type, targets;
  return regeneratorRuntime.wrap(function addLayerActionsSaga$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _ref4.payload, type = _ref4.type;

          if (!(payload && payload.origin === LayerActionOrigin.ReactMapViewParseLayer)) {
            _context4.next = 3;
            break;
          }

          return _context4.abrupt("return");

        case 3:
          _context4.next = 5;
          return select(getAddLayerActionsTargets, payload, SYNCGROUPS_TYPE_SETLAYERACTIONS);

        case 5:
          targets = _context4.sent;

          if (!(targets && targets.length > 0)) {
            _context4.next = 9;
            break;
          }

          _context4.next = 9;
          return put(setLayerActionSync(payload, targets, type));

        case 9:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4$2);
}
function deleteLayerActionsSaga(_ref5) {
  var payload, type, targets;
  return regeneratorRuntime.wrap(function deleteLayerActionsSaga$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          payload = _ref5.payload, type = _ref5.type;

          if (!(payload && payload.origin === LayerActionOrigin.ReactMapViewParseLayer)) {
            _context5.next = 3;
            break;
          }

          return _context5.abrupt("return");

        case 3:
          _context5.next = 5;
          return select(getLayerDeleteActionsTargets, payload, SYNCGROUPS_TYPE_SETLAYERACTIONS);

        case 5:
          targets = _context5.sent;

          if (!(targets && targets.length > 0)) {
            _context5.next = 9;
            break;
          }

          _context5.next = 9;
          return put(setLayerActionSync(payload, targets, type));

        case 9:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5$2);
}
function moveLayerActionsSaga(_ref6) {
  var payload, type, targets;
  return regeneratorRuntime.wrap(function moveLayerActionsSaga$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          payload = _ref6.payload, type = _ref6.type;

          if (!(payload && payload.origin === LayerActionOrigin.ReactMapViewParseLayer)) {
            _context6.next = 3;
            break;
          }

          return _context6.abrupt("return");

        case 3:
          _context6.next = 5;
          return select(getLayerMoveActionsTargets, payload, SYNCGROUPS_TYPE_SETLAYERACTIONS);

        case 5:
          targets = _context6.sent;

          if (!(targets && targets.length > 0)) {
            _context6.next = 9;
            break;
          }

          _context6.next = 9;
          return put(setLayerActionSync(payload, targets, type));

        case 9:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6$1);
}
function setActiveLayerIdActionsSaga(_ref7) {
  var payload, type, targets;
  return regeneratorRuntime.wrap(function setActiveLayerIdActionsSaga$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          payload = _ref7.payload, type = _ref7.type;
          _context7.next = 3;
          return select(getSetActiveLayerIdActionsTargets, payload, SYNCGROUPS_TYPE_SETLAYERACTIONS);

        case 3:
          targets = _context7.sent;

          if (!(targets && targets.length > 0)) {
            _context7.next = 7;
            break;
          }

          _context7.next = 7;
          return put(setLayerActionSync(payload, targets, type));

        case 7:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7$1);
}
function mapBaseLayerActionsSaga(_ref8) {
  var payload, type, targets;
  return regeneratorRuntime.wrap(function mapBaseLayerActionsSaga$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          payload = _ref8.payload, type = _ref8.type;

          if (!(payload && payload.origin === LayerActionOrigin.ReactMapViewParseLayer)) {
            _context8.next = 3;
            break;
          }

          return _context8.abrupt("return");

        case 3:
          _context8.next = 5;
          return select(getMapBaseLayerActionsTargets, payload, SYNCGROUPS_TYPE_SETLAYERACTIONS);

        case 5:
          targets = _context8.sent;

          if (!(targets && targets.length > 0)) {
            _context8.next = 9;
            break;
          }

          _context8.next = 9;
          return put(setLayerActionSync(payload, targets, type));

        case 9:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8$1);
}
function rootSaga$4() {
  return regeneratorRuntime.wrap(function rootSaga$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return takeLatest(setTime.type, setTimeSaga);

        case 2:
          _context9.next = 4;
          return takeLatest(setBbox.type, setBBoxSaga);

        case 4:
          _context9.next = 6;
          return takeLatest(layerChangeName.type, layerActionsSaga);

        case 6:
          _context9.next = 8;
          return takeLatest(layerChangeEnabled.type, layerActionsSaga);

        case 8:
          _context9.next = 10;
          return takeLatest(layerChangeOpacity.type, layerActionsSaga);

        case 10:
          _context9.next = 12;
          return takeLatest(layerChangeDimension.type, layerActionsSaga);

        case 12:
          _context9.next = 14;
          return takeLatest(layerChangeStyle.type, layerActionsSaga);

        case 14:
          _context9.next = 16;
          return takeLatest(layerDelete.type, deleteLayerActionsSaga);

        case 16:
          _context9.next = 18;
          return takeLatest(addLayer.type, addLayerActionsSaga);

        case 18:
          _context9.next = 20;
          return takeLatest(mapActions$1.layerMoveLayer.type, moveLayerActionsSaga);

        case 20:
          _context9.next = 22;
          return takeLatest(mapActions$1.setActiveLayerId.type, setActiveLayerIdActionsSaga);

        case 22:
          _context9.next = 24;
          return takeLatest(setBaseLayers.type, mapBaseLayerActionsSaga);

        case 24:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked9$1);
}

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */
var emptyState = {
  timeslider: {
    groups: [],
    sourcesById: []
  },
  zoompane: {
    groups: [],
    sourcesById: []
  },
  level: {
    groups: [],
    sourcesById: []
  }
};
var groupTypes = [{
  title: 'Timeslider',
  syncType: 'SYNCGROUPS_TYPE_SETTIME',
  groupType: 'timeslider'
}, {
  title: 'Zoompane',
  syncType: 'SYNCGROUPS_TYPE_SETBBOX',
  groupType: 'zoompane'
}];
/*
    _____ Creates viewState  _____
      - Runs Each time viewState is created:
      - Fill arrays inside initialState with objects containing new values from Redux
*/

var createSyncGroupViewState = function createSyncGroupViewState(groups, sources) {
  var initialState = produce$1(emptyState, function (draft) {
    /*
      _____ 1. Fill groups _____
        1. Goes through all groups by ID
        2. Collects original timeslider or zoompane values into an array
        3. Sorts and adds selected sources to ViewState based on ID type
    */
    Object.keys(groups.byId).forEach(function (id) {
      var _a;

      var groupType = (_a = groupTypes.find(function (object) {
        return object.syncType === groups.byId[id].type;
      })) === null || _a === void 0 ? void 0 : _a.groupType;

      if (groupType) {
        draft[groupType].groups.push({
          id: id,
          selected: groups.byId[id].targets.allIds
        });
      }
    });
    /*
      _____ 2. Fill sourcesById _____
        1. Loop though sources and add source to each group type
    */

    Object.keys(sources.byId).forEach(function (id) {
      groupTypes.forEach(function (_ref) {
        var syncType = _ref.syncType,
            groupType = _ref.groupType;

        if (sources.byId[id].types.includes(syncType)) {
          draft[groupType].sourcesById.push({
            id: id,
            name: id
          });
        }
      });
    });
  });
  return initialState;
};

var groups = function groups(store) {
  return store.syncronizationGroupStore.groups;
};

var sources = function sources(store) {
  return store.syncronizationGroupStore.sources;
};

var createSyncGroupViewStateSelector = createSelector(groups, sources, createSyncGroupViewState);

var _marked$3 = /*#__PURE__*/regeneratorRuntime.mark(updateSourceValueWhenLinkingComponentToGroupSaga),
    _marked2$3 = /*#__PURE__*/regeneratorRuntime.mark(addGroupTargetSaga),
    _marked3$3 = /*#__PURE__*/regeneratorRuntime.mark(linkGroupTargetSaga),
    _marked4$1 = /*#__PURE__*/regeneratorRuntime.mark(updateViewStateSaga),
    _marked5$1 = /*#__PURE__*/regeneratorRuntime.mark(rootSaga$3);
function updateSourceValueWhenLinkingComponentToGroupSaga(groupId, targetToUpdate) {
  var group;
  return regeneratorRuntime.wrap(function updateSourceValueWhenLinkingComponentToGroupSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return select(getSynchronizationGroup, groupId);

        case 2:
          group = _context.sent;

          if (group) {
            _context.next = 5;
            break;
          }

          return _context.abrupt("return");

        case 5:
          _context.t0 = group.type;
          _context.next = _context.t0 === SYNCGROUPS_TYPE_SETTIME ? 8 : _context.t0 === SYNCGROUPS_TYPE_SETBBOX ? 13 : 18;
          break;

        case 8:
          if (group.payloadByType[SYNCGROUPS_TYPE_SETTIME]) {
            _context.next = 10;
            break;
          }

          return _context.abrupt("return");

        case 10:
          _context.next = 12;
          return put(setTimeSync(group.payloadByType[SYNCGROUPS_TYPE_SETTIME], [{
            targetId: targetToUpdate,
            value: group.payloadByType[SYNCGROUPS_TYPE_SETTIME].value
          }], [groupId]));

        case 12:
          return _context.abrupt("break", 18);

        case 13:
          if (group.payloadByType[SYNCGROUPS_TYPE_SETBBOX]) {
            _context.next = 15;
            break;
          }

          return _context.abrupt("return");

        case 15:
          _context.next = 17;
          return put(setBboxSync(group.payloadByType[SYNCGROUPS_TYPE_SETBBOX], [{
            targetId: targetToUpdate,
            bbox: group.payloadByType[SYNCGROUPS_TYPE_SETBBOX].bbox,
            srs: group.payloadByType[SYNCGROUPS_TYPE_SETBBOX].srs
          }], [groupId]));

        case 17:
          return _context.abrupt("break", 18);

        case 18:
        case "end":
          return _context.stop();
      }
    }
  }, _marked$3);
}
function addGroupTargetSaga(_ref) {
  var payload, groupId, linked, targetToUpdate;
  return regeneratorRuntime.wrap(function addGroupTargetSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _ref.payload;
          groupId = payload.groupId, linked = payload.linked, targetToUpdate = payload.targetId;

          if (linked) {
            _context2.next = 5;
            break;
          }

          _context2.next = 5;
          return call(updateSourceValueWhenLinkingComponentToGroupSaga, groupId, targetToUpdate);

        case 5:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2$3);
}
function linkGroupTargetSaga(_ref2) {
  var payload, groupId, linked, targetToUpdate;
  return regeneratorRuntime.wrap(function linkGroupTargetSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _ref2.payload;
          groupId = payload.groupId, linked = payload.linked, targetToUpdate = payload.targetId;

          if (linked) {
            _context3.next = 5;
            break;
          }

          _context3.next = 5;
          return call(updateSourceValueWhenLinkingComponentToGroupSaga, groupId, targetToUpdate);

        case 5:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3$3);
}
function updateViewStateSaga() {
  var viewState;
  return regeneratorRuntime.wrap(function updateViewStateSaga$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return select(createSyncGroupViewStateSelector);

        case 2:
          viewState = _context4.sent;
          _context4.next = 5;
          return put(syncGroupSetViewState({
            viewState: viewState
          }));

        case 5:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4$1);
}

function rootSaga$3() {
  return regeneratorRuntime.wrap(function rootSaga$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return takeLatest(syncGroupAddTarget.type, addGroupTargetSaga);

        case 2:
          _context5.next = 4;
          return takeLatest(syncGroupLinkTarget.type, linkGroupTargetSaga);

        case 4:
          _context5.next = 6;
          return takeLatest(syncGroupAddGroup.type, updateViewStateSaga);

        case 6:
          _context5.next = 8;
          return takeLatest(syncGroupRemoveGroup.type, updateViewStateSaga);

        case 8:
          _context5.next = 10;
          return takeLatest(syncGroupAddSource.type, updateViewStateSaga);

        case 10:
          _context5.next = 12;
          return takeLatest(syncGroupRemoveSource.type, updateViewStateSaga);

        case 12:
          _context5.next = 14;
          return takeLatest(syncGroupAddTarget.type, updateViewStateSaga);

        case 14:
          _context5.next = 16;
          return takeLatest(syncGroupRemoveTarget.type, updateViewStateSaga);

        case 16:
          _context5.next = 18;
          return takeLatest(syncGroupLinkTarget.type, updateViewStateSaga);

        case 18:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5$1);
}

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */
var synchronizationGroupConfig = {
  id: 'syncronizationGroupStore-module',
  reducerMap: {
    syncronizationGroupStore: reducer$1
  },
  sagas: [rootSaga$4, rootSaga$3]
};

var _marked$2 = /*#__PURE__*/regeneratorRuntime.mark(registerMapUISaga),
    _marked2$2 = /*#__PURE__*/regeneratorRuntime.mark(unregisterUIMapSaga),
    _marked3$2 = /*#__PURE__*/regeneratorRuntime.mark(rootSaga$2);
function registerMapUISaga() {
  var fields, source;
  return regeneratorRuntime.wrap(function registerMapUISaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return select(getAllMapIds);

        case 2:
          fields = _context.sent;

          if (!(fields.length === 1)) {
            _context.next = 9;
            break;
          }

          _context.next = 6;
          return select(getDialogSource, 'legend');

        case 6:
          source = _context.sent;
          _context.next = 9;
          return put(uiActions.setActiveMapIdForDialog({
            type: 'legend',
            mapId: fields[0],
            setOpen: true,
            source: source
          }));

        case 9:
        case "end":
          return _context.stop();
      }
    }
  }, _marked$2);
}
function unregisterUIMapSaga() {
  var fields, activeUI;
  return regeneratorRuntime.wrap(function unregisterUIMapSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return select(getAllMapIds);

        case 2:
          fields = _context2.sent;
          _context2.next = 5;
          return select(getDialogDetailsByType, 'legend');

        case 5:
          activeUI = _context2.sent;

          if (!(fields.length && activeUI && !fields.includes(activeUI.activeMapId))) {
            _context2.next = 11;
            break;
          }

          _context2.next = 9;
          return put(uiActions.setActiveMapIdForDialog({
            type: 'legend',
            mapId: fields[0],
            setOpen: activeUI.isOpen
          }));

        case 9:
          _context2.next = 14;
          break;

        case 11:
          if (fields.length) {
            _context2.next = 14;
            break;
          }

          _context2.next = 14;
          return put(uiActions.setToggleOpenDialog({
            type: 'legend',
            setOpen: false
          }));

        case 14:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2$2);
}
function rootSaga$2() {
  return regeneratorRuntime.wrap(function rootSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return takeLatest(mapActions$1.registerMap.type, registerMapUISaga);

        case 2:
          _context3.next = 4;
          return takeLatest(mapActions$1.unregisterMap.type, unregisterUIMapSaga);

        case 4:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3$2);
}

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */
var uiModuleConfig = {
  id: 'ui-module',
  reducerMap: {
    ui: reducer$3
  },
  sagas: [rootSaga$2]
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */
var generateUniqueLayerIds = function generateUniqueLayerIds(layers, activeLayerId) {
  // if there is an activeLayerId given, generate a unique id for it
  var activeLayerNewId = activeLayerId ? generateLayerId() : activeLayerId; // first match is set as activeLayer because there can only be one

  var activeLayerIndex = layers.findIndex(function (layer) {
    return layer.id === activeLayerId;
  });
  var layersNewIds = layers.map(function (layer, index) {
    if (layer.id && index === activeLayerIndex) {
      return Object.assign(Object.assign({}, layer), {
        id: activeLayerNewId
      });
    }

    return Object.assign(Object.assign({}, layer), {
      id: generateLayerId()
    });
  });
  return {
    layersNewIds: layersNewIds,
    activeLayerNewId: activeLayerNewId
  };
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */

var PlayButton = function PlayButton(_ref) {
  var isAnimating = _ref.isAnimating,
      isDisabled = _ref.isDisabled,
      _ref$onTogglePlayButt = _ref.onTogglePlayButton,
      onTogglePlayButton = _ref$onTogglePlayButt === void 0 ? function () {
    return null;
  } : _ref$onTogglePlayButt;

  var onTogglePlay = function onTogglePlay() {
    onTogglePlayButton();
  };

  return /*#__PURE__*/React.createElement(Tooltip, {
    title: isAnimating ? 'Pause' : 'Play'
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(ToolButton, {
    onClick: onTogglePlay,
    disabled: isDisabled,
    "data-testid": "playButton",
    active: isAnimating
  }, isAnimating ? /*#__PURE__*/React.createElement(Pause, {
    "data-testid": "pause-svg-path"
  }) : /*#__PURE__*/React.createElement(Play, {
    "data-testid": "play-svg-path"
  }))));
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */
var animationIntervalDefault = 5;
var connectRedux$6 = connect(function (store, props) {
  return {
    animationStartTime: getAnimationStartTime(store, props.mapId),
    animationEndTime: getAnimationEndTime(store, props.mapId),
    timeStep: getMapTimeStep(store, props.mapId),
    linkedMapAnimationInfo: linkedMapAnimationInfo(store, props.mapId)
  };
}, {
  mapStartAnimation: mapActions$1.mapStartAnimation,
  mapStopAnimation: mapActions$1.mapStopAnimation
});
var PlayButtonConnect = connectRedux$6(function (_ref) {
  var mapId = _ref.mapId,
      animationStartTime = _ref.animationStartTime,
      animationEndTime = _ref.animationEndTime,
      isDisabled = _ref.isDisabled,
      timeStep = _ref.timeStep,
      linkedMapAnimationInfo = _ref.linkedMapAnimationInfo,
      mapStartAnimation = _ref.mapStartAnimation,
      mapStopAnimation = _ref.mapStopAnimation;
  var animationInterval = timeStep || animationIntervalDefault;

  var onTogglePlay = function onTogglePlay() {
    if (linkedMapAnimationInfo.isAnimating) {
      mapStopAnimation({
        mapId: linkedMapAnimationInfo.id,
        origin: MapActionOrigin.map
      });
    } else {
      mapStartAnimation({
        mapId: mapId,
        start: animationStartTime,
        end: animationEndTime,
        interval: animationInterval,
        origin: MapActionOrigin.map
      });
    }
  };

  return /*#__PURE__*/React__default.createElement(PlayButton, {
    isAnimating: linkedMapAnimationInfo.isAnimating,
    isDisabled: isDisabled,
    onTogglePlayButton: function onTogglePlayButton() {
      onTogglePlay();
    }
  });
});

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2022 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2022 - Finnish Meteorological Institute (FMI)
 * */

var parseBoolean = function parseBoolean(value) {
  return ['true', 'false', true, false].includes(value) && JSON.parse(value);
};

var isBaseLayer = function isBaseLayer(layer) {
  return ['baseLayer'].includes(layer.layerType);
};

var isMapLayer = function isMapLayer(layer) {
  return ['mapLayer'].includes(layer.layerType);
};

var isOverLayer = function isOverLayer(layer) {
  return ['overLayer'].includes(layer.layerType);
};

var isValidService = function isValidService(service) {
  return Object.prototype.hasOwnProperty.call(service, 'url');
};

var parseLayerType = function parseLayerType(layer, defaultValue) {
  if (isBaseLayer(layer)) {
    return LayerType.baseLayer;
  }

  if (isMapLayer(layer)) {
    return LayerType.mapLayer;
  }

  if (isOverLayer(layer)) {
    return LayerType.overLayer;
  }

  return defaultValue;
};

var parseLayer = function parseLayer(layer) {
  var lr = JSON.parse(JSON.stringify(layer)); // Cloning used here to achieve object immutability

  if (!lr.id) {
    lr.id = generateLayerId();
  }

  if (lr.layerType) {
    lr.layerType = parseLayerType(lr, null);
  }

  if (lr.enabled) {
    lr.enabled = parseBoolean(lr.enabled);
  }

  return lr;
};

var filterBaseLayers = function filterBaseLayers(presetArray) {
  var hasLayers = presetArray && Array.isArray(presetArray) && presetArray.length > 0;
  var filteredBaseLayers = hasLayers ? presetArray.filter(function (preset) {
    return isBaseLayer(preset);
  }).map(function (filteredPresetLayer) {
    return parseLayer(filteredPresetLayer);
  }) : null;
  var hasBaseLayers = filteredBaseLayers && filteredBaseLayers.length > 0;
  var baseLayers = hasBaseLayers ? filteredBaseLayers : undefined;
  return baseLayers;
};
var filterMapLayers = function filterMapLayers(presetArray) {
  var hasLayers = presetArray && Array.isArray(presetArray) && presetArray.length > 0;
  var filteredMapLayers = hasLayers ? presetArray.filter(function (preset) {
    return isMapLayer(preset);
  }).map(function (filteredPresetLayer) {
    return parseLayer(filteredPresetLayer);
  }) : null;
  var hasMapLayers = filteredMapLayers && filteredMapLayers.length > 0;
  var mapLayers = hasMapLayers ? filteredMapLayers : undefined;
  return mapLayers;
};
var filterLayers = function filterLayers() {
  var layers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return layers.reduce(function (layers, layer) {
    var mapLayers = layers.mapLayers,
        baseLayers = layers.baseLayers,
        overLayers = layers.overLayers;

    if (layer.layerType === LayerType.baseLayer) {
      return {
        mapLayers: mapLayers,
        baseLayers: baseLayers.concat(layer),
        overLayers: overLayers
      };
    }

    if (layer.layerType === LayerType.mapLayer) {
      return {
        mapLayers: mapLayers.concat(layer),
        baseLayers: baseLayers,
        overLayers: overLayers
      };
    }

    if (layer.layerType === LayerType.overLayer) {
      return {
        mapLayers: mapLayers,
        baseLayers: baseLayers,
        overLayers: overLayers.concat(layer)
      };
    }

    return layers;
  }, {
    mapLayers: [],
    baseLayers: [],
    overLayers: []
  });
};
var filterServices = function filterServices(presetArray) {
  var hasServices = presetArray && Array.isArray(presetArray) && presetArray.length > 0;
  var validServices = hasServices ? presetArray.filter(function (preset) {
    return isValidService(preset);
  }) : null;
  var hasValidServices = validServices && validServices.length > 0;
  var services = hasValidServices ? validServices : undefined;
  return services;
};
var filterMapPresets = function filterMapPresets(presets) {
  var preset = presets && presets.preset;
  var filterredServices = preset && preset.services ? filterServices(preset.services) : undefined;
  var baseServices = preset && preset.baseServices ? filterServices(preset.baseServices) : undefined;
  var filteredBaseLayers = preset && preset.layers ? filterBaseLayers(preset.layers) : undefined;
  var filteredMapLayers = preset && preset.layers ? filterMapLayers(preset.layers) : undefined;
  var filteredPreset = {
    services: filterredServices,
    baseServices: baseServices,
    baseLayers: filteredBaseLayers,
    mapLayers: filteredMapLayers
  };
  return filteredPreset;
};
var getInitialPresets = function getInitialPresets(mapPreset, defaultInitialPresets) {
  var filteredPresets = mapPreset ? filterMapPresets(mapPreset) : null;
  var initialPresets = filteredPresets || filterMapPresets(defaultInitialPresets);
  return initialPresets;
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */
var DWD = {
  name: 'DWD',
  url: 'https://maps.dwd.de/geoserver/ows?',
  id: 'dwd'
};
var nationaalgeoregister = {
  name: 'nationaalgeoregister.nl',
  url: 'https://geodata.nationaalgeoregister.nl/cbsgebiedsindelingen/wms?request=GetCapabilities&service=wms',
  id: 'nationaalgeoregister'
};
var KNMImsgcpp = {
  name: 'KNMImsgcpp',
  url: 'https://adaguc-server-msg-cpp-portal.pmc.knmi.cloud/wms?DATASET=msgrt&',
  id: 'msgcpp-ogc-realtime'
};
var HeiGit = {
  name: 'HeiGit',
  url: 'https://maps.heigit.org/osm-wms/service',
  id: 'HeiGit-osm-wms'
};
var ArcGisCanvas = {
  name: 'ArcGisCanvas',
  url: 'https://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/',
  id: 'ArcGisCanvas'
};
var KNMIgeoservicesBaselayers = {
  name: 'KNMIgeoservicesBaselayers',
  url: 'https://geoservices.knmi.nl/wms?DATASET=baselayers&',
  id: 'KNMIgeoservicesBaselayers'
};
var KNMIgeoservicesRadar = {
  name: 'KNMIgeoservicesRadar',
  url: 'https://geoservices.knmi.nl/wms?dataset=RADAR&',
  id: 'KNMIgeoservicesRadar'
};
var KNMIgeoservicesObs = {
  name: 'KNMIgeoservicesObs',
  url: 'https://geoservices.knmi.nl/adagucserver?dataset=OBS&service=WMS&',
  id: 'KNMIgeoservicesObs'
};
var KNMIgeoservicesKlimaatAtlas = {
  name: 'KNMIgeoservicesKlimaatAtlas',
  url: 'https://geoservices.knmi.nl/wms?DATASET=gsie-dataset&SERVICE=WMS&',
  id: 'KNMIgeoservicesKlimaatAtlas'
};
var KNMIgeoservicesHarmonie = {
  name: 'KNMIgeoservicesHarmonie',
  url: 'https://geoservices.knmi.nl/wms?DATASET=HARM_N25&',
  id: 'KNMIgeoservicesKliKNMIgeoservicesHarmoniemaatAtlas'
};
var KNMIgeoservicesHarmonieMLService = {
  name: 'KNMI Harmonie ML',
  url: 'https://geoservices.knmi.nl/wms?DATASET=HARM_N25_ML&SERVICE=WMS&',
  id: 'harmonieML'
};
var MetNorwayService = {
  name: 'MetNorwayService',
  url: 'https://wms-e1.geoweb.met.no/wms?',
  id: 'MetNorwayService'
};
var FMIopenwms = {
  name: 'FMIopenwms',
  url: 'https://openwms.fmi.fi/geoserver/wms?',
  id: 'FMIopenwms'
};
var DWDObservations = {
  name: 'DWDObservations',
  url: 'https://maps.dwd.de/geoserver/dwd/Wetter_Beobachtungen/ows?',
  id: 'DWDObservations'
};
var DWDWarnings = {
  name: 'DWDWarnings',
  url: 'https://maps.dwd.de/geoserver/dwd/Warnungen_Gemeinden_vereinigt/ows?',
  id: 'DWDWarnings'
};
var DWDWXProdukt = {
  name: 'DWDWXProdukt',
  url: 'https://maps.dwd.de/geoserver/dwd/WX-Produkt/ows?',
  id: 'DWDWXProdukt'
};
var EUMETSAT = {
  name: 'EUMETSAT',
  url: 'https://view.eumetsat.int/geoserver/wms?',
  id: 'EUMETSAT'
};
var eumetviewEUMETSAT = {
  name: 'eumetviewEUMETSAT',
  url: 'https://eumetview.eumetsat.int/geoserv/wms?',
  id: 'eumetviewEUMETSAT'
};
var ECMWFPublicService = {
  name: 'ECMWF',
  url: 'https://eccharts.ecmwf.int/wms/?token=public',
  id: 'ecmwf'
};
var MeteoCanada = {
  name: 'Meteo Canada',
  url: 'https://geo.weather.gc.ca/geomet/?lang=en&',
  id: 'MeteoCanada'
};

var publicServices = /*#__PURE__*/Object.freeze({
  __proto__: null,
  DWD: DWD,
  nationaalgeoregister: nationaalgeoregister,
  KNMImsgcpp: KNMImsgcpp,
  HeiGit: HeiGit,
  ArcGisCanvas: ArcGisCanvas,
  KNMIgeoservicesBaselayers: KNMIgeoservicesBaselayers,
  KNMIgeoservicesRadar: KNMIgeoservicesRadar,
  KNMIgeoservicesObs: KNMIgeoservicesObs,
  KNMIgeoservicesKlimaatAtlas: KNMIgeoservicesKlimaatAtlas,
  KNMIgeoservicesHarmonie: KNMIgeoservicesHarmonie,
  KNMIgeoservicesHarmonieMLService: KNMIgeoservicesHarmonieMLService,
  MetNorwayService: MetNorwayService,
  FMIopenwms: FMIopenwms,
  DWDObservations: DWDObservations,
  DWDWarnings: DWDWarnings,
  DWDWXProdukt: DWDWXProdukt,
  EUMETSAT: EUMETSAT,
  eumetviewEUMETSAT: eumetviewEUMETSAT,
  ECMWFPublicService: ECMWFPublicService,
  MeteoCanada: MeteoCanada
});

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */
var baseLayer$1 = {
  name: 'arcGisSat',
  title: 'arcGisSat',
  type: 'twms',
  layerType: LayerType.baseLayer,
  enabled: true,
  id: generateLayerId()
}; // Base Layers List

var baseLayerGrey$1 = {
  id: generateLayerId(),
  name: 'WorldMap_Light_Grey_Canvas',
  type: 'twms',
  layerType: LayerType.baseLayer
};
var baseLayerOpenStreetMapNL$1 = {
  id: 'base-layer-2',
  name: 'OpenStreetMap_NL',
  type: 'twms',
  layerType: LayerType.baseLayer,
  enabled: true
};
var baseLayerArcGisCanvas$1 = {
  service: ArcGisCanvas.url,
  id: generateLayerId(),
  name: 'arcGisCanvas',
  type: 'twms',
  enabled: true,
  layerType: LayerType.baseLayer
};
var baseLayerWorldMap$1 = {
  id: generateLayerId(),
  name: 'WorldMap',
  type: 'twms',
  layerType: LayerType.baseLayer,
  enabled: true
};
var baseLayerHeiGit = {
  service: HeiGit.url,
  id: generateLayerId(),
  name: 'osm_auto:all',
  layerType: LayerType.baseLayer
}; // Over Layers List

var overLayer$1 = {
  service: KNMIgeoservicesBaselayers.url,
  name: 'countryborders',
  format: 'image/png',
  enabled: true,
  id: generateLayerId(),
  layerType: LayerType.overLayer
}; // KNMI msgcpp List

var msgCppLayer = {
  // doesn't work with https
  service: KNMImsgcpp.url,
  name: 'lwe_precipitation_rate',
  format: 'image/png',
  enabled: true,
  style: 'precip-transparent/nearest',
  id: generateLayerId(),
  layerType: LayerType.mapLayer
}; // Nederlandse Nationaal Georegister Layers list

var veiligheidsRegiosGebiedsIndelingenLabels = {
  service: nationaalgeoregister.url,
  name: 'cbsgebiedsindelingen:cbs_veiligheidsregio_2020_labelpoint',
  style: 'CBS_Label',
  enabled: false,
  layerType: LayerType.mapLayer
};
var veiligheidsRegiosGebiedsIndelingen = {
  service: nationaalgeoregister.url,
  name: 'cbsgebiedsindelingen:cbs_veiligheidsregio_2020_gegeneraliseerd',
  style: 'CBS_Gebiedsindeling',
  enabled: false,
  layerType: LayerType.mapLayer
}; // KNMI Geoservices Layers List

var radarLayer$1 = {
  service: KNMIgeoservicesRadar.url,
  name: 'RAD_NL25_PCP_CM',
  format: 'image/png',
  enabled: true,
  style: 'radar/nearest',
  id: generateLayerId(),
  layerType: LayerType.mapLayer
};
var radarLayerWithError = {
  service: KNMIgeoservicesRadar.url,
  name: 'radarLayer',
  format: 'image/png',
  enabled: true,
  style: 'knmiradar/nearest',
  id: generateLayerId(),
  layerType: LayerType.mapLayer
};
var obsAirTemperature = {
  service: KNMIgeoservicesObs.url,
  name: '10M/ta',
  id: generateLayerId(),
  layerType: LayerType.mapLayer
};
var obsWind = {
  service: KNMIgeoservicesObs.url,
  name: '10M/wind',
  id: generateLayerId(),
  layerType: LayerType.mapLayer
};
var obsAirPressureAtSeaLevel = {
  service: KNMIgeoservicesObs.url,
  name: '10M/pp',
  id: generateLayerId(),
  layerType: LayerType.mapLayer
};
var obsRelativeHumidity = {
  service: KNMIgeoservicesObs.url,
  name: '10M/rh',
  id: generateLayerId(),
  layerType: LayerType.mapLayer
};
var obsGlobalSolarRadiation = {
  service: KNMIgeoservicesObs.url,
  name: '10M/qg',
  id: generateLayerId(),
  layerType: LayerType.mapLayer
};
var obsPrecipitationIntensityPWS = {
  service: KNMIgeoservicesObs.url,
  name: '10M/pg',
  id: generateLayerId(),
  layerType: LayerType.mapLayer
};
var harmonieRelativeHumidityPl = {
  service: KNMIgeoservicesHarmonie.url,
  name: 'relative_humidity__at_pl',
  id: generateLayerId(),
  layerType: LayerType.mapLayer,
  enabled: true
};
var harmonieWindPl = {
  service: KNMIgeoservicesHarmonie.url,
  name: 'wind__at_pl',
  id: generateLayerId(),
  layerType: LayerType.mapLayer,
  enabled: true
};
var harmonieAirTemperature = {
  service: KNMIgeoservicesHarmonie.url,
  name: 'air_temperature__at_2m',
  id: generateLayerId(),
  layerType: LayerType.mapLayer,
  enabled: true
};
var harmoniePrecipitation = {
  service: KNMIgeoservicesHarmonie.url,
  name: 'precipitation_flux',
  id: generateLayerId(),
  layerType: LayerType.mapLayer,
  enabled: true
};
var harmoniePressure = {
  service: KNMIgeoservicesHarmonie.url,
  name: 'air_pressure_at_sea_level',
  id: generateLayerId(),
  layerType: LayerType.mapLayer,
  enabled: true
};
var harmonieWindFlags = {
  service: KNMIgeoservicesHarmonie.url,
  name: 'wind__at_10m',
  enabled: true,
  id: generateLayerId(),
  layerType: LayerType.mapLayer
};
var klimaatAtlasTG3 = {
  service: KNMIgeoservicesKlimaatAtlas.url,
  name: 'TG3',
  enabled: true,
  id: generateLayerId(),
  layerType: LayerType.mapLayer
}; // DWD Layers List

var dwdWarningLayer = {
  service: DWDWarnings.url,
  name: 'Warnungen_Gemeinden_vereinigt',
  format: 'image/png',
  // style: 'warnungen_gemeinden_vereinigt_event_seamless_param',
  enabled: true,
  id: generateLayerId(),
  layerType: LayerType.mapLayer
};
var dwdRadarLayer = {
  service: DWDWXProdukt.url,
  name: 'WX-Produkt',
  format: 'image/png',
  enabled: true,
  id: generateLayerId(),
  layerType: LayerType.mapLayer
}; // this needs authentication to work

var dwdObservationsWetterLayer = {
  service: DWDObservations.url,
  name: 'Wetter_Beobachtungen',
  style: 'Wetter_Symbole',
  format: 'image/png',
  enabled: true,
  id: generateLayerId(),
  layerType: LayerType.mapLayer // headers: [{ name: 'Authorization', value: 'Basic ...' }]

};
var dwdObservationsWetterLayerWithHeader = {
  service: DWDObservations.url,
  name: 'Wetter_Beobachtungen',
  style: 'Wetter_Symbole',
  format: 'image/png',
  enabled: true,
  id: generateLayerId(),
  layerType: LayerType.mapLayer,
  headers: [{
    name: 'authorization',
    value: 'Basic aW50cmFuZXQtdXNlcjpDQnMjMTEh'
  }]
}; // this needs authentication to work

var dwdObservationsWindLayer = {
  service: DWDObservations.url,
  name: 'Wetter_Beobachtungen',
  style: 'Wetter_Wind',
  format: 'image/png',
  enabled: true,
  id: generateLayerId(),
  layerType: LayerType.mapLayer
}; // FMI open wms Layers List

var FMITemp = {
  service: FMIopenwms.url,
  name: 'temperature-forecast',
  format: 'image/png',
  enabled: true,
  id: generateLayerId(),
  layerType: LayerType.mapLayer
}; // Met Norway Layers List

var MetNoTemp = {
  service: MetNorwayService.url,
  name: 'thredds_meps_latest_wind',
  format: 'image/png',
  enabled: true,
  id: generateLayerId(),
  layerType: LayerType.mapLayer
};
var metNorwayWind1 = {
  service: MetNorwayService.url,
  name: 'thredds_meps_latest_wind',
  format: 'image/png',
  enabled: true,
  id: generateLayerId(),
  layerType: LayerType.mapLayer
};
var metNorwayWind2 = {
  service: MetNorwayService.url,
  name: 'thredds_aromearctic_extracted_t',
  format: 'image/png',
  enabled: true,
  id: generateLayerId(),
  layerType: LayerType.mapLayer
};
var metNorwayWind3 = {
  service: MetNorwayService.url,
  name: 'thredds_nk800_temperature',
  format: 'image/png',
  enabled: true,
  id: generateLayerId(),
  layerType: LayerType.mapLayer
};
var metNorwayLatestT = {
  service: MetNorwayService.url,
  name: 'thredds_meps_latest_t',
  format: 'image/png',
  enabled: true,
  id: generateLayerId(),
  layerType: LayerType.mapLayer
};
var metNorwaySalinaty = {
  service: MetNorwayService.url,
  name: 'thredds_barents_2_5km_1h_salinity',
  format: 'image/png',
  enabled: true,
  id: generateLayerId(),
  layerType: LayerType.mapLayer
};
var msgFesEUMETSAT = {
  service: EUMETSAT.url,
  name: 'msg_fes:rgb_eview',
  enabled: true,
  id: generateLayerId(),
  layerType: LayerType.mapLayer
};
var msgNaturalenhncdEUMETSAT = {
  service: eumetviewEUMETSAT.url,
  name: 'meteosat:msg_naturalenhncd',
  enabled: true,
  id: generateLayerId(),
  layerType: LayerType.mapLayer
};
var msgAshEUMETSAT = {
  service: eumetviewEUMETSAT.url,
  name: 'meteosat:msg_ash',
  enabled: true,
  id: generateLayerId(),
  layerType: LayerType.mapLayer
};
var msgCthEUMETSAT = {
  service: eumetviewEUMETSAT.url,
  name: 'meteosat:msg_cth',
  enabled: true,
  id: generateLayerId(),
  layerType: LayerType.mapLayer
};
var msgFogEUMETSAT = {
  service: eumetviewEUMETSAT.url,
  name: 'meteosat:msg_fog',
  enabled: true,
  id: generateLayerId(),
  layerType: LayerType.mapLayer
};
var msgNaturalEUMETSAT = {
  service: eumetviewEUMETSAT.url,
  name: 'meteosat:msg_natural',
  enabled: true,
  id: generateLayerId(),
  layerType: LayerType.mapLayer
};

var publicLayers = /*#__PURE__*/Object.freeze({
  __proto__: null,
  baseLayer: baseLayer$1,
  baseLayerGrey: baseLayerGrey$1,
  baseLayerOpenStreetMapNL: baseLayerOpenStreetMapNL$1,
  baseLayerArcGisCanvas: baseLayerArcGisCanvas$1,
  baseLayerWorldMap: baseLayerWorldMap$1,
  baseLayerHeiGit: baseLayerHeiGit,
  overLayer: overLayer$1,
  msgCppLayer: msgCppLayer,
  veiligheidsRegiosGebiedsIndelingenLabels: veiligheidsRegiosGebiedsIndelingenLabels,
  veiligheidsRegiosGebiedsIndelingen: veiligheidsRegiosGebiedsIndelingen,
  radarLayer: radarLayer$1,
  radarLayerWithError: radarLayerWithError,
  obsAirTemperature: obsAirTemperature,
  obsWind: obsWind,
  obsAirPressureAtSeaLevel: obsAirPressureAtSeaLevel,
  obsRelativeHumidity: obsRelativeHumidity,
  obsGlobalSolarRadiation: obsGlobalSolarRadiation,
  obsPrecipitationIntensityPWS: obsPrecipitationIntensityPWS,
  harmonieRelativeHumidityPl: harmonieRelativeHumidityPl,
  harmonieWindPl: harmonieWindPl,
  harmonieAirTemperature: harmonieAirTemperature,
  harmoniePrecipitation: harmoniePrecipitation,
  harmoniePressure: harmoniePressure,
  harmonieWindFlags: harmonieWindFlags,
  klimaatAtlasTG3: klimaatAtlasTG3,
  dwdWarningLayer: dwdWarningLayer,
  dwdRadarLayer: dwdRadarLayer,
  dwdObservationsWetterLayer: dwdObservationsWetterLayer,
  dwdObservationsWetterLayerWithHeader: dwdObservationsWetterLayerWithHeader,
  dwdObservationsWindLayer: dwdObservationsWindLayer,
  FMITemp: FMITemp,
  MetNoTemp: MetNoTemp,
  metNorwayWind1: metNorwayWind1,
  metNorwayWind2: metNorwayWind2,
  metNorwayWind3: metNorwayWind3,
  metNorwayLatestT: metNorwayLatestT,
  metNorwaySalinaty: metNorwaySalinaty,
  msgFesEUMETSAT: msgFesEUMETSAT,
  msgNaturalenhncdEUMETSAT: msgNaturalenhncdEUMETSAT,
  msgAshEUMETSAT: msgAshEUMETSAT,
  msgCthEUMETSAT: msgCthEUMETSAT,
  msgFogEUMETSAT: msgFogEUMETSAT,
  msgNaturalEUMETSAT: msgNaturalEUMETSAT
});

var CanvasComponent = /*#__PURE__*/function (_Component) {
  _inherits(CanvasComponent, _Component);

  var _super = _createSuper(CanvasComponent);

  function CanvasComponent(props) {
    var _this;

    _classCallCheck(this, CanvasComponent);

    _this = _super.call(this, props);
    _this.canvas = null;
    _this.ctx = null;
    _this.currentWidth = 1;
    _this.currentHeight = 1;
    _this.canvascontaineroutside = null;
    _this.canvascontainer = null;
    _this.timer = null;
    _this.redrawTimer = null;
    _this.loopHasStarted = false;
    _this.mounted = false;
    _this.updateCanvas = _this.updateCanvas.bind(_assertThisInitialized(_this));
    _this.handleMouseMoveEvent = _this.handleMouseMoveEvent.bind(_assertThisInitialized(_this));
    _this.handleMouseUpEvent = _this.handleMouseUpEvent.bind(_assertThisInitialized(_this));
    _this.handleMouseDownEvent = _this.handleMouseDownEvent.bind(_assertThisInitialized(_this));
    _this.resize = _this.resize.bind(_assertThisInitialized(_this));
    _this._handleWindowResize = _this._handleWindowResize.bind(_assertThisInitialized(_this));
    _this.handleClickEvent = _this.handleClickEvent.bind(_assertThisInitialized(_this));
    _this.handleWheelEvent = _this.handleWheelEvent.bind(_assertThisInitialized(_this));
    _this.handleTouchStartEvent = _this.handleTouchStartEvent.bind(_assertThisInitialized(_this));
    _this.handleTouchEndEvent = _this.handleTouchEndEvent.bind(_assertThisInitialized(_this));
    _this.handleTouchMoveEvent = _this.handleTouchMoveEvent.bind(_assertThisInitialized(_this));
    _this.onKeyUp = _this.onKeyUp.bind(_assertThisInitialized(_this));
    _this.onBlur = _this.onBlur.bind(_assertThisInitialized(_this));
    _this.onFocus = _this.onFocus.bind(_assertThisInitialized(_this));
    _this.startLoop = _this.startLoop.bind(_assertThisInitialized(_this));
    _this._documentKeyDown = _this._documentKeyDown.bind(_assertThisInitialized(_this));
    _this._isFocussed = false;
    _this.canvas = null;
    _this.canvascontaineroutside = /*#__PURE__*/React__default.createRef();
    _this.canvascontainer = /*#__PURE__*/React__default.createRef();
    return _this;
  }

  _createClass(CanvasComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.mounted = true;

      if (this.canvas) {
        this.canvas.addEventListener('mousemove', this.handleMouseMoveEvent);
        this.canvas.addEventListener('mouseup', this.handleMouseUpEvent);
        this.canvas.addEventListener('mousedown', this.handleMouseDownEvent);
        this.canvas.addEventListener('touchstart', this.handleTouchStartEvent);
        this.canvas.addEventListener('touchend', this.handleTouchEndEvent);
        this.canvas.addEventListener('touchmove', this.handleTouchMoveEvent);
        this.canvas.addEventListener('wheel', this.handleWheelEvent);
        this.canvas.addEventListener('click', this.handleClickEvent);
        document.addEventListener('keydown', this._documentKeyDown, false);
        this.resize();
        this.updateCanvas();
      }

      var _this$props = this.props,
          onKeyUp = _this$props.onKeyUp,
          loopInterval = _this$props.redrawInterval;
      if (onKeyUp) window.addEventListener('keyup', this.onKeyUp);
      window.addEventListener('resize', this._handleWindowResize);

      if (this.canvascontaineroutside && this.canvascontaineroutside.current && onKeyUp) {
        this.canvascontaineroutside.current.focus();
      }

      this.timer = setInterval(function () {
        _this2.resize();
      }, 1000);

      if (loopInterval) {
        this.redrawTimer = setInterval(function () {
          _this2.updateCanvas();
        }, loopInterval);
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      var _this3 = this;

      window.requestAnimationFrame(function () {
        _this3.updateCanvas();
      });
      return false;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
      window.removeEventListener('resize', this._handleWindowResize);
      var onKeyUp = this.props.onKeyUp;
      if (onKeyUp) window.removeEventListener('keyup', this.onKeyUp);

      if (this.canvas) {
        this.canvas.removeEventListener('mousedown', this.handleMouseDownEvent);
        this.canvas.removeEventListener('mouseup', this.handleMouseUpEvent);
        this.canvas.removeEventListener('mousemove', this.handleMouseMoveEvent);
        this.canvas.removeEventListener('touchstart', this.handleTouchStartEvent);
        this.canvas.removeEventListener('touchend', this.handleTouchEndEvent);
        this.canvas.removeEventListener('touchmove', this.handleTouchMoveEvent);
        this.canvas.removeEventListener('wheel', this.handleWheelEvent);
        this.canvas.removeEventListener('click', this.handleClickEvent);
        document.removeEventListener('keydown', this._documentKeyDown);
      }

      clearInterval(this.timer);
      clearInterval(this.redrawTimer);
    }
  }, {
    key: "onFocus",
    value: function onFocus() {
      var isFocussed = this.props.isFocussed;
      this._isFocussed = true;

      if (isFocussed) {
        isFocussed(true);
      }
    }
  }, {
    key: "onBlur",
    value: function onBlur() {
      var isFocussed = this.props.isFocussed;
      this._isFocussed = false;

      if (isFocussed) {
        isFocussed(false);
      }
    }
  }, {
    key: "onKeyUp",
    value: function onKeyUp(event) {
      var onKeyUp = this.props.onKeyUp;
      if (onKeyUp) onKeyUp(event);

      if (this.canvascontaineroutside && this.canvascontaineroutside.current && onKeyUp) {
        if (event.code === 'Escape') {
          this.canvascontaineroutside.current.focus();
        }
      }
    }
  }, {
    key: "_documentKeyDown",
    value: function _documentKeyDown(event) {
      if (this._isFocussed) {
        var onKeyDown = this.props.onKeyDown;
        if (onKeyDown) onKeyDown(event);
      }
    }
  }, {
    key: "_handleWindowResize",
    value: function _handleWindowResize() {
      this.resize();
    }
  }, {
    key: "startLoop",
    value: function startLoop() {
      var onRenderCanvas = this.props.onRenderCanvas;
      if (this.mounted === false || this.loopHasStarted === false) return;

      if (this.canvas) {
        onRenderCanvas(this.ctx, this.currentWidth, this.currentHeight, this.canvas);
      }

      requestAnimationFrame(this.startLoop);
    }
  }, {
    key: "updateCanvas",
    value: function updateCanvas() {
      if (!this.canvas) {
        return;
      }

      var _this$props2 = this.props,
          onRenderCanvas = _this$props2.onRenderCanvas,
          loop = _this$props2.loop;
      this.ctx = this.canvas.getContext('2d');

      if (!this.ctx) {
        return;
      }

      if (parseInt(this.ctx.canvas.height, 10) !== this.currentHeight) {
        this.ctx.canvas.height = this.currentHeight;
      }

      if (parseInt(this.ctx.canvas.width, 10) !== this.currentWidth) {
        this.ctx.canvas.width = this.currentWidth;
      }

      if (loop !== true) {
        this.loopHasStarted = false;
        onRenderCanvas(this.ctx, this.currentWidth, this.currentHeight, this.canvas);
      } else if (this.loopHasStarted === false) {
        this.loopHasStarted = true;
        this.startLoop();
      }
    }
  }, {
    key: "resize",
    value: function resize() {
      var canvascontainer = this.canvascontainer,
          resizeCallback = this.props.resizeCallback;

      if (canvascontainer && canvascontainer.current) {
        var newWidth = canvascontainer.current.clientWidth;
        var newHeight = canvascontainer.current.clientHeight;

        if (newWidth !== undefined && newHeight !== undefined && (this.currentWidth !== newWidth || this.currentHeight !== newHeight)) {
          this.currentWidth = newWidth;
          this.currentHeight = newHeight;
          this.updateCanvas();
          resizeCallback && resizeCallback(newWidth);
        }
      }
    }
  }, {
    key: "handleMouseMoveEvent",
    value: function handleMouseMoveEvent(event) {
      var _this$props3 = this.props,
          onMouseMove = _this$props3.onMouseMove,
          onCanvasClick = _this$props3.onCanvasClick;
      var x = event.offsetX;
      var y = event.offsetY;

      if (event.buttons === 1) {
        onCanvasClick(x, y, this.currentWidth, this.currentHeight);
      }

      onMouseMove(x, y, event, this.currentWidth);
    }
  }, {
    key: "handleMouseUpEvent",
    value: function handleMouseUpEvent() {
      var onMouseUp = this.props.onMouseUp;
      onMouseUp();
    }
  }, {
    key: "handleMouseDownEvent",
    value: function handleMouseDownEvent(event) {
      var onMouseDown = this.props.onMouseDown;
      var x = event.offsetX;
      var y = event.offsetY;
      onMouseDown(x, y, this.currentWidth);
    }
  }, {
    key: "handleTouchStartEvent",
    value: function handleTouchStartEvent(event) {
      var onTouchStart = this.props.onTouchStart;
      onTouchStart(event, this.currentWidth);
    }
  }, {
    key: "handleTouchEndEvent",
    value: function handleTouchEndEvent() {
      var onTouchEnd = this.props.onTouchEnd;
      onTouchEnd();
    }
  }, {
    key: "handleTouchMoveEvent",
    value: function handleTouchMoveEvent(event) {
      var _this$props4 = this.props,
          onTouchMove = _this$props4.onTouchMove,
          onCanvasClick = _this$props4.onCanvasClick;
      var touches = event && event.touches && event.touches[0];

      if (touches && touches.clientX && touches.clientY) {
        var x2 = event.touches[0].clientX - event.touches[0].target.offsetLeft;
        var y2 = event.touches[0].clientY;
        onCanvasClick(x2, y2, this.currentWidth, this.currentHeight);
      }

      onTouchMove(event, this.currentWidth);
    }
  }, {
    key: "handleClickEvent",
    value: function handleClickEvent(event) {
      var onCanvasClick = this.props.onCanvasClick;
      var x = event.offsetX;
      var y = event.offsetY;
      onCanvasClick(x, y, this.currentWidth, this.currentHeight);
    }
  }, {
    key: "handleWheelEvent",
    value: function handleWheelEvent(event) {
      var onWheel = this.props.onWheel;
      onWheel({
        event: event,
        deltaY: event.deltaY,
        deltaX: event.deltaX,
        canvasWidth: event.srcElement.width,
        mouseX: event.offsetX
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      this.updateCanvas();

      this._handleWindowResize();

      return /*#__PURE__*/React__default.createElement("div", {
        role: "button",
        ref: this.canvascontaineroutside,
        tabIndex: 0,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        style: {
          height: '100%',
          width: '100%',
          border: 'none',
          display: 'block',
          overflow: 'hidden'
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        ref: this.canvascontainer,
        style: {
          minWidth: 'inherit',
          minHeight: 'inherit',
          width: 'inherit',
          height: 'inherit',
          overflow: 'hidden',
          display: 'block',
          border: 'none'
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        style: {
          overflow: 'visible',
          width: 0,
          height: 0
        }
      }, /*#__PURE__*/React__default.createElement("canvas", {
        ref: function ref(canvas) {
          _this4.canvas = canvas;
        }
      }))));
    }
  }]);

  return CanvasComponent;
}(Component); // eslint-disable-next-line react/static-property-placement
CanvasComponent.defaultProps = {
  onRenderCanvas: function onRenderCanvas() {
    /* intentionally left blank */
  },
  onCanvasClick: function onCanvasClick() {
    /* intentionally left blank */
  },
  onMouseMove: function onMouseMove() {
    /* intentionally left blank */
  },
  onMouseUp: function onMouseUp() {
    /* intentionally left blank */
  },
  onMouseDown: function onMouseDown() {
    /* intentionally left blank */
  },
  onTouchStart: function onTouchStart() {
    /* intentionally left blank */
  },
  onTouchEnd: function onTouchEnd() {
    /* intentionally left blank */
  },
  onTouchMove: function onTouchMove() {
    /* intentionally left blank */
  },
  onWheel: function onWheel() {
    /* intentionally left blank */
  }
};

var defaultCanvasWidth = 150;
var defaultCanvasHeight = 30; // TODO: remove fontFamily styles after theming is fully implemented

var useStyles$s = makeStyles(function (theme) {
  return {
    legendCanvas: {
      margin: '10px 0px 10px 0px'
    },
    noLegendTitle: {
      fontSize: '12px',
      fontFamily: 'Roboto, Helvetica, Arial',
      color: 'red'
    },
    legendComponent: {
      padding: 10,
      border: '1px solid grey',
      display: 'inline-block',
      backgroundColor: '#FFF',
      overflow: 'hidden',
      marginBottom: 4
    },
    legendTitle: {
      fontFamily: 'Roboto, Helvetica, Arial',
      fontSize: '10px',
      minWidth: defaultCanvasWidth,
      wordWrap: 'break-word',
      color: theme.palette.common.black
    },
    legendInfo: {
      fontFamily: 'Roboto, Helvetica, Arial',
      fontSize: 10,
      color: theme.palette.common.black,
      overflowX: 'hidden',
      minWidth: defaultCanvasWidth,
      wordWrap: 'break-word'
    }
  };
});
/**
 * Renders a legendgraphic image based on a WMImage.
 *
 * @param wmImage The wmImage element to render (from WMImage.js)
 * @param ctx The canvas to render the image on
 * @param width The width you want the image to have
 * @param height The height you want the image to have
 */

var renderLegendGraphic = function renderLegendGraphic(wmImage, ctx, width, height) {
  ctx.beginPath();
  ctx.fillStyle = 'white';
  ctx.rect(0, 0, width, height);
  ctx.fill();

  if (wmImage) {
    if (wmImage.isLoading()) {
      /* Legend image is loading */
      ctx.fillStyle = 'blue';
      ctx.fillText('... loading ...', 10, 10);
    } else if (wmImage.hasError()) {
      /* Legend image has an error */
      ctx.fillStyle = 'red';
      ctx.fillText('error :(', 10, 10);
    } else {
      /* All OK, just draw the legend image */
      ctx.drawImage(wmImage.getElement(), 0, 0, Math.min(wmImage.getElement().width, width), Math.min(wmImage.getElement().height, height));
    }
  }
};

var Legend = function Legend(_ref) {
  var layer = _ref.layer;
  var classes = useStyles$s();
  /* Variable to remember the previous image */

  var previousLegendImage = useRef(null);
  /* Function to force rerender of this component when legend image loads */

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      setState = _useState2[1];

  var layerId = layer && layer.id;
  /* The canvas listens to the size of its container. We will update it according to the image size. */

  var _useState3 = useState(defaultCanvasWidth),
      _useState4 = _slicedToArray(_useState3, 2),
      canvasContainerWidth = _useState4[0],
      setCanvasContainerWidth = _useState4[1];

  var _useState5 = useState(defaultCanvasHeight),
      _useState6 = _slicedToArray(_useState5, 2),
      canvasContainerHeight = _useState6[0],
      setCanvasContainerHeight = _useState6[1];

  var imageWidth;
  var imageHeight;
  /* Register callback to legendImagestore to trigger rerender when image is loaded. */

  useEffect(function () {
    legendImageStore.addImageEventCallback(function (image, id, imageEventType) {
      if (imageEventType === WMImageEventType.Loaded) {
        setState(null);
      }
    }, "Legend_".concat(layerId));
    return function () {
      legendImageStore.removeEventCallback("Legend_".concat(layerId));
    };
  }, [layerId]);
  /* Should not do anything if no layer is given */

  if (!layer) return null;
  var isLayerEnabled = layer.enabled;
  if (!isLayerEnabled) return null;
  var layerOpacity = layer.opacity ? layer.opacity : 1;
  /* Get the wmLayer, it has more detailed info about the WMS service,
  like a title and the WMS legendgraphic url */

  var wmLayer = getWMLayerById(layer.id);
  return /*#__PURE__*/React__default.createElement(Paper, {
    "data-testid": "legend",
    className: classes.legendComponent
  }, /*#__PURE__*/React__default.createElement("div", {
    "data-testid": "legend-title",
    style: {
      maxWidth: canvasContainerWidth
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    className: classes.legendTitle,
    variant: "h3"
  }, wmLayer && wmLayer.title)), /*#__PURE__*/React__default.createElement(Tooltip, {
    title: wmLayer && wmLayer.title || 'loading',
    placement: "top"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.legendCanvas,
    style: {
      height: canvasContainerHeight,
      width: canvasContainerWidth
    }
  }, /*#__PURE__*/React__default.createElement(CanvasComponent, {
    redrawInterval: 500,
    onRenderCanvas: function onRenderCanvas(ctx, width, height) {
      /*
        Check if the wmLayer is available, this happens when the WMS GetCapabilities is loaded and parsed.
        Note that we cannot use the wmLayer variable above, as this one could contain a non initialized WMJSLayer.
       */
      var legendWmLayer = getWMLayerById(layer.id);
      var legendUrl = getLegendGraphicURLForLayer(legendWmLayer);
      var image = legendImageStore.getImage(legendUrl);
      /* If there is no image for the given URL, we do not want to display a legend image (e.g. outside range) */

      if (!image) {
        previousLegendImage.current = null;
        setCanvasContainerWidth(defaultCanvasWidth);
        setCanvasContainerHeight(defaultCanvasHeight);
        ctx.beginPath();
        ctx.fillStyle = '#fff';
        ctx.rect(0, 0, width, height);
        ctx.fill();
        ctx.fillStyle = 'black';

        if (!legendUrl) {
          ctx.fillText('No legend graphic available', 5, 16);
        }
      } else {
        /* If there is an image for the given url, and has no error, but it is not yet loading or loaded, start loading it! */
        if (image && image.hasError() === false && image.isLoaded() === false && image.isLoading() === false) {
          image.load();
          /* Will eventually trigger the callback used in the useEffect */
        }
        /* If the image is ready, we can show it in the component, store it in our ref, otherwise we keep the previous image to prevent flickering */


        if (image && image.isLoaded()) {
          previousLegendImage.current = image;
          /* Set the canvas container to the same size as the image */

          imageHeight = image.getHeight();
          setCanvasContainerHeight(imageHeight);
          imageWidth = image.getWidth();
          setCanvasContainerWidth(imageWidth);
          /* Give the canvas a white background before adding the image */

          ctx.fillStyle = '#fff';
          ctx.rect(0, 0, width, height);
          ctx.fill();
          /* Set the opacity used in the layer */

          ctx.globalAlpha = layerOpacity;
        }

        renderLegendGraphic(previousLegendImage.current, ctx, imageWidth, imageHeight);
      }
    }
  }))), /*#__PURE__*/React__default.createElement("div", {
    "data-testid": "legend-info",
    className: classes.legendInfo,
    style: {
      maxWidth: canvasContainerWidth
    }
  }, layer.dimensions && layer.dimensions.map(function (dim) {
    return /*#__PURE__*/React__default.createElement("div", {
      key: layer.name + dim.name
    }, dim.name === 'time' ? "".concat(dim.currentValue) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      style: {
        fontWeight: 500
      }
    }, dim.name, ":"), dim.currentValue, " ", dim.units));
  })));
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */
var useStyles$r = makeStyles(function () {
  return {
    legendList: {
      display: 'flex',
      flexDirection: 'column',
      '&>div:last-child': {
        marginBottom: 0
      }
    },
    legendContainer: {
      padding: 4
    }
  };
});

var LegendDialog = function LegendDialog(_ref) {
  var layers = _ref.layers,
      isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      _ref$onMouseDown = _ref.onMouseDown,
      onMouseDown = _ref$onMouseDown === void 0 ? function () {} : _ref$onMouseDown,
      mapId = _ref.mapId,
      _ref$showMapId = _ref.showMapId,
      showMapId = _ref$showMapId === void 0 ? false : _ref$showMapId,
      _ref$order = _ref.order,
      order = _ref$order === void 0 ? 0 : _ref$order,
      _ref$source = _ref.source,
      source = _ref$source === void 0 ? 'app' : _ref$source;
  var classes = useStyles$r();
  return /*#__PURE__*/React.createElement(ToolContainerDraggable, {
    startPosition: {
      right: 20,
      top: 50
    },
    minWidth: 100,
    onClose: onClose,
    title: showMapId ? "Legend ".concat(mapId) : 'Legend',
    headerSize: "small",
    initialMaxHeight: 440,
    isOpen: isOpen,
    "data-testid": "moveable-legend",
    bounds: "parent",
    onMouseDown: onMouseDown,
    order: order,
    source: source
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.legendContainer
  }, layers && layers.length > 0 ? /*#__PURE__*/React.createElement("div", {
    "data-testid": "LegendList",
    className: classes.legendList
  }, layers.map(function (layer) {
    return /*#__PURE__*/React.createElement(Legend, {
      key: layer.id,
      layer: layer
    });
  })) : /*#__PURE__*/React.createElement(Typography, {
    "data-testid": "NoLayers",
    variant: "body1",
    style: {
      fontWeight: 500,
      fontSize: 14
    }
  }, "No layers")));
};

var IS_LEGEND_OPEN_BY_DEFAULT = false;

var LegendConnectComponent = function LegendConnectComponent(_ref) {
  var _ref$showMapId = _ref.showMapId,
      showMapId = _ref$showMapId === void 0 ? false : _ref$showMapId,
      _ref$source = _ref.source,
      source = _ref$source === void 0 ? 'app' : _ref$source,
      _ref$mapId = _ref.mapId,
      initialMapId = _ref$mapId === void 0 ? null : _ref$mapId,
      _ref$multiLegend = _ref.multiLegend,
      multiLegend = _ref$multiLegend === void 0 ? false : _ref$multiLegend;
  var dispatch = useDispatch();
  var legendType = multiLegend ? "legend-".concat(initialMapId) : "legend";
  var mapIdStore = useSelector(function (store) {
    return getDialogMapId(store, legendType);
  });

  var _React$useState = React.useState(initialMapId),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      mapId = _React$useState2[0],
      setMapId = _React$useState2[1];

  React.useEffect(function () {
    setMapId(mapIdStore);
  }, [mapIdStore]);
  var mapLayers = useSelector(function (store) {
    return getMapLayers(store, mapId);
  });
  var isDialogOpen = useSelector(function (store) {
    return getisDialogOpen(store, legendType);
  });
  var uiOrder = useSelector(function (store) {
    return getDialogOrder(store, legendType);
  });
  var uiSource = useSelector(function (store) {
    return getDialogSource(store, legendType);
  });
  var uiIsOrderedOnTop = useSelector(function (store) {
    return getDialogIsOrderedOnTop(store, legendType);
  });

  var onClose = function onClose() {
    dispatch(uiActions.setToggleOpenDialog({
      type: legendType,
      setOpen: false,
      origin: MapActionOrigin.map,
      mapId: mapId
    }));
  };

  var registerDialog = React.useCallback(function (setOpen) {
    return dispatch(uiActions.registerDialog({
      type: legendType,
      mapId: mapId,
      setOpen: setOpen,
      source: source
    }));
  }, [dispatch, source, legendType, mapId]);
  var unregisterDialog = React.useCallback(function () {
    return dispatch(uiActions.unregisterDialog({
      type: legendType
    }));
  }, [dispatch, legendType]);
  var onOrderDialog = React.useCallback(function () {
    if (!uiIsOrderedOnTop) {
      dispatch(uiActions.orderDialog({
        type: legendType
      }));
    }
  }, [dispatch, uiIsOrderedOnTop, legendType]); // Register this dialog in the store

  React.useEffect(function () {
    registerDialog(IS_LEGEND_OPEN_BY_DEFAULT);
    return function () {
      unregisterDialog();
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(LegendDialog, {
    layers: mapLayers,
    isOpen: isDialogOpen,
    onClose: onClose,
    mapId: mapId,
    showMapId: showMapId,
    onMouseDown: onOrderDialog,
    order: uiOrder,
    source: uiSource
  });
};
/**
 * Legend component connected to the store displaying a legend for every layer shown on the active map Id
 * Please note that in order to use this and open/close the dialog, every map on the screen that should be able to show
 * a dialog should have the <LegendMapButtonConnect/> which is used to focus the correct map and open the dialog
 *
 * Expects the following props:
 * @param {boolean} showMapId (optional) showMapId: boolean - show the id of the map in the dialog title of which the legend is shown in te dialog
 * @param {Source} source (optional) source: Source - default is 'app', 'module' makes sure it will be shown on top of the module

 * ``` <LegendConnect legendDialogId={legendDialogId} />```
 */


var LegendConnect = function LegendConnect(_a) {
  var _a$showMapId = _a.showMapId,
      showMapId = _a$showMapId === void 0 ? false : _a$showMapId,
      props = __rest(_a, ["showMapId"]);

  return /*#__PURE__*/React.createElement(LegendConnectComponent, Object.assign({
    showMapId: showMapId
  }, props));
};

var _marked$1 = /*#__PURE__*/regeneratorRuntime.mark(startAnimationSaga),
    _marked2$1 = /*#__PURE__*/regeneratorRuntime.mark(stopAnimationSaga),
    _marked3$1 = /*#__PURE__*/regeneratorRuntime.mark(deleteLayerSaga),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(updateAnimation),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(setLayerDimensionsSaga),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(toggleAutoUpdateSaga),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(handleBaseLayersSaga),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(setMapPresetSaga),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(checkMapPresetForChangesSaga),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(rootSaga$1);

var generateTimeList = function generateTimeList(start, end, interval) {
  var timeList = [];
  var unixStart = moment(start).utc().unix();
  var unixEnd = moment(end).utc().unix();
  var intervalSeconds = interval * 60;

  for (var j = unixStart; j <= unixEnd; j += intervalSeconds) {
    timeList.push({
      name: 'time',
      value: moment.unix(j).toISOString()
    });
  }

  return timeList;
};
function updateMapDraw(mapId, draw) {
  var webMap = getWMJSMapById(mapId);

  if (webMap) {
    webMap.getListener().suspendEvents();
    webMap.stopAnimating();
    webMap.draw(draw);
    webMap.getListener().resumeEvents();
  }
}
function startAnimationSaga(_ref) {
  var payload, mapId, start, end, interval, timeList, roundedStart, roundedEnd, animationList;
  return regeneratorRuntime.wrap(function startAnimationSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          payload = _ref.payload;
          mapId = payload.mapId, start = payload.start, end = payload.end, interval = payload.interval, timeList = payload.timeList;
          roundedStart = roundWithTimeStep(start && moment.utc(start).unix(), interval, 'ceil');
          roundedEnd = roundWithTimeStep(end && moment.utc(end).unix(), interval, 'floor');
          _context.next = 6;
          return timeList || generateTimeList(moment.utc(roundedStart * 1000), moment.utc(roundedEnd * 1000), interval);

        case 6:
          animationList = _context.sent;
          _context.next = 9;
          return updateMapDraw(mapId, animationList);

        case 9:
        case "end":
          return _context.stop();
      }
    }
  }, _marked$1);
}
function stopAnimationSaga(_ref2) {
  var payload, mapId;
  return regeneratorRuntime.wrap(function stopAnimationSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _ref2.payload;
          mapId = payload.mapId;
          _context2.next = 4;
          return updateMapDraw(mapId, 'opengeoweb-core-map-reducer');

        case 4:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2$1);
}
function deleteLayerSaga(_ref3) {
  var payload, mapId, layers;
  return regeneratorRuntime.wrap(function deleteLayerSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _ref3.payload;
          mapId = payload.mapId;
          _context3.next = 4;
          return select(getMapLayers, mapId);

        case 4:
          layers = _context3.sent;

          if (layers.length) {
            _context3.next = 8;
            break;
          }

          _context3.next = 8;
          return put(mapActions$1.mapStopAnimation({
            mapId: mapId
          }));

        case 8:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3$1);
}
function updateAnimation(mapId, maxValue) {
  var animationStart, animationStartUnix, animationEnd, animationEndUnix, t, deltaT, start, end, isAnimating$1, timeStep;
  return regeneratorRuntime.wrap(function updateAnimation$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return select(getAnimationStartTime, mapId);

        case 2:
          animationStart = _context4.sent;
          animationStartUnix = moment.utc(animationStart).unix();
          _context4.next = 6;
          return select(getAnimationEndTime, mapId);

        case 6:
          animationEnd = _context4.sent;
          animationEndUnix = moment.utc(animationEnd).unix();
          t = moment.utc(maxValue).unix();
          deltaT = t - animationEndUnix;
          start = moment.unix(animationStartUnix + deltaT).utc().format(dateFormat);
          end = moment.unix(animationEndUnix + deltaT).utc().format(dateFormat);
          _context4.next = 14;
          return put(mapActions$1.setAnimationEndTime({
            mapId: mapId,
            animationEndTime: end
          }));

        case 14:
          _context4.next = 16;
          return put(mapActions$1.setAnimationStartTime({
            mapId: mapId,
            animationStartTime: start
          }));

        case 16:
          _context4.next = 18;
          return select(isAnimating, mapId);

        case 18:
          isAnimating$1 = _context4.sent;

          if (!isAnimating$1) {
            _context4.next = 25;
            break;
          }

          _context4.next = 22;
          return select(getMapTimeStep, mapId);

        case 22:
          timeStep = _context4.sent;
          _context4.next = 25;
          return put(mapActions$1.mapStartAnimation({
            mapId: mapId,
            start: start,
            end: end,
            interval: timeStep
          }));

        case 25:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}
function setLayerDimensionsSaga(_ref4) {
  var payload, layerDimensions, dimensions, layerId, layer, newTimeDimension, mapId, activeLayerId, shouldAutoUpdate, prevTimeDimension, isAnimating$1, webmapInstance;
  return regeneratorRuntime.wrap(function setLayerDimensionsSaga$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          payload = _ref4.payload;
          _context5.prev = 1;
          layerDimensions = payload.layerDimensions;

          if (layerDimensions) {
            _context5.next = 5;
            break;
          }

          return _context5.abrupt("return");

        case 5:
          dimensions = layerDimensions.dimensions, layerId = layerDimensions.layerId;
          _context5.next = 8;
          return select(getLayerById, layerId);

        case 8:
          layer = _context5.sent;

          if (layer) {
            _context5.next = 11;
            break;
          }

          return _context5.abrupt("return");

        case 11:
          newTimeDimension = dimensions.find(function (dimension) {
            return dimension.name === 'time';
          });
          mapId = layer.mapId;
          _context5.next = 15;
          return select(getActiveLayerId, mapId);

        case 15:
          activeLayerId = _context5.sent;
          _context5.next = 18;
          return select(isAutoUpdating, mapId);

        case 18:
          shouldAutoUpdate = _context5.sent;
          _context5.next = 21;
          return select(getLayerTimeDimension, layerId);

        case 21:
          prevTimeDimension = _context5.sent;
          _context5.next = 24;
          return select(isAnimating, mapId);

        case 24:
          isAnimating$1 = _context5.sent;
          webmapInstance = getWMJSMapById(mapId);

          if (!(layerId === activeLayerId && // only update the active layer
          shouldAutoUpdate && newTimeDimension && newTimeDimension.maxValue && prevTimeDimension && prevTimeDimension.currentValue && prevTimeDimension.currentValue !== newTimeDimension.maxValue)) {
            _context5.next = 34;
            break;
          }

          if (isAnimating$1) {
            _context5.next = 30;
            break;
          }

          _context5.next = 30;
          return put(layerActions.layerChangeDimension({
            layerId: layerId,
            origin: LayerActionOrigin.setLayerDimensionSaga,
            dimension: {
              name: 'time',
              currentValue: newTimeDimension.maxValue
            }
          }));

        case 30:
          _context5.next = 32;
          return call(updateAnimation, mapId, newTimeDimension.maxValue);

        case 32:
          _context5.next = 37;
          break;

        case 34:
          if (!(isAnimating$1 && !webmapInstance.isAnimating && newTimeDimension && newTimeDimension.maxValue)) {
            _context5.next = 37;
            break;
          }

          _context5.next = 37;
          return call(updateAnimation, mapId, newTimeDimension.maxValue);

        case 37:
          _context5.next = 42;
          break;

        case 39:
          _context5.prev = 39;
          _context5.t0 = _context5["catch"](1);
          // eslint-disable-next-line no-console
          console.warn(_context5.t0);

        case 42:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5, null, [[1, 39]]);
}
function toggleAutoUpdateSaga(_ref5) {
  var payload, shouldAutoUpdate, mapId, layerId, timeDimension;
  return regeneratorRuntime.wrap(function toggleAutoUpdateSaga$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          payload = _ref5.payload;
          _context6.prev = 1;
          shouldAutoUpdate = payload.shouldAutoUpdate, mapId = payload.mapId;

          if (!shouldAutoUpdate) {
            _context6.next = 15;
            break;
          }

          _context6.next = 6;
          return select(getActiveLayerId, mapId);

        case 6:
          layerId = _context6.sent;
          _context6.next = 9;
          return select(getLayerTimeDimension, layerId);

        case 9:
          timeDimension = _context6.sent;

          if (!(timeDimension && timeDimension.maxValue)) {
            _context6.next = 15;
            break;
          }

          _context6.next = 13;
          return put(layerActions.layerChangeDimension({
            layerId: layerId,
            origin: LayerActionOrigin.toggleAutoUpdateSaga,
            dimension: {
              name: 'time',
              currentValue: timeDimension.maxValue
            }
          }));

        case 13:
          _context6.next = 15;
          return call(updateAnimation, mapId, timeDimension.maxValue);

        case 15:
          _context6.next = 20;
          break;

        case 17:
          _context6.prev = 17;
          _context6.t0 = _context6["catch"](1);
          // eslint-disable-next-line no-console
          console.warn(_context6.t0);

        case 20:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6, null, [[1, 17]]);
}
function handleBaseLayersSaga(mapId, baseLayers) {
  var baseLayer, currentAvailableBaseLayers, activeAvailableBaseLayer, activeBaseLayerId, baseLayersWithActiveId;
  return regeneratorRuntime.wrap(function handleBaseLayersSaga$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          baseLayer = baseLayers.find(function (layer) {
            return layer.layerType === 'baseLayer';
          });
          _context7.next = 3;
          return select(getAvailableBaseLayersForMap, mapId);

        case 3:
          currentAvailableBaseLayers = _context7.sent;
          // find a availableBaseLayer with the same name, and use that id for the active baselayer
          activeAvailableBaseLayer = currentAvailableBaseLayers.find(function (availableBaseLayer) {
            return availableBaseLayer.name === baseLayer.name;
          });
          activeBaseLayerId = activeAvailableBaseLayer ? activeAvailableBaseLayer.id : generateLayerId(); // if the baseLayer can't be found in a visible available baseLayer list, add it

          if (!(!activeAvailableBaseLayer && currentAvailableBaseLayers.length)) {
            _context7.next = 9;
            break;
          }

          _context7.next = 9;
          return put(layerActions.addAvailableBaseLayers({
            // TODO: remove type casting in https://gitlab.com/opengeoweb/opengeoweb/-/issues/1884
            layers: [Object.assign(Object.assign({}, baseLayer), {
              mapId: mapId,
              id: activeBaseLayerId
            })]
          }));

        case 9:
          baseLayersWithActiveId = baseLayers.map(function (layer, index) {
            return index === 0 ? Object.assign(Object.assign({}, layer), {
              id: activeBaseLayerId || layer.id
            }) : layer;
          });
          _context7.next = 12;
          return put(layerActions.setBaseLayers({
            mapId: mapId,
            // TODO: remove type casting in https://gitlab.com/opengeoweb/opengeoweb/-/issues/1884
            layers: baseLayersWithActiveId
          }));

        case 12:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7);
}
function setMapPresetSaga(_ref6) {
  var payload, mapId, initialProps, mapPreset, layers, activeLayerId, proj, shouldAutoUpdate, shouldAnimate, animationPayload, toggleTimestepAuto, showTimeSlider, displayMapPin, shouldShowZoomControls, shouldShowLegend, _filterLayers, mapLayers, baseLayers, overLayers, _yield$call, layersNewIds, activeLayerNewId, newActiveLayerId, baseLayersWithDefaultLayer, overLayersWithDefaultLayer, allBaseLayers, interval, duration, shouldOpenLegend, legendId;

  return regeneratorRuntime.wrap(function setMapPresetSaga$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          payload = _ref6.payload;
          _context8.prev = 1;
          mapId = payload.mapId, initialProps = payload.initialProps;
          mapPreset = initialProps.mapPreset;

          if (!mapPreset) {
            _context8.next = 64;
            break;
          }

          layers = mapPreset.layers, activeLayerId = mapPreset.activeLayerId, proj = mapPreset.proj, shouldAutoUpdate = mapPreset.shouldAutoUpdate, shouldAnimate = mapPreset.shouldAnimate, animationPayload = mapPreset.animationPayload, toggleTimestepAuto = mapPreset.toggleTimestepAuto, showTimeSlider = mapPreset.showTimeSlider, displayMapPin = mapPreset.displayMapPin, shouldShowZoomControls = mapPreset.shouldShowZoomControls, shouldShowLegend = mapPreset.shouldShowLegend;
          _filterLayers = filterLayers(layers), mapLayers = _filterLayers.mapLayers, baseLayers = _filterLayers.baseLayers, overLayers = _filterLayers.overLayers;

          if (!layers) {
            _context8.next = 18;
            break;
          }

          _context8.next = 10;
          return call(generateUniqueLayerIds, mapLayers, activeLayerId);

        case 10:
          _yield$call = _context8.sent;
          layersNewIds = _yield$call.layersNewIds;
          activeLayerNewId = _yield$call.activeLayerNewId;
          _context8.next = 15;
          return put(layerActions.setLayers({
            mapId: mapId,
            layers: layersNewIds
          }));

        case 15:
          //  set active layer if given otherwise to first layer
          newActiveLayerId = activeLayerNewId || (layersNewIds.length ? layersNewIds[0].id : undefined);
          _context8.next = 18;
          return put(mapActions$1.setActiveLayerId({
            mapId: mapId,
            layerId: newActiveLayerId
          }));

        case 18:
          // sets (default) baseLayers
          baseLayersWithDefaultLayer = baseLayers.length ? baseLayers : [baseLayerGrey$1]; // sets (default) overLayers

          overLayersWithDefaultLayer = overLayers.length ? overLayers : [overLayer$1];
          allBaseLayers = [].concat(_toConsumableArray(baseLayersWithDefaultLayer), _toConsumableArray(overLayersWithDefaultLayer)).map(function (layer) {
            return Object.assign(Object.assign({}, layer), {
              id: generateLayerId()
            });
          });
          _context8.next = 23;
          return call(handleBaseLayersSaga, mapId, allBaseLayers);

        case 23:
          if (!proj) {
            _context8.next = 26;
            break;
          }

          _context8.next = 26;
          return put(mapActions$1.setBbox({
            mapId: mapId,
            bbox: proj === null || proj === void 0 ? void 0 : proj.bbox,
            srs: proj === null || proj === void 0 ? void 0 : proj.srs
          }));

        case 26:
          if (!(shouldAutoUpdate !== undefined)) {
            _context8.next = 29;
            break;
          }

          _context8.next = 29;
          return put(mapActions$1.toggleAutoUpdate({
            mapId: mapId,
            shouldAutoUpdate: shouldAutoUpdate
          }));

        case 29:
          if (!(showTimeSlider !== undefined)) {
            _context8.next = 32;
            break;
          }

          _context8.next = 32;
          return put(mapActions$1.toggleTimeSliderIsVisible({
            mapId: mapId,
            isTimeSliderVisible: showTimeSlider
          }));

        case 32:
          if (!(shouldShowZoomControls !== undefined)) {
            _context8.next = 35;
            break;
          }

          _context8.next = 35;
          return put(mapActions$1.toggleZoomControls({
            mapId: mapId,
            shouldShowZoomControls: shouldShowZoomControls
          }));

        case 35:
          if (!(displayMapPin !== undefined)) {
            _context8.next = 38;
            break;
          }

          _context8.next = 38;
          return put(mapActions$1.toggleMapPinIsVisible({
            mapId: mapId,
            displayMapPin: displayMapPin
          }));

        case 38:
          // sets timestep by interval of animationPayload
          interval = animationPayload && animationPayload.interval;

          if (!interval) {
            _context8.next = 42;
            break;
          }

          _context8.next = 42;
          return put(mapActions$1.setAnimationInterval({
            mapId: mapId,
            interval: interval
          }));

        case 42:
          if (!(animationPayload && animationPayload.speed)) {
            _context8.next = 45;
            break;
          }

          _context8.next = 45;
          return put(mapActions$1.setAnimationDelay({
            mapId: mapId,
            animationDelay: getSpeedDelay(animationPayload.speed)
          }));

        case 45:
          if (!(shouldAnimate === true)) {
            _context8.next = 54;
            break;
          }

          duration = animationPayload && animationPayload.duration ? animationPayload.duration : 5 * 60; //  set to default of 5 hours

          _context8.next = 49;
          return put(mapActions$1.mapStartAnimation({
            mapId: mapId,
            start: moment.utc().subtract(duration, 'minutes').format(dateFormat),
            end: moment.utc().format(dateFormat),
            interval: interval || animationIntervalDefault
          }));

        case 49:
          if (!interval) {
            _context8.next = 52;
            break;
          }

          _context8.next = 52;
          return put(mapActions$1.toggleTimestepAuto({
            mapId: mapId,
            timestepAuto: false
          }));

        case 52:
          _context8.next = 57;
          break;

        case 54:
          if (!(toggleTimestepAuto !== undefined)) {
            _context8.next = 57;
            break;
          }

          _context8.next = 57;
          return put(mapActions$1.toggleTimestepAuto({
            mapId: mapId,
            timestepAuto: toggleTimestepAuto
          }));

        case 57:
          // show legend
          shouldOpenLegend = shouldShowLegend !== undefined ? shouldShowLegend : IS_LEGEND_OPEN_BY_DEFAULT;
          _context8.next = 60;
          return select(getLegendId, mapId);

        case 60:
          legendId = _context8.sent;

          if (!legendId) {
            _context8.next = 64;
            break;
          }

          _context8.next = 64;
          return put(uiActions.setToggleOpenDialog({
            type: legendId,
            setOpen: shouldOpenLegend
          }));

        case 64:
          _context8.next = 69;
          break;

        case 66:
          _context8.prev = 66;
          _context8.t0 = _context8["catch"](1);
          console.error(_context8.t0);

        case 69:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8, null, [[1, 66]]);
}
var mapPresetChangeActions = [layerActions.setBaseLayers.type, layerActions.layerDelete.type, layerActions.addLayer.type, layerActions.layerChangeEnabled.type, layerActions.layerChangeName.type, layerActions.layerChangeStyle.type, layerActions.layerChangeOpacity.type, layerActions.layerChangeDimension.type, mapActions$1.layerMoveLayer.type, mapActions$1.setActiveLayerId.type, mapActions$1.toggleAutoUpdate, mapActions$1.mapStartAnimation, mapActions$1.mapStopAnimation, mapActions$1.toggleTimeSliderIsVisible, mapActions$1.setTimeStep, mapActions$1.setAnimationDelay, mapActions$1.toggleTimestepAuto, uiActions.setActiveMapIdForDialog, uiActions.setToggleOpenDialog, genericActions.setBbox.type];
var supportedChangeOrigins = [LayerActionOrigin.layerManager, LayerActionOrigin.wmsLoader, MapActionOrigin.map];
function checkMapPresetForChangesSaga(action) {
  var _action$payload, mapId, origin, isChangeOriginSupported, hasMapPresetChanges;

  return regeneratorRuntime.wrap(function checkMapPresetForChangesSaga$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _action$payload = action.payload, mapId = _action$payload.mapId, origin = _action$payload.origin;

          if (origin) {
            _context9.next = 3;
            break;
          }

          return _context9.abrupt("return");

        case 3:
          isChangeOriginSupported = supportedChangeOrigins.indexOf(origin) >= 0;

          if (!isChangeOriginSupported) {
            _context9.next = 11;
            break;
          }

          _context9.next = 7;
          return select(getHasMapPresetChanges, mapId);

        case 7:
          hasMapPresetChanges = _context9.sent;

          if (hasMapPresetChanges) {
            _context9.next = 11;
            break;
          }

          _context9.next = 11;
          return put(mapActions$1.setHasMapPresetChanges({
            mapId: mapId,
            hasChanges: true
          }));

        case 11:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked9);
}
function rootSaga$1() {
  return regeneratorRuntime.wrap(function rootSaga$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return all([takeLatest(mapActions$1.mapStopAnimation.type, stopAnimationSaga), takeLatest(mapActions$1.setActiveMapPresetId.type, stopAnimationSaga)]);

        case 2:
          _context10.next = 4;
          return takeLatest(mapActions$1.mapStartAnimation.type, startAnimationSaga);

        case 4:
          _context10.next = 6;
          return takeLatest(layerActions.layerDelete.type, deleteLayerSaga);

        case 6:
          _context10.next = 8;
          return takeLatest(layerActions.onUpdateLayerInformation.type, setLayerDimensionsSaga);

        case 8:
          _context10.next = 10;
          return takeLatest(mapActions$1.toggleAutoUpdate.type, toggleAutoUpdateSaga);

        case 10:
          _context10.next = 12;
          return takeEvery(mapActions$1.setMapPreset.type, setMapPresetSaga);

        case 12:
          _context10.next = 14;
          return all(mapPresetChangeActions.map(function (action) {
            return takeEvery(action, checkMapPresetForChangesSaga);
          }));

        case 14:
        case "end":
          return _context10.stop();
      }
    }
  }, _marked10);
}

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */
var moduleConfig = {
  id: 'webmap-module',
  reducerMap: {
    webmap: reducer$2,
    services: reducer$4,
    layers: reducer$5
  },
  sagas: [rootSaga$1]
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2022 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2022 - Finnish Meteorological Institute (FMI)
 * */
var mergePresetsAndUserAddedServices = function mergePresetsAndUserAddedServices(presets, userAddedServices) {
  return Object.values(Object.assign(Object.assign({}, presets.reduce(function (byId, preset) {
    return Object.assign(Object.assign({}, byId), _defineProperty({}, preset.id, preset));
  }, {})), userAddedServices));
};
var isService = function isService(param) {
  var serviceParam = param;
  return !!((serviceParam === null || serviceParam === void 0 ? void 0 : serviceParam.id) && (serviceParam === null || serviceParam === void 0 ? void 0 : serviceParam.name) && (serviceParam === null || serviceParam === void 0 ? void 0 : serviceParam.url));
};

var getUserAddedServices = function getUserAddedServices() {
  try {
    var storedString = window.localStorage.getItem('userAddedServices');
    var parsedData = JSON.parse(storedString);

    if (parsedData && _typeof(parsedData) === 'object') {
      return Object.entries(parsedData).reduce(function (userServices, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            serviceUrl = _ref2[0],
            service = _ref2[1];

        return Object.assign(Object.assign({}, userServices), isService(service) ? _defineProperty({}, serviceUrl, service) : {});
      }, {});
    }
  } catch (e) {
    console.error('Unable to read services from localStorage: ', e);
  }

  return {};
};
var setUserAddedServices = function setUserAddedServices(services) {
  try {
    window.localStorage.setItem('userAddedServices', JSON.stringify(services));
  } catch (e) {
    console.error('Unable to write services to localStorage: ', e);
  }
};

var _marked = /*#__PURE__*/regeneratorRuntime.mark(newServiceAddedSaga),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(layerSelectServiceRemovedSaga),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(rootSaga);
function newServiceAddedSaga(capturedAction) {
  var addedService, id, serviceUrl, name, keywords, services, findServiceName;
  return regeneratorRuntime.wrap(function newServiceAddedSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          addedService = capturedAction.payload;
          id = addedService.id, serviceUrl = addedService.serviceUrl, name = addedService.name;
          keywords = addedService.layers.reduce(function (keywordAccumulator, layer) {
            return keywordAccumulator.concat(layer.path, layer.keywords);
          }, []);
          _context.next = 5;
          return select(getServicesInArray);

        case 5:
          services = _context.sent;

          findServiceName = function findServiceName() {
            var foundService = services.find(function (object) {
              return (object === null || object === void 0 ? void 0 : object.url) === serviceUrl;
            });
            if (foundService) return foundService.name;
            return name;
          };

          _context.next = 9;
          return put(layerSelectActions.addKeywordsAndActiveServices({
            serviceId: id,
            serviceName: findServiceName(),
            serviceUrl: serviceUrl,
            keywords: keywords
          }));

        case 9:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
function layerSelectServiceRemovedSaga(capturedAction) {
  var removedService, serviceId;
  return regeneratorRuntime.wrap(function layerSelectServiceRemovedSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          removedService = capturedAction.payload;
          serviceId = removedService.id;
          _context2.next = 4;
          return put(layerSelectActions.layerSelectServiceRemoved({
            serviceId: serviceId
          }));

        case 4:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}
function addServiceToLocalStorageSaga(_ref) {
  var payload = _ref.payload;
  var isUserAddedService = payload.isUserAddedService,
      name = payload.name,
      serviceUrl = payload.serviceUrl;
  if (!isUserAddedService) return;
  var localStorageServices = getUserAddedServices();
  setUserAddedServices(Object.assign(Object.assign({}, localStorageServices), _defineProperty({}, serviceUrl, {
    id: serviceUrl,
    name: name,
    url: serviceUrl
  })));
}
function removeServiceFromLocalStorageSaga(_ref2) {
  var payload = _ref2.payload;
  var serviceUrl = payload.serviceUrl;
  var localStorageServices = getUserAddedServices();
  if (!localStorageServices[serviceUrl]) return;
  var updatedServices = Object.assign({}, localStorageServices);
  delete updatedServices[serviceUrl];
  setUserAddedServices(updatedServices);
}
function rootSaga() {
  return regeneratorRuntime.wrap(function rootSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return takeEvery(serviceActions.serviceSetLayers.type, newServiceAddedSaga);

        case 2:
          _context3.next = 4;
          return takeEvery(serviceActions.mapStoreRemoveService.type, layerSelectServiceRemovedSaga);

        case 4:
          _context3.next = 6;
          return takeEvery(serviceActions.serviceSetLayers.type, addServiceToLocalStorageSaga);

        case 6:
          _context3.next = 8;
          return takeEvery(serviceActions.mapStoreRemoveService.type, removeServiceFromLocalStorageSaga);

        case 8:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */
var layerSelectConfig = {
  id: 'layerSelect-module',
  reducerMap: {
    layerSelect: reducer
  },
  sagas: [rootSaga]
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */
var coreModuleConfig = [moduleConfig, synchronizationGroupConfig, uiModuleConfig, layerSelectConfig];

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */
/**
 * Converts webmapjs node structure to LayerTree
 * @param nodesToRecur THe WebMapJS node structure from service.getNodes();
 */

var recurseNodes = function recurseNodes(nodesToRecur) {
  var newLayerTreeObj = {
    leaf: nodesToRecur.leaf,
    name: nodesToRecur.name,
    title: nodesToRecur.text,
    path: nodesToRecur.path || [],
    children: [],
    keywords: nodesToRecur.keywords || [],
    "abstract": nodesToRecur["abstract"] || '',
    styles: nodesToRecur.styles || []
  };

  if (nodesToRecur.children) {
    for (var j = 0; j < nodesToRecur.children.length; j += 1) {
      newLayerTreeObj.children.push(recurseNodes(nodesToRecur.children[j]));
    }
  }

  return newLayerTreeObj;
};
/**
 * Returns a promise with a hierarchical tree of layers from the WMS GetCapabilities document.
 * @param serviceUrl The URL of the WMS service
 * @param {boolean} forceReload **optional** forceReload: boolean, true will force the layers to be reloaded from the service, defaults to false
 */

var getLayersFromService = function getLayersFromService(serviceUrl) {
  var forceReload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return new Promise(function (resolve, reject) {
    var serviceObject = WMGetServiceFromStore(serviceUrl);
    serviceObject.getNodes(function (nodes) {
      var layerTree = recurseNodes(nodes);
      resolve(layerTree);
    }, function (error) {
      reject(new Error(error));
    }, forceReload);
  });
};
/**
 * Returns a promise with an array of flattened layerobjects from the WMS GetCapabilities document.
 * @param serviceUrl The URL of the WMS service
 * @param {boolean} forceReload **optional** forceReload: boolean, true will force the layers to be reloaded from the service, defaults to false
 */

var getLayersFlattenedFromService = function getLayersFlattenedFromService(serviceUrl) {
  var forceReload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return new Promise(function (resolve, reject) {
    var serviceObject = WMGetServiceFromStore(serviceUrl);
    serviceObject.getLayerObjectsFlat(function (layers) {
      resolve(layers);
    }, function (error) {
      reject(new Error(error));
    }, forceReload);
  });
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */

var WMSLayerTreeHeader = function WMSLayerTreeHeader(_ref) {
  var serviceName = _ref.serviceName,
      onClickReload = _ref.onClickReload;
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "row",
    spacing: 1,
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(InputLabel, {
    shrink: true,
    htmlFor: "select-multiple-native"
  }, "Available layers for ", serviceName)), onClickReload && /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Tooltip, {
    title: "Reload layers from service",
    placement: "top"
  }, /*#__PURE__*/React.createElement(IconButton, {
    "data-testid": "reloadLayers",
    color: "primary",
    style: {
      padding: 3
    },
    onClick: onClickReload,
    size: "large"
  }, /*#__PURE__*/React.createElement(Cached, null)))));
};

var WMSLayerTree = function WMSLayerTree(_ref) {
  var service = _ref.service,
      onClickLayer = _ref.onClickLayer,
      highlightedLayers = _ref.highlightedLayers;
  var initialTree = {
    name: 'loading wms getcapabilities',
    leaf: true,
    path: [],
    title: '',
    children: []
  };

  var _React$useState = React.useState([]),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      processedOK = _React$useState2[0],
      setProcessedOK = _React$useState2[1];

  var handleInternalSelect = function handleInternalSelect(layerName) {
    onClickLayer(service.url, layerName);
    setProcessedOK([].concat(_toConsumableArray(processedOK), [layerName]));
  };

  var _React$useState3 = React.useState(initialTree),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      layerTree = _React$useState4[0],
      setLayerTree = _React$useState4[1];

  var _React$useState5 = React.useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      isLoading = _React$useState6[0],
      setIsLoading = _React$useState6[1];

  var _React$useState7 = React.useState(false),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      forceReload = _React$useState8[0],
      setForceReload = _React$useState8[1];

  React.useEffect(function () {
    var isMounted = true;
    setIsLoading(true);
    getLayersFromService(service.url, forceReload).then(function (layerTreeFromPromise) {
      if (isMounted) {
        setLayerTree(layerTreeFromPromise);
        setIsLoading(false);
      }
    })["catch"](function (error) {
      if (isMounted) {
        setLayerTree(error.toString());
        setIsLoading(false);
      }
    });
    return function () {
      isMounted = false;
      setForceReload(false);
    };
  }, [service, forceReload]);
  var paperStyle = {
    height: 200,
    overflow: 'auto'
  };

  if ((!layerTree.children || !layerTree.children.length) && !isLoading) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(WMSLayerTreeHeader, {
      serviceName: service.name
    }), /*#__PURE__*/React.createElement(Paper, {
      "data-testid": "message",
      style: paperStyle
    }, /*#__PURE__*/React.createElement(Box, {
      p: 2,
      display: "flex"
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2"
    }, "No data"))));
  } // Base case where there exists at least one layer
  // TODO: find a better way of doing this, without using prototype


  var flatten = function flatten(children, parent) {
    return Array.prototype.concat.apply((children || []).map(function (treeElem) {
      return Object.assign(Object.assign({}, treeElem), {
        parent: parent || null
      });
    }), (children || []).map(function (treeElem) {
      return flatten(treeElem.children || [], treeElem.title);
    }));
  };

  var flattenedLayerTree = flatten(layerTree.children, []);

  var layerMap = _.groupBy(flattenedLayerTree, 'parent'); // Check if a layer of the same name and service is in an array


  var layerExists = function layerExists(targetLayer, layers) {
    return layers.filter(function (layerInMap) {
      return layerInMap.name === targetLayer.name && layerInMap.service === service.url;
    }).length > 0;
  };

  var categories = Object.keys(layerMap);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(WMSLayerTreeHeader, {
    serviceName: service.name,
    onClickReload: function onClickReload() {
      return setForceReload(true);
    }
  }), /*#__PURE__*/React.createElement(Paper, {
    style: paperStyle
  }, isLoading ? /*#__PURE__*/React.createElement(Box, {
    p: 4,
    display: "flex",
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(CircularProgress, null)) : /*#__PURE__*/React.createElement(List, {
    "data-testid": "layer-list",
    dense: true,
    style: {
      backgroundColor: 'inherit'
    }
  }, categories.map(function (category) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: category
    }, category === '' ? '' // Do not render a subheader if category is empty
    :
    /*#__PURE__*/
    React.createElement(ListSubheader, {
      key: category
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        width: '100%',
        fontWeight: 'bold',
        textOverflow: 'ellipsis'
      }
    }, category)), layerMap[category].map(function (layer) {
      return layer.leaf ? /*#__PURE__*/React.createElement(ListItem, {
        "data-testid": "selectableLayer",
        key: layer.name,
        button: true,
        selected: processedOK.indexOf(layer.name) !== -1 || layerExists(layer, highlightedLayers),
        onClick: function onClick() {
          return handleInternalSelect(layer.name);
        }
      }, /*#__PURE__*/React.createElement(ListItemText, {
        id: layer.name,
        primary: layer.title
      })) : null; // Do not list subcategories as layers
    }));
  }))));
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */
var connectRedux$5 = connect(function (store, props) {
  return {
    loadedLayers: getMapLayers(store, props.mapId)
  };
}, {
  addLayer: layerActions.addLayer,
  setBaseLayers: layerActions.setBaseLayers,
  addAvailableBaseLayer: layerActions.addAvailableBaseLayer
});

var ConnectedTree = function ConnectedTree(_ref) {
  var addLayer = _ref.addLayer,
      setBaseLayers = _ref.setBaseLayers,
      addAvailableBaseLayer = _ref.addAvailableBaseLayer,
      service = _ref.service,
      mapId = _ref.mapId,
      loadedLayers = _ref.loadedLayers,
      _ref$layerType = _ref.layerType,
      layerType = _ref$layerType === void 0 ? LayerType.mapLayer : _ref$layerType;

  var addMapLayer = function addMapLayer(serviceURL, layerName) {
    var newWms = {
      service: serviceURL,
      name: layerName,
      id: generateLayerId(),
      layerType: LayerType.mapLayer
    };
    addLayer({
      mapId: mapId,
      layerId: newWms.id,
      layer: newWms,
      origin: LayerActionOrigin.wmsLoader
    });
  };

  var addBaseLayer = function addBaseLayer(serviceURL, layerName) {
    var newBaseLayer = {
      service: serviceURL,
      name: layerName,
      id: generateLayerId(),
      layerType: LayerType.baseLayer,
      mapId: mapId
    };
    addAvailableBaseLayer({
      layer: newBaseLayer
    });
    setBaseLayers({
      mapId: mapId,
      layers: [newBaseLayer],
      origin: LayerActionOrigin.wmsLoader
    });
  };

  return /*#__PURE__*/React__default.createElement(WMSLayerTree, {
    service: service,
    onClickLayer: function onClickLayer(serviceURL, layerName) {
      if (layerType === LayerType.baseLayer) {
        addBaseLayer(serviceURL, layerName);
      } else addMapLayer(serviceURL, layerName);
    },
    highlightedLayers: loadedLayers
  });
};

var WMSLayerTreeConnect = connectRedux$5(ConnectedTree);

var WMSServerList = function WMSServerList(_ref) {
  var availableServices = _ref.availableServices,
      handleChangeService = _ref.handleChangeService,
      activeService = _ref.service;

  var handleListItemClick = function handleListItemClick(event, service) {
    handleChangeService(service);
  };

  var sortedServices = _toConsumableArray(availableServices).sort(function (a, b) {
    return a.name.localeCompare(b.name);
  });

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "row",
    spacing: 1,
    style: {
      height: '34px'
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(InputLabel, {
    shrink: true,
    htmlFor: "select-multiple-native"
  }, "Available services"))), /*#__PURE__*/React.createElement(Paper, {
    style: {
      height: 200,
      overflow: 'auto'
    }
  }, /*#__PURE__*/React.createElement(List, {
    dense: true
  }, sortedServices.map(function (service) {
    return /*#__PURE__*/React.createElement(ListItem, {
      "data-testid": "service-item",
      key: service.url,
      selected: service === activeService,
      button: true,
      onClick: function onClick(event) {
        handleListItemClick(event, service);
      }
    }, /*#__PURE__*/React.createElement(ListItemText, {
      primary: service.name
    }));
  }))));
};

var preset = {
	presetType: "mapPreset",
	presetId: "mapPreset-1",
	presetName: "Layer manager preset",
	services: [
		{
			name: "KNMIgeoservicesRadar",
			url: "https://geoservices.knmi.nl/wms?dataset=RADAR&",
			id: "KNMIgeoservicesRadar"
		},
		{
			name: "MetNorwayService",
			url: "https://wms-e1.geoweb.met.no/wms?",
			id: "MetNorwayService"
		},
		{
			name: "FMIopenwms",
			url: "https://openwms.fmi.fi/geoserver/wms?",
			id: "FMIopenwms"
		},
		{
			name: "ECMWF",
			url: "https://eccharts.ecmwf.int/wms/?token=public",
			id: "ecmwf"
		},
		{
			name: "KNMIgeoservicesHarmonie",
			url: "https://geoservices.knmi.nl/wms?DATASET=HARM_N25&",
			id: "KNMIgeoservicesKliKNMIgeoservicesHarmoniemaatAtlas"
		},
		{
			name: "KNMI Harmonie ML",
			url: "https://geoservices.knmi.nl/wms?DATASET=HARM_N25_ML&SERVICE=WMS&",
			id: "harmonieML"
		},
		{
			name: "KNMIgeoservicesObs",
			url: "https://geoservices.knmi.nl/adagucserver?dataset=OBS&service=WMS&",
			id: "KNMIgeoservicesObs"
		},
		{
			name: "DWD",
			url: "https://maps.dwd.de/geoserver/ows?",
			id: "dwd"
		}
	],
	baseServices: [
		{
			name: "KNMIgeoservicesBaselayers",
			url: "https://geoservices.knmi.nl/wms?DATASET=baselayers&",
			id: "KNMIgeoservicesBaselayers"
		},
		{
			name: "DWD",
			url: "https://maps.dwd.de/geoserver/ows?",
			id: "dwd"
		}
	],
	layers: [
		{
			id: "layerid_2",
			name: "WorldMap_Light_Grey_Canvas",
			type: "twms",
			layerType: "baseLayer"
		},
		{
			service: "https://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/",
			id: "layerid_3",
			name: "arcGisCanvas",
			type: "twms",
			enabled: true,
			layerType: "baseLayer"
		},
		{
			id: "base-layer-2",
			name: "OpenStreetMap_NL",
			type: "twms",
			layerType: "baseLayer",
			enabled: true
		},
		{
			service: "https://maps.heigit.org/osm-wms/service",
			id: "layerid_5",
			name: "osm_auto:all",
			layerType: "baseLayer"
		}
	]
};
var initialPreset = {
	preset: preset
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */

var _filterMapPresets = filterMapPresets(initialPreset),
    services = _filterMapPresets.services,
    baseServices = _filterMapPresets.baseServices,
    baseLayers = _filterMapPresets.baseLayers;

var availableDefaultBaseLayers = baseLayers;
var preloadedDefaultBaseServices = baseServices;
var preloadedDefaultMapServices = services;

var defaultConfigurations = /*#__PURE__*/Object.freeze({
  __proto__: null,
  availableDefaultBaseLayers: availableDefaultBaseLayers,
  preloadedDefaultBaseServices: preloadedDefaultBaseServices,
  preloadedDefaultMapServices: preloadedDefaultMapServices
});

var useStyles$q = makeStyles({
  buttonDiv: {
    position: 'relative'
  },
  loadingButton: {
    position: 'absolute',
    top: 7,
    left: 7,
    zIndex: 1
  },
  button: {
    width: '24px',
    height: '24px',
    margin: '6px 0px 0px 10px'
  }
});

var validateServiceUrl = function validateServiceUrl(url) {
  if (url === '' || url === null || typeof url === 'undefined') return false;
  var matcher = /^(?:\w+:)?\/\/([^\s.]+\.\S{2}|[0-9a-zA-Z]+[:?\d]*)\S*$/;
  if (!matcher.test(url)) return false;
  return true;
};

var AddLayersPopup = function AddLayersPopup(_ref) {
  var onRenderTree = _ref.onRenderTree,
      _ref$preloadedService = _ref.preloadedServices,
      preloadedServices = _ref$preloadedService === void 0 ? preloadedDefaultMapServices : _ref$preloadedService,
      _ref$open = _ref.open,
      open = _ref$open === void 0 ? false : _ref$open,
      handleClose = _ref.handleClose,
      _ref$layerType = _ref.layerType,
      layerType = _ref$layerType === void 0 ? LayerType.mapLayer : _ref$layerType;
  var classes = useStyles$q();

  var _React$useState = React.useState(''),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      serviceURL = _React$useState2[0],
      setServiceURL = _React$useState2[1];

  var _React$useState3 = React.useState(preloadedServices),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      services = _React$useState4[0],
      setServices = _React$useState4[1];

  var _React$useState5 = React.useState(preloadedServices[0]),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      activeService = _React$useState6[0],
      setActiveService = _React$useState6[1];

  var _React$useState7 = React.useState(''),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      urlError = _React$useState8[0],
      setUrlError = _React$useState8[1];

  var _React$useState9 = React.useState(false),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      loading = _React$useState10[0],
      setLoading = _React$useState10[1];

  var handleChangeService = function handleChangeService(service) {
    setActiveService(service);
  };

  var handleAddToList = function handleAddToList(newServiceName) {
    setServices([{
      name: newServiceName,
      url: serviceURL,
      id: serviceURL
    }].concat(_toConsumableArray(services)));
    setServiceURL('');
  };

  var getServiceIndex = function getServiceIndex(url) {
    return services.findIndex(function (serviceInList) {
      return serviceInList.url === url;
    });
  };

  var handleAddServiceURL = function handleAddServiceURL() {
    setLoading(true);
    var serviceIndex = getServiceIndex(serviceURL); // Check if service already exists in the list

    if (serviceIndex !== -1) {
      setActiveService(services[serviceIndex]);
      setServiceURL('');
      setUrlError('');
      setLoading(false); // Check if valid URL was passed
    } else if (validateServiceUrl(serviceURL)) {
      // Check if service is WMS server
      getLayersFromService(serviceURL).then(function (layerTreeFromPromise) {
        // Shorten URL as a naming backup
        var shortenedURL = serviceURL.substring(serviceURL.indexOf('//') + 2, serviceURL.indexOf('?'));
        handleAddToList(layerTreeFromPromise.title || layerTreeFromPromise.name || shortenedURL);
        setUrlError('');
        setLoading(false);
      })["catch"](function () {
        setUrlError('Please enter a valid WMS service');
        setLoading(false);
      });
    } else {
      setUrlError('Please enter a valid URL');
      setLoading(false);
    }
  };

  React.useEffect(function () {
    if (!isEqual(preloadedServices, services)) {
      setServices(preloadedServices);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [preloadedServices]);
  return /*#__PURE__*/React.createElement(Dialog, {
    fullWidth: true,
    maxWidth: "md",
    open: open,
    onClose: handleClose,
    "aria-labelledby": "form-dialog-title",
    "data-testid": "addLayersPopup"
  }, /*#__PURE__*/React.createElement(DialogTitle, {
    id: "form-dialog-title"
  }, "Load WMS layer(s)"), /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement(DialogContentText, null, "Please enter a wms server, or select one from the list."), /*#__PURE__*/React.createElement(Box, {
    m: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "row",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 10
  }, /*#__PURE__*/React.createElement(TextField, {
    margin: "dense",
    id: "serviceurl",
    label: "Service URL",
    value: serviceURL,
    type: "url",
    onChange: function onChange(event) {
      var url = event.target.value.trim();
      setServiceURL(url); // No error message until new check

      setUrlError('');
    },
    onKeyPress: function onKeyPress(event) {
      if (event.key === 'Enter') {
        handleAddServiceURL();
      }
    },
    fullWidth: true,
    disabled: loading,
    error: urlError !== '',
    helperText: urlError,
    variant: "standard"
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2,
    className: classes.buttonDiv
  }, /*#__PURE__*/React.createElement(IconButton, {
    "data-testid": "add-service",
    onClick: handleAddServiceURL,
    disabled: loading,
    size: "large"
  }, /*#__PURE__*/React.createElement(Add, null)), loading && /*#__PURE__*/React.createElement(CircularProgress, {
    size: 35,
    className: classes.loadingButton
  })))), /*#__PURE__*/React.createElement(Box, {
    m: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "row",
    alignItems: "center",
    spacing: 3
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(WMSServerList, {
    availableServices: services,
    service: activeService,
    handleChangeService: handleChangeService
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 8
  }, onRenderTree ? onRenderTree(activeService) : /*#__PURE__*/React.createElement(WMSLayerTreeConnect, {
    mapId: "",
    service: activeService,
    layerType: layerType
  }))))), /*#__PURE__*/React.createElement(DialogActions, null, /*#__PURE__*/React.createElement(Button, {
    onClick: handleClose,
    color: "primary"
  }, "Close")));
};

var styles$2 = {
  buttonDiv: {
    position: 'relative'
  },
  loadingButton: {
    position: 'absolute',
    top: 7,
    left: 7,
    zIndex: 1
  },
  button: {
    width: '24px',
    height: '24px',
    margin: '6px 0px 0px 10px',
    borderRadius: '15%'
  }
};

var AddLayersButton = function AddLayersButton(_ref) {
  var onRenderTree = _ref.onRenderTree,
      _ref$tooltip = _ref.tooltip,
      tooltip = _ref$tooltip === void 0 ? '' : _ref$tooltip,
      _ref$preloadedService = _ref.preloadedServices,
      preloadedServices = _ref$preloadedService === void 0 ? preloadedDefaultMapServices : _ref$preloadedService,
      _ref$layerType = _ref.layerType,
      layerType = _ref$layerType === void 0 ? LayerType.mapLayer : _ref$layerType,
      _ref$shouldFocus = _ref.shouldFocus,
      shouldFocus = _ref$shouldFocus === void 0 ? false : _ref$shouldFocus;
  var ref = React.useRef(null);

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      open = _React$useState2[0],
      setOpen = _React$useState2[1];

  var _React$useState3 = React.useState(shouldFocus),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      isTooltipDisabled = _React$useState4[0],
      setTooltipDisabled = _React$useState4[1];

  var handleClose = function handleClose() {
    setOpen(!open);
  };

  var onBlurTooltip = function onBlurTooltip(event) {
    // enable tooltip again after user blurs
    if (event.relatedTarget) {
      setTooltipDisabled(false);
    }
  };

  React.useEffect(function () {
    if (shouldFocus && ref.current) {
      ref.current.focus();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Tooltip, {
    title: tooltip,
    disableFocusListener: isTooltipDisabled,
    onBlur: onBlurTooltip
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: handleClose,
    sx: styles$2.button,
    disableRipple: true,
    "data-testid": "addLayersButton",
    ref: ref,
    size: "large"
  }, /*#__PURE__*/React.createElement(Add, null))), /*#__PURE__*/React.createElement(AddLayersPopup, {
    open: open,
    handleClose: handleClose,
    onRenderTree: onRenderTree,
    preloadedServices: preloadedServices,
    layerType: layerType
  }));
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */
var iconButtonSize = 30;
var totalButtons = 5;
var LayerManagerColumnsLarge = makeStyles({
  column1: {
    width: iconButtonSize * 3,
    display: 'flex'
  },
  column2: {
    width: "calc((100% - ".concat(iconButtonSize * totalButtons, "px) * 0.25)")
  },
  column3: {
    width: "calc((100% - ".concat(iconButtonSize * totalButtons, "px) * 0.25)")
  },
  column4: {
    width: "calc((100% - ".concat(iconButtonSize * totalButtons, "px) * 0.10)")
  },
  column5: {
    width: "calc((100% - ".concat(iconButtonSize * totalButtons, "px) * 0.40)")
  },
  column6: {
    width: iconButtonSize * 2,
    display: 'inline-flex'
  },
  columns35: {
    width: "calc((100% - ".concat(iconButtonSize * totalButtons, "px) * 0.75)")
  }
});
var LayerManagerColumnsSmall = makeStyles({
  column1: {
    width: iconButtonSize * 3
  },
  column2: {
    width: "calc(100% - ".concat(iconButtonSize * totalButtons, "px)")
  },
  column3: {
    display: 'none'
  },
  column4: {
    display: 'none'
  },
  column5: {
    display: 'none'
  },
  column6: {
    width: iconButtonSize * 2,
    display: 'inline-flex'
  },
  columns35: {
    display: 'none'
  }
});
var LayerManagerWidth;

(function (LayerManagerWidth) {
  LayerManagerWidth[LayerManagerWidth["sm"] = 0] = "sm";
  LayerManagerWidth[LayerManagerWidth["lg"] = 1] = "lg";
})(LayerManagerWidth || (LayerManagerWidth = {}));

var widthToWidthClass = function widthToWidthClass(w) {
  if (w <= 500) return LayerManagerWidth.sm;
  return LayerManagerWidth.lg;
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */
var style$2 = {
  width: '24px',
  height: '24px',
  margin: '6px 0px 0px 10px',
  borderRadius: '15%'
};

var LayerSelectButtonConnect = function LayerSelectButtonConnect(_ref) {
  var mapId = _ref.mapId,
      _ref$source = _ref.source,
      source = _ref$source === void 0 ? 'app' : _ref$source;
  var dispatch = useDispatch();
  var currentActiveMapId = useSelector(function (store) {
    return getDialogMapId(store, 'layerSelect');
  });
  var isOpenInStore = useSelector(function (store) {
    return getisDialogOpen(store, 'layerSelect');
  });
  var openLayerSelectDialog = React.useCallback(function () {
    dispatch(uiActions.setActiveMapIdForDialog({
      type: 'layerSelect',
      mapId: mapId,
      setOpen: currentActiveMapId !== mapId ? true : !isOpenInStore,
      source: source
    }));
  }, [currentActiveMapId, dispatch, isOpenInStore, mapId, source]);
  return /*#__PURE__*/React.createElement(Tooltip, {
    title: "Layer Select"
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: openLayerSelectDialog,
    sx: style$2,
    id: "layerSelectButton",
    "data-testid": "layerSelectButton",
    disableRipple: true,
    size: "large"
  }, /*#__PURE__*/React.createElement(Add, null)));
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */
var useStyles$p = makeStyles({
  row: {
    height: '32px'
  },
  text: {
    paddingLeft: '10px',
    fontSize: '12px',
    marginTop: '10px',
    fontFamily: 'Roboto',
    opacity: 0.67
  }
});

var DescriptionRow = function DescriptionRow(_ref) {
  var mapId = _ref.mapId,
      _ref$layerType = _ref.layerType,
      layerType = _ref$layerType === void 0 ? LayerType.mapLayer : _ref$layerType,
      _ref$preloadedService = _ref.preloadedServices,
      preloadedServices = _ref$preloadedService === void 0 ? preloadedDefaultMapServices : _ref$preloadedService,
      _ref$tooltip = _ref.tooltip,
      tooltip = _ref$tooltip === void 0 ? '' : _ref$tooltip,
      layerManagerWidth = _ref.layerManagerWidth,
      _ref$layerSelect = _ref.layerSelect,
      layerSelect = _ref$layerSelect === void 0 ? false : _ref$layerSelect;
  var classes = useStyles$p();
  var columnSizes = layerManagerWidth === LayerManagerWidth.sm ? LayerManagerColumnsSmall() : LayerManagerColumnsLarge();
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    item: true,
    "data-testid": "descriptionRow",
    className: classes.row
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    className: columnSizes.column1
  }, /*#__PURE__*/React.createElement(AddLayersButton, {
    preloadedServices: preloadedServices,
    tooltip: tooltip,
    onRenderTree: function onRenderTree(service) {
      return /*#__PURE__*/React.createElement(WMSLayerTreeConnect, {
        mapId: mapId,
        service: service,
        layerType: layerType
      });
    },
    shouldFocus: true
  }), layerSelect && /*#__PURE__*/React.createElement(LayerSelectButtonConnect, {
    mapId: mapId
  })), /*#__PURE__*/React.createElement(Grid, {
    className: columnSizes.column2
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.text
  }, "Layer")), /*#__PURE__*/React.createElement(Grid, {
    className: columnSizes.column3
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.text
  }, "Style")), /*#__PURE__*/React.createElement(Grid, {
    className: columnSizes.column4
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.text
  }, "Opacity")), /*#__PURE__*/React.createElement(Grid, {
    className: columnSizes.column5
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.text
  }, "Dimensions")), /*#__PURE__*/React.createElement(Grid, {
    className: columnSizes.column6
  }));
};

var DimensionSelect = function DimensionSelect(_ref) {
  var layerId = _ref.layerId,
      onLayerChangeDimension = _ref.onLayerChangeDimension,
      _ref$layerDimensions = _ref.layerDimensions,
      layerDimensions = _ref$layerDimensions === void 0 ? [] : _ref$layerDimensions,
      isEnabled = _ref.isEnabled;

  var _React$useState = React.useState(layerDimensions.length ? layerDimensions[0].name : ''),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      activeDimName = _React$useState2[0],
      setActiveDimName = _React$useState2[1];

  React.useEffect(function () {
    var activeDim = layerDimensions.find(function (d) {
      return d.name === activeDimName;
    });

    if (!activeDim) {
      setActiveDimName(layerDimensions.length ? layerDimensions[0].name : '');
    }
  }, [layerDimensions, activeDimName]);
  React.useEffect(function () {
    var activeDim = layerDimensions.find(function (d) {
      return d.name === activeDimName;
    });

    if (activeDim) {
      onLayerChangeDimension(activeDim.name, activeDim.currentValue);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
  if (!layerDimensions.length || !layerId) return null;

  var getValuesToDisplay = function getValuesToDisplay() {
    var activeWMJSDim = getWMJSDimensionForLayerAndDimension(layerId, activeDimName) || getWMJSDimensionForLayerAndDimension(layerId, layerDimensions[0].name);
    if (!activeWMJSDim) return null;
    var availableDimValues = [];

    for (var j = 0; j < activeWMJSDim.size(); j += 1) {
      availableDimValues.push(activeWMJSDim.getValueForIndex(j));
    }

    availableDimValues.reverse(); // Only display last 100 values, to avoid performance issues
    // TODO: (2020-06-29 Tineke van Rijn) replace this with lazy loading

    return availableDimValues.slice(0, 100);
  };

  var valuesToDisplay = getValuesToDisplay();
  if (valuesToDisplay === null) return null;
  var activeDim = layerDimensions.find(function (dim) {
    return dim.name === activeDimName;
  });
  if (!activeDim) return null;

  var selectDimensionValue = function selectDimensionValue(event) {
    event.stopPropagation();

    if (activeDim) {
      onLayerChangeDimension(activeDim.name, event.target.value, LayerActionOrigin.layerManager);
    }
  };

  var onChangeActiveDimensionName = function onChangeActiveDimensionName(event) {
    event.stopPropagation();
    setActiveDimName(event.target.value);
  };

  var dimNameList = layerDimensions.map(function (dimension) {
    return {
      value: dimension.name
    };
  });
  var dimNameCurrentIndex = layerDimensions.findIndex(function (value) {
    return value.name === activeDim.name;
  });
  var dimValueList = valuesToDisplay.map(function (value) {
    return {
      value: value
    };
  });
  var dimValueCurrentIndex = valuesToDisplay.findIndex(function (value) {
    return value === activeDim.currentValue;
  });
  if (dimValueCurrentIndex === -1) return null;
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "row",
    justifyContent: "flex-start",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TooltipSelect, {
    disableUnderline: true,
    tooltip: "Dimensions: ".concat(activeDimName),
    inputProps: {
      SelectDisplayProps: {
        'data-testid': 'selectDimension'
      }
    },
    isEnabled: isEnabled,
    value: activeDimName,
    list: dimNameList,
    currentIndex: dimNameCurrentIndex,
    onChange: onChangeActiveDimensionName,
    onChangeMouseWheel: function onChangeMouseWheel(e) {
      return setActiveDimName(e.value);
    },
    style: {
      maxWidth: '50%'
    }
  }, /*#__PURE__*/React.createElement(MenuItem, {
    disabled: true
  }, "Dimension"), layerDimensions.map(function (dimension) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: dimension.name,
      value: dimension.name
    }, dimension.name);
  })), /*#__PURE__*/React.createElement(TooltipSelect, {
    disableUnderline: true,
    tooltip: "Dimensions: ".concat(activeDimName, " ").concat(activeDim.currentValue, " ").concat(activeDim.units),
    inputProps: {
      SelectDisplayProps: {
        'data-testid': 'selectDimensionValue'
      }
    },
    isEnabled: isEnabled,
    value: activeDim && activeDim.currentValue,
    list: dimValueList,
    currentIndex: dimValueCurrentIndex,
    onChange: selectDimensionValue,
    onChangeMouseWheel: function onChangeMouseWheel(e) {
      return onLayerChangeDimension(activeDim.name, e.value, LayerActionOrigin.layerManager);
    },
    style: {
      maxWidth: '50%'
    }
  }, /*#__PURE__*/React.createElement(MenuItem, {
    disabled: true
  }, "Dimension value (", valuesToDisplay.length, " options)"), valuesToDisplay.map(function (dimValue) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: dimValue,
      value: dimValue
    }, "".concat(dimValue), /*#__PURE__*/React.createElement(React.Fragment, null, "\xA0", /*#__PURE__*/React.createElement("i", null, "".concat(activeDim.units))));
  }))));
};

var useStyles$o = makeStyles(function (theme) {
  return createStyles({
    dropdownEmpty: {
      paddingLeft: 8,
      height: 32,
      display: 'inline-flex',
      alignItems: 'center'
    },
    emptyText: {
      fontSize: theme.palette.geowebColors.layerManager.tableRowDefaultText.fontSize,
      color: theme.palette.geowebColors.layerManager.tableRowDefaultText.rgba,
      fontWeight: 500
    }
  });
});

var getRenderLayersValues = function getRenderLayersValues(layerName, layers) {
  var serviceLayer = layers.find(function (l) {
    return l.name === layerName;
  });

  if (!serviceLayer && layerName) {
    return {
      currentValue: layerName,
      currentIndex: layers.length,
      extendedLayers: [].concat(_toConsumableArray(layers), [{
        name: layerName,
        text: layerName,
        leaf: true,
        path: []
      }])
    };
  }

  return {
    currentValue: (serviceLayer === null || serviceLayer === void 0 ? void 0 : serviceLayer.name) || '',
    currentIndex: layers.findIndex(function (l) {
      return l.name === (serviceLayer === null || serviceLayer === void 0 ? void 0 : serviceLayer.name);
    }),
    extendedLayers: layers
  };
};

var RenderLayers = function RenderLayers(_ref) {
  var onChangeLayerName = _ref.onChangeLayerName,
      layerName = _ref.layerName,
      _ref$layers = _ref.layers,
      layers = _ref$layers === void 0 ? [] : _ref$layers,
      _ref$isEnabled = _ref.isEnabled,
      isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled;

  var _a;

  var classes = useStyles$o();

  if (!layers || !layers.length) {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.dropdownEmpty
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body1",
      className: classes.emptyText
    }, "No service available"));
  }

  var selectLayer = function selectLayer(event) {
    event.stopPropagation();
    onChangeLayerName(event.target.value);
  };

  var _getRenderLayersValue = getRenderLayersValues(layerName, layers),
      currentIndex = _getRenderLayersValue.currentIndex,
      currentValue = _getRenderLayersValue.currentValue,
      extendedLayers = _getRenderLayersValue.extendedLayers;

  var list = extendedLayers.map(function (layer) {
    return {
      value: layer.name
    };
  });
  return /*#__PURE__*/React.createElement(TooltipSelect, {
    disableUnderline: true,
    tooltip: "Layer: ".concat((_a = extendedLayers[currentIndex]) === null || _a === void 0 ? void 0 : _a.text),
    inputProps: {
      SelectDisplayProps: {
        'data-testid': 'selectLayer'
      }
    },
    isEnabled: isEnabled,
    value: currentValue,
    list: list,
    currentIndex: currentIndex,
    onChange: selectLayer,
    onChangeMouseWheel: function onChangeMouseWheel(e) {
      return onChangeLayerName(e.value);
    },
    requiresCtrlToChange: true,
    renderValue: function renderValue(value) {
      return extendedLayers.find(function (layer) {
        return layer.name === value;
      }).text;
    }
  }, /*#__PURE__*/React.createElement(MenuItem, {
    disabled: true
  }, "Layer"), extendedLayers.map(function (layerFromServiceLayers, currentIndex) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: layerFromServiceLayers.name,
      value: layerFromServiceLayers.name,
      disabled: !layerFromServiceLayers.leaf,
      sx: {
        '& .MuiSvgIcon-root': {
          marginLeft: '28px'
        }
      }
    }, layerFromServiceLayers.text, currentIndex === layers.length && /*#__PURE__*/React.createElement(AlertIcon, {
      severity: "error"
    }));
  }));
};

var useStyles$n = makeStyles(function (theme) {
  return {
    opacityDiv: {
      height: 'calc(100% - 5px)',
      width: '100%',
      position: 'relative',
      top: '2px'
    },
    opacityButton: {
      height: '100%',
      width: '100%',
      borderRadius: '0',
      minWidth: '49px'
    },
    sliderBackground: {
      padding: '0 0 60px 0',
      marginLeft: '60px',
      backgroundColor: theme.palette.geowebColors.background.surface,
      width: '82px',
      height: '248px',
      position: 'fixed',
      top: '-5px',
      boxSizing: 'initial',
      zIndex: 2,
      boxShadow: theme.shadows[8]
    }
  };
});
var marks$1 = [{
  value: 0,
  label: '0 %'
}, {
  value: 0.1
}, {
  value: 0.2
}, {
  value: 0.3
}, {
  value: 0.4
}, {
  value: 0.5,
  label: '50 %'
}, {
  value: 0.6
}, {
  value: 0.7
}, {
  value: 0.8
}, {
  value: 0.9
}, {
  value: 1,
  label: '100 %'
}];

var OpacitySelect = function OpacitySelect(_ref) {
  var currentOpacity = _ref.currentOpacity,
      onLayerChangeOpacity = _ref.onLayerChangeOpacity,
      _ref$isEnabled = _ref.isEnabled,
      isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled;
  var classes = useStyles$n();
  var sliderClasses = sliderStyles();

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      open = _React$useState2[0],
      setOpen = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      tooltipOpen = _React$useState4[0],
      setTooltipOpen = _React$useState4[1];

  var onWheel = React.useCallback(function (event) {
    if (event.ctrlKey || event.metaKey) {
      var multiplier = event.altKey ? 10 : 1;
      var direction = event.deltaY > 0 ? 0.01 * multiplier : -0.01 * multiplier;
      var newValue = Math.min(Math.max(currentOpacity - direction, 0), 1); // Kind of "one frame debouncer", meant to dampen too fast slider movement

      window.requestAnimationFrame(function () {
        onLayerChangeOpacity(newValue);
      });
    }
  }, [currentOpacity, onLayerChangeOpacity]);
  var onClickButton = React.useCallback(function () {
    setOpen(!open);
  }, [open]);
  var onKeyDown = React.useCallback(function (event) {
    if (event.key === 'Tab') {
      setOpen(!open);
    }
  }, [open]);
  var onMouseEnter = React.useCallback(function () {
    if (!open) setTooltipOpen(true);
  }, [open]);
  var onMouseLeave = React.useCallback(function () {
    setTooltipOpen(false);
  }, []);
  var onFocus = React.useCallback(function () {
    setTooltipOpen(true);
  }, []);
  var onBlur = React.useCallback(function () {
    setOpen(false);
    setTooltipOpen(false);
  }, []);
  var currentOpacityText = "".concat(Math.round(currentOpacity * 100), "  %");
  return /*#__PURE__*/React.createElement("div", {
    className: classes.opacityDiv,
    onWheel: onWheel,
    "data-testid": "scrollOpacity"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    title: "Opacity: ".concat(currentOpacityText),
    sx: tooltipContainerStyles(isEnabled),
    placement: "top",
    open: tooltipOpen
  }, /*#__PURE__*/React.createElement(Button, {
    tabIndex: 0,
    className: classes.opacityButton,
    onClick: onClickButton,
    "data-testid": "selectOpacity",
    disableRipple: true,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onFocus: onFocus,
    onBlur: onBlur
  }, currentOpacityText)), open ? /*#__PURE__*/React.createElement("div", {
    className: classes.sliderBackground
  }, /*#__PURE__*/React.createElement("div", {
    className: sliderClasses.sliderHeader
  }, "Opacity"), /*#__PURE__*/React.createElement(CustomSlider, {
    "data-testid": "opacitySlider",
    orientation: "vertical",
    value: currentOpacity,
    step: 0.01,
    max: 1,
    min: 0,
    marks: marks$1,
    onChange: function onChange(event, newValue) {
      event.stopPropagation();
      onLayerChangeOpacity(newValue);
    },
    onKeyDown: onKeyDown,
    onFocus: function onFocus() {
      setOpen(true);
    },
    onBlur: function onBlur() {
      setOpen(false);
    }
  })) : null);
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */

var LayerManagerMenuButton = function LayerManagerMenuButton(_ref) {
  var mapId = _ref.mapId,
      layerId = _ref.layerId,
      onLayerDuplicate = _ref.onLayerDuplicate;

  var onClickDuplicate = function onClickDuplicate() {
    onLayerDuplicate({
      mapId: mapId,
      layerId: layerId
    });
  };

  return /*#__PURE__*/React.createElement(ToggleMenu, {
    buttonTestId: "openMenuButton",
    buttonSx: {
      margin: '4px 2px',
      '&.MuiButtonBase-root': {
        backgroundColor: 'transparent',
        color: 'geowebColors.greys.accessible'
      }
    },
    menuPosition: "bottom",
    menuItems: [{
      text: 'Duplicate layer',
      action: onClickDuplicate,
      icon: /*#__PURE__*/React.createElement(Copy, null)
    }],
    tooltipTitle: "Options"
  });
};

var RenderStyles = function RenderStyles(_ref) {
  var layerStyles = _ref.layerStyles,
      currentLayerStyle = _ref.currentLayerStyle,
      onChangeLayerStyle = _ref.onChangeLayerStyle,
      _ref$isEnabled = _ref.isEnabled,
      isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled;

  var _a;

  var styles = [{
    title: 'default',
    name: 'default',
    "abstract": '',
    legendURL: ''
  }];

  if (layerStyles && layerStyles.length > 0) {
    styles.push.apply(styles, _toConsumableArray(layerStyles));
  }

  var currentStyle = currentLayerStyle !== '' ? currentLayerStyle : styles[0].name;

  var selectStyle = function selectStyle(event) {
    event.stopPropagation();
    onChangeLayerStyle(event.target.value);
  };

  var list = styles.map(function (style) {
    return {
      value: style.name
    };
  });
  var currentIndex = styles.findIndex(function (style) {
    return currentStyle === style.name;
  });
  return /*#__PURE__*/React.createElement(TooltipSelect, {
    disableUnderline: true,
    tooltip: "Style: ".concat((_a = styles[currentIndex]) === null || _a === void 0 ? void 0 : _a.title),
    inputProps: {
      SelectDisplayProps: {
        'data-testid': 'selectStyle'
      }
    },
    isEnabled: isEnabled,
    value: currentStyle,
    list: list,
    currentIndex: currentIndex,
    onChange: selectStyle,
    onChangeMouseWheel: function onChangeMouseWheel(e) {
      return onChangeLayerStyle(e.value);
    },
    requiresCtrlToChange: true
  }, /*#__PURE__*/React.createElement(MenuItem, {
    disabled: true
  }, "Style"), styles.map(function (styleFromlayer) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: styleFromlayer.name,
      value: styleFromlayer.name
    }, styleFromlayer.title);
  }));
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */
var useStyles$m = makeStyles(function (theme) {
  return createStyles({
    svgIcon: {
      fill: function fill(_ref) {
        var isActive = _ref.isActive,
            isEnabled = _ref.isEnabled;

        if (isActive) {
          return theme.palette.common.white;
        }

        if (isEnabled) {
          return theme.palette.geowebColors.buttons.flat["default"].color;
        }

        return theme.palette.geowebColors.buttons.flat.disabled.color;
      }
    }
  });
});

var ActivateLayer = function ActivateLayer(_ref2) {
  var _ref2$tooltipTitle = _ref2.tooltipTitle,
      tooltipTitle = _ref2$tooltipTitle === void 0 ? 'Leading layer' : _ref2$tooltipTitle,
      onClickActivate = _ref2.onClickActivate,
      _ref2$isActive = _ref2.isActive,
      isActive = _ref2$isActive === void 0 ? false : _ref2$isActive,
      _ref2$isEnabled = _ref2.isEnabled,
      isEnabled = _ref2$isEnabled === void 0 ? true : _ref2$isEnabled;
  var classes = useStyles$m({
    isActive: isActive,
    isEnabled: isEnabled
  });
  return /*#__PURE__*/React.createElement(ManagerButton, {
    tooltipTitle: tooltipTitle,
    onClick: onClickActivate,
    icon: /*#__PURE__*/React.createElement(Flag, {
      className: classes.svgIcon
    }),
    testId: "activateLayerButton",
    isActive: isActive
  });
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */
var useStyles$l = makeStyles(function (theme) {
  return createStyles({
    row: {
      background: function background(isEnabled) {
        return isEnabled ? theme.palette.geowebColors.layerManager.tableRowDefaultCardContainer.fill : theme.palette.geowebColors.layerManager.tableRowDisabledCardContainer.fill;
      },
      border: function border(isEnabled) {
        return isEnabled ? theme.palette.geowebColors.layerManager.tableRowDefaultCardContainer.border : theme.palette.geowebColors.layerManager.tableRowDisabledCardContainer.border;
      },
      borderRadius: theme.shape.borderRadius,
      marginBottom: 4,
      height: 34,
      '&.sortable-drag': {
        boxShadow: theme.shadows[4] // elevation_06

      },
      '&.sortable-ghost': {
        opacity: 0.5
      }
    }
  });
});

var LayerRow = function LayerRow(_ref) {
  var layerId = _ref.layerId,
      layer = _ref.layer,
      services = _ref.services,
      mapId = _ref.mapId,
      _ref$onLayerRowClick = _ref.onLayerRowClick,
      onLayerRowClick = _ref$onLayerRowClick === void 0 ? function () {
    return null;
  } : _ref$onLayerRowClick,
      _ref$isEnabled = _ref.isEnabled,
      isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled,
      _ref$isLayerMissing = _ref.isLayerMissing,
      isLayerMissing = _ref$isLayerMissing === void 0 ? false : _ref$isLayerMissing,
      onLayerEnable = _ref.onLayerEnable,
      onLayerChangeName = _ref.onLayerChangeName,
      onLayerChangeStyle = _ref.onLayerChangeStyle,
      _onLayerChangeOpacity = _ref.onLayerChangeOpacity,
      _onLayerChangeDimension = _ref.onLayerChangeDimension,
      onLayerDelete = _ref.onLayerDelete,
      onLayerDuplicate = _ref.onLayerDuplicate,
      layerEnableLayout = _ref.layerEnableLayout,
      layerServicesLayout = _ref.layerServicesLayout,
      layerStylesLayout = _ref.layerStylesLayout,
      layerOpacityLayout = _ref.layerOpacityLayout,
      layerDimensionLayout = _ref.layerDimensionLayout,
      layerDeleteLayout = _ref.layerDeleteLayout,
      layerMenuLayout = _ref.layerMenuLayout,
      layerActiveLayout = _ref.layerActiveLayout,
      layerManagerWidth = _ref.layerManagerWidth,
      dragHandle = _ref.dragHandle;
  var classes = useStyles$l(isEnabled);
  var columnSizes = layerManagerWidth === LayerManagerWidth.sm ? LayerManagerColumnsSmall() : LayerManagerColumnsLarge();

  var onClickRow = function onClickRow() {
    return onLayerRowClick(layerId);
  };

  return /*#__PURE__*/React__default.createElement(Grid, {
    className: classes.row,
    item: true,
    container: true,
    "data-testid": "layerRow-".concat(layerId)
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    className: columnSizes.column1
  }, dragHandle, layerEnableLayout || /*#__PURE__*/React__default.createElement(EnableButton, {
    isEnabled: layer.enabled,
    title: layer.name,
    onChangeEnableLayer: function onChangeEnableLayer() {
      onLayerEnable({
        layerId: layerId,
        enabled: !layer.enabled
      });
    }
  }), layerActiveLayout || /*#__PURE__*/React__default.createElement(ActivateLayer, {
    onClickActivate: onClickRow
  })), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    className: "".concat(columnSizes.column2)
  }, layerServicesLayout || /*#__PURE__*/React__default.createElement(RenderLayers, {
    layerName: layer.name,
    layers: services && layer.service && services[layer.service] && services[layer.service].layers || [],
    onChangeLayerName: function onChangeLayerName(name) {
      onLayerChangeName({
        layerId: layer.id,
        name: name
      });
    }
  })), isLayerMissing ? /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    className: "".concat(columnSizes.columns35)
  }, /*#__PURE__*/React__default.createElement(AlertBanner, {
    title: "This layer could not be loaded: does not exist on the server.",
    isCompact: true
  })) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    className: "".concat(columnSizes.column3)
  }, layerStylesLayout || /*#__PURE__*/React__default.createElement(RenderStyles, {
    layerStyles: layer.styles,
    currentLayerStyle: layer.style,
    onChangeLayerStyle: function onChangeLayerStyle(style) {
      onLayerChangeStyle({
        layerId: layerId,
        style: style
      });
    }
  })), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    className: "".concat(columnSizes.column4)
  }, layerOpacityLayout || /*#__PURE__*/React__default.createElement(OpacitySelect, {
    currentOpacity: layer.opacity,
    onLayerChangeOpacity: function onLayerChangeOpacity(_opacity) {
      _onLayerChangeOpacity({
        layerId: layer.id,
        opacity: _opacity
      });
    }
  })), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    className: "".concat(columnSizes.column5)
  }, layerDimensionLayout || /*#__PURE__*/React__default.createElement(DimensionSelect, {
    layerId: layerId,
    layerDimensions: filterNonTimeDimensions(layer.dimensions),
    onLayerChangeDimension: function onLayerChangeDimension(dimensionName, dimensionValue) {
      var dimension = {
        name: dimensionName,
        currentValue: dimensionValue
      };

      _onLayerChangeDimension({
        origin: 'layerrow',
        layerId: layerId,
        dimension: dimension
      });
    }
  }))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    className: columnSizes.column6
  }, layerDeleteLayout || /*#__PURE__*/React__default.createElement(ManagerDeleteButton, {
    tooltipTitle: "Delete",
    onClickDelete: function onClickDelete() {
      onLayerDelete({
        mapId: mapId,
        layerId: layerId
      });
    }
  }), layerMenuLayout || /*#__PURE__*/React__default.createElement(LayerManagerMenuButton, {
    mapId: mapId,
    layerId: layerId,
    onLayerDuplicate: onLayerDuplicate
  })));
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */

var DeleteLayerConnect = function DeleteLayerConnect(_ref) {
  var layerId = _ref.layerId,
      mapId = _ref.mapId,
      layerIndex = _ref.layerIndex;
  var dispatch = useDispatch();
  var layerDelete = React.useCallback(function (_ref2) {
    var mapId = _ref2.mapId,
        layerId = _ref2.layerId,
        layerIndex = _ref2.layerIndex;
    return dispatch(layerActions.layerDelete({
      mapId: mapId,
      layerId: layerId,
      layerIndex: layerIndex,
      origin: LayerActionOrigin.layerManager
    }));
  }, [dispatch]);
  var isLayerEnabled = useSelector(function (store) {
    return getLayerEnabled(store, layerId);
  });
  return /*#__PURE__*/React.createElement(ManagerDeleteButton, {
    tooltipTitle: "Delete",
    onClickDelete: function onClickDelete() {
      layerDelete({
        mapId: mapId,
        layerId: layerId,
        layerIndex: layerIndex
      });
    },
    isEnabled: isLayerEnabled
  });
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */

var EnableLayerConnect = function EnableLayerConnect(_ref) {
  var layerId = _ref.layerId,
      mapId = _ref.mapId;
  var dispatch = useDispatch();
  var isEnabled = useSelector(function (store) {
    return getLayerEnabled(store, layerId);
  });
  var layerChangeEnabled = React.useCallback(function (_ref2) {
    var layerId = _ref2.layerId,
        enabled = _ref2.enabled;
    return dispatch(layerActions.layerChangeEnabled({
      layerId: layerId,
      enabled: enabled,
      mapId: mapId,
      origin: LayerActionOrigin.layerManager
    }));
  }, [dispatch, mapId]);
  return /*#__PURE__*/React.createElement(EnableButton, {
    isEnabled: isEnabled,
    title: "Toggle visibility",
    onChangeEnableLayer: function onChangeEnableLayer(enabled) {
      layerChangeEnabled({
        layerId: layerId,
        enabled: enabled
      });
    }
  });
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */

var OpacitySelectConnect = function OpacitySelectConnect(_ref) {
  var layerId = _ref.layerId,
      mapId = _ref.mapId;
  var dispatch = useDispatch();
  var opacity = useSelector(function (store) {
    return getLayerOpacity(store, layerId);
  });
  var isLayerEnabled = useSelector(function (store) {
    return getLayerEnabled(store, layerId);
  });
  return /*#__PURE__*/React.createElement(OpacitySelect, {
    currentOpacity: opacity,
    onLayerChangeOpacity: function onLayerChangeOpacity(newOpacity) {
      dispatch(layerActions.layerChangeOpacity({
        layerId: layerId,
        opacity: newOpacity,
        mapId: mapId,
        origin: LayerActionOrigin.layerManager
      }));
    },
    isEnabled: isLayerEnabled
  });
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */

var DimensionSelectConnect = function DimensionSelectConnect(_ref) {
  var layerId = _ref.layerId,
      mapId = _ref.mapId;
  var dispatch = useDispatch();
  var layerDimensions = useSelector(function (store) {
    return getLayerNonTimeDimensions(store, layerId);
  });
  var isLayerEnabled = useSelector(function (store) {
    return getLayerEnabled(store, layerId);
  });
  var layerChangeDimension = React.useCallback(function (_ref2) {
    var dimension = _ref2.dimension,
        origin = _ref2.origin;
    return dispatch(layerActions.layerChangeDimension({
      layerId: layerId,
      dimension: dimension,
      mapId: mapId,
      origin: origin
    }));
  }, [layerId, dispatch, mapId]);
  return /*#__PURE__*/React.createElement(DimensionSelect, {
    layerId: layerId,
    layerDimensions: layerDimensions,
    onLayerChangeDimension: function onLayerChangeDimension(dimensionName, dimensionValue, origin) {
      var dimension = {
        name: dimensionName,
        currentValue: dimensionValue
      };
      layerChangeDimension({
        dimension: dimension,
        origin: origin
      });
    },
    isEnabled: isLayerEnabled
  });
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */

var RenderStylesConnect = function RenderStylesConnect(_ref) {
  var layerId = _ref.layerId,
      mapId = _ref.mapId;
  var dispatch = useDispatch();
  var layerService = useSelector(function (store) {
    return getLayerService(store, layerId);
  });
  var layerName = useSelector(function (store) {
    return getLayerName(store, layerId);
  });
  var layerStyles = useSelector(function (store) {
    return getLayerStyles(store, layerService, layerName);
  });
  var currentLayerStyle = useSelector(function (store) {
    return getLayerStyle(store, layerId);
  });
  var isLayerEnabled = useSelector(function (store) {
    return getLayerEnabled(store, layerId);
  });
  var layerChangeStyle = React.useCallback(function (style) {
    return dispatch(layerActions.layerChangeStyle({
      layerId: layerId,
      style: style,
      mapId: mapId,
      origin: LayerActionOrigin.layerManager
    }));
  }, [layerId, dispatch, mapId]);
  return /*#__PURE__*/React.createElement(RenderStyles, {
    layerStyles: layerStyles,
    currentLayerStyle: currentLayerStyle,
    onChangeLayerStyle: layerChangeStyle,
    isEnabled: isLayerEnabled
  });
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */

var RenderLayersConnect = function RenderLayersConnect(_ref) {
  var layerId = _ref.layerId,
      mapId = _ref.mapId;
  var dispatch = useDispatch();
  var layerName = useSelector(function (store) {
    return getLayerName(store, layerId);
  });
  var layerService = useSelector(function (store) {
    return getLayerService(store, layerId);
  });
  var isLayerEnabled = useSelector(function (store) {
    return getLayerEnabled(store, layerId);
  });
  var layers = useSelector(function (store) {
    return getLayersFromService$1(store, layerService);
  });
  var layerChangeName = React.useCallback(function (_ref2) {
    var layerId = _ref2.layerId,
        name = _ref2.name;
    return dispatch(layerActions.layerChangeName({
      layerId: layerId,
      name: name,
      mapId: mapId,
      origin: LayerActionOrigin.layerManager
    }));
  }, [dispatch, mapId]);
  return /*#__PURE__*/React.createElement(RenderLayers, {
    layers: layers,
    layerName: layerName,
    onChangeLayerName: function onChangeLayerName(name) {
      layerChangeName({
        layerId: layerId,
        name: name
      });
    },
    isEnabled: isLayerEnabled
  });
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */

var LayerManagerMenuButtonConnect = function LayerManagerMenuButtonConnect(_ref) {
  var layerId = _ref.layerId,
      mapId = _ref.mapId;
  var dispatch = useDispatch();
  var layer = useSelector(function (store) {
    return getLayerById(store, layerId);
  });
  var addLayer = React.useCallback(function (_ref2) {
    var mapId = _ref2.mapId,
        layerId = _ref2.layerId,
        layer = _ref2.layer;
    return dispatch(layerActions.addLayer({
      mapId: mapId,
      layerId: layerId,
      layer: layer,
      origin: LayerActionOrigin.layerManager
    }));
  }, [dispatch]);
  return /*#__PURE__*/React.createElement(LayerManagerMenuButton, {
    layerId: layerId,
    mapId: mapId,
    onLayerDuplicate: function onLayerDuplicate() {
      addLayer({
        layerId: generateLayerId(),
        mapId: mapId,
        layer: layer
      });
    }
  });
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */

var ActivateLayerConnect = function ActivateLayerConnect(_ref) {
  var layerId = _ref.layerId,
      mapId = _ref.mapId;
  var dispatch = useDispatch();
  var activeLayerId = useSelector(function (store) {
    return getActiveLayerId(store, mapId);
  });
  var isLayerEnabled = useSelector(function (store) {
    return getLayerEnabled(store, layerId);
  });
  var setActiveLayerId = React.useCallback(function (_ref2) {
    var layerId = _ref2.layerId,
        mapId = _ref2.mapId;
    return dispatch(mapActions$1.setActiveLayerId({
      layerId: layerId,
      mapId: mapId,
      origin: LayerActionOrigin.layerManager
    }));
  }, [dispatch]);
  var isAutoUpdating$1 = useSelector(function (store) {
    return isAutoUpdating(store, mapId);
  });
  var setAutoUpdateOn = React.useCallback(function (mapId) {
    return dispatch(mapActions$1.toggleAutoUpdate({
      mapId: mapId,
      shouldAutoUpdate: true
    }));
  }, [dispatch]);
  var isActive = activeLayerId === layerId;
  return /*#__PURE__*/React.createElement(ActivateLayer, {
    tooltipTitle: "Leading layer",
    onClickActivate: function onClickActivate() {
      setActiveLayerId({
        mapId: mapId,
        layerId: layerId
      });

      if (isAutoUpdating$1) {
        // Layer is now set active *and* autoupdate is currently on => autoupdate is desired to be set on.
        setAutoUpdateOn(mapId);
      }
    },
    isActive: isActive,
    isEnabled: isLayerEnabled
  });
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */

var LayerRowConnect = function LayerRowConnect(_ref) {
  var layerId = _ref.layerId,
      mapId = _ref.mapId,
      layerManagerWidth = _ref.layerManagerWidth,
      dragHandle = _ref.dragHandle,
      layerIndex = _ref.layerIndex;
  var isEnabled = useSelector(function (store) {
    return getLayerEnabled(store, layerId);
  });
  var layerName = useSelector(function (store) {
    return getLayerName(store, layerId);
  });
  var layerService = useSelector(function (store) {
    return getLayerService(store, layerId);
  });
  var layers = useSelector(function (store) {
    return getLayersFromService$1(store, layerService);
  });
  var isLayerMissing = layers && layers.length > 0 && !layers.some(function (l) {
    return l.name === layerName;
  });
  return /*#__PURE__*/React.createElement(LayerRow, {
    isEnabled: isEnabled,
    mapId: mapId,
    layerId: layerId,
    isLayerMissing: isLayerMissing,
    layerEnableLayout: /*#__PURE__*/React.createElement(EnableLayerConnect, {
      layerId: layerId,
      mapId: mapId
    }),
    layerOpacityLayout: /*#__PURE__*/React.createElement(OpacitySelectConnect, {
      layerId: layerId,
      mapId: mapId
    }),
    layerServicesLayout: /*#__PURE__*/React.createElement(RenderLayersConnect, {
      layerId: layerId,
      mapId: mapId
    }),
    layerDimensionLayout: /*#__PURE__*/React.createElement(DimensionSelectConnect, {
      layerId: layerId,
      mapId: mapId
    }),
    layerStylesLayout: /*#__PURE__*/React.createElement(RenderStylesConnect, {
      layerId: layerId,
      mapId: mapId
    }),
    layerDeleteLayout: /*#__PURE__*/React.createElement(DeleteLayerConnect, {
      mapId: mapId,
      layerId: layerId,
      layerIndex: layerIndex
    }),
    layerMenuLayout: /*#__PURE__*/React.createElement(LayerManagerMenuButtonConnect, {
      mapId: mapId,
      layerId: layerId
    }),
    layerActiveLayout: /*#__PURE__*/React.createElement(ActivateLayerConnect, {
      mapId: mapId,
      layerId: layerId
    }),
    layerManagerWidth: layerManagerWidth,
    dragHandle: dragHandle
  });
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */
var TOOLTIP_TITLE = 'Drag';

var DragHandle = function DragHandle(_ref) {
  var _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$index = _ref.index,
      index = _ref$index === void 0 ? undefined : _ref$index,
      _ref$hideTooltip = _ref.hideTooltip,
      hideTooltip = _ref$hideTooltip === void 0 ? false : _ref$hideTooltip;
  var tooltipTitle = hideTooltip ? '' : TOOLTIP_TITLE;
  return /*#__PURE__*/React__default.createElement(ManagerButton, {
    tooltipTitle: tooltipTitle,
    icon: /*#__PURE__*/React__default.createElement(DragHandle$1, null),
    testId: "dragHandle".concat(index !== undefined ? "-".concat(index) : ''),
    className: "handle",
    tabIndex: -1,
    isEnabled: !isDisabled,
    disableFocusRipple: true,
    disableTouchRipple: true,
    disabled: isDisabled,
    isAccessible: true,
    sx: {
      cursor: 'grab',
      '&:hover': {
        backgroundColor: 'inherit!important'
      },
      marginLeft: '3px',
      marginRight: '3px'
    }
  });
};

var useStyles$k = makeStyles(function () {
  return {
    layerRows: {
      width: '100%',
      maxHeight: 'calc(100% - 10px)',
      overflow: 'auto'
    },
    sortableRow: {
      width: '100%',
      cursor: function cursor(isSorting) {
        return isSorting ? 'grabbing' : 'inherit';
      }
    }
  };
});

var LayerContainerRow = function LayerContainerRow(_ref) {
  var mapId = _ref.mapId,
      layerManagerWidth = _ref.layerManagerWidth;
  var dispatch = useDispatch();

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      keyPressed = _React$useState2[0],
      setKeyPressed = _React$useState2[1];

  var layerIds = useSelector(function (store) {
    return getLayerIds(store, mapId);
  });
  var layerMoveLayer = React.useCallback(function (_ref2) {
    var mapId = _ref2.mapId,
        oldIndex = _ref2.oldIndex,
        newIndex = _ref2.newIndex;
    return dispatch(mapActions$1.layerMoveLayer({
      mapId: mapId,
      oldIndex: oldIndex,
      newIndex: newIndex,
      origin: LayerActionOrigin.layerManager
    }));
  }, [dispatch]);

  var _React$useState3 = React.useState(null),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      activeDragIndex = _React$useState4[0],
      setActiveDragIndex = _React$useState4[1];

  var onSetList = function onSetList() {}; // since we use activeDragIndex, we don't need inner state handling of ReactSortable


  var onStart = React.useCallback(function (_ref3) {
    var oldIndex = _ref3.oldIndex;
    setActiveDragIndex(oldIndex);
    Sortable.ghost.style.opacity = '1';
  }, []);
  var onEnd = React.useCallback(function () {
    if (activeDragIndex !== null) {
      setActiveDragIndex(null);
    }
  }, [activeDragIndex]);

  var onSortEnd = function onSortEnd(_ref4) {
    var oldIndex = _ref4.oldIndex,
        newIndex = _ref4.newIndex;
    setActiveDragIndex(null);
    layerMoveLayer({
      mapId: mapId,
      oldIndex: oldIndex,
      newIndex: newIndex
    });
  };

  var isSorting = activeDragIndex !== null;
  var isDragDisabled = layerIds.length === 1;
  var classes = useStyles$k(isSorting);

  var keyPressedTrue = function keyPressedTrue(event) {
    if (event.ctrlKey || event.metaKey) {
      setKeyPressed(true);
    }
  };

  var keyPressedFalse = function keyPressedFalse() {
    setKeyPressed(false);
  };

  React.useEffect(function () {
    window.addEventListener('keydown', keyPressedTrue);
    window.addEventListener('keyup', keyPressedFalse);
    return function () {
      window.removeEventListener('keydown', keyPressedTrue);
      window.removeEventListener('keyup', keyPressedFalse);
    };
  }, []);
  var preventDefault = React.useCallback(function (event) {
    event.preventDefault();
    event.stopPropagation();
  }, []);
  React.useEffect(function () {
    if (keyPressed === true) {
      window.addEventListener('wheel', preventDefault, {
        passive: false
      });
    } else {
      window.removeEventListener('wheel', preventDefault);
    }

    return function () {
      return window.removeEventListener('wheel', preventDefault);
    };
  }, [keyPressed, preventDefault]);
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    item: true,
    className: classes.layerRows,
    "data-testid": "layerContainerRow"
  }, /*#__PURE__*/React.createElement(ReactSortable, {
    tag: "div",
    list: layerIds.map(function (layerId) {
      return {
        id: layerId
      };
    }),
    setList: onSetList,
    animation: 200,
    onSort: onSortEnd,
    handle: ".handle",
    direction: "vertical",
    // hover props
    forceFallback: true,
    className: classes.sortableRow,
    onStart: onStart,
    onEnd: onEnd
  }, layerIds.map(function (layerId, index) {
    return /*#__PURE__*/React.createElement(LayerRowConnect, {
      mapId: mapId,
      layerId: layerId,
      layerIndex: index,
      layerManagerWidth: layerManagerWidth,
      key: "layerRowConnect-".concat(layerId),
      dragHandle: /*#__PURE__*/React.createElement(DragHandle, {
        isDisabled: isDragDisabled,
        index: index,
        hideTooltip: isSorting || isDragDisabled
      })
    });
  })));
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */

var BaseLayers = function BaseLayers(_ref) {
  var selectedBaseLayers = _ref.selectedBaseLayers,
      availableBaseLayers = _ref.availableBaseLayers,
      onChangeBaseLayers = _ref.onChangeBaseLayers;

  var _a;

  if (!availableBaseLayers || !availableBaseLayers.length) {
    return /*#__PURE__*/React.createElement("div", null, "No service available");
  }

  var selectedBaseLayerId = typeof selectedBaseLayers[0] !== 'undefined' ? selectedBaseLayers[0].id : '';
  var list = availableBaseLayers.map(function (layer) {
    return {
      value: layer.id
    };
  });
  var currentIndex = availableBaseLayers.findIndex(function (layer) {
    return selectedBaseLayerId === layer.id;
  });
  return /*#__PURE__*/React.createElement(FormControl, {
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(TooltipSelect, {
    disableUnderline: true,
    tooltip: "Base layer: ".concat((_a = availableBaseLayers[currentIndex]) === null || _a === void 0 ? void 0 : _a.name),
    inputProps: {
      SelectDisplayProps: {
        'data-testid': 'selectBaseLayer'
      }
    },
    style: {
      maxWidth: '100%'
    },
    isEnabled: true,
    value: selectedBaseLayerId,
    list: list,
    currentIndex: currentIndex,
    onChange: function onChange(event) {
      onChangeBaseLayers(event.target.value);
    },
    onChangeMouseWheel: function onChangeMouseWheel(e) {
      return onChangeBaseLayers(e.value);
    }
  }, /*#__PURE__*/React.createElement(MenuItem, {
    disabled: true
  }, "Base layer"), availableBaseLayers.map(function (baseLayer) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: baseLayer.id,
      value: baseLayer.id
    }, baseLayer.name);
  })));
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */
// If already in selectedBaseLayers based on name or id, keep current id

var constructLayerId = function constructLayerId(baseLayer, selectedBaseLayers) {
  var foundLayer = selectedBaseLayers.find(function (selectedBaseLayer) {
    return baseLayer.id === selectedBaseLayer.id || baseLayer.name === selectedBaseLayer.name;
  });
  return foundLayer ? foundLayer.id : generateLayerId();
};
var constructListAvailableBaseLayers = function constructListAvailableBaseLayers(selectedBaseLayers, preloadedAvailableBaseLayers, mapId) {
  // Ensure we use unique id's for the base layers - excepting the ones that are currently selected, reuse the existing ids
  // Add mapId of map these available base layers are added for
  var baseLayersWithMapId = preloadedAvailableBaseLayers.map(function (baseLayer) {
    var layerId = constructLayerId(baseLayer, selectedBaseLayers);
    return Object.assign(Object.assign({}, baseLayer), {
      mapId: mapId,
      id: layerId
    });
  }); // Ensure that current selected baselayer(s) are in the baseLayersWithMapId array, otherwise add them

  return selectedBaseLayers.reduce(function (list, selectedBaseLayer) {
    var foundLayer = baseLayersWithMapId.find(function (layer) {
      return layer.id === selectedBaseLayer.id;
    });

    if (foundLayer) {
      return list;
    }

    return list.concat(Object.assign(Object.assign({}, selectedBaseLayer), {
      mapId: mapId
    }));
  }, baseLayersWithMapId);
};

var BaseLayersConnect = function BaseLayersConnect(_ref) {
  var mapId = _ref.mapId,
      preloadedAvailableBaseLayers = _ref.preloadedAvailableBaseLayers;
  var dispatch = useDispatch();
  var selectedBaseLayers = useSelector(function (store) {
    return getMapBaseLayers(store, mapId);
  });
  var currentAvailableBaseLayers = useSelector(function (store) {
    return getAvailableBaseLayersForMap(store, mapId);
  });
  React.useEffect(function () {
    // Set initial availableBaseLayers only if none set for that map yet
    if (currentAvailableBaseLayers.length < 1) {
      var availableBaseLayersToBeAdded = constructListAvailableBaseLayers(selectedBaseLayers, preloadedAvailableBaseLayers, mapId);
      dispatch(layerActions.addAvailableBaseLayers({
        layers: availableBaseLayersToBeAdded
      }));
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [mapId]);

  var onChangeBaseLayers = function onChangeBaseLayers(newSelectedLayerId) {
    var newBaseLayer = currentAvailableBaseLayers.filter(function (layer) {
      return layer.id === newSelectedLayerId;
    });
    dispatch(layerActions.setBaseLayers({
      mapId: mapId,
      layers: newBaseLayer,
      origin: LayerActionOrigin.layerManager
    }));
  };

  return /*#__PURE__*/React.createElement(BaseLayers, {
    selectedBaseLayers: selectedBaseLayers,
    availableBaseLayers: currentAvailableBaseLayers,
    onChangeBaseLayers: onChangeBaseLayers
  });
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */
var useStyles$j = makeStyles({
  layerRow: {
    width: '100%',
    height: '36px'
  },
  icon: {
    width: '24px',
    height: '24px'
  },
  addBaseLayers: {
    marginTop: '-2px'
  }
});

var BaseLayerRow = function BaseLayerRow(_ref) {
  var mapId = _ref.mapId,
      _ref$preloadedAvailab = _ref.preloadedAvailableBaseLayers,
      preloadedAvailableBaseLayers = _ref$preloadedAvailab === void 0 ? availableDefaultBaseLayers : _ref$preloadedAvailab,
      _ref$preloadedService = _ref.preloadedServices,
      preloadedServices = _ref$preloadedService === void 0 ? preloadedDefaultBaseServices : _ref$preloadedService,
      layerManagerWidth = _ref.layerManagerWidth,
      _ref$tooltip = _ref.tooltip,
      tooltip = _ref$tooltip === void 0 ? '' : _ref$tooltip;
  var classes = useStyles$j();
  var columnSizes = layerManagerWidth === LayerManagerWidth.sm ? LayerManagerColumnsSmall() : LayerManagerColumnsLarge();
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    item: true,
    className: classes.layerRow,
    "data-testid": "baseLayerRow"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    className: "".concat(columnSizes.column1, " ").concat(classes.addBaseLayers)
  }, /*#__PURE__*/React.createElement(AddLayersButton, {
    preloadedServices: preloadedServices,
    tooltip: tooltip,
    onRenderTree: function onRenderTree(service) {
      return /*#__PURE__*/React.createElement(WMSLayerTreeConnect, {
        mapId: mapId,
        service: service,
        layerType: LayerType.baseLayer
      });
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    className: "".concat(columnSizes.column2)
  }, /*#__PURE__*/React.createElement(BaseLayersConnect, {
    mapId: mapId,
    preloadedAvailableBaseLayers: preloadedAvailableBaseLayers
  })));
};

var styles$1 = {
  layerRowContainer: {
    position: 'relative',
    width: '100%',
    height: 'calc(100% - 59px)',
    display: 'inline-block'
  },
  layerManagerContainer: {
    position: 'absolute',
    height: '100%',
    width: '100%',
    boxSizing: 'border-box'
  }
};

var LayerManager = function LayerManager(_ref) {
  var mapId = _ref.mapId,
      preloadedAvailableBaseLayers = _ref.preloadedAvailableBaseLayers,
      preloadedMapServices = _ref.preloadedMapServices,
      preloadedBaseServices = _ref.preloadedBaseServices,
      bounds = _ref.bounds,
      onClose = _ref.onClose,
      showTitle = _ref.showTitle,
      isOpen = _ref.isOpen,
      _ref$onMouseDown = _ref.onMouseDown,
      onMouseDown = _ref$onMouseDown === void 0 ? function () {} : _ref$onMouseDown,
      _ref$order = _ref.order,
      order = _ref$order === void 0 ? 0 : _ref$order,
      _ref$source = _ref.source,
      source = _ref$source === void 0 ? 'app' : _ref$source,
      _ref$layerSelect = _ref.layerSelect,
      layerSelect = _ref$layerSelect === void 0 ? false : _ref$layerSelect,
      _ref$showAddLayersToo = _ref.showAddLayersTooltip,
      showAddLayersTooltip = _ref$showAddLayersToo === void 0 ? true : _ref$showAddLayersToo,
      _ref$leftComponent = _ref.leftComponent,
      leftComponent = _ref$leftComponent === void 0 ? null : _ref$leftComponent,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      error = _ref.error;

  var _React$useState = React.useState(LayerManagerWidth.lg),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      layerManagerWidth = _React$useState2[0],
      setLayerManagerWidth = _React$useState2[1];

  var onChangeSize = function onChangeSize(_ref2) {
    var width = _ref2.width;
    setLayerManagerWidth(widthToWidthClass(width));
  };

  return /*#__PURE__*/React.createElement(ToolContainerDraggable, {
    title: showTitle ? "Layer Manager ".concat(mapId) : 'Layer Manager',
    startSize: {
      width: 720,
      height: 300
    },
    minWidth: 300,
    minHeight: 126,
    startPosition: {
      top: 96,
      left: 50
    },
    isOpen: isOpen,
    onChangeSize: onChangeSize,
    onClose: onClose,
    headerSize: "medium",
    bounds: bounds,
    "data-testid": "layerManagerWindow",
    onMouseDown: onMouseDown,
    order: order,
    source: source,
    leftComponent: leftComponent
  }, /*#__PURE__*/React.createElement(Box, {
    sx: styles$1.layerManagerContainer
  }, isLoading && /*#__PURE__*/React.createElement(LinearProgress, {
    "data-testid": "loading-bar",
    color: "secondary",
    sx: {
      position: 'absolute',
      width: '100%'
    }
  }), /*#__PURE__*/React.createElement(Box, {
    sx: {
      padding: '0 6px'
    }
  }, error && /*#__PURE__*/React.createElement(AlertBanner, {
    title: error,
    shouldClose: true
  }), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    "data-testid": "layerManagerRowContainer",
    sx: styles$1.layerRowContainer
  }, /*#__PURE__*/React.createElement(DescriptionRow, {
    mapId: mapId,
    tooltip: showAddLayersTooltip ? 'Add layers' : '',
    layerManagerWidth: layerManagerWidth,
    preloadedServices: preloadedMapServices,
    layerSelect: layerSelect
  }), /*#__PURE__*/React.createElement(LayerContainerRow, {
    mapId: mapId,
    layerManagerWidth: layerManagerWidth
  }), /*#__PURE__*/React.createElement(BaseLayerRow, {
    mapId: mapId,
    tooltip: "Add base layers",
    layerManagerWidth: layerManagerWidth,
    preloadedAvailableBaseLayers: preloadedAvailableBaseLayers,
    preloadedServices: preloadedBaseServices
  })))));
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */

var KeywordFilterButtonConnect = function KeywordFilterButtonConnect(_ref) {
  var mapId = _ref.mapId,
      _ref$source = _ref.source,
      source = _ref$source === void 0 ? 'app' : _ref$source;
  var dispatch = useDispatch();
  var currentActiveMapId = useSelector(function (store) {
    return getDialogMapId(store, 'keywordFilter');
  });
  var isOpenInStore = useSelector(function (store) {
    return getisDialogOpen(store, 'keywordFilter');
  });
  var openFilterResultsDialog = React.useCallback(function () {
    dispatch(uiActions.setActiveMapIdForDialog({
      type: 'keywordFilter',
      mapId: mapId,
      setOpen: currentActiveMapId !== mapId ? true : !isOpenInStore,
      source: source
    }));
  }, [currentActiveMapId, dispatch, isOpenInStore, mapId, source]);
  return /*#__PURE__*/React.createElement(ToolButton, {
    onClick: openFilterResultsDialog,
    active: isOpenInStore,
    id: "keywordFilterButton",
    "data-testid": "keywordFilterButton",
    disableRipple: true,
    variant: "tool"
  }, /*#__PURE__*/React.createElement(Filter, null));
};

var style$1 = {
  dialogTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '16px 16px 20px 16px',
    ' span': {
      fontSize: '2.125rem'
    }
  },
  container: function container(theme) {
    return {
      '& .MuiDialog-paper': {
        backgroundColor: theme.palette.geowebColors.cards.cardContainer
      }
    };
  },
  closeBtn: function closeBtn(theme) {
    return {
      color: theme.palette.geowebColors.captions.captionDisabled.color,
      marginTop: 'auto',
      marginBottom: 'auto'
    };
  },
  textField: {
    width: '100%'
  },
  dialogContent: {
    padding: '8px 16px'
  },
  footerContent: {
    padding: '16px'
  }
};
var ADD_HEADING = 'Add a new service';
var EDIT_HEADING = 'Edit service';
var SAVE_HEADING = 'Save service';

var getTitleForVariant = function getTitleForVariant(variant) {
  switch (variant) {
    case 'add':
      return ADD_HEADING;

    case 'edit':
      return EDIT_HEADING;

    default:
      return SAVE_HEADING;
  }
};

var ServicePopup = function ServicePopup(_ref) {
  var servicePopupVariant = _ref.servicePopupVariant,
      _ref$hideBackdrop = _ref.hideBackdrop,
      hideBackdrop = _ref$hideBackdrop === void 0 ? false : _ref$hideBackdrop,
      isOpen = _ref.isOpen,
      closePopup = _ref.closePopup,
      url = _ref.url,
      services = _ref.services,
      serviceSetLayers = _ref.serviceSetLayers;

  var _a, _b;

  var _React$useState = React.useState(servicePopupVariant !== 'edit' || services === undefined ? '' : (_a = services[url]) === null || _a === void 0 ? void 0 : _a.name),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      serviceName = _React$useState2[0],
      setServiceName = _React$useState2[1];

  var _React$useState3 = React.useState(servicePopupVariant === 'add' || url === undefined ? '' : url),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      serviceUrl = _React$useState4[0],
      setServiceUrl = _React$useState4[1];

  var _React$useState5 = React.useState(servicePopupVariant !== 'edit' || services === undefined ? '' : (_b = services[url]) === null || _b === void 0 ? void 0 : _b["abstract"]),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      _abstract = _React$useState6[0],
      setAbstract = _React$useState6[1];

  var _React$useState7 = React.useState(false),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      disableButton = _React$useState8[0],
      setDisableButton = _React$useState8[1];

  var _React$useState9 = React.useState(false),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      isLoading = _React$useState10[0],
      setIsLoading = _React$useState10[1];

  var _React$useState11 = React.useState(false),
      _React$useState12 = _slicedToArray(_React$useState11, 2),
      serviceNameHasError = _React$useState12[0],
      setServiceNameHasError = _React$useState12[1];

  var _React$useState13 = React.useState(''),
      _React$useState14 = _slicedToArray(_React$useState13, 2),
      serviceNameHelperText = _React$useState14[0],
      setServiceNameHelperText = _React$useState14[1];

  var _React$useState15 = React.useState(false),
      _React$useState16 = _slicedToArray(_React$useState15, 2),
      serviceUrlHasError = _React$useState16[0],
      setServiceUrlHasError = _React$useState16[1];

  var _React$useState17 = React.useState(''),
      _React$useState18 = _slicedToArray(_React$useState17, 2),
      serviceUrlHelperText = _React$useState18[0],
      setServiceUrlHelperText = _React$useState18[1];

  var validateServiceUrl = function validateServiceUrl(url) {
    if (url === '' || url === null || typeof url === 'undefined') return false;
    var matcher = /^(?:\w+:)?\/\/([^\s.]+\.\S{2}|[0-9a-zA-Z]+[:?\d]*)\S*$/;
    if (!matcher.test(url)) return false;
    return true;
  };

  var addNewService = function addNewService() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var layers, serviceLayers, _iterator, _step, object, service;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setServiceUrlHasError(false);

              if (!validateServiceUrl(serviceUrl)) {
                _context.next = 15;
                break;
              }

              setIsLoading(true);
              _context.prev = 3;
              _context.next = 6;
              return getLayersFromService(serviceUrl);

            case 6:
              layers = _context.sent;

              if (layers.children) {
                serviceLayers = [];
                _iterator = _createForOfIteratorHelper(layers.children);

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    object = _step.value;
                    serviceLayers.push({
                      name: object.name,
                      text: object.title,
                      leaf: object.leaf,
                      path: object.path,
                      keywords: object.keywords ? object.keywords : [],
                      "abstract": object["abstract"] ? object["abstract"] : '',
                      styles: object.styles ? object.styles : []
                    });
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                service = WMGetServiceFromStore(serviceUrl);
                serviceSetLayers({
                  id: service.id,
                  name: serviceName,
                  serviceUrl: serviceUrl,
                  layers: serviceLayers,
                  isUserAddedService: true
                });
                setIsLoading(false);
                closePopupAndResetState();
              }

              _context.next = 15;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](3);
              setIsLoading(false);
              setServiceUrlHasError(true);
              setServiceUrlHelperText('Error: Download failed. Check the URL.');

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 10]]);
    }));
  };

  var ServiceNameInRedux = function ServiceNameInRedux() {
    if (servicePopupVariant === 'add' || servicePopupVariant === 'save') {
      for (var service in services) {
        if (services && services[service].name.toLowerCase() === serviceName.toLowerCase()) return true;
      }

      return false;
    }

    return false;
  };

  var UrlInRedux = function UrlInRedux() {
    if (servicePopupVariant === 'add' || servicePopupVariant === 'save') {
      if (services && services[serviceUrl]) {
        return true;
      }

      return false;
    }

    return false;
  }; // Check serviceName


  React.useEffect(function () {
    setServiceNameHelperText('');

    if (ServiceNameInRedux()) {
      setServiceNameHasError(true);
      setServiceNameHelperText('Error: This name already exists. Choose another name.');
    } else {
      setServiceNameHasError(false);
      setServiceNameHelperText('');
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [serviceName]); // Check Url

  React.useEffect(function () {
    setServiceUrlHelperText('');

    if (serviceUrl.length > 0 && !validateServiceUrl(serviceUrl)) {
      setServiceUrlHasError(true);
      setServiceUrlHelperText('Error: Not a valid URL.');
    } else if (UrlInRedux()) {
      setServiceUrlHasError(true);
      setServiceUrlHelperText('Error: URL already exists.');
    } else {
      setServiceUrlHasError(false);
      setServiceNameHelperText('');
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [serviceUrl]); // Check if all fields are valid

  React.useEffect(function () {
    if (!serviceNameHasError && !serviceUrlHasError && validateServiceUrl(serviceUrl) && serviceName.length > 0) {
      setDisableButton(false);
    } else setDisableButton(true);
  }, [serviceNameHasError, serviceUrlHasError, serviceName, serviceUrl]);

  var closePopupAndResetState = function closePopupAndResetState() {
    setServiceName('');
    setServiceUrl('');
    setAbstract('');
    closePopup();
  };

  return /*#__PURE__*/React.createElement(Dialog, {
    open: isOpen,
    hideBackdrop: hideBackdrop,
    fullWidth: true,
    maxWidth: "xs",
    "data-testid": "servicePopup",
    sx: style$1.container
  }, /*#__PURE__*/React.createElement(DialogTitle, {
    sx: style$1.dialogTitle
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    component: "span"
  }, getTitleForVariant(servicePopupVariant)), /*#__PURE__*/React.createElement(IconButton, {
    size: "small",
    onClick: closePopupAndResetState,
    "data-testid": "closePopupButtonCross",
    sx: style$1.closeBtn
  }, /*#__PURE__*/React.createElement(Close, null))), /*#__PURE__*/React.createElement(DialogContent, {
    sx: style$1.dialogContent
  }, /*#__PURE__*/React.createElement(TextField, {
    sx: style$1.textField,
    variant: "filled",
    label: "Service name",
    onChange: function onChange(event) {
      return setServiceName(event.target.value);
    },
    value: serviceName,
    inputProps: {
      'data-testid': 'serviceNameTextField'
    },
    error: serviceNameHasError,
    helperText: serviceNameHelperText
  })), /*#__PURE__*/React.createElement(DialogContent, {
    sx: style$1.dialogContent
  }, /*#__PURE__*/React.createElement(TextField, {
    sx: style$1.textField,
    variant: "filled",
    label: "Service URL",
    onChange: function onChange(event) {
      return setServiceUrl(event.target.value);
    },
    value: serviceUrl,
    id: "service-url",
    inputProps: {
      'data-testid': 'serviceUrlTextField'
    },
    error: serviceUrlHasError,
    helperText: serviceUrlHelperText
  })), /*#__PURE__*/React.createElement(DialogContent, {
    sx: style$1.dialogContent
  }, /*#__PURE__*/React.createElement(TextField, {
    sx: style$1.textField,
    variant: "filled",
    multiline: true,
    rows: 4,
    label: "Abstracts",
    helperText: "Short description of what this service does",
    onChange: function onChange(event) {
      return setAbstract(event.target.value);
    },
    value: _abstract,
    "data-testid": "abstractTextField"
  })), /*#__PURE__*/React.createElement(DialogActions, {
    sx: style$1.footerContent
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: closePopupAndResetState,
    "data-testid": "closePopupButtonCancel",
    variant: "tertiary",
    sx: {
      width: '117px'
    }
  }, "cancel"), !isLoading ? /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    disabled: disableButton,
    onClick: addNewService,
    "data-testid": "saveServiceButton",
    sx: {
      width: '117px',
      marginLeft: '16px!important'
    }
  }, "save") : /*#__PURE__*/React.createElement(Box, {
    "data-testid": "loadingIndicator",
    sx: {
      width: '117px',
      height: '40px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginLeft: '16px!important'
    }
  }, /*#__PURE__*/React.createElement(CircularProgress, {
    size: 35
  }))));
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2022 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2022 - Finnish Meteorological Institute (FMI)
 * */

var ServicePopupConnect = function ServicePopupConnect(_ref) {
  var servicePopupVariant = _ref.servicePopupVariant,
      hideBackdrop = _ref.hideBackdrop,
      isOpen = _ref.isOpen,
      closePopup = _ref.closePopup,
      url = _ref.url;
  var dispatch = useDispatch();
  var services = useSelector(function (store) {
    return getServices(store);
  });
  var serviceSetLayers = React__default.useCallback(function (payload) {
    dispatch(serviceActions.serviceSetLayers(payload));
  }, [dispatch]);
  return /*#__PURE__*/React__default.createElement(ServicePopup, {
    servicePopupVariant: servicePopupVariant,
    hideBackdrop: hideBackdrop,
    isOpen: isOpen,
    closePopup: closePopup,
    url: url,
    services: services,
    serviceSetLayers: serviceSetLayers
  });
};

var isURL = function isURL(string) {
  return /^https?:\/\//.test(string);
};

var SearchFieldButtonContainer = function SearchFieldButtonContainer(_ref) {
  var localSearchString = _ref.localSearchString,
      onClickClear = _ref.onClickClear;

  var _React$useState = React__default.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isPopupOpen = _React$useState2[0],
      setPopupOpen = _React$useState2[1];

  React__default.useEffect(function () {
    if (isPopupOpen === false) {
      onClickClear();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [isPopupOpen]);
  var ClearButton = /*#__PURE__*/React__default.createElement(Tooltip, {
    title: "Clear",
    placement: "top"
  }, /*#__PURE__*/React__default.createElement(IconButton, {
    edge: "end",
    onClick: function onClick() {
      onClickClear();
    },
    size: "large"
  }, /*#__PURE__*/React__default.createElement(Clear, null)));
  if (isURL(localSearchString)) return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginRight: '15px'
    }
  }, ClearButton), /*#__PURE__*/React__default.createElement(Button, {
    variant: "tertiary",
    onClick: function onClick() {
      return setPopupOpen(true);
    }
  }, "Save"), /*#__PURE__*/React__default.createElement(ServicePopupConnect, {
    servicePopupVariant: "save",
    isOpen: isPopupOpen,
    closePopup: function closePopup() {
      return setPopupOpen(false);
    },
    url: localSearchString
  }));
  if (localSearchString) return ClearButton;
  return /*#__PURE__*/React__default.createElement(Tooltip, {
    title: "Search",
    placement: "top"
  }, /*#__PURE__*/React__default.createElement(IconButton, {
    edge: "end",
    size: "large"
  }, /*#__PURE__*/React__default.createElement(Search, null)));
};

var SearchField = function SearchField(_ref) {
  var searchFilter = _ref.searchFilter,
      setSearchFilter = _ref.setSearchFilter;

  var _React$useState = React.useState(''),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      localSearchString = _React$useState2[0],
      setLocalSearchString = _React$useState2[1]; // mirror store unless typing a URL


  React.useEffect(function () {
    if (isURL(localSearchString)) return;
    setLocalSearchString(searchFilter); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchFilter]); // eslint-disable-next-line react-hooks/exhaustive-deps

  var setSearchFilterDebounced = React.useCallback(debounce(setSearchFilter, 300), []);

  var handleChange = function handleChange(text) {
    setLocalSearchString(text);
    if (!isURL(text)) setSearchFilterDebounced(text);else if (searchFilter) setSearchFilterDebounced('');
  };

  return /*#__PURE__*/React.createElement(TextField, {
    variant: "filled",
    label: "Search through services or enter a service URL",
    value: localSearchString,
    onChange: function onChange(e) {
      handleChange(e.target.value);
    },
    autoFocus: true,
    fullWidth: true,
    InputProps: {
      endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React.createElement(SearchFieldButtonContainer, {
        localSearchString: localSearchString,
        onClickClear: function onClickClear() {
          setLocalSearchString('');
          setSearchFilterDebounced('');
        }
      }))
    }
  });
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */

var SearchFieldConnect = function SearchFieldConnect() {
  var dispatch = useDispatch();
  var searchFilter = useSelector(function (store) {
    return getSearchFilter(store);
  });
  return /*#__PURE__*/React.createElement(SearchField, {
    setSearchFilter: function setSearchFilter(filterText) {
      dispatch(layerSelectActions.setSearchFilter({
        filterText: filterText
      }));
    },
    searchFilter: searchFilter
  });
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */
var filterLayersFromService = function filterLayersFromService(serviceId, services, keywordIds, allKeywordsActive, searchString) {
  var mapStoreService = services[serviceId];
  if (!mapStoreService) return [];

  if (searchString === '' && allKeywordsActive) {
    return mapStoreService.layers.filter(function (layer) {
      return layer.leaf;
    });
  }

  var searchStringArray = searchString.split(' ');
  return mapStoreService.layers.filter(function (layer) {
    return searchStringArray.every(function (search) {
      var layerPathAndKeywords = layer.path.concat(layer.keywords);
      return (!!layerPathAndKeywords && !layerPathAndKeywords.every(function (keyword) {
        return !keywordIds.includes(keyword);
      }) || allKeywordsActive) && (!!layer.name && layer.name.toLowerCase().includes(search.toLowerCase()) || !!layer.text && layer.text.toLowerCase().includes(search.toLowerCase()) || !!layer["abstract"] && layer["abstract"].toLowerCase().includes(search.toLowerCase()) || !!layerPathAndKeywords && !layerPathAndKeywords.every(function (keyword) {
        return !keyword.toLowerCase().includes(search.toLowerCase());
      }) || mapStoreService.name.toLowerCase().includes(search.toLowerCase()));
    });
  }).filter(function (layer) {
    return layer.leaf;
  });
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2022 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2022 - Finnish Meteorological Institute (FMI)
 * */

var LayerAddRemoveButton = function LayerAddRemoveButton(_ref) {
  var layer = _ref.layer,
      layerIndex = _ref.layerIndex,
      serviceUrl = _ref.serviceUrl,
      addLayer = _ref.addLayer,
      deleteLayer = _ref.deleteLayer,
      mapLayers = _ref.mapLayers;
  var foundLayer = mapLayers.find(function (lr) {
    return lr.name === layer.name && lr.service === serviceUrl;
  });
  return /*#__PURE__*/React.createElement(CustomToggleButton, {
    "data-testid": "layerAddRemoveButton-".concat(layer.name),
    onClick: function onClick() {
      !foundLayer ? addLayer({
        serviceUrl: serviceUrl,
        layerName: layer.name
      }) : deleteLayer({
        layerId: foundLayer.id,
        layerIndex: layerIndex
      });
    },
    selected: !!foundLayer,
    variant: "tool",
    fullWidth: true
  }, !foundLayer ? 'Add' : 'Remove');
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2022 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2022 - Finnish Meteorological Institute (FMI)
 * */

var LayerListRow = function LayerListRow(_ref) {
  var layer = _ref.layer,
      layerIndex = _ref.layerIndex,
      service = _ref.service,
      serviceUrl = _ref.serviceUrl,
      addLayer = _ref.addLayer,
      deleteLayer = _ref.deleteLayer,
      mapLayers = _ref.mapLayers;
  return /*#__PURE__*/React__default.createElement(Grid, {
    "data-testid": "layerListLayerRow",
    container: true,
    item: true,
    xs: 12,
    justifyContent: "center",
    alignItems: "center",
    sx: {
      backgroundColor: 'geowebColors.cards.cardContainer',
      paddingLeft: '12px',
      marginBottom: '4px',
      height: '64px',
      border: 'solid 1px',
      borderColor: 'geowebColors.cards.cardContainerBorder'
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    item: true,
    xs: 10
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    item: true,
    xs: 12
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      fontSize: '12px',
      height: '24px',
      lineHeight: '24px',
      fontWeight: 500,
      WebkitLineClamp: 1,
      display: '-webkit-box',
      WebkitBoxOrient: 'vertical',
      textOverflow: 'ellipsis',
      overflow: 'hidden'
    }
  }, layer.text)), /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    item: true,
    xs: 4
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      fontSize: '12px',
      height: '24px',
      lineHeight: '24px',
      WebkitLineClamp: 1,
      display: '-webkit-box',
      WebkitBoxOrient: 'vertical',
      textOverflow: 'ellipsis',
      overflow: 'hidden'
    }
  }, service.name)), layer["abstract"] ? /*#__PURE__*/React__default.createElement(Grid, {
    "data-testid": "layerAbstract",
    container: true,
    item: true,
    xs: 8,
    sx: {
      fontSize: '10px',
      height: '30px',
      paddingLeft: '20px',
      WebkitLineClamp: 2,
      display: '-webkit-box',
      WebkitBoxOrient: 'vertical',
      textOverflow: 'ellipsis',
      overflow: 'hidden'
    }
  }, layer["abstract"]) : null), /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    item: true,
    xs: 2,
    justifyContent: "flex-end",
    alignItems: "center"
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      width: '80px',
      height: '48px',
      marginRight: '8px',
      paddingTop: '4px'
    }
  }, /*#__PURE__*/React__default.createElement(LayerAddRemoveButton, {
    layer: layer,
    layerIndex: layerIndex,
    serviceUrl: serviceUrl,
    addLayer: addLayer,
    deleteLayer: deleteLayer,
    mapLayers: mapLayers
  }))));
};

var LayerList = function LayerList(_ref) {
  var services = _ref.services,
      serviceIds = _ref.serviceIds,
      layerSelectHeight = _ref.layerSelectHeight,
      addLayer = _ref.addLayer,
      deleteLayer = _ref.deleteLayer,
      searchString = _ref.searchString,
      mapLayers = _ref.mapLayers,
      keywordIds = _ref.keywordIds,
      allKeywordsActive = _ref.allKeywordsActive;
  var layerSelectFilterHeight = 199;

  var _React$useState = React.useState(0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      numberOfLayers = _React$useState2[0],
      setNumberOfLayers = _React$useState2[1];

  var _React$useState3 = React.useState([]),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      layersFilteredFromService = _React$useState4[0],
      setLayersFilteredFromService = _React$useState4[1];

  React.useEffect(function () {
    setNumberOfLayers(serviceIds.reduce(function (totalNumberOfLayers, serviceId) {
      return totalNumberOfLayers + filterLayersFromService(serviceId, services, keywordIds, allKeywordsActive, searchString).length;
    }, 0));
    setLayersFilteredFromService(serviceIds.reduce(function (layerList, serviceId) {
      return layerList.concat(filterLayersFromService(serviceId, services, keywordIds, allKeywordsActive, searchString).map(function (layer) {
        return Object.assign(Object.assign({}, layer), {
          serviceId: serviceId
        });
      }));
    }, []));
  }, [serviceIds, keywordIds, services, searchString, allKeywordsActive]);
  return /*#__PURE__*/React.createElement(Box, {
    "data-testid": "layerList"
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      marginBottom: '4px',
      fontSize: '12px'
    }
  }, numberOfLayers, " results"), /*#__PURE__*/React.createElement(FixedSizeList, {
    height: layerSelectHeight - layerSelectFilterHeight,
    itemCount: numberOfLayers,
    itemSize: 68
  }, function (_ref2) {
    var index = _ref2.index,
        style = _ref2.style;
    return /*#__PURE__*/React.createElement("div", {
      style: style,
      key: layersFilteredFromService[index].name
    }, /*#__PURE__*/React.createElement(LayerListRow, {
      layer: layersFilteredFromService[index],
      layerIndex: index,
      service: services[layersFilteredFromService[index].serviceId],
      serviceUrl: services[layersFilteredFromService[index].serviceId].serviceUrl,
      addLayer: addLayer,
      deleteLayer: deleteLayer,
      mapLayers: mapLayers
    }));
  }));
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */

var LayerListConnect = function LayerListConnect(_ref) {
  var mapId = _ref.mapId,
      layerSelectHeight = _ref.layerSelectHeight;
  var services = useSelector(function (store) {
    return getServices(store);
  });
  var dispatch = useDispatch();
  var enabledServiceIds = useSelector(function (store) {
    return getEnabledServiceIds(store);
  });
  var mapLayers = useSelector(function (store) {
    return getMapLayers(store, mapId);
  });

  var addLayer = function addLayer(_ref2) {
    var serviceUrl = _ref2.serviceUrl,
        layerName = _ref2.layerName;
    var layer = {
      service: serviceUrl,
      name: layerName,
      id: generateLayerId(),
      layerType: LayerType$1.mapLayer
    };
    addMapLayer({
      mapId: mapId,
      layerId: layer.id,
      layer: layer,
      origin: LayerActionOrigin.layerManager
    });
  };

  var addMapLayer = React.useCallback(function (_ref3) {
    var layerId = _ref3.layerId,
        layer = _ref3.layer,
        origin = _ref3.origin;
    return dispatch(layerActions.addLayer({
      mapId: mapId,
      layerId: layerId,
      layer: layer,
      origin: origin
    }));
  }, [dispatch, mapId]);
  var deleteLayer = React.useCallback(function (_ref4) {
    var layerId = _ref4.layerId,
        layerIndex = _ref4.layerIndex;
    return dispatch(layerActions.layerDelete({
      mapId: mapId,
      layerId: layerId,
      layerIndex: layerIndex,
      origin: LayerActionOrigin.layerManager
    }));
  }, [dispatch, mapId]);
  var checkedKeywordIds = useSelector(function (store) {
    return getCheckedKeywordIds(store);
  });
  var allKeywordsActive = useSelector(function (store) {
    return isAllKeywordsChecked(store);
  });
  var searchString = useSelector(function (store) {
    return getSearchFilter(store);
  });
  return /*#__PURE__*/React.createElement(LayerList, {
    services: services,
    serviceIds: enabledServiceIds,
    layerSelectHeight: layerSelectHeight,
    addLayer: addLayer,
    deleteLayer: deleteLayer,
    keywordIds: checkedKeywordIds,
    allKeywordsActive: allKeywordsActive,
    searchString: searchString,
    mapLayers: mapLayers
  });
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */
var style = {
  borderRadius: '20px!important',
  marginRight: '8px',
  whiteSpace: 'nowrap',
  height: '32px!important',
  padding: '5px 12px!important',
  textTransform: 'none!important',
  fontWeight: 'normal'
};

var ServiceChip = function ServiceChip(_ref) {
  var _ref$all = _ref.all,
      all = _ref$all === void 0 ? false : _ref$all,
      service = _ref.service,
      isSelected = _ref.isSelected,
      isDisabled = _ref.isDisabled,
      toggleChip = _ref.toggleChip;
  return /*#__PURE__*/React.createElement(CustomToggleButton, {
    variant: "boxed",
    selected: isSelected,
    tabIndex: 0,
    "data-testid": all ? 'serviceChipAll' : 'serviceChip',
    onClick: function onClick() {
      return toggleChip(all ? 'all' : service && service.serviceUrl);
    },
    onKeyPress: function onKeyPress() {
      return toggleChip(all ? 'all' : service && service.serviceUrl);
    },
    disabled: isDisabled,
    sx: style
  }, service ? service.serviceName : 'All');
};

var ServiceChipConnect = function ServiceChipConnect(_ref) {
  var _ref$all = _ref.all,
      all = _ref$all === void 0 ? false : _ref$all,
      serviceId = _ref.serviceId,
      service = _ref.service,
      isSelected = _ref.isSelected,
      isDisabled = _ref.isDisabled;
  var dispatch = useDispatch();
  var activeServices = useSelector(function (store) {
    return getActiveServices(store);
  });

  var toggleChip = function toggleChip(service) {
    if (service === 'all') {
      if (isSelected) {
        for (var _i = 0, _Object$entries = Object.entries(activeServices); _i < _Object$entries.length; _i++) {
          var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
              key = _Object$entries$_i[0],
              value = _Object$entries$_i[1];

          var serviceID = key;
          var _service = value;

          if (_service.enabled) {
            dispatch(layerSelectActions.disableActiveService({
              serviceId: serviceID,
              keywords: _service.keywordsPerService
            }));
          }
        }
      } else {
        for (var _i2 = 0, _Object$entries2 = Object.entries(activeServices); _i2 < _Object$entries2.length; _i2++) {
          var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
              _key = _Object$entries2$_i[0],
              _value = _Object$entries2$_i[1];

          var _serviceID = _key;
          var _service2 = _value;

          if (!_service2.enabled) {
            dispatch(layerSelectActions.enableActiveService({
              serviceId: _serviceID,
              keywords: _service2.keywordsPerService
            }));
          }
        }
      }
    } else if (isSelected) {
      dispatch(layerSelectActions.disableActiveService({
        serviceId: serviceId,
        keywords: activeServices[serviceId].keywordsPerService
      }));
    } else {
      dispatch(layerSelectActions.enableActiveService({
        serviceId: serviceId,
        keywords: activeServices[serviceId].keywordsPerService
      }));
    }
  };

  return /*#__PURE__*/React.createElement(ServiceChip, {
    service: service,
    all: all,
    toggleChip: toggleChip,
    isSelected: isSelected,
    isDisabled: isDisabled
  });
};

var useStyles$i = makeStyles(function (theme) {
  return createStyles({
    serviceChips: {
      width: '100%',
      display: 'inline-flex',
      alignItems: 'center',
      overflowX: 'visible',
      "float": 'left',
      paddingLeft: '40px',
      marginRight: function marginRight(_ref) {
        var margin = _ref.margin;
        return margin;
      },
      marginLeft: function marginLeft(_ref2) {
        var margin = _ref2.margin;
        return -margin;
      },
      maxWidth: function maxWidth(_ref3) {
        var maxWidthValue = _ref3.maxWidthValue;
        return maxWidthValue;
      },
      fontSize: '0.875rem'
    },
    scrollArrowLeft: {
      width: '100px',
      marginBottom: '-12px',
      height: '34px',
      backgroundImage: "linear-gradient(to left, rgba(0, 0, 0, 0), ".concat(theme.palette.geowebColors.background.surfaceApp, " 51%)"),
      cursor: 'pointer',
      marginRight: '-120px',
      paddingTop: '6px',
      paddingBottom: '6px',
      "float": 'left',
      zIndex: 1,
      position: 'relative',
      color: theme.palette.geowebColors.buttons.tertiary["default"].color,
      '&:hover': {
        color: theme.palette.geowebColors.buttons.tertiary.activeMouseOver.color
      }
    },
    serviceList: {
      height: '32px',
      marginTop: '8px',
      width: '100%',
      overflow: 'hidden'
    },
    scrollArrowRight: {
      width: '100px',
      marginBottom: '-12px',
      height: '34px',
      paddingTop: '6px',
      paddingBottom: '6px',
      backgroundImage: "linear-gradient(to right, rgba(0, 0, 0, 0), ".concat(theme.palette.geowebColors.background.surfaceApp, " 51%)"),
      right: '0px',
      position: 'fixed',
      cursor: 'pointer',
      color: theme.palette.geowebColors.buttons.tertiary["default"].color,
      '&:hover': {
        color: theme.palette.geowebColors.buttons.tertiary.activeMouseOver.color
      }
    }
  });
});

var ServiceList = function ServiceList(_ref4) {
  var layerSelectWidth = _ref4.layerSelectWidth,
      activeServices = _ref4.activeServices;

  var _React$useState = React.useState(0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      margin = _React$useState2[0],
      setMargin = _React$useState2[1];

  var _React$useState3 = React.useState(0),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      width = _React$useState4[0],
      setWidth = _React$useState4[1];

  var _React$useState5 = React.useState(null),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      intervalId = _React$useState6[0],
      setIntervalId = _React$useState6[1];

  var ref = React.useRef(null);
  var scrollSpeed = 5;
  var maxWidthValue = ref && ref.current && ref.current.scrollWidth && ref.current.scrollWidth >= layerSelectWidth - margin && ref.current.scrollWidth || layerSelectWidth - 50;
  var classes = useStyles$i({
    margin: margin,
    maxWidthValue: maxWidthValue
  });

  var onMouseWheelScroll = function onMouseWheelScroll(e) {
    var delta = e.deltaY;
    var scrollSpeed = 0.1;
    if (delta > 0) setMargin(Math.min(Math.max(margin + scrollSpeed * delta, 0), width - layerSelectWidth));else setMargin(Math.min(Math.max(margin + scrollSpeed * delta, 0), width - layerSelectWidth));
  };

  var onLeftChevronPressed = function onLeftChevronPressed() {
    setMargin(function (prevMargin) {
      return Math.max(prevMargin - scrollSpeed, 0);
    });
    setIntervalId(setInterval(function () {
      setMargin(function (prevMargin) {
        return Math.max(prevMargin - scrollSpeed, 0);
      });
    }, 20));
  };

  var onRightChevronPressed = React.useCallback(function () {
    setMargin(function (prevMargin) {
      return Math.min(prevMargin + scrollSpeed, width - layerSelectWidth);
    });
    setIntervalId(setInterval(function () {
      setMargin(function (prevMargin) {
        return Math.min(prevMargin + scrollSpeed, width - layerSelectWidth);
      });
    }, 20));
  }, [width, layerSelectWidth]);

  var onChevronMouseUp = function onChevronMouseUp() {
    clearInterval(intervalId);
    setIntervalId(null);
  };

  React.useEffect(function () {
    setWidth(ref.current.scrollWidth + 50);
    setMargin(Math.max(0, Math.min(width - layerSelectWidth, margin)));

    if ((margin === 0 || layerSelectWidth + margin === width) && intervalId != null) {
      clearInterval(intervalId);
      setIntervalId(null);
    }
  }, [activeServices, layerSelectWidth, width, margin, intervalId]);
  var isAllSelected = Object.values(activeServices).every(function (activeService) {
    return activeService.enabled;
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classes.serviceList,
    "data-testid": "serviceList",
    onWheel: onMouseWheelScroll
  }, margin !== 0 && /*#__PURE__*/React.createElement(ChevronLeft, {
    className: classes.scrollArrowLeft,
    onMouseDown: onLeftChevronPressed,
    onMouseUp: onChevronMouseUp,
    "data-testid": "leftScrollArrow"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.serviceChips,
    ref: ref
  }, activeServices && Object.keys(activeServices) && Object.keys(activeServices).length > 0 && /*#__PURE__*/React.createElement(ServiceChipConnect, {
    key: "All",
    all: true,
    isSelected: isAllSelected
  }), Object.keys(activeServices).map(function (serviceId) {
    var _a;

    var service = activeServices[serviceId];
    return /*#__PURE__*/React.createElement(ServiceChipConnect, {
      key: serviceId,
      serviceId: serviceId,
      service: service,
      isSelected: (_a = activeServices[serviceId]) === null || _a === void 0 ? void 0 : _a.enabled,
      isDisabled: activeServices[serviceId] === undefined
    });
  })), layerSelectWidth + margin < width && /*#__PURE__*/React.createElement(ChevronRight, {
    className: classes.scrollArrowRight,
    onMouseDown: onRightChevronPressed,
    onMouseUp: onChevronMouseUp,
    "data-testid": "rightScrollArrow"
  }));
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */

var ServiceListConnect = function ServiceListConnect(_ref) {
  var layerSelectWidth = _ref.layerSelectWidth;
  var activeServices = useSelector(function (store) {
    return getActiveServices(store);
  });
  return /*#__PURE__*/React.createElement(ServiceList, {
    layerSelectWidth: layerSelectWidth,
    activeServices: activeServices
  });
};

var styles = {
  servicesContainer: {
    width: '300px',
    maxHeight: '380px',
    top: '140px',
    backgroundColor: 'geowebColors.background.surface',
    boxShadow: 6,
    overflow: 'auto'
  },
  header: {
    position: 'sticky',
    top: 0,
    fontSize: 'default',
    padding: '12px',
    backgroundColor: 'geowebColors.background.surface',
    zIndex: 100
  },
  footer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'sticky',
    bottom: 0,
    backgroundColor: 'geowebColors.background.surface',
    zIndex: 100
  },
  button: {
    margin: '16px',
    width: '80%',
    fontSize: '12px',
    textTransform: 'none'
  }
};

var ServiceOptionsDialog = function ServiceOptionsDialog(_ref) {
  var services = _ref.services,
      mapStoreRemoveService = _ref.mapStoreRemoveService,
      _ref$layers = _ref.layers,
      layers = _ref$layers === void 0 ? [] : _ref$layers;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      addServiceisOpen = _React$useState2[0],
      setAddServiceIsOpen = _React$useState2[1];

  var openAddService = function openAddService() {
    setAddServiceIsOpen(true);
  };

  var closePopup = function closePopup() {
    setAddServiceIsOpen(false);
  };

  var isDisabled = function isDisabled(service) {
    return layers.some(function (layer) {
      return layer.service && layer.service.includes(service);
    }) || preloadedDefaultMapServices.some(function (defaultMapService) {
      return defaultMapService.url && defaultMapService.url.includes(service);
    });
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    sx: styles.servicesContainer,
    "data-testid": "ServiceDialog"
  }, /*#__PURE__*/React.createElement(Box, {
    sx: styles.header
  }, "Services"), /*#__PURE__*/React.createElement(List, {
    disablePadding: true
  }, Object.keys(services).map(function (serviceId) {
    return /*#__PURE__*/React.createElement(ListItem, {
      key: services[serviceId].serviceUrl
    }, /*#__PURE__*/React.createElement(ListItemText, {
      style: {
        fontSize: '16px'
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      noWrap: true,
      style: {
        textOverflow: 'ellipsis',
        paddingRight: '60px'
      }
    }, services[serviceId].serviceName)), /*#__PURE__*/React.createElement(ListItemSecondaryAction, {
      style: {
        marginRight: '-10px'
      }
    }, /*#__PURE__*/React.createElement(Tooltip, {
      title: "Edit Service"
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(IconButton, {
      disabled: isDisabled(services[serviceId].serviceUrl),
      "data-testid": "openEditServiceButton",
      size: "large"
    }, /*#__PURE__*/React.createElement(Edit, null)))), /*#__PURE__*/React.createElement(Tooltip, {
      title: "Delete Service"
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(IconButton, {
      size: "large",
      disabled: isDisabled(services[serviceId].serviceUrl),
      onClick: function onClick() {
        return mapStoreRemoveService(serviceId, services[serviceId].serviceUrl);
      },
      "data-testid": "removeServiceButton"
    }, /*#__PURE__*/React.createElement(Delete, null))))));
  })), /*#__PURE__*/React.createElement(Box, {
    sx: styles.footer
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: openAddService,
    "data-testid": "openAddServiceButton",
    sx: styles.button,
    variant: "tertiary",
    startIcon: /*#__PURE__*/React.createElement(Add, null)
  }, "Add a new service"))), addServiceisOpen && /*#__PURE__*/React.createElement(ServicePopupConnect, {
    servicePopupVariant: "add",
    isOpen: addServiceisOpen,
    closePopup: closePopup
  }));
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2022 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2022 - Finnish Meteorological Institute (FMI)
 * */

var ServiceOptionsDialogConnect = function ServiceOptionsDialogConnect() {
  var dispatch = useDispatch();
  var allLayers = useSelector(function (store) {
    return getAllLayers(store);
  });
  var mapStoreRemoveService = React.useCallback(function (serviceId, serviceUrl) {
    dispatch(serviceActions.mapStoreRemoveService({
      id: serviceId,
      serviceUrl: serviceUrl
    }));
  }, [dispatch]);
  var services = useSelector(function (store) {
    return getActiveServices(store);
  });
  return /*#__PURE__*/React.createElement(ServiceOptionsDialog, {
    services: services,
    layers: allLayers,
    mapStoreRemoveService: mapStoreRemoveService
  });
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */

var ServiceOptionsButton = function ServiceOptionsButton() {
  return /*#__PURE__*/React.createElement(ToggleMenu, {
    buttonTestId: "serviceOptionsButton",
    menuPosition: "bottom"
  }, /*#__PURE__*/React.createElement(ServiceOptionsDialogConnect, null));
};

var useStyles$h = makeStyles({
  serviceList: {
    height: '48px'
  },
  keywordFilterButton: {
    "float": 'left',
    position: 'absolute',
    margin: '12px 0 0 8px',
    zIndex: 2
  },
  serviceOptionsButton: {
    position: 'absolute',
    margin: '12px 0 0 calc(100% - 36px)',
    zIndex: 2
  },
  layerSelectContainer: {
    padding: '0 8px'
  }
});

var LayerSelect = function LayerSelect(_ref) {
  var mapId = _ref.mapId,
      bounds = _ref.bounds,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose,
      showTitle = _ref.showTitle,
      isOpen = _ref.isOpen,
      _ref$onMouseDown = _ref.onMouseDown,
      onMouseDown = _ref$onMouseDown === void 0 ? function () {} : _ref$onMouseDown,
      _ref$order = _ref.order,
      order = _ref$order === void 0 ? 0 : _ref$order,
      _ref$source = _ref.source,
      source = _ref$source === void 0 ? 'module' : _ref$source;
  var classes = useStyles$h();

  var _React$useState = React.useState(500),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      height = _React$useState2[0],
      setHeight = _React$useState2[1];

  var _React$useState3 = React.useState(750),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      width = _React$useState4[0],
      setWidth = _React$useState4[1];

  var onChangeSize = function onChangeSize(_ref2) {
    var height = _ref2.height,
        width = _ref2.width;
    setHeight(height);
    setWidth(width);
  };

  return /*#__PURE__*/React.createElement(ToolContainerDraggable, {
    title: showTitle ? "Layer Select ".concat(mapId) : 'Layer Select',
    startSize: {
      width: width,
      height: height
    },
    minWidth: 390,
    minHeight: 126,
    startPosition: {
      top: 150,
      left: 100
    },
    isOpen: isOpen,
    onChangeSize: onChangeSize,
    onClose: onClose,
    headerSize: "small",
    bounds: bounds,
    "data-testid": "layerSelectWindow",
    onMouseDown: onMouseDown,
    order: order,
    source: source
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      padding: '6px'
    }
  }, /*#__PURE__*/React.createElement(SearchFieldConnect, null)), /*#__PURE__*/React.createElement("div", {
    className: classes.keywordFilterButton
  }, /*#__PURE__*/React.createElement(KeywordFilterButtonConnect, {
    mapId: mapId
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.serviceOptionsButton
  }, /*#__PURE__*/React.createElement(ServiceOptionsButton, null)), /*#__PURE__*/React.createElement("div", {
    className: classes.serviceList
  }, /*#__PURE__*/React.createElement(ServiceListConnect, {
    layerSelectWidth: width
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.layerSelectContainer
  }, /*#__PURE__*/React.createElement(LayerListConnect, {
    mapId: mapId,
    layerSelectHeight: height
  })));
};

var useStyles$g = makeStyles(function (theme) {
  return createStyles({
    listItem: {
      width: '100%',
      minWidth: '300px',
      padding: '0px',
      paddingLeft: '10px',
      paddingRight: '50px',
      fontSize: '12px'
    },
    onlyByttonText: {
      color: theme.palette.geowebColors.buttons.primary["default"].fill,
      fontSize: '14px',
      fontWeight: 500
    },
    checkbox: {
      paddingTop: '6px',
      paddingBottom: '7px',
      '&&:hover': {
        backgroundColor: 'transparent'
      }
    },
    listItemIcon: {
      minWidth: '42px'
    },
    listItemText: {
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden'
    }
  });
});

var FilterListItem = function FilterListItem(_ref) {
  var keyword = _ref.keyword,
      toggleKeywords = _ref.toggleKeywords,
      enableOnlyOneKeyword = _ref.enableOnlyOneKeyword;
  var classes = useStyles$g();

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      hovering = _React$useState2[0],
      setHovering = _React$useState2[1];

  var handleMouseOver = React.useCallback(function () {
    setHovering(true);
  }, []);
  var handleMouseLeave = React.useCallback(function () {
    setHovering(false);
  }, []);

  var selectOnlyOne = function selectOnlyOne(keyword) {
    enableOnlyOneKeyword(keyword);
  };

  var toggleCheckbox = function toggleCheckbox(keyword) {
    toggleKeywords([keyword]);
  };

  if (keyword.amountVisible !== 0) {
    return /*#__PURE__*/React.createElement("div", {
      onMouseOver: handleMouseOver,
      onMouseLeave: handleMouseLeave,
      onFocus: handleMouseOver,
      onBlur: handleMouseLeave,
      "data-testid": "filterResultListItem"
    }, /*#__PURE__*/React.createElement(ListItem, {
      className: classes.listItem
    }, /*#__PURE__*/React.createElement(ListItemIcon, {
      className: classes.listItemIcon
    }, /*#__PURE__*/React.createElement(Checkbox, {
      color: "secondary",
      checked: keyword.checked,
      onChange: function onChange() {
        return toggleCheckbox(keyword.id);
      },
      className: classes.checkbox
    })), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      className: classes.listItemText
    }, keyword.id), hovering ? /*#__PURE__*/React.createElement(ListItemSecondaryAction, null, /*#__PURE__*/React.createElement(IconButton, {
      style: {
        backgroundColor: 'transparent'
      },
      edge: "end",
      size: "small",
      onClick: function onClick() {
        return selectOnlyOne(keyword.id);
      },
      "data-testid": "onlyButton"
    }, /*#__PURE__*/React.createElement(Typography, {
      className: classes.onlyByttonText
    }, "ONLY"))) : null));
  }

  return null;
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */

var KeywordFilterResultsListItemConnect = function KeywordFilterResultsListItemConnect(_ref) {
  var keyword = _ref.keyword;
  var dispatch = useDispatch();
  var toggleKeywords = React.useCallback(function (keywords) {
    dispatch(layerSelectActions.toggleKeywords({
      keywords: keywords
    }));
  }, [dispatch]);
  var enableOnlyOneKeyword = React.useCallback(function (keyword) {
    dispatch(layerSelectActions.enableOnlyOneKeyword({
      keyword: keyword
    }));
  }, [dispatch]);
  var keywordObject = useSelector(function (store) {
    return getKeywordObjectById(store, keyword);
  });
  return /*#__PURE__*/React.createElement(FilterListItem, {
    keyword: keywordObject,
    toggleKeywords: toggleKeywords,
    enableOnlyOneKeyword: enableOnlyOneKeyword
  });
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */

var KeywordFilterSelectAllSwitchConnect = function KeywordFilterSelectAllSwitchConnect() {
  var dispatch = useDispatch();
  var allKeywordsActive = useSelector(function (store) {
    return isAllKeywordsChecked(store);
  });
  var allKeywordIds = useSelector(function (store) {
    return getAllKeywordIds(store);
  });
  var checkedKeywordIds = useSelector(function (store) {
    return getCheckedKeywordIds(store);
  });
  var toggleKeywords = React.useCallback(function () {
    var keywords = allKeywordsActive ? checkedKeywordIds : allKeywordIds.filter(function (id) {
      return !checkedKeywordIds.includes(id);
    });
    dispatch(layerSelectActions.toggleKeywords({
      keywords: keywords
    }));
  }, [allKeywordIds, allKeywordsActive, checkedKeywordIds, dispatch]);
  return /*#__PURE__*/React.createElement(Switch, {
    checked: allKeywordsActive,
    onChange: toggleKeywords,
    "data-testid": "customSwitch"
  });
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */
var useStyles$f = makeStyles(function (theme) {
  return createStyles({
    selectAll: {
      padding: '15px',
      paddingLeft: '20px'
    },
    "switch": {
      padding: '15px'
    },
    selectAllContainer: {
      backgroundColor: theme.palette.background.paper,
      position: 'sticky',
      top: 0,
      zIndex: 100
    }
  });
});

var KeywordFilterResults = function KeywordFilterResults(_ref) {
  var allKeywordIds = _ref.allKeywordIds,
      mapId = _ref.mapId,
      bounds = _ref.bounds,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose,
      showTitle = _ref.showTitle,
      isOpen = _ref.isOpen,
      _ref$onMouseDown = _ref.onMouseDown,
      onMouseDown = _ref$onMouseDown === void 0 ? function () {} : _ref$onMouseDown,
      _ref$order = _ref.order,
      order = _ref$order === void 0 ? 0 : _ref$order,
      _ref$source = _ref.source,
      source = _ref$source === void 0 ? 'module' : _ref$source;
  var classes = useStyles$f();
  return /*#__PURE__*/React.createElement(ToolContainerDraggable, {
    title: showTitle ? "Filter Results ".concat(mapId) : 'Filter Results',
    "data-testid": "keywordFilterResults",
    startSize: {
      width: 349,
      height: 600
    },
    minWidth: 312,
    minHeight: 192,
    isOpen: isOpen,
    onClose: onClose,
    headerSize: "small",
    bounds: bounds,
    onMouseDown: onMouseDown,
    order: order,
    source: source
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    item: true,
    xs: 12,
    justifyContent: "space-between",
    alignItems: "center",
    className: classes.selectAllContainer
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    item: true,
    xs: 6,
    justifyContent: "flex-start",
    alignItems: "center",
    className: classes.selectAll
  }, "Select all"), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    item: true,
    xs: 6,
    justifyContent: "flex-end",
    alignContent: "center",
    className: classes["switch"]
  }, /*#__PURE__*/React.createElement(KeywordFilterSelectAllSwitchConnect, null))), /*#__PURE__*/React.createElement(List, {
    dense: true,
    style: {
      padding: '0px'
    }
  }, allKeywordIds.map(function (keywordId) {
    return /*#__PURE__*/React.createElement(KeywordFilterResultsListItemConnect, {
      key: keywordId,
      keyword: keywordId
    });
  })));
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */

var KeywordFilterResultsConnect = function KeywordFilterResultsConnect(_ref) {
  var bounds = _ref.bounds,
      _ref$showTitle = _ref.showTitle,
      showTitle = _ref$showTitle === void 0 ? false : _ref$showTitle;
  var dispatch = useDispatch();
  var mapId = useSelector(function (store) {
    return getDialogMapId(store, 'keywordFilter');
  });
  var isOpenInStore = useSelector(function (store) {
    return getisDialogOpen(store, 'keywordFilter');
  });
  var onClose = React.useCallback(function () {
    return dispatch(uiActions.setToggleOpenDialog({
      type: 'keywordFilter',
      setOpen: false
    }));
  }, [dispatch]);
  var isMapPresent = useSelector(function (store) {
    return getIsMapPresent(store, mapId);
  });
  var uiOrder = useSelector(function (store) {
    return getDialogOrder(store, 'keywordFilter');
  });
  var uiSource = useSelector(function (store) {
    return getDialogSource(store, 'keywordFilter');
  });
  var uiIsOrderedOnTop = useSelector(function (store) {
    return getDialogIsOrderedOnTop(store, 'keywordFilter');
  }); // Check to ensure the currently active map is still present on screen - if not, close the dialog

  React.useEffect(function () {
    if (mapId !== '' && !isMapPresent) {
      onClose();
    }
  }, [mapId, isMapPresent, onClose]);
  var registerDialog = React.useCallback(function () {
    return dispatch(uiActions.registerDialog({
      type: 'keywordFilter',
      setOpen: false
    }));
  }, [dispatch]);
  var unregisterDialog = React.useCallback(function () {
    return dispatch(uiActions.unregisterDialog({
      type: 'keywordFilter'
    }));
  }, [dispatch]);
  var onOrderDialog = React.useCallback(function () {
    if (!uiIsOrderedOnTop) {
      dispatch(uiActions.orderDialog({
        type: 'keywordFilter'
      }));
    }
  }, [dispatch, uiIsOrderedOnTop]); // Register this dialog in the store

  React.useEffect(function () {
    registerDialog();
    return function () {
      unregisterDialog();
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var allKeywordIds = useSelector(function (store) {
    return getAllKeywordIds(store);
  });
  return /*#__PURE__*/React.createElement(KeywordFilterResults, {
    allKeywordIds: allKeywordIds,
    mapId: mapId,
    bounds: bounds,
    isOpen: isOpenInStore,
    onClose: onClose,
    showTitle: showTitle,
    onMouseDown: onOrderDialog,
    order: uiOrder,
    source: uiSource
  });
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */
/**
 * LayerSelectConnect is a component that is opened from LayerManager
 * It's used to add Services and Layers to the application
 * It doesn't expect any props, its subcomponents only read and write to redux store
 *
 * ``` <LayerSelectConnect />```
 */

var LayerSelectConnect = function LayerSelectConnect(_ref) {
  var bounds = _ref.bounds,
      _ref$showTitle = _ref.showTitle,
      showTitle = _ref$showTitle === void 0 ? false : _ref$showTitle,
      _ref$preloadedService = _ref.preloadedServices,
      preloadedServices = _ref$preloadedService === void 0 ? preloadedDefaultMapServices : _ref$preloadedService;
  var dispatch = useDispatch();

  var _useIsMounted = useIsMounted(),
      isMounted = _useIsMounted.isMounted;

  var mapId = useSelector(function (store) {
    return getDialogMapId(store, 'layerSelect');
  });
  var isOpenInStore = useSelector(function (store) {
    return getisDialogOpen(store, 'layerSelect');
  });
  var onClose = React.useCallback(function () {
    return dispatch(uiActions.setToggleOpenDialog({
      type: 'layerSelect',
      setOpen: false
    }));
  }, [dispatch]);
  var isMapPresent = useSelector(function (store) {
    return getIsMapPresent(store, mapId);
  });
  var uiOrder = useSelector(function (store) {
    return getDialogOrder(store, 'layerSelect');
  });
  var uiSource = useSelector(function (store) {
    return getDialogSource(store, 'layerSelect');
  });
  var uiIsOrderedOnTop = useSelector(function (store) {
    return getDialogIsOrderedOnTop(store, 'layerSelect');
  }); // Check to ensure the currently active map is still present on screen - if not, close the dialog

  React.useEffect(function () {
    if (mapId !== '' && !isMapPresent) {
      onClose();
    }
  }, [mapId, isMapPresent, onClose]);
  var registerDialog = React.useCallback(function () {
    return dispatch(uiActions.registerDialog({
      type: 'layerSelect',
      setOpen: false
    }));
  }, [dispatch]);
  var unregisterDialog = React.useCallback(function () {
    return dispatch(uiActions.unregisterDialog({
      type: 'layerSelect'
    }));
  }, [dispatch]);
  var onOrderDialog = React.useCallback(function () {
    if (!uiIsOrderedOnTop) {
      dispatch(uiActions.orderDialog({
        type: 'layerSelect'
      }));
    }
  }, [dispatch, uiIsOrderedOnTop]); // Register this dialog in the store

  React.useEffect(function () {
    registerDialog();
    return function () {
      unregisterDialog();
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var serviceSetLayers = React.useCallback(function (payload) {
    dispatch(serviceActions.serviceSetLayers(payload));
  }, [dispatch]);
  React.useEffect(function () {
    if (isOpenInStore && preloadedServices && preloadedServices.length > 0) {
      mergePresetsAndUserAddedServices(preloadedServices, getUserAddedServices()).forEach(function (service) {
        getLayersFlattenedFromService(service.url).then(function (layers) {
          if (isMounted.current) {
            var wmService = WMGetServiceFromStore(service.url);
            serviceSetLayers({
              id: wmService.id,
              name: service.name,
              serviceUrl: service.url,
              layers: layers,
              isUserAddedService: false
            });
          }
        })["catch"](function () {
          return null;
        });
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [isOpenInStore, preloadedServices, serviceSetLayers]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LayerSelect, {
    mapId: mapId,
    bounds: bounds,
    isOpen: isOpenInStore,
    onClose: onClose,
    showTitle: showTitle,
    onMouseDown: onOrderDialog,
    order: uiOrder,
    source: uiSource
  }), /*#__PURE__*/React.createElement(KeywordFilterResultsConnect, null));
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */
/**
 * Layer Managerconnected to the store displaying the layers forthe active map Id
 * Please note that in order to use this and open/close the dialog, every map on the screen that should be able to show
 * a dialog should have the <LayerManagerMapButtonConnect/> which is used to focus the correct map and open the dialog
 *
 * Expects the following props:
 * @param {Service[]} preloadedMapServices preloadedMapServices: array of Service objects - contains an array of Service objects that are preloaded into in the WMS Loader for maplayers
 * @param {Service[]} preloadedBaseServices preloadedBaseServices: array of Service objects - contains an array of Service objects that are preloaded into in the WMS Loader fpr baselayers
 * @param {Layer[]} preloadedAvailableBaseLayers preloadedAvailableBaseLayers: array of Layer objects - contains an array of Layer objects (consisting solely of type baseLayer) that are available to be shown as basemaps
 * ``` <LayerManagerConnect />```
 */

var LayerManagerConnect = function LayerManagerConnect(_ref) {
  var preloadedAvailableBaseLayers = _ref.preloadedAvailableBaseLayers,
      preloadedMapServices = _ref.preloadedMapServices,
      preloadedBaseServices = _ref.preloadedBaseServices,
      bounds = _ref.bounds,
      _ref$showTitle = _ref.showTitle,
      showTitle = _ref$showTitle === void 0 ? false : _ref$showTitle,
      _ref$layerSelect = _ref.layerSelect,
      layerSelect = _ref$layerSelect === void 0 ? false : _ref$layerSelect,
      _ref$leftComponent = _ref.leftComponent,
      leftComponent = _ref$leftComponent === void 0 ? null : _ref$leftComponent;
  var dispatch = useDispatch();
  var isOpenInStore = useSelector(function (store) {
    return getisDialogOpen(store, 'layerManager');
  });
  var mapId = useSelector(function (store) {
    return getDialogMapId(store, 'layerManager');
  });
  var onClose = React.useCallback(function () {
    return dispatch(uiActions.setToggleOpenDialog({
      type: 'layerManager',
      setOpen: false
    }));
  }, [dispatch]);
  var isMapPresent = useSelector(function (store) {
    return getIsMapPresent(store, mapId);
  });
  var uiOrder = useSelector(function (store) {
    return getDialogOrder(store, 'layerManager');
  });
  var uiSource = useSelector(function (store) {
    return getDialogSource(store, 'layerManager');
  });
  var uiIsOrderedOnTop = useSelector(function (store) {
    return getDialogIsOrderedOnTop(store, 'layerManager');
  });
  var isMapPresetLoading = useSelector(function (store) {
    return getIsMapPresetLoading(store, mapId);
  });
  var mapPresetError = useSelector(function (store) {
    return getMapPresetError(store, mapId);
  }); // Check to ensure the currently active map is still present on screen - if not, close the dialog

  React.useEffect(function () {
    if (mapId !== '' && !isMapPresent) {
      onClose();
    }
  }, [mapId, isMapPresent, onClose]);
  var registerDialog = React.useCallback(function () {
    return dispatch(uiActions.registerDialog({
      type: 'layerManager',
      setOpen: false
    }));
  }, [dispatch]);
  var unregisterDialog = React.useCallback(function () {
    return dispatch(uiActions.unregisterDialog({
      type: 'layerManager'
    }));
  }, [dispatch]);
  var onOrderDialog = React.useCallback(function () {
    if (!uiIsOrderedOnTop) {
      dispatch(uiActions.orderDialog({
        type: 'layerManager'
      }));
    }
  }, [dispatch, uiIsOrderedOnTop]); // Register this dialog in the store

  React.useEffect(function () {
    registerDialog();
    return function () {
      unregisterDialog();
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LayerManager, {
    mapId: mapId,
    preloadedAvailableBaseLayers: preloadedAvailableBaseLayers,
    preloadedMapServices: preloadedMapServices,
    preloadedBaseServices: preloadedBaseServices,
    bounds: bounds,
    isOpen: isOpenInStore,
    onClose: onClose,
    showTitle: showTitle,
    onMouseDown: onOrderDialog,
    order: uiOrder,
    source: uiSource,
    layerSelect: layerSelect,
    leftComponent: leftComponent,
    isLoading: isMapPresetLoading,
    error: mapPresetError
  }), layerSelect && /*#__PURE__*/React.createElement(LayerSelectConnect, {
    preloadedServices: preloadedMapServices
  }));
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */

var MapControlButton = function MapControlButton(_a) {
  var onClick = _a.onClick,
      children = _a.children,
      title = _a.title,
      _a$placement = _a.placement,
      placement = _a$placement === void 0 ? 'right' : _a$placement,
      _a$isActive = _a.isActive,
      isActive = _a$isActive === void 0 ? false : _a$isActive,
      props = __rest(_a, ["onClick", "children", "title", "placement", "isActive"]);

  return /*#__PURE__*/React.createElement(Tooltip, {
    placement: placement,
    title: title
  }, /*#__PURE__*/React.createElement(Box, {
    component: "span",
    sx: {
      marginBottom: '8px'
    }
  }, /*#__PURE__*/React.createElement(ToolButton, Object.assign({
    onClick: onClick,
    active: isActive
  }, props), children)));
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */

var ZoomControls = function ZoomControls(_ref) {
  var onZoomIn = _ref.onZoomIn,
      onZoomOut = _ref.onZoomOut,
      onZoomReset = _ref.onZoomReset;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MapControlButton, {
    title: "Reset zoom",
    "data-testid": "zoom-reset",
    onClick: onZoomReset
  }, /*#__PURE__*/React.createElement(Home, null)), /*#__PURE__*/React.createElement(MapControlButton, {
    title: "Zoom in",
    "data-testid": "zoom-in",
    onClick: onZoomIn
  }, /*#__PURE__*/React.createElement(Add, null)), /*#__PURE__*/React.createElement(MapControlButton, {
    title: "Zoom out",
    "data-testid": "zoom-out",
    onClick: onZoomOut
  }, /*#__PURE__*/React.createElement(Minus, null)));
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */

var ZoomControlConnect = function ZoomControlConnect(_ref) {
  var mapId = _ref.mapId;
  var isVisible = useSelector(function (store) {
    return isZoomControlsVisible(store, mapId);
  });
  var adagucRef = React.useRef(null);
  React.useEffect(function () {
    adagucRef.current = getWMJSMapById(mapId);
  }, [mapId]);

  var onZoomIn = function onZoomIn() {
    return adagucRef.current.zoomIn();
  };

  var onZoomOut = function onZoomOut() {
    return adagucRef.current.zoomOut();
  };

  var onZoomReset = function onZoomReset() {
    return adagucRef.current.zoomToLayer(adagucRef.current.getActiveLayer());
  };

  if (!isVisible) {
    return null;
  }

  return /*#__PURE__*/React.createElement(ZoomControls, {
    onZoomIn: onZoomIn,
    onZoomOut: onZoomOut,
    onZoomReset: onZoomReset
  });
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */
var useStyles$e = makeStyles(function () {
  return {
    container: {
      '& > button': {
        marginBottom: 8
      }
    },
    wrapper: {
      position: 'absolute',
      overflow: 'visible',
      display: 'block',
      left: 0,
      margin: 8,
      zIndex: 50,
      top: 96
    }
  };
});

var MapControls = function MapControls(_a) {
  var children = _a.children,
      props = __rest(_a, ["children"]);

  var classes = useStyles$e();
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: classes.wrapper
  }, props), /*#__PURE__*/React.createElement(Grid, {
    className: classes.container,
    container: true,
    direction: "column"
  }, children));
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */

var LayerManagerMapButtonConnect = function LayerManagerMapButtonConnect(_ref) {
  var mapId = _ref.mapId,
      _ref$source = _ref.source,
      source = _ref$source === void 0 ? 'app' : _ref$source;
  var dispatch = useDispatch();
  var currentActiveMapId = useSelector(function (store) {
    return getDialogMapId(store, 'layerManager');
  });
  var isOpenInStore = useSelector(function (store) {
    return getisDialogOpen(store, 'layerManager');
  });
  var openLayerManagerDialog = React.useCallback(function () {
    dispatch(uiActions.setActiveMapIdForDialog({
      type: 'layerManager',
      mapId: mapId,
      setOpen: currentActiveMapId !== mapId ? true : !isOpenInStore,
      source: source
    }));
  }, [currentActiveMapId, dispatch, isOpenInStore, mapId, source]);
  var isOpen = currentActiveMapId === mapId && isOpenInStore;
  return /*#__PURE__*/React.createElement(MapControlButton, {
    title: "Layer Manager",
    "data-testid": "layerManagerButton",
    onClick: openLayerManagerDialog,
    isActive: isOpen
  }, /*#__PURE__*/React.createElement(Layers, null));
};

var dimensionConfig = [{
  name: 'elevation',
  label: 'Vertical level',
  defaultUnit: 'hPa',
  reversed: true,
  iconType: 'IconLevels'
}, {
  name: 'ensemble_member',
  label: 'Ensemble member',
  defaultUnit: 'member',
  reversed: false,
  iconType: 'IconEnsemble'
}, {
  name: 'probability',
  label: 'Probability',
  defaultUnit: '%',
  reversed: false,
  iconType: 'IconLevels'
}, {
  name: 'level',
  label: 'Level',
  defaultUnit: 'level',
  reversed: false,
  iconType: 'IconLevels'
}];
var getDimensionIcon = function getDimensionIcon(iconType) {
  if (iconType === 'IconEnsemble') {
    return Equalizer;
  }

  return Sort;
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */

var DimensionSelectButton = function DimensionSelectButton(_ref) {
  var dimension = _ref.dimension,
      onClickDimensionButton = _ref.onClickDimensionButton,
      _ref$isActive = _ref.isActive,
      isActive = _ref$isActive === void 0 ? false : _ref$isActive;
  var dimConfig = dimensionConfig.find(function (cnf) {
    return cnf.name === dimension;
  });
  var Icon = getDimensionIcon(dimConfig && dimConfig.iconType || 'IconLevels');
  var title = "Show ".concat(dimConfig ? dimConfig.label.toLowerCase() : dimension.toLowerCase());
  return /*#__PURE__*/React.createElement(MapControlButton, {
    title: title,
    "data-testid": "dimensionMapBtn-".concat(dimension),
    onClick: onClickDimensionButton,
    isActive: isActive
  }, /*#__PURE__*/React.createElement(Icon, null));
};

var useStyles$d = makeStyles(function () {
  return {
    verticalLevelDimensionSelectContainer: {
      height: '320px',
      margin: '10px',
      marginLeft: '-5px',
      minWidth: 120,
      fontSize: '90%'
    },
    layerName: {
      paddingLeft: '10px',
      maxWidth: 130,
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  };
});
var SmallFontSlider = withStyles({
  markLabel: {
    fontSize: '80%'
  }
})(Slider);

var DimensionSelectSlider = function DimensionSelectSlider(_ref) {
  var marks = _ref.marks,
      layerName = _ref.layerName,
      _ref$reverse = _ref.reverse,
      reverse = _ref$reverse === void 0 ? false : _ref$reverse,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$managedValue = _ref.managedValue,
      managedValue = _ref$managedValue === void 0 ? null : _ref$managedValue,
      _ref$validSelection = _ref.validSelection,
      validSelection = _ref$validSelection === void 0 ? true : _ref$validSelection,
      _ref$alertColor = _ref.alertColor,
      alertColor = _ref$alertColor === void 0 ? 'red' : _ref$alertColor,
      onChangeDimensionValue = _ref.onChangeDimensionValue;
  var classes = useStyles$d();

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      currentIndex = _useState2[0],
      setCurrentIndex = _useState2[1];

  if (!marks || !marks.length) {
    return null;
  }

  var sortedMarks = _toConsumableArray(marks).sort(function (a, b) {
    return typeof a.value === 'number' && typeof b.value === 'number' && a.value - b.value;
  });

  var adaptedMarks = reverse ? sortedMarks.reverse() : sortedMarks;
  var values = adaptedMarks.map(function (m) {
    return m.value;
  }); // using index as values in slider to get constant spacing between marks

  var indexLabelMarks = adaptedMarks.map(function (m, index) {
    return {
      value: index,
      label: m.label
    };
  });
  var sliderValue = managedValue !== null ? values.findIndex(function (v) {
    return v === managedValue;
  }) : currentIndex;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.verticalLevelDimensionSelectContainer,
    "data-testid": "slider-dimensionSelect"
  }, /*#__PURE__*/React.createElement(Box, {
    component: "span",
    m: 1
  }, /*#__PURE__*/React.createElement(SmallFontSlider, {
    "data-testid": "verticalSlider",
    orientation: "vertical",
    "aria-labelledby": "vertical-slider",
    step: null,
    min: 0,
    max: indexLabelMarks.length - 1,
    marks: indexLabelMarks,
    style: !validSelection ? {
      color: alertColor
    } : {},
    disabled: isDisabled,
    value: sliderValue,
    onChange: function onChange(e, val) {
      onChangeDimensionValue(values[val].toString());
      if (!managedValue) setCurrentIndex(val);
    }
  }))), /*#__PURE__*/React.createElement(Tooltip, {
    title: layerName
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    className: classes.layerName
  }, layerName)));
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */
var marksByDimension = function marksByDimension(dim) {
  if (!dim || !dim.name) return [];
  var dimCnf = dimensionConfig.find(function (cnf) {
    return cnf.name === dim.name;
  });
  var defaultUnit = dimCnf ? dimCnf.defaultUnit : '';
  var marks = [];

  if (dim && dim.size) {
    for (var i = 0; i < dim.size(); i += 1) {
      marks.push({
        value: Number(dim.getValueForIndex(i)) || dim.getValueForIndex(i),
        label: "".concat(Number(dim.getValueForIndex(i)) || dim.getValueForIndex(i), " ").concat(dim.unitSymbol ? dim.unitSymbol : defaultUnit)
      });
    }
  }

  return marks;
};
/**
 * Re-formats moment's isoString to the string that is expected by WMJSDimension (for time).
 * @param dateIn The input date to re-format, usually in the format `YYYY-MM-DDThh:mm:ss.uuuZ`
 * @returns The formated input date in the format `YYYY-MM-DDThh:mm:ssZ`
 */

var handleMomentISOString = function handleMomentISOString(dateIn) {
  /* Try to fix the timestrings generated by moment js made with moment.toISOString() */
  if (!dateIn) return null;

  if (dateIn.length > 20) {
    var fixedDate = dateIn.substring(0, 19);
    return "".concat(fixedDate, "Z");
  }

  if (dateIn.length === 17) {
    var _fixedDate = dateIn.substring(0, 16);

    return "".concat(_fixedDate, ":00Z");
  }

  return dateIn;
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */

var DimensionSelectSliderConnect = function DimensionSelectSliderConnect(_ref) {
  var layerId = _ref.layerId,
      dimConfig = _ref.dimConfig,
      dimensionName = _ref.dimensionName,
      handleDimensionValueChanged = _ref.handleDimensionValueChanged,
      handleSyncChanged = _ref.handleSyncChanged;
  var layerDimension = useSelector(function (store) {
    return getLayerDimension(store, layerId, dimensionName);
  });
  var wmLayer = getWMLayerById(layerId);

  if (!layerDimension || !wmLayer) {
    return null;
  }

  var wmsDimension = wmLayer.getDimension(dimensionName);

  if (!wmsDimension) {
    return null;
  }

  var layerName = wmLayer.getLayerName();
  var marks = marksByDimension(wmsDimension);
  var isLayerDimensionSynced = layerDimension.synced !== undefined && layerDimension.synced === true;
  var tooltipTitle = isLayerDimensionSynced ? 'Click to disconnect layer' : 'Click to connect layer';

  var Icon = function Icon() {
    return isLayerDimensionSynced ? /*#__PURE__*/React.createElement(Link, {
      "data-testid": "syncIcon"
    }) : /*#__PURE__*/React.createElement(LinkOff, {
      "data-testid": "syncDisIcon"
    });
  };

  return /*#__PURE__*/React.createElement(Grid, {
    key: layerId,
    item: true,
    xs: "auto"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    title: tooltipTitle,
    placement: "top"
  }, /*#__PURE__*/React.createElement(IconButton, {
    "data-testid": "syncButton",
    size: "small",
    onClick: function onClick() {
      return handleSyncChanged(layerId, dimensionName, layerDimension.currentValue, !layerDimension.synced);
    }
  }, /*#__PURE__*/React.createElement(Icon, null))), /*#__PURE__*/React.createElement(DimensionSelectSlider, {
    marks: marks,
    layerName: layerName,
    reverse: dimConfig ? dimConfig.reversed : false,
    managedValue: Number(layerDimension.currentValue) || layerDimension.currentValue,
    onChangeDimensionValue: function onChangeDimensionValue(value) {
      handleDimensionValueChanged(layerId, dimensionName, value);
    },
    isDisabled: false,
    validSelection: layerDimension.synced === false || !(layerDimension.validSyncSelection !== undefined && layerDimension.validSyncSelection === false)
  }));
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */

var DimensionSelectDialogConnect = function DimensionSelectDialogConnect(_ref) {
  var mapId = _ref.mapId,
      dimensionName = _ref.dimensionName,
      isOpen = _ref.isOpen,
      _ref$order = _ref.order,
      order = _ref$order === void 0 ? 0 : _ref$order,
      onMouseDown = _ref.onMouseDown,
      onToggleDialog = _ref.onToggleDialog,
      _ref$index = _ref.index,
      index = _ref$index === void 0 ? 0 : _ref$index,
      _ref$source = _ref.source,
      source = _ref$source === void 0 ? 'app' : _ref$source;
  var dispatch = useDispatch();
  var mapDimension = useSelector(function (store) {
    return getMapDimension(store, mapId, dimensionName);
  });
  var layerIds = useSelector(function (store) {
    return getLayerIds(store, mapId);
  });
  var handleDimensionValueChanged = React.useCallback(function (layerId, dimensionName, newValue) {
    dispatch(layerActions.layerChangeDimension({
      origin: LayerActionOrigin.layerManager,
      layerId: layerId,
      dimension: {
        name: dimensionName,
        currentValue: newValue
      },
      mapId: mapId
    }));
  }, [dispatch, mapId]);
  var handleSyncChanged = React.useCallback(function (layerId, dimensionName, dimensionValue, synced) {
    dispatch(layerActions.layerChangeDimension({
      origin: LayerActionOrigin.layerManager,
      layerId: layerId,
      dimension: {
        name: dimensionName,
        currentValue: dimensionValue,
        synced: synced
      }
    }));
  }, [dispatch]);

  if (!mapDimension || !layerIds || layerIds.length < 1) {
    return null;
  }

  var dimConfig = dimensionConfig.find(function (cnf) {
    return cnf.name === dimensionName;
  });
  var title = dimConfig ? dimConfig.label : dimensionName;
  var topPos = index * 32 + 164; // index * btn height + offset top of window

  return /*#__PURE__*/React.createElement(ToolContainerDraggable, {
    startPosition: {
      left: 50,
      top: topPos
    },
    minWidth: 180,
    title: title,
    headerSize: "small",
    isOpen: isOpen,
    "data-testid": "multidimensionContent-".concat(title),
    onClose: function onClose() {
      return onToggleDialog(false);
    },
    bounds: "parent",
    onMouseDown: onMouseDown,
    order: order,
    source: source
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      padding: 4
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "row"
  }, layerIds.map(function (layerId) {
    return /*#__PURE__*/React.createElement(DimensionSelectSliderConnect, {
      key: layerId,
      handleDimensionValueChanged: handleDimensionValueChanged,
      handleSyncChanged: handleSyncChanged,
      layerId: layerId,
      dimConfig: dimConfig,
      dimensionName: dimensionName
    });
  }))));
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */
var getDimensionType = function getDimensionType(dimensionName) {
  return "dimensionSelect-".concat(dimensionName);
};

var MultiMapSingleDimensionSelectConnect = function MultiMapSingleDimensionSelectConnect(_ref) {
  var dimensionName = _ref.dimensionName,
      index = _ref.index;
  var dispatch = useDispatch();
  var uiDialogType = getDimensionType(dimensionName);
  var mapId = useSelector(function (store) {
    return getDialogMapId(store, uiDialogType);
  });
  var uiOrder = useSelector(function (store) {
    return getDialogOrder(store, uiDialogType);
  });
  var uiSource = useSelector(function (store) {
    return getDialogSource(store, uiDialogType);
  });
  var uiIsOrderedOnTop = useSelector(function (store) {
    return getDialogIsOrderedOnTop(store, uiDialogType);
  });
  var isOpen = useSelector(function (store) {
    return getisDialogOpen(store, uiDialogType);
  });
  var isMapPresent = useSelector(function (store) {
    return getIsMapPresent(store, mapId);
  });
  var onOrderDialog = React.useCallback(function () {
    if (!uiIsOrderedOnTop) {
      dispatch(uiActions.orderDialog({
        type: uiDialogType
      }));
    }
  }, [dispatch, uiDialogType, uiIsOrderedOnTop]);
  var onToggleDialog = React.useCallback(function (setOpen) {
    dispatch(uiActions.setToggleOpenDialog({
      type: uiDialogType,
      setOpen: setOpen
    }));
  }, [dispatch, uiDialogType]);
  var registerDialog = React.useCallback(function (activeMapId) {
    return dispatch(uiActions.registerDialog({
      type: uiDialogType,
      mapId: activeMapId
    }));
  }, [dispatch, uiDialogType]);
  var unregisterDialog = React.useCallback(function () {
    return dispatch(uiActions.unregisterDialog({
      type: uiDialogType
    }));
  }, [dispatch, uiDialogType]); // Check to ensure the currently active map is still present on screen - if not, close the dialog

  React.useEffect(function () {
    if (mapId !== '' && !isMapPresent) {
      onToggleDialog(false);
    }
  }, [mapId, isMapPresent, onToggleDialog]); // Register this dialog in the store

  React.useEffect(function () {
    registerDialog(mapId);
    return function () {
      unregisterDialog();
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(DimensionSelectDialogConnect, {
    mapId: mapId,
    dimensionName: dimensionName,
    onMouseDown: onOrderDialog,
    onToggleDialog: onToggleDialog,
    order: uiOrder,
    source: uiSource,
    isOpen: isOpen,
    index: index
  });
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */

var DimensionSelectMapButtonConnect = function DimensionSelectMapButtonConnect(_ref) {
  var mapId = _ref.mapId,
      dimension = _ref.dimension,
      _ref$source = _ref.source,
      source = _ref$source === void 0 ? 'app' : _ref$source;
  var dispatch = useDispatch();
  var uiDialogType = getDimensionType(dimension);
  var currentActiveMapId = useSelector(function (store) {
    return getDialogMapId(store, uiDialogType);
  });
  var isOpenInStore = useSelector(function (store) {
    return getisDialogOpen(store, uiDialogType);
  });
  var openMultiDimensionDialog = React.useCallback(function () {
    var setOpen = currentActiveMapId !== mapId ? true : !isOpenInStore;
    dispatch(uiActions.setActiveMapIdForDialog({
      type: uiDialogType,
      mapId: mapId,
      setOpen: setOpen,
      source: source
    }));
  }, [currentActiveMapId, dispatch, isOpenInStore, uiDialogType, mapId, source]);
  var isOpen = currentActiveMapId === mapId && isOpenInStore;
  return /*#__PURE__*/React.createElement(DimensionSelectButton, {
    dimension: dimension,
    onClickDimensionButton: openMultiDimensionDialog,
    isActive: isOpen
  });
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */

var MultiDimensionSelectMapButtonsConnect = function MultiDimensionSelectMapButtonsConnect(_ref) {
  var mapId = _ref.mapId,
      _ref$source = _ref.source,
      source = _ref$source === void 0 ? 'app' : _ref$source;
  var dimensions = useSelector(function (store) {
    return getMapDimensions(store, mapId);
  });
  var availableDimensionsNoTime = dimensions.filter(function (dimension) {
    return !dimension.name.includes('time');
  });

  if (!availableDimensionsNoTime || !availableDimensionsNoTime.length) {
    return null;
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, availableDimensionsNoTime.map(function (dimension) {
    return /*#__PURE__*/React.createElement(DimensionSelectMapButtonConnect, {
      mapId: mapId,
      dimension: dimension.name,
      key: dimension.name,
      source: source
    });
  }));
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */

var MultiMapMultiDimensionSelectConnect = function MultiMapMultiDimensionSelectConnect() {
  var allDimensions = useSelector(function (store) {
    return getAllUniqueDimensions(store);
  });
  var allDimensionsNoTime = allDimensions.filter(function (dimension) {
    return !dimension.includes('time');
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, allDimensionsNoTime.map(function (dimName, index) {
    return /*#__PURE__*/React.createElement(MultiMapSingleDimensionSelectConnect, {
      key: "v-select-".concat(dimName),
      dimensionName: dimName,
      index: index
    });
  }));
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */

var AutoUpdateButton = function AutoUpdateButton(_ref) {
  var _ref$toggleAutoUpdate = _ref.toggleAutoUpdate,
      toggleAutoUpdate = _ref$toggleAutoUpdate === void 0 ? function () {
    return null;
  } : _ref$toggleAutoUpdate,
      _ref$isAutoUpdating = _ref.isAutoUpdating,
      isAutoUpdating = _ref$isAutoUpdating === void 0 ? false : _ref$isAutoUpdating,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  return /*#__PURE__*/React.createElement(Tooltip, {
    title: isAutoUpdating ? 'Auto update on' : 'Auto update off'
  }, /*#__PURE__*/React.createElement("span", {
    "data-testid": "autoUpdateButtonTooltip"
  }, /*#__PURE__*/React.createElement(ToolButton, {
    active: isAutoUpdating,
    disabled: disabled,
    onClick: function onClick() {
      return toggleAutoUpdate();
    },
    "data-testid": "autoUpdateButton"
  }, isAutoUpdating ? /*#__PURE__*/React.createElement(AutoUpdateActive, {
    "data-testid": "auto-update-svg-on"
  }) : /*#__PURE__*/React.createElement(AutoUpdateInActive, {
    "data-testid": "auto-update-svg-off"
  }))));
};

var useStyles$c = makeStyles(function (theme) {
  return {
    speedButtonDiv: {
      height: '24px',
      width: '24px',
      position: 'relative'
    },
    sliderBackground: {
      padding: '0 0 60px 0',
      backgroundColor: theme.palette.geowebColors.background.surface,
      width: '95px',
      height: '150px',
      position: 'absolute',
      bottom: '34px',
      left: '-18px'
    }
  };
});

var SpeedButton = function SpeedButton(_ref) {
  var animationDelay = _ref.animationDelay,
      setMapAnimationDelay = _ref.setMapAnimationDelay;
  var classes = useStyles$c();
  var sliderClasses = sliderStyles();

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      open = _React$useState2[0],
      setOpen = _React$useState2[1];

  var marks = speedFactors.map(function (speedFactor, i) {
    return {
      delay: getSpeedDelay(speedFactor),
      markPos: i,
      text: "".concat(speedFactor, "x")
    };
  });
  var max = marks.length - 1;
  var min = 0;
  var currentValue = marks.findIndex(function (info) {
    return info.delay === animationDelay;
  });

  var getAnimationDelayValue = function getAnimationDelayValue(markPos) {
    return marks[markPos].delay || marks[0].delay;
  };

  var onClickButton = function onClickButton() {
    setOpen(!open);
  };

  var onChangeSlider = function onChangeSlider(event, value) {
    var newValue = getAnimationDelayValue(value);

    if (event.type !== 'keydown') {
      setMapAnimationDelay(newValue);
    }
  };

  var onKeyDown = function onKeyDown(event) {
    // disable default Slider behavior
    event.stopPropagation();
    event.preventDefault(); // custom logic

    if (event.key === 'Tab') {
      setOpen(!open);
    }

    var newValue = getValueFromKeyboardEvent(event, currentValue, min, max);

    if (newValue !== null) {
      setMapAnimationDelay(getAnimationDelayValue(newValue));
    }
  };

  var text = marks[currentValue].text;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.speedButtonDiv
  }, /*#__PURE__*/React.createElement(Tooltip, {
    title: "Speed"
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(ToolButton, {
    onClick: onClickButton,
    active: true,
    "data-testid": "speedButton"
  }, /*#__PURE__*/React.createElement(TextIcon, {
    text: text
  })))), open ? /*#__PURE__*/React.createElement("div", {
    className: classes.sliderBackground
  }, /*#__PURE__*/React.createElement("div", {
    className: sliderClasses.sliderHeader
  }, "Speed"), /*#__PURE__*/React.createElement(CustomSlider, {
    "data-testid": "speedSlider",
    orientation: "vertical",
    value: currentValue,
    step: null,
    max: max,
    min: min,
    marks: marks.map(function (_ref2) {
      var markPos = _ref2.markPos,
          text = _ref2.text;
      return {
        value: markPos,
        label: text
      };
    }),
    onChange: onChangeSlider,
    onKeyDown: onKeyDown
  })) : null);
};

var timestepAutoSwitchActive = {
  title: 'Timestep Auto on'
};
var timestepAutoSwitchInactive = {
  title: 'Timestep Auto off'
};
var timeStepMarks = [{
  value: 1,
  label: '1 min',
  timeStepValue: 1,
  text: '1m'
}, {
  value: 2,
  label: '2 min',
  timeStepValue: 2,
  text: '2m'
}, {
  value: 3,
  label: '5 min',
  timeStepValue: 5,
  text: '5m'
}, {
  value: 4,
  label: '10 min',
  timeStepValue: 10,
  text: '10m'
}, {
  value: 5,
  label: '15 min',
  timeStepValue: 15,
  text: '15m'
}, {
  value: 6,
  label: '30 min',
  timeStepValue: 30,
  text: '30m'
}, {
  value: 7,
  label: '1 h',
  timeStepValue: 60,
  text: '1h'
}, {
  value: 8,
  label: '2 h',
  timeStepValue: 120,
  text: '2h'
}, {
  value: 9,
  label: '3 h',
  timeStepValue: 180,
  text: '3h'
}, {
  value: 10,
  label: '6 h',
  timeStepValue: 360,
  text: '6h'
}, {
  value: 11,
  label: '12 h',
  timeStepValue: 720,
  text: '12h'
}, {
  value: 12,
  label: '24 h',
  timeStepValue: 1440,
  text: '24h'
}, {
  value: 13,
  label: '48 h',
  timeStepValue: 2880,
  text: '48h'
}, {
  value: 14,
  label: '72 h',
  timeStepValue: 4320,
  text: '72h'
}, {
  value: 15,
  label: '1 week',
  timeStepValue: 10080,
  text: '1w'
}, {
  value: 16,
  label: '2 weeks',
  timeStepValue: 20160,
  text: '2w'
}, {
  value: 17,
  label: '1 month',
  timeStepValue: 40320,
  text: '4w'
}, {
  value: 18,
  label: '2 months',
  timeStepValue: 80640,
  text: '8w'
}, {
  value: 19,
  label: '6 months',
  timeStepValue: 241920,
  text: '24w'
}, {
  value: 20,
  label: '1 year',
  timeStepValue: 525600,
  text: '1y'
}, {
  value: 21,
  label: '10 years',
  timeStepValue: 5256000,
  text: '10y'
}];
var useStyles$b = makeStyles(function (theme) {
  return {
    timeStepDiv: {
      width: '58px',
      height: '24px',
      position: 'relative'
    },
    sliderBackground: {
      backgroundColor: theme.palette.geowebColors.background.surface,
      width: '110px',
      height: '350px',
      padding: '0 0 83px 0',
      position: 'absolute',
      bottom: '34px'
    },
    timestepAutoText: {
      fontFamily: 'Roboto-Black, Roboto',
      fontSize: 12,
      color: theme.palette.geowebColors.typographyAndIcons.text
    },
    timestepAutoTextOff: {
      fontFamily: 'Roboto-Black, Roboto',
      fontSize: 12,
      color: theme.palette.geowebColors.typographyAndIcons.text
    },
    disabled: {}
  };
});

var TimeStepButton = function TimeStepButton(_ref) {
  var timeStep = _ref.timeStep,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$isTimestepAuto = _ref.isTimestepAuto,
      isTimestepAuto = _ref$isTimestepAuto === void 0 ? false : _ref$isTimestepAuto,
      timeDimension = _ref.timeDimension,
      onChangeTimeStep = _ref.onChangeTimeStep,
      _ref$onToggleTimestep = _ref.onToggleTimestepAuto,
      onToggleTimestepAuto = _ref$onToggleTimestep === void 0 ? function () {
    return null;
  } : _ref$onToggleTimestep;
  var classes = useStyles$b();
  var sliderClasses = sliderStyles();

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      open = _React$useState2[0],
      setOpen = _React$useState2[1];

  var onClickButton = function onClickButton() {
    setOpen(!open);
  };

  var timestepAutoSwitch = !isTimestepAuto ? timestepAutoSwitchInactive : timestepAutoSwitchActive;
  var timestepAutoTextStyle = !isTimestepAuto ? classes.timestepAutoText : classes.timestepAutoTextOff;
  var disabledSlider = disabled || isTimestepAuto;
  var timeStepFromLayer = getActiveLayerTimeStep(timeDimension) || timeStep;
  var currentMark = timeStepMarks.find(function (mark) {
    return mark.timeStepValue === timeStep;
  });
  var value = currentMark && currentMark.value ? currentMark.value : 0;
  var min = timeStepMarks[0].value;
  var max = timeStepMarks[timeStepMarks.length - 1].value;

  var getTimeStepValue = function getTimeStepValue(value) {
    return timeStepMarks[Math.round(value - 1)].timeStepValue;
  };

  var onChangeSlider = function onChangeSlider(event, value) {
    var newValue = getTimeStepValue(value);

    if (event.type !== 'keydown') {
      onChangeTimeStep(newValue, MapActionOrigin.map);
    }
  };

  var onKeyDown = function onKeyDown(event) {
    // disable default Slider behavior
    event.stopPropagation();
    event.preventDefault(); // custom logic

    if (event.key === 'Tab') {
      setOpen(!open);
    }

    var newValue = getValueFromKeyboardEvent(event, value, min, max);

    if (newValue !== null) {
      onChangeTimeStep(getTimeStepValue(newValue), MapActionOrigin.map);
    }
  };

  React.useEffect(function () {
    if (isTimestepAuto) {
      onChangeTimeStep(timeStepFromLayer);
    }
  }, [timeStepFromLayer, isTimestepAuto, onChangeTimeStep]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.timeStepDiv
  }, /*#__PURE__*/React.createElement(Tooltip, {
    title: "Time step"
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(ToolButton, {
    active: true,
    onClick: onClickButton,
    "data-testid": "timeStepButton",
    width: "58px"
  }, /*#__PURE__*/React.createElement(FastForward, null), /*#__PURE__*/React.createElement(TextIcon, {
    text: currentMark && currentMark.text || '',
    "data-testid": "timeStepButtonText"
  })))), open ? /*#__PURE__*/React.createElement("div", {
    className: classes.sliderBackground
  }, /*#__PURE__*/React.createElement("div", {
    className: sliderClasses.sliderHeader
  }, "Time step"), /*#__PURE__*/React.createElement(CustomSlider, {
    "data-testid": "timeStepButtonSlider",
    orientation: "vertical",
    value: value,
    step: null,
    min: min,
    max: max,
    marks: timeStepMarks,
    disabled: disabledSlider,
    onChange: onChangeSlider,
    onKeyDown: onKeyDown,
    shouldAutoFocus: true
  }), /*#__PURE__*/React.createElement(Tooltip, {
    title: timestepAutoSwitch.title
  }, /*#__PURE__*/React.createElement("span", {
    "data-testid": "timestepAutoSwitchTooltip"
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Switch, {
      checked: isTimestepAuto,
      onChange: function onChange() {
        return onToggleTimestepAuto();
      },
      disabled: disabled,
      id: "timestepAutoSwitch",
      disableRipple: true,
      sx: {
        marginLeft: '18px'
      }
    }),
    label: "Auto",
    labelPlacement: "end",
    classes: {
      label: timestepAutoTextStyle
    }
  })))) : null);
};

var OptionsPopOver = withStyles(function (theme) {
  return {
    paper: {
      height: '24px',
      padding: '8px',
      borderRadius: '0',
      overflow: 'visible',
      backgroundColor: theme.palette.geowebColors.background.surface
    }
  };
})(Popover);

var OptionsMenuButton = function OptionsMenuButton(_ref) {
  var autoUpdateBtn = _ref.autoUpdateBtn,
      speedBtn = _ref.speedBtn,
      timeStepBtn = _ref.timeStepBtn;

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var onClickButton = function onClickButton(event) {
    setAnchorEl(event.currentTarget);
  };

  var handleClose = function handleClose() {
    setAnchorEl(null);
  };

  var open = Boolean(anchorEl);
  var id = open ? 'simple-popover' : undefined;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Tooltip, {
    title: "Options"
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(ToolButton, {
    onClick: onClickButton,
    "data-testid": "optionsMenuButton",
    active: open
  }, /*#__PURE__*/React.createElement(Options, {
    "data-testid": "optionsIcon"
  })))), /*#__PURE__*/React.createElement(OptionsPopOver, {
    id: id,
    open: open,
    "data-testid": "optionsMenuPopOver",
    anchorEl: anchorEl,
    onClose: handleClose,
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'left'
    },
    transformOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 1
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: "auto"
  }, timeStepBtn || /*#__PURE__*/React.createElement(TimeStepButton, {
    timeStep: 0,
    onChangeTimeStep: function onChangeTimeStep() {
      return null;
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: "auto"
  }, speedBtn || /*#__PURE__*/React.createElement(SpeedButton, {
    animationDelay: defaultAnimationDelayAtStart,
    setMapAnimationDelay: function setMapAnimationDelay() {
      return null;
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: "auto"
  }, autoUpdateBtn || /*#__PURE__*/React.createElement(AutoUpdateButton, null)))));
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */
var useStyles$a = makeStyles({
  buttonContainerBig: {
    padding: '20px 0px 0px 12px',
    width: '210px'
  },
  buttonContainerSmall: {
    padding: '20px 0px 0px 12px',
    width: '80px'
  }
});

var TimeSliderButtons = function TimeSliderButtons(_ref) {
  var autoUpdateBtn = _ref.autoUpdateBtn,
      optionsMenuBtn = _ref.optionsMenuBtn,
      playBtn = _ref.playBtn,
      speedBtn = _ref.speedBtn,
      timeStepBtn = _ref.timeStepBtn;
  var classes = useStyles$a();
  var matches = useMediaQuery('(min-width:600px)');
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "timeSliderButtons"
  }, matches ? /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    className: classes.buttonContainerBig
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, timeStepBtn || /*#__PURE__*/React.createElement(TimeStepButton, {
    timeStep: 5,
    onChangeTimeStep: function onChangeTimeStep() {
      return null;
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, speedBtn || /*#__PURE__*/React.createElement(SpeedButton, {
    animationDelay: defaultAnimationDelayAtStart,
    setMapAnimationDelay: function setMapAnimationDelay() {
      return null;
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, autoUpdateBtn || /*#__PURE__*/React.createElement(AutoUpdateButton, null)), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, playBtn || /*#__PURE__*/React.createElement(PlayButton, null))) : /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 1,
    className: classes.buttonContainerSmall
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, optionsMenuBtn || /*#__PURE__*/React.createElement(OptionsMenuButton, null)), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, playBtn || /*#__PURE__*/React.createElement(PlayButton, null))));
};

var _scaleToUnitSeconds, _scaleToRoundableUnit;
var scaleToUnitSeconds = (_scaleToUnitSeconds = {}, _defineProperty(_scaleToUnitSeconds, Scale.Minutes5, 5 * 60), _defineProperty(_scaleToUnitSeconds, Scale.Hour, 60 * 60), _defineProperty(_scaleToUnitSeconds, Scale.Hours3, 3 * 60 * 60), _defineProperty(_scaleToUnitSeconds, Scale.Hours6, 6 * 60 * 60), _defineProperty(_scaleToUnitSeconds, Scale.Day, 24 * 60 * 60), _defineProperty(_scaleToUnitSeconds, Scale.Week, 7 * 24 * 60 * 60), _scaleToUnitSeconds);

var drawNeedle = function drawNeedle(context, theme, width, height, startTime, endTime, selectedTime) {
  if (!selectedTime) return;
  var ctx = context;
  var _theme$palette$geoweb = theme.palette.geowebColors.timeSlider,
      playerNeedlePlayer = _theme$palette$geoweb.playerNeedlePlayer,
      playerNeedlePlayerTop = _theme$palette$geoweb.playerNeedlePlayerTop;
  var selectedPx = timestampToPixelEdges(selectedTime, startTime, endTime, width); // Draw a high vertical line (needle) indicating the current or selected time

  ctx.beginPath(); // Move 1 pixel line by 0.5 pixels to prevent it from being shown as blurry: https://usefulangle.com/post/17/html5-canvas-drawing-1px-crisp-straight-lines

  ctx.moveTo(Math.floor(selectedPx) + 0.5, height - 50);
  ctx.lineTo(Math.floor(selectedPx) + 0.5, height);
  ctx.lineWidth = 3;
  ctx.strokeStyle = playerNeedlePlayer.rgba;
  ctx.stroke();
  ctx.lineWidth = 1;
  ctx.strokeStyle = playerNeedlePlayerTop.rgba;
  ctx.stroke();
};

var drawCurrentTime = function drawCurrentTime(context, theme, width, height, startTime, endTime, currentTime) {
  var ctx = context;
  var _theme$palette$geoweb2 = theme.palette.geowebColors.timeSlider,
      playerNeedleTime = _theme$palette$geoweb2.playerNeedleTime,
      playerNeedleTimeTop = _theme$palette$geoweb2.playerNeedleTimeTop;
  var current = currentTime;
  var currentPx = current ? timestampToPixelEdges(current, startTime, endTime, width) : 0; // Draw a high vertical line (needle) indicating the current or selected time

  ctx.beginPath(); // Move 1 pixel line by 0.5 pixels to prevent it from being shown as blurry: https://usefulangle.com/post/17/html5-canvas-drawing-1px-crisp-straight-lines

  ctx.moveTo(Math.floor(currentPx) + 0.5, height - 50);
  ctx.lineTo(Math.floor(currentPx) + 0.5, height);
  ctx.lineWidth = 3;
  ctx.strokeStyle = playerNeedleTime.rgba;
  ctx.stroke();
  ctx.lineWidth = 1;
  ctx.strokeStyle = playerNeedleTimeTop.rgba;
  ctx.stroke();
};

var TICK_MARK_HEIGHT_PRIMARY = 40;
var TICK_MARK_HEIGHT_SECONDARY = 10;
var TICK_MARK_HEIGHT_TERTIARY = 5;

var getStepPxLineHeight = function getStepPxLineHeight(scale, timestep) {
  if ([Scale.Hour, Scale.Hours3, Scale.Hours6, Scale.Day].includes(scale)) {
    var scaleUnitSeconds = scaleToUnitSeconds[scale];
    var rem = timestep % scaleUnitSeconds;

    switch (scale) {
      case Scale.Hour:
        {
          if (rem === 0) return TICK_MARK_HEIGHT_PRIMARY; // 15 min subdivisions

          if (rem % (15 * 60) === 0) return TICK_MARK_HEIGHT_SECONDARY;
          return TICK_MARK_HEIGHT_TERTIARY;
        }

      case Scale.Hours3:
        {
          if (rem === 0) return TICK_MARK_HEIGHT_PRIMARY;
          return TICK_MARK_HEIGHT_TERTIARY;
        }

      case Scale.Hours6:
        {
          if (rem === 0) return TICK_MARK_HEIGHT_PRIMARY; // 3 hour subdivisions

          if (rem % (3 * 60 * 60) === 0) return TICK_MARK_HEIGHT_SECONDARY;
          return TICK_MARK_HEIGHT_TERTIARY;
        }

      default:
        {
          // Scale.Day
          if (rem === 0) return TICK_MARK_HEIGHT_PRIMARY; // 6 hour subdivisions

          if (rem % (6 * 60 * 60) === 0) return TICK_MARK_HEIGHT_SECONDARY;
          return TICK_MARK_HEIGHT_TERTIARY;
        }
    }
  } else {
    switch (scale) {
      case Scale.Week:
        {
          var weekday = moment.unix(timestep).utc().isoWeekday(); // momentjs isoWeekdays range from 1(Monday) to 7(Sunday)

          if (weekday === 1) return TICK_MARK_HEIGHT_PRIMARY;
          return TICK_MARK_HEIGHT_TERTIARY;
        }

      case Scale.Year:
        {
          var month = moment.unix(timestep).utc().month(); // momentjs months are zero indexed

          if (month === 0) return TICK_MARK_HEIGHT_PRIMARY;
          if (month % 3 === 0) return TICK_MARK_HEIGHT_SECONDARY;
          return TICK_MARK_HEIGHT_TERTIARY;
        }

      case Scale.Minutes5:
        {
          // add primary line on day change
          if (timestep % (60 * 60 * 24) === 0) return TICK_MARK_HEIGHT_PRIMARY;
          return TICK_MARK_HEIGHT_TERTIARY;
        }

      default:
        // Scale.Month
        return TICK_MARK_HEIGHT_TERTIARY;
    }
  }
};

var getStepPxLineHeightForDataScale = function getStepPxLineHeightForDataScale(scale, timestep) {
  var scaleUnitSeconds = scaleToUnitSeconds[scale];
  var rem = timestep % scaleUnitSeconds;

  switch (scale) {
    case Scale.Hour:
      {
        if (rem === 0) return TICK_MARK_HEIGHT_PRIMARY; // 15 min subdivisions

        if (rem % (15 * 60) === 0) return TICK_MARK_HEIGHT_SECONDARY;
        return TICK_MARK_HEIGHT_TERTIARY;
      }

    case Scale.Hours3:
      {
        if (rem === 0) return TICK_MARK_HEIGHT_PRIMARY;
        return TICK_MARK_HEIGHT_TERTIARY;
      }

    case Scale.Hours6:
      {
        if (rem === 0) return TICK_MARK_HEIGHT_PRIMARY; // 3 hour subdivisions

        if (rem % (3 * 60 * 60) === 0) return TICK_MARK_HEIGHT_SECONDARY;
        return TICK_MARK_HEIGHT_TERTIARY;
      }

    case Scale.Day:
      {
        if (rem === 0) return TICK_MARK_HEIGHT_PRIMARY; // 6 hour subdivisions

        if (rem % (6 * 60 * 60) === 0) return TICK_MARK_HEIGHT_SECONDARY;
        return TICK_MARK_HEIGHT_TERTIARY;
      }

    case Scale.Week:
      {
        var weekday = moment.unix(timestep).utc().isoWeekday(); // momentjs isoWeekdays range from 1(Monday) to 7(Sunday)

        if (weekday === 1) return TICK_MARK_HEIGHT_PRIMARY;
        return TICK_MARK_HEIGHT_TERTIARY;
      }

    case Scale.Year:
      {
        var month = moment.unix(timestep).utc().month(); // momentjs months are zero indexed

        if (month === 0) return TICK_MARK_HEIGHT_PRIMARY;
        return TICK_MARK_HEIGHT_TERTIARY;
      }

    case Scale.Minutes5:
      {
        // add primary line on day change
        if (timestep % (60 * 60 * 24) === 0) return TICK_MARK_HEIGHT_PRIMARY;
        return TICK_MARK_HEIGHT_TERTIARY;
      }

    default:
      // Scale.Month
      return TICK_MARK_HEIGHT_TERTIARY;
  }
};

var drawStepPxLine = function drawStepPxLine(ctx, theme, stepPx, height, scale, fundamentalScale, timestep) {
  var ctx2 = ctx;
  ctx2.strokeStyle = theme.palette.geowebColors.timeSlider.timelineTimeScale.fill;
  ctx2.lineWidth = 1;
  var stepPxLineHeight = scale !== Scale.DataScale ? getStepPxLineHeight(scale, timestep) : getStepPxLineHeightForDataScale(fundamentalScale, timestep);
  ctx2.beginPath();
  ctx2.moveTo(stepPx, height - stepPxLineHeight);
  ctx2.lineTo(stepPx, height);
  ctx2.stroke();
};

var drawTimeText = function drawTimeText(ctx, theme, stepPx, height, timeText, scale) {
  var ctx2 = ctx;
  var _theme$palette$geoweb3 = theme.palette.geowebColors.timeSlider.timelineText,
      fontFamily = _theme$palette$geoweb3.fontFamily,
      color = _theme$palette$geoweb3.color;
  ctx2.fillStyle = color; // time text has smaller font than other timeline text

  ctx2.font = "12px ".concat(fontFamily);
  ctx2.textAlign = 'left';

  if (scale === Scale.Year || scale === Scale.Month || scale === Scale.Week || scale === Scale.Day) {
    ctx2.fillText(timeText, stepPx, height - 12);
  } else {
    ctx2.fillText(timeText, stepPx - 15, height - 12);
  }
};

var drawUpperText = function drawUpperText(ctx, theme, newDate, stepPx, height, minOffset) {
  if (stepPx <= 0) return;
  var ctx2 = ctx;
  var _theme$palette$geoweb4 = theme.palette.geowebColors.timeSlider.timelineText,
      fontSize = _theme$palette$geoweb4.fontSize,
      fontFamily = _theme$palette$geoweb4.fontFamily,
      color = _theme$palette$geoweb4.color;
  ctx2.fillStyle = color;
  ctx2.font = "".concat(fontSize, "px ").concat(fontFamily);
  ctx2.textAlign = 'left';
  ctx2.fillText(newDate, Math.max(minOffset, stepPx + 2), height - 30);
};

var drawYearScaleText = function drawYearScaleText(ctx, theme, newDate, stepPx, height) {
  var ctx2 = ctx;
  var _theme$palette$geoweb5 = theme.palette.geowebColors.timeSlider.timelineText,
      fontSize = _theme$palette$geoweb5.fontSize,
      fontFamily = _theme$palette$geoweb5.fontFamily,
      color = _theme$palette$geoweb5.color;
  ctx2.fillStyle = color;
  ctx2.font = "".concat(fontSize, "px ").concat(fontFamily);
  ctx2.textAlign = 'left';
  ctx2.fillText(newDate, stepPx + 2, height - 30);
};

var drawLeftSideDateText = function drawLeftSideDateText(ctx, theme, newDate, height) {
  var ctx2 = ctx;
  var _theme$palette$geoweb6 = theme.palette.geowebColors.timeSlider.timelineText,
      fontSize = _theme$palette$geoweb6.fontSize,
      fontFamily = _theme$palette$geoweb6.fontFamily,
      color = _theme$palette$geoweb6.color;
  ctx2.fillStyle = color;
  ctx2.font = "".concat(fontSize, "px ").concat(fontFamily);
  ctx2.textAlign = 'left';
  ctx2.fillText(newDate, 2, height - 30);
};

var getTimeFormat = function getTimeFormat(scale) {
  switch (scale) {
    case Scale.Year:
      return 'Y';

    case Scale.Month:
      return 'MMM';

    case Scale.Week:
      return 'DD';

    case Scale.Day:
      return 'ddd DD';

    default:
      return 'HH:mm';
  }
};

var drawDateChangeLine = function drawDateChangeLine(ctx, theme, stepPx, height) {
  var ctx2 = ctx;
  ctx2.strokeStyle = theme.palette.geowebColors.timeSlider.timelineTimeScale.fill;
  ctx2.lineWidth = 1;
  ctx2.beginPath();
  ctx2.moveTo(stepPx, height - 40);
  ctx2.lineTo(stepPx, height);
  ctx2.stroke();
};

var drawDashedMonthChangeLine = function drawDashedMonthChangeLine(ctx, theme, stepPx, height) {
  var ctx2 = ctx;
  ctx2.strokeStyle = theme.palette.geowebColors.timeSlider.timelineMonthChangeDash.rgba;
  ctx2.lineWidth = 3;
  ctx2.setLineDash([5, 5]);
  ctx2.beginPath();
  ctx2.moveTo(stepPx, 0);
  ctx2.lineTo(stepPx, height);
  ctx2.stroke();
  ctx2.setLineDash([]);
};

var roundByUnitOfTime = function roundByUnitOfTime(timeUnix, scaleType) {
  var roundUp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var unitOfTimeStart = moment.unix(timeUnix).utc().startOf(scaleType);

  if (roundUp) {
    return unitOfTimeStart.add(1, scaleType).unix();
  }

  return unitOfTimeStart.unix();
};

var roundToNearestMultiple = function roundToNearestMultiple(timeUnix, scale) {
  var roundUp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var stepSeconds = scaleToUnitSeconds[scale];
  var roundFn = roundUp ? Math.ceil : Math.floor;
  return roundFn(timeUnix / stepSeconds) * stepSeconds;
};
/**
 * In this script starting and ending times of the time slider are rounded.
 * Here it is defined what is a time unit to a start of which a rounding is
 * done for each scale.
 * @returns an object where there are rounding units of each scale
 */


var scaleToRoundableUnit = (_scaleToRoundableUnit = {}, _defineProperty(_scaleToRoundableUnit, Scale.Hour, 'hour'), _defineProperty(_scaleToRoundableUnit, Scale.Day, 'day'), _defineProperty(_scaleToRoundableUnit, Scale.Week, 'isoWeek'), _defineProperty(_scaleToRoundableUnit, Scale.Month, 'isoWeek'), _defineProperty(_scaleToRoundableUnit, Scale.Year, 'year'), _defineProperty(_scaleToRoundableUnit, Scale.DataScale, 'year'), _scaleToRoundableUnit);
var getRoundedStartAndEnd = function getRoundedStartAndEnd(visibleTimeStart, visibleTimeEnd, scale) {
  if (scale === Scale.Minutes5 || scale === Scale.Hours3 || scale === Scale.Hours6) {
    return [roundToNearestMultiple(visibleTimeStart, scale, false), roundToNearestMultiple(visibleTimeEnd, scale, true)];
  }

  var momentUnit = scaleToRoundableUnit[scale];
  return [roundByUnitOfTime(visibleTimeStart, momentUnit, false), roundByUnitOfTime(visibleTimeEnd, momentUnit, true)];
};
var getCustomRoundedStartAndEnd = function getCustomRoundedStartAndEnd(visibleTimeStart, visibleTimeEnd, unit) {
  return [roundByUnitOfTime(visibleTimeStart, unit, false), roundByUnitOfTime(visibleTimeEnd, unit, true)];
};

var incrementTimestep = function incrementTimestep(timeAtTimeStep, fundamentalScale) {
  switch (fundamentalScale) {
    case Scale.Minutes5:
      return timeAtTimeStep.add(1, 'minute');

    case Scale.Hour:
      return timeAtTimeStep.add(5, 'minutes');

    case Scale.Hours3:
    case Scale.Hours6:
      return timeAtTimeStep.add(1, 'hour');

    case Scale.Day:
      return timeAtTimeStep.add(3, 'hours');

    case Scale.Week:
      return timeAtTimeStep.add(1, 'day');

    case Scale.Month:
      return timeAtTimeStep.add(1, 'week');

    case Scale.Year:
      return timeAtTimeStep.add(1, 'month');

    default:
      return timeAtTimeStep.add(1, 'month');
  }
};

var getTimesteps = function getTimesteps(roundedStart, roundedEnd, fundamentalScaleType) {
  var timesteps = [];
  var timestep = roundedStart;

  while (timestep <= roundedEnd) {
    timesteps.push(timestep);
    timestep = incrementTimestep(moment.unix(timestep).utc(), fundamentalScaleType).unix();
  }

  return timesteps;
};

var getDateChangeTimestepUnit = function getDateChangeTimestepUnit(scale) {
  switch (scale) {
    case Scale.DataScale:
      return 'year';

    case Scale.Month:
      return 'year';

    case Scale.Week:
    case Scale.Day:
      return 'month';

    default:
      return 'day';
  }
};

var getMinOffset = function getMinOffset(scale) {
  switch (scale) {
    case Scale.Month:
      return 42;

    case Scale.Week:
    case Scale.Day:
      return 70;

    default:
      return 115;
  }
};

var getCustomTimesteps = function getCustomTimesteps(roundedStart, roundedEnd, increment) {
  var momentIncrement = increment;
  var timesteps = [];
  var timestep = roundedStart;

  while (timestep <= roundedEnd) {
    timesteps.push(timestep);
    timestep = moment.unix(timestep).utc().add(1, momentIncrement).unix();
  }

  return timesteps;
};

var getLeftSideDateText = function getLeftSideDateText(timestamp, scale) {
  var timeMoment = moment.unix(timestamp).utc();

  switch (scale) {
    case Scale.Minutes5:
    case Scale.Hour:
    case Scale.Hours3:
    case Scale.Hours6:
      return timeMoment.format('Y MMM ddd DD');

    case Scale.Day:
    case Scale.Week:
      return timeMoment.format('Y MMM');

    case Scale.Month:
      return timeMoment.format('Y');

    default:
      return '';
  }
};

var getLeftSideDateTextForDataScale = function getLeftSideDateTextForDataScale(timestamp, fundamentalScale) {
  var timeMoment = moment.unix(timestamp).utc();

  switch (fundamentalScale) {
    case Scale.Minutes5:
    case Scale.Hour:
    case Scale.Hours3:
    case Scale.Hours6:
      return timeMoment.format('Y MMM ddd DD');

    case Scale.Day:
    case Scale.Week:
      return timeMoment.format('Y MMM');

    case Scale.Month:
      return timeMoment.format('Y');

    case Scale.Year:
      return timeMoment.format('Y');

    default:
      return '';
  }
};

var getDateChangeFormat = function getDateChangeFormat(timestamp, timestepUnit) {
  var momentTime = moment.unix(timestamp).utc();

  if (timestepUnit === 'year') {
    return momentTime.format('Y');
  }

  if (timestepUnit === 'month') {
    if (momentTime.month() === 0) {
      return momentTime.format('Y MMM');
    }

    return momentTime.format('MMM');
  }

  if (momentTime.month() === 0 && momentTime.date() === 1) {
    return momentTime.format('Y MMM ddd DD');
  }

  if (momentTime.date() === 1) {
    return momentTime.format('MMM ddd DD');
  }

  return momentTime.format('ddd DD');
}; // For a data scale an appropriate fundamental scale is chosen
// depending on dataScaleToSecondsPerPx of data. When a time range of
// data is for example many months. the fundamental scale Scale.Year
// is chosen here and the legend of the time slider is drawn in the
// same as if otiginally a year scale would have been chose.
//
// If a  time range of data is a few weeks, Scale.Month is chosen. So, all
// the time range of data can be shown in the window.


var getFundamentalScaleForDataScale = function getFundamentalScaleForDataScale(dataScaleToSecondsPerPx) {
  if (dataScaleToSecondsPerPx >= scaleToSecondsPerPx[Scale.Month]) {
    return Scale.Year;
  }

  if (dataScaleToSecondsPerPx >= scaleToSecondsPerPx[Scale.Week]) {
    return Scale.Month;
  }

  if (dataScaleToSecondsPerPx >= scaleToSecondsPerPx[Scale.Day]) {
    return Scale.Week;
  }

  if (dataScaleToSecondsPerPx >= scaleToSecondsPerPx[Scale.Hour]) {
    return Scale.Day;
  }

  return Scale.Hour;
};

var getColorChangeTimestepUnit = function getColorChangeTimestepUnit(scale) {
  switch (scale) {
    case Scale.Year:
      return 'year';

    case Scale.Month:
      return 'month';

    case Scale.Week:
      return 'isoWeek';

    default:
      return 'day';
  }
};

var isColorIntervalEven = function isColorIntervalEven(scale, timestep) {
  var momentTime = moment.unix(timestep).utc();

  switch (scale) {
    case Scale.Year:
      return momentTime.year() % 2 === 0;

    case Scale.Month:
      return momentTime.month() % 2 === 0;

    case Scale.Week:
      return momentTime.isoWeek() % 2 === 0;

    default:
      return timestep / (60 * 60 * 24) % 2 === 0;
  }
};

var drawBackground = function drawBackground(context, theme, visibleTimeStart, visibleTimeEnd, animationStartPx, animationEndPx, canvasWidth, height, scale) {
  var ctx = context;
  var _theme$palette$geoweb7 = theme.palette.geowebColors.timeSlider,
      timelineTimelineSurface = _theme$palette$geoweb7.timelineTimelineSurface,
      timelineNightTime = _theme$palette$geoweb7.timelineNightTime;
  ctx.fillStyle = timelineTimelineSurface.fill;
  ctx.fillRect(0, 0, canvasWidth, height);
  ctx.fillStyle = theme.palette.geowebColors.timeSlider.timelineSelectionBackground.rgba;
  ctx.fillRect(animationStartPx, 0, Math.max(animationEndPx - animationStartPx, 0), height);
  var colorChangeUnit = getColorChangeTimestepUnit(scale);

  var _getCustomRoundedStar = getCustomRoundedStartAndEnd(visibleTimeStart, visibleTimeEnd, colorChangeUnit),
      _getCustomRoundedStar2 = _slicedToArray(_getCustomRoundedStar, 2),
      colorChangeStart = _getCustomRoundedStar2[0],
      colorChangeEnd = _getCustomRoundedStar2[1];

  var colorChangeTimesteps = getCustomTimesteps(colorChangeStart, colorChangeEnd, colorChangeUnit);
  colorChangeTimesteps.forEach(function (timestep, i, arr) {
    if (i === 0) return;

    var _map = [arr[i - 1], timestep].map(function (timestep) {
      return timestampToPixelEdges(timestep, visibleTimeStart, visibleTimeEnd, canvasWidth);
    }),
        _map2 = _slicedToArray(_map, 2),
        prevPx = _map2[0],
        currPx = _map2[1];

    if (!isColorIntervalEven(scale, timestep)) {
      ctx.fillStyle = timelineNightTime.rgba;
      ctx.fillRect(prevPx, 0, currPx - prevPx, height);
    }
  });
};

var drawTimeScale = function drawTimeScale(context, theme, visibleTimeStart, visibleTimeEnd, canvasWidth, height, scale, dataScaleToSecondsPerPx) {
  var fundamentalScale = scale === Scale.DataScale ? getFundamentalScaleForDataScale(dataScaleToSecondsPerPx) : scale;

  var _getRoundedStartAndEn = getRoundedStartAndEnd(visibleTimeStart, visibleTimeEnd, fundamentalScale),
      _getRoundedStartAndEn2 = _slicedToArray(_getRoundedStartAndEn, 2),
      roundedStart = _getRoundedStartAndEn2[0],
      roundedEnd = _getRoundedStartAndEn2[1]; // draw regular tickmarks


  var ctx = context;
  getTimesteps(roundedStart, roundedEnd, fundamentalScale).forEach(function (timestep) {
    var stepPx = timestampToPixelEdges(timestep, visibleTimeStart, visibleTimeEnd, canvasWidth); // Move 1 pixel line by 0.5 pixels to prevent it from being shown as blurry: https://usefulangle.com/post/17/html5-canvas-drawing-1px-crisp-straight-lines

    drawStepPxLine(ctx, theme, Math.floor(stepPx) + 0.5, height, scale, fundamentalScale, timestep); // Draw the time step time as text

    var timeFormat = getTimeFormat(fundamentalScale);
    var timeText = moment.unix(timestep).utc().format(timeFormat).toString();

    if ([Scale.Minutes5, Scale.Hour, Scale.Hours3, Scale.Hours6, Scale.Day].includes(fundamentalScale) && timestep % scaleToUnitSeconds[fundamentalScale] === 0 || fundamentalScale === Scale.Week && moment.unix(timestep).isoWeekday() === 1) {
      drawTimeText(ctx, theme, stepPx, height, timeText, fundamentalScale);
    }

    if (fundamentalScale === Scale.Year && moment.unix(timestep).month() === 0) {
      drawYearScaleText(ctx, theme, timeText, stepPx, height);
    }
  }); // draw month overlay lines

  if (fundamentalScale === Scale.Week || fundamentalScale === Scale.Month || scale === Scale.DataScale) {
    var _getCustomRoundedStar3 = getCustomRoundedStartAndEnd(visibleTimeStart, visibleTimeEnd, 'month'),
        _getCustomRoundedStar4 = _slicedToArray(_getCustomRoundedStar3, 2),
        _roundedStart = _getCustomRoundedStar4[0],
        _roundedEnd = _getCustomRoundedStar4[1];

    var monthTimesteps = getCustomTimesteps(_roundedStart, _roundedEnd, 'month');
    monthTimesteps.forEach(function (timestep) {
      var stepPx = timestampToPixelEdges(timestep, visibleTimeStart, visibleTimeEnd, canvasWidth);

      if (fundamentalScale === Scale.Month || scale === Scale.DataScale && fundamentalScale !== Scale.Day) {
        var momentTime = moment.unix(timestep).utc(); // Move 1 pixel line by 0.5 pixels to prevent it from being shown as blurry: https://usefulangle.com/post/17/html5-canvas-drawing-1px-crisp-straight-lines

        drawDateChangeLine(ctx, theme, Math.floor(stepPx) + 0.5, height);
        drawTimeText(ctx, theme, stepPx, height, momentTime.format('MMM'), fundamentalScale);
        return;
      } // adding 0.5 to make line not so blurred


      drawDashedMonthChangeLine(ctx, theme, Math.floor(stepPx) + 0.5, height);
    });
  } // draw date change texts


  if (scale === Scale.Year && fundamentalScale === Scale.Year) return;
  var timestepUnit = getDateChangeTimestepUnit(fundamentalScale);

  var _getCustomRoundedStar5 = getCustomRoundedStartAndEnd(visibleTimeStart, visibleTimeEnd, timestepUnit),
      _getCustomRoundedStar6 = _slicedToArray(_getCustomRoundedStar5, 2),
      dateChangeStart = _getCustomRoundedStar6[0],
      dateChangeEnd = _getCustomRoundedStar6[1];

  var dateChangeTimesteps = getCustomTimesteps(dateChangeStart, dateChangeEnd, timestepUnit);
  dateChangeTimesteps.forEach(function (timestep) {
    var stepPx = timestampToPixelEdges(timestep, visibleTimeStart, visibleTimeEnd, canvasWidth);
    var textFormat = getDateChangeFormat(timestep, timestepUnit);
    var minOffset = getMinOffset(fundamentalScale);

    if (scale !== Scale.DataScale) {
      drawUpperText(ctx, theme, textFormat, stepPx, height, minOffset);
    }
  });
  var dateText = scale === Scale.DataScale ? getLeftSideDateTextForDataScale(visibleTimeStart, fundamentalScale) : getLeftSideDateText(visibleTimeStart, scale);
  drawLeftSideDateText(ctx, theme, dateText, height);
};

var renderTimeSliderLegend = function renderTimeSliderLegend(context, theme, canvasWidth, height, centerTime, secondsPerPx, dataScaleToSecondsPerPx, selectedTimeUnix, scale, currentTimeUnix, animationStartTime, animationEndTime) {
  var ctx = context;

  var _map3 = [0, canvasWidth].map(function (px) {
    return pixelToTimestamp(px, centerTime, canvasWidth, secondsPerPx);
  }),
      _map4 = _slicedToArray(_map3, 2),
      visibleTimeStart = _map4[0],
      visibleTimeEnd = _map4[1];

  var _map5 = [animationStartTime, animationEndTime].map(function (time) {
    return timestampToPixel(time, centerTime, canvasWidth, secondsPerPx);
  }),
      _map6 = _slicedToArray(_map5, 2),
      animationStartPx = _map6[0],
      animationEndPx = _map6[1];

  drawBackground(ctx, theme, visibleTimeStart, visibleTimeEnd, animationStartPx, animationEndPx, canvasWidth, height, scale);
  drawTimeScale(ctx, theme, visibleTimeStart, visibleTimeEnd, canvasWidth, height, scale, dataScaleToSecondsPerPx);
  drawNeedle(ctx, theme, canvasWidth, height, visibleTimeStart, visibleTimeEnd, selectedTimeUnix);
  drawCurrentTime(ctx, theme, canvasWidth, height, visibleTimeStart, visibleTimeEnd, currentTimeUnix);
};

var useStyles$9 = makeStyles({
  timeSliderLegend: {
    height: '50px'
  }
});

var getNextSecondsPerPxValue = function getNextSecondsPerPxValue(direction, oldSecondsPerPx, dataScaleToSecondsPerPx) {
  var fullSecondsPerPxValues = secondsPerPxValues(dataScaleToSecondsPerPx);
  var ind = fullSecondsPerPxValues.indexOf(oldSecondsPerPx);
  var newInd = ind + direction;
  var clampedInd = Math.max(0, Math.min(fullSecondsPerPxValues.length - 1, newInd));
  return fullSecondsPerPxValues[clampedInd];
};

var NEEDLE_HANDLE_WIDTH = 10;
var LEFT_MOUSE_BTN = 1;
var THROTTLE_WAIT_TIME = 500; // [ms]

var THROTTLE_OPTIONS = {
  trailing: false // Invoke function when called, but not more than once every <THROTTLE_WAIT_TIME>.

};

var TimeSliderLegend = function TimeSliderLegend(_ref) {
  var centerTime = _ref.centerTime,
      secondsPerPx = _ref.secondsPerPx,
      _ref$dataScaleToSecon = _ref.dataScaleToSecondsPerPx,
      dataScaleToSecondsPerPx = _ref$dataScaleToSecon === void 0 ? defaultDataScaleToSecondsPerPx : _ref$dataScaleToSecon,
      selectedTime = _ref.selectedTime,
      _ref$scale = _ref.scale,
      scale = _ref$scale === void 0 ? Scale.Hour : _ref$scale,
      currentTime = _ref.currentTime,
      dataStartTime = _ref.dataStartTime,
      dataEndTime = _ref.dataEndTime,
      animationStartTime = _ref.animationStartTime,
      animationEndTime = _ref.animationEndTime,
      isTimeSliderHoverOn = _ref.isTimeSliderHoverOn,
      timeStep = _ref.timeStep,
      _ref$mapIsActive = _ref.mapIsActive,
      mapIsActive = _ref$mapIsActive === void 0 ? true : _ref$mapIsActive,
      onSetNewDate = _ref.onSetNewDate,
      onSetCenterTime = _ref.onSetCenterTime,
      onZoom = _ref.onZoom;
  var classes = useStyles$9();

  var _useCanvasTarget = useCanvasTarget('mousedown'),
      _useCanvasTarget2 = _slicedToArray(_useCanvasTarget, 2),
      isAllowedCanvasNodePointed = _useCanvasTarget2[0],
      node = _useCanvasTarget2[1];

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isDragged = _React$useState2[0],
      setDragged = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      isReleased = _React$useState4[0],
      setReleased = _React$useState4[1];

  var _React$useState5 = React.useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      isNewSelectionTimeRequested = _React$useState6[0],
      setNewSelectionTimeRequested = _React$useState6[1];

  var _React$useState7 = React.useState(animationStartTime && moment.utc(animationStartTime).unix()),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      localAnimationStartTime = _React$useState8[0],
      setLocalAnimationStartTime = _React$useState8[1];

  var _React$useState9 = React.useState(animationEndTime && moment.utc(animationEndTime).unix()),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      localAnimationEndTime = _React$useState10[0],
      setLocalAnimationEndTime = _React$useState10[1];

  React.useEffect(function () {
    setLocalAnimationStartTime(animationStartTime && moment.utc(animationStartTime).unix());
    setLocalAnimationEndTime(animationEndTime && moment.utc(animationEndTime).unix());
  }, [animationStartTime, animationEndTime]);
  React.useEffect(function () {
    var handleKeyDown = function handleKeyDown(event) {
      if (event.key === 'Home' && mapIsActive) {
        if (dataStartTime < dataEndTime) {
          if (dataEndTime < currentTime) {
            onSetNewDate(moment.utc(dataEndTime * 1000).toISOString());
            onSetCenterTime(dataEndTime);
          } else if (dataStartTime > currentTime) {
            onSetNewDate(moment.utc(dataStartTime * 1000).toISOString());
            onSetCenterTime(dataStartTime);
          } else {
            var closestToCurrent = roundWithTimeStep(currentTime, timeStep);
            onSetNewDate(moment.utc(closestToCurrent * 1000).toISOString());
            onSetCenterTime(closestToCurrent);
          }
        }
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return function () {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [timeStep, isTimeSliderHoverOn, currentTime, dataStartTime, dataEndTime, mapIsActive, onSetCenterTime, onSetNewDate]);

  var setSelectedTime = function setSelectedTime(x, width) {
    setNewRoundedTime(x, centerTime, width, secondsPerPx, timeStep, dataStartTime, dataEndTime, onSetNewDate);
  };

  var theme = useTheme(); // eslint-disable-next-line react-hooks/exhaustive-deps

  var throttledZoom = React.useCallback(throttle(function (newSecondsPerPx, newCenterTime) {
    onZoom(newSecondsPerPx, newCenterTime);
  }, THROTTLE_WAIT_TIME, THROTTLE_OPTIONS), []);

  var zoom = function zoom(deltaY, deltaX, canvasWidth, mouseX) {
    if (!onZoom) return;
    var direction = deltaY || deltaX;
    var newSecondsPerPx = getNextSecondsPerPxValue(Math.sign(direction), secondsPerPx, dataScaleToSecondsPerPx);
    var mouseTime = pixelToTimestamp(mouseX, centerTime, canvasWidth, secondsPerPx);
    var newCenterTime = getNewCenterOfFixedPointZoom(mouseTime, secondsPerPx, newSecondsPerPx, centerTime);
    throttledZoom(newSecondsPerPx, newCenterTime);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: classes.timeSliderLegend,
    "data-testid": "timeSliderLegend"
  }, /*#__PURE__*/React.createElement(CanvasComponent, {
    ref: node,
    onMouseMove: function onMouseMove(x, y, event, width) {
      if (isTimeSliderHoverOn && dataStartTime && dataEndTime) {
        // Sets new selection time when moving and mouse was down when close enough the time slider needle. This makes needle draggable while leaving time slider legend in rest.
        setSelectedTime(x, width);
        return;
      }

      if (isAllowedCanvasNodePointed && event.buttons === LEFT_MOUSE_BTN) {
        // Sets new center time while dragging. This allows the whole time slider legend [as well as the time slider needle] to be mouse dragged as one.
        var dragDistanceX = event.movementX;
        setDragged(dragDistanceX !== 0);

        if (isNewSelectionTimeRequested) {
          setSelectedTime(x, width);
        } else {
          var dragDistanceTime = dragDistanceX * secondsPerPx;
          var newCenterTime = centerTime - dragDistanceTime;
          onSetCenterTime && onSetCenterTime(newCenterTime);
        }
      }
    },
    onWheel: function onWheel(_ref2) {
      var deltaY = _ref2.deltaY,
          deltaX = _ref2.deltaX,
          canvasWidth = _ref2.canvasWidth,
          mouseX = _ref2.mouseX;
      zoom(deltaY, deltaX, canvasWidth, mouseX);
    },
    onMouseDown: function onMouseDown(x, y, width) {
      setDragged(false);
      setReleased(false);
      var selectedTimeX = timestampToPixel(selectedTime, centerTime, width, secondsPerPx);
      setNewSelectionTimeRequested(Math.abs(x - selectedTimeX) < NEEDLE_HANDLE_WIDTH);
    },
    onMouseUp: function onMouseUp() {
      setReleased(true);
      setNewSelectionTimeRequested(false);
    },
    onCanvasClick: function onCanvasClick(x, y, width) {
      var isCanvasArea = x >= 0 && x < width;

      if (isCanvasArea) {
        if (isReleased && !isDragged) {
          setSelectedTime(x, width);
        }
      }
    },
    onRenderCanvas: function onRenderCanvas(ctx, width, height) {
      renderTimeSliderLegend(ctx, theme, width, height, centerTime, secondsPerPx, dataScaleToSecondsPerPx, selectedTime, scale, currentTime, localAnimationStartTime, localAnimationEndTime);
    }
  }));
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */
var scaleSliderOtherSettings = {
  LEFT_PADDING: '10%'
};
var useStyles$8 = makeStyles(function (theme) {
  return {
    Background: {
      backgroundColor: theme.palette.geowebColors.background.surface,
      width: '229px',
      height: '40px',
      paddingTop: '4px',
      paddingBottom: '7px',
      boxSizing: 'content-box'
    },
    ScaleText: {
      width: '67px',
      height: '15px',
      padding: '0px 10px 0 8px',
      color: theme.palette.geowebColors.typographyAndIcons.text,
      font: "".concat(theme.palette.geowebColors.timeSlider.timeScaleText.fontSize, "px Roboto")
    }
  };
});

var thumbComponent = function thumbComponent(props) {
  var children = props.children,
      other = __rest(props, ["children"]);

  return /*#__PURE__*/React.createElement(SliderThumb, Object.assign({}, other, {
    "data-testid": "scaleSliderSliderThumb",
    tabIndex: 0
  }), children, /*#__PURE__*/React.createElement(SliderThumb$1, null));
};

var marks = [{
  text: '5 min scale',
  paddingLeft: '2px',
  value: Scale.Minutes5
}, {
  text: '1 h scale',
  paddingLeft: '25px',
  value: Scale.Hour
}, {
  text: '3 h scale',
  paddingLeft: '45px',
  value: Scale.Hours3
}, {
  text: '6 h scale',
  paddingLeft: '65px',
  value: Scale.Hours6
}, {
  text: 'day scale',
  paddingLeft: '80px',
  value: Scale.Day
}, {
  text: 'week scale',
  paddingLeft: '92px',
  value: Scale.Week
}, {
  text: 'month scale',
  paddingLeft: '107px',
  value: Scale.Month
}, {
  text: 'year scale',
  paddingLeft: '130px',
  value: Scale.Year
}, {
  text: 'data scale',
  paddingLeft: '140px',
  value: Scale.DataScale
}];

var valueLabelFormat = function valueLabelFormat(value) {
  var valueNew = value.toString();
  return valueNew;
};

var GeoWebScaleSlider = withStyles(function (theme) {
  return {
    root: {
      height: 4,
      width: 167,
      margin: "0 0 18px ".concat(scaleSliderOtherSettings.LEFT_PADDING)
    },
    thumb: {
      backgroundColor: 'rgba(0,0,0,0)',
      marginTop: 0,
      width: 12,
      height: 12,
      color: theme.palette.geowebColors.timeSlider.timeScalePointer.fill,
      '& svg polygon': {
        filter: theme.palette.geowebColors.timeSlider.timeScaleShadowButtonScale.filter
      },
      '&:before': {
        display: 'none'
      }
    },
    valueLabel: {
      left: '20px'
    },
    rail: {
      color: theme.palette.geowebColors.timeSlider.timeScaleHorizontalScale.fill,
      height: 4,
      width: 170,
      borderRadius: 4.5,
      opacity: theme.palette.geowebColors.timeSlider.timeScaleHorizontalScale.opacity
    },
    mark: {
      backgroundColor: theme.palette.geowebColors.timeSlider.timeScaleTimeIndicators.fill,
      height: 6,
      width: 2,
      marginTop: -9
    },
    markActive: {
      backgroundColor: theme.palette.geowebColors.timeSlider.timeScaleTimeIndicatorsActive.fill,
      height: 6,
      width: 2,
      marginTop: -9
    },
    '@media (max-width: 585px)': {
      root: {
        width: 110
      },
      rail: {
        width: 110
      }
    },
    '@media (max-width: 395px)': {
      root: {
        width: 60
      },
      rail: {
        width: 60
      }
    }
  };
})(Slider);
var RAIL_GUTTER_OFFSET = 0.4;

var TimeSliderScaleSlider = function TimeSliderScaleSlider(_ref) {
  var layers = _ref.layers,
      _ref$timeSliderScale = _ref.timeSliderScale,
      timeSliderScale = _ref$timeSliderScale === void 0 ? Scale.Hour : _ref$timeSliderScale,
      centerTime = _ref.centerTime,
      secondsPerPx = _ref.secondsPerPx,
      selectedTime = _ref.selectedTime,
      onChangeTimeSliderScale = _ref.onChangeTimeSliderScale;
  var classes = useStyles$8();
  var min = 0;
  var max = marks.length - 1;
  var value = marks.findIndex(function (mark) {
    return mark.value === timeSliderScale;
  });

  var onChangeSliderValue = function onChangeSliderValue(newSliderValue) {
    var newValue = newSliderValue ? Math.round(newSliderValue) : 0;
    var newScale = marks.find(function (el) {
      return el.value === newValue;
    }).value;
    var scaleToSecPerPx = newScale === Scale.DataScale ? getScaleToSecondsPerPxForDataScale(layers) : scaleToSecondsPerPx[newScale];
    var newCenterTime = getNewCenterOfFixedPointZoom(selectedTime, secondsPerPx, scaleToSecPerPx, centerTime);
    onChangeTimeSliderScale(newScale, newCenterTime, scaleToSecPerPx);
  };

  var onChange = function onChange(event, value) {
    if (event.type !== 'keydown') {
      onChangeSliderValue(value);
    }
  };

  var onKeyDown = function onKeyDown(event) {
    // disable default Slider behavior
    event.preventDefault();
    event.stopPropagation(); // custom logic

    var newValue = getValueFromKeyboardEvent(event, value, min, max, true);

    if (newValue !== null) {
      onChangeSliderValue(newValue);
    }
  };

  var _marks$find = marks.find(function (mark) {
    return mark.value === value;
  }),
      paddingLeft = _marks$find.paddingLeft,
      text = _marks$find.text;

  var scaleTextPadding = {
    paddingLeft: paddingLeft
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.Background,
    "data-testid": "scaleSlider"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    "data-testid": "scaleSliderText",
    className: classes.ScaleText,
    style: scaleTextPadding
  }, text)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(GeoWebScaleSlider, {
    "data-testid": "scaleSliderSlider",
    defaultValue: Scale.Hour,
    value: value,
    min: min - RAIL_GUTTER_OFFSET,
    step: 1,
    max: max + RAIL_GUTTER_OFFSET,
    getAriaValueText: valueLabelFormat,
    onChange: onChange,
    onKeyDown: onKeyDown,
    "aria-labelledby": "scale-slider",
    components: {
      Thumb: thumbComponent
    },
    marks: marks,
    track: false
  })));
};

/* eslint-disable no-param-reassign */

var drawRoundedRectangle = function drawRoundedRectangle(ctx, x, y, width, height, cornerRadius, theme) {
  ctx.save();
  ctx.translate(x, y);
  var playerTimeMarkers = theme.palette.geowebColors.timeSlider.playerTimeMarkers;
  ctx.beginPath();
  ctx.strokeStyle = playerTimeMarkers.fill;
  ctx.fillStyle = playerTimeMarkers.fill;
  ctx.lineWidth = needleGeom.lineWidth;
  var halfLineWidth = needleGeom.lineWidth / 2; // Top left corner

  ctx.moveTo(halfLineWidth, height / 2);
  ctx.arcTo(halfLineWidth, halfLineWidth, width / 2, halfLineWidth, cornerRadius); // Top right corner

  ctx.arcTo(width - halfLineWidth, halfLineWidth, width - halfLineWidth, height / 2, cornerRadius); // Bottom right corner

  ctx.arcTo(width - halfLineWidth, height - halfLineWidth, width / 2, height - halfLineWidth, cornerRadius); // Arrow down

  ctx.lineTo(width / 2 + 5, height);
  ctx.lineTo(width / 2, height + 5);
  ctx.lineTo(width / 2 - 5, height); // Bottom left corner

  ctx.arcTo(halfLineWidth, height - halfLineWidth, halfLineWidth, height / 2, cornerRadius);
  ctx.lineTo(halfLineWidth, height / 2);
  ctx.fill();
  ctx.stroke();
  ctx.restore();
};

var drawTextAnnotation = function drawTextAnnotation(ctx, x, y, text, theme) {
  var playerTimeText = theme.palette.geowebColors.timeSlider.playerTimeText;
  ctx.save();
  ctx.translate(x, y);
  ctx.fillStyle = playerTimeText.color;
  ctx.font = "".concat(playerTimeText.fontSize, "px ").concat(playerTimeText.fontFamily);
  var textMetrics = ctx.measureText(text);
  var actualTextWidth = textMetrics.actualBoundingBoxRight - textMetrics.actualBoundingBoxLeft;
  var actualTextHeight = ctx.measureText('O').width;
  ctx.fillText(text, -actualTextWidth / 2, actualTextHeight / 2);
  ctx.restore();
};

var drawPlayerLoopIcon = function drawPlayerLoopIcon(ctx, x, y, theme) {
  var playerTimeMarkers = theme.palette.geowebColors.timeSlider.playerTimeMarkers;
  ctx.save();
  var qAndDTranslateXSvg = -12;
  var qAndDTranslateYSvg = 0;
  ctx.translate(x + qAndDTranslateXSvg, y + qAndDTranslateYSvg);
  var svgIconPath = new Path2D('M8.843 1.029c-.56 0-.814.362-.814.699 0 .179.065.36.19.54l3.06 4.34c.065.093.14.171.221.234v8.373c-.082.064-.156.142-.22.234L8.219 19.79c-.125.18-.19.361-.19.54 0 .337.255.699.814.699h6.373c.56 0 .813-.361.813-.7 0-.178-.064-.36-.19-.538l-3.06-4.343c-.08-.112-.174-.204-.278-.273V6.883c.104-.069.199-.16.278-.273l3.06-4.343c.126-.179.19-.36.19-.539 0-.338-.254-.7-.813-.7z');
  ctx.fillStyle = playerTimeMarkers.fill;
  ctx.fill(svgIconPath);
  ctx.strokeStyle = theme.palette.geowebColors.timeSlider.playerNeedlePlayer.rgba;
  ctx.lineWidth = 1;
  ctx.stroke(svgIconPath);
  ctx.restore();
};

var drawNewNeedleLabel = function drawNewNeedleLabel(ctx, selectedTime, selectedPx, animationStartPx, animationEndPx, scale, theme) {
  var smallWidth = needleGeom.smallWidth,
      largeWidth = needleGeom.largeWidth,
      height = needleGeom.height;
  var needleWidth = scale === Scale.Year ? largeWidth : smallWidth;
  var needleX = selectedPx - needleWidth / 2;
  var needleY = needleGeom.lineWidth;
  drawRoundedRectangle(ctx, needleX, needleY, needleWidth, height, needleGeom.cornerRadius, theme);
  var timeFormat = scale === Scale.Year ? 'Y ddd DD MMM HH:mm' : 'ddd DD MMM HH:mm';
  var timeText = moment.utc(selectedTime * 1000).format(timeFormat).toString();
  drawTextAnnotation(ctx, needleX + needleWidth / 2, needleY + height / 2, timeText, theme);

  if (!animationStartPx || !animationEndPx) {
    drawPlayerLoopIcon(ctx, selectedPx, needleY + height - needleGeom.lineWidth, theme);
    return;
  }

  drawPlayerLoopIcon(ctx, animationStartPx, needleY + height - needleGeom.lineWidth, theme);
  drawPlayerLoopIcon(ctx, animationEndPx, needleY + height - needleGeom.lineWidth, theme);
}; // top spacing


var y = 31;

var drawRoundedRailMask = function drawRoundedRailMask(ctx, width, height) {
  var r = 4;
  ctx.beginPath();
  ctx.moveTo(r, y);
  ctx.lineTo(width - r, y); // top right corner

  ctx.quadraticCurveTo(width, y, width, r + y);
  ctx.lineTo(width, height - r + y); // bottom right corner

  ctx.quadraticCurveTo(width, height + y, width - r, height + y);
  ctx.lineTo(r, height + y); // bottom left corner

  ctx.quadraticCurveTo(0, height + y, 0, height - r + y);
  ctx.lineTo(0, r + y); // top left corner

  ctx.quadraticCurveTo(0, y, r, y);
  ctx.closePath(); // the mask color is not visible but needs to be completely opaque

  ctx.fillStyle = '#ffffff';
  ctx.fill();
};

var drawSelectedTimeLine = function drawSelectedTimeLine(ctx, selectedPx, railHeight, theme) {
  var _theme$palette$geoweb = theme.palette.geowebColors.timeSlider,
      playerNeedlePlayer = _theme$palette$geoweb.playerNeedlePlayer,
      playerNeedlePlayerTop = _theme$palette$geoweb.playerNeedlePlayerTop;
  ctx.beginPath(); // Move 1 pixel line by 0.5 pixels to prevent it from being shown as blurry: https://usefulangle.com/post/17/html5-canvas-drawing-1px-crisp-straight-lines

  ctx.moveTo(Math.floor(selectedPx) + 0.5, y);
  ctx.lineTo(Math.floor(selectedPx) + 0.5, y + railHeight);
  ctx.lineWidth = 3;
  ctx.strokeStyle = playerNeedlePlayer.rgba;
  ctx.stroke();
  ctx.lineWidth = 1;
  ctx.strokeStyle = playerNeedlePlayerTop.rgba;
  ctx.stroke();
};

var drawCurrentTimeLine = function drawCurrentTimeLine(ctx, currentTimePx, railHeight, theme) {
  var _theme$palette$geoweb2 = theme.palette.geowebColors.timeSlider,
      playerNeedleTime = _theme$palette$geoweb2.playerNeedleTime,
      playerNeedleTimeTop = _theme$palette$geoweb2.playerNeedleTimeTop;
  ctx.beginPath(); // Move 1 pixel line by 0.5 pixels to prevent it from being shown as blurry: https://usefulangle.com/post/17/html5-canvas-drawing-1px-crisp-straight-lines

  ctx.moveTo(Math.floor(currentTimePx) + 0.5, y);
  ctx.lineTo(Math.floor(currentTimePx) + 0.5, y + railHeight);
  ctx.lineWidth = 3;
  ctx.strokeStyle = playerNeedleTime.rgba;
  ctx.stroke();
  ctx.lineWidth = 1;
  ctx.strokeStyle = playerNeedleTimeTop.rgba;
  ctx.stroke();
};

var drawRailColors = function drawRailColors(ctx, theme, width, railHeight, selectedPx, currentTimePx, animationStartPx, animationEndPx, dataStartPx, dataEndPx) {
  var _theme$palette$geoweb3 = theme.palette.geowebColors.timeSlider,
      playerRailSelection = _theme$palette$geoweb3.playerRailSelection,
      playerRailForecastNoData = _theme$palette$geoweb3.playerRailForecastNoData,
      playerRailObservation = _theme$palette$geoweb3.playerRailObservation,
      playerRailForecastData = _theme$palette$geoweb3.playerRailForecastData;
  ctx.fillStyle = playerRailForecastNoData.rgba;
  ctx.fillRect(0, y, width, railHeight);

  if (dataStartPx < currentTimePx) {
    ctx.fillStyle = playerRailObservation.rgba;
    ctx.fillRect(Math.max(dataStartPx, 0), y, Math.min(currentTimePx, dataEndPx) - Math.max(dataStartPx, 0), railHeight);
  }

  if (dataEndPx > currentTimePx) {
    ctx.fillStyle = playerRailForecastData.rgba;
    ctx.fillRect(Math.max(currentTimePx, dataStartPx), y, Math.min(width, dataEndPx) - Math.max(currentTimePx, dataStartPx), railHeight);
  }

  if (animationStartPx && animationEndPx) {
    var start = Math.max(animationStartPx, dataStartPx);
    var end = Math.min(animationEndPx, dataEndPx);
    ctx.fillStyle = playerRailSelection.rgba;
    ctx.fillRect(start, y, Math.max(end - start, 0), // no negative widths
    railHeight);
  }

  drawSelectedTimeLine(ctx, selectedPx, railHeight, theme);
  drawCurrentTimeLine(ctx, currentTimePx, railHeight, theme);
};

var renderTimeSliderRailWithNeedle = function renderTimeSliderRailWithNeedle(ctx, theme, width, height, centerTime, selected, secondsPerPx, scale, animationStart, animationEnd, dataStartTime, dataEndTime, currentTime) {
  // map unix timestamps to pixel values
  var _map = [selected, animationStart, animationEnd, currentTime, dataStartTime, dataEndTime].map(function (t) {
    return timestampToPixel(t, centerTime, width, secondsPerPx);
  }),
      _map2 = _slicedToArray(_map, 6),
      selectedPx = _map2[0],
      animationStartPx = _map2[1],
      animationEndPx = _map2[2],
      currentTimePx = _map2[3],
      dataStartPx = _map2[4],
      dataEndPx = _map2[5];

  ctx.clearRect(0, 0, width, height);
  drawRailColors(ctx, theme, width, 8, selectedPx, currentTimePx, animationStartPx, animationEndPx, dataStartPx, dataEndPx); // destination-in only leaves those areas visible that overlap with the mask

  ctx.globalCompositeOperation = 'destination-in';
  drawRoundedRailMask(ctx, width, 8); // source-over is the default

  ctx.globalCompositeOperation = 'source-over';
  drawNewNeedleLabel(ctx, selected, selectedPx, animationStartPx, animationEndPx, scale, theme);
};

var useStyles$7 = makeStyles({
  timeSliderRail: {
    '& div': {
      outline: 'none'
    },
    height: '45px',
    '& canvas': {
      display: 'block'
    }
  }
});

var setPreviousTimeStep = function setPreviousTimeStep(timeStep, curTime, dataStartTime, onSetNewDate) {
  var prevTimeStep = moment.utc(curTime).subtract(timeStep, 'm').toISOString();
  if (!prevTimeStep) return;
  if (moment.utc(prevTimeStep) < moment.utc(dataStartTime * 1000)) return;
  onsetNewDateDebounced(prevTimeStep, onSetNewDate);
};

var setNextTimeStep = function setNextTimeStep(timeStep, curTime, dataEndTime, onSetNewDate) {
  var nextTimeStep = moment.utc(curTime).add(timeStep, 'm').toISOString();
  if (!nextTimeStep) return;
  if (moment.utc(nextTimeStep) > moment.utc(dataEndTime * 1000)) return;
  onsetNewDateDebounced(nextTimeStep, onSetNewDate);
};

var DRAG_AREA_WIDTH = 10;
var DRAG_HANDLER_AREA_WIDTH = 30;

var TimeSliderRail = function TimeSliderRail(_ref) {
  var _ref$centerTime = _ref.centerTime,
      centerTime = _ref$centerTime === void 0 ? moment.utc().unix() : _ref$centerTime,
      _ref$secondsPerPx = _ref.secondsPerPx,
      secondsPerPx = _ref$secondsPerPx === void 0 ? 50 : _ref$secondsPerPx,
      selectedTime = _ref.selectedTime,
      timeStep = _ref.timeStep,
      animationStartTime = _ref.animationStartTime,
      animationEndTime = _ref.animationEndTime,
      currentTime = _ref.currentTime,
      dataStartTime = _ref.dataStartTime,
      dataEndTime = _ref.dataEndTime,
      isTimeSliderHoverOn = _ref.isTimeSliderHoverOn,
      _ref$scale = _ref.scale,
      scale = _ref$scale === void 0 ? Scale.Hour : _ref$scale,
      mapIsActive = _ref.mapIsActive,
      onSetAnimationStartTime = _ref.onSetAnimationStartTime,
      onSetAnimationEndTime = _ref.onSetAnimationEndTime,
      onSetNewDate = _ref.onSetNewDate,
      onSetCenterTime = _ref.onSetCenterTime;
  var classes = useStyles$7();
  var ZOOM_RATIO = 1.1;

  var zoomOut = function zoomOut(relativeX) {
    var su = moment.utc(animationStartTime).unix();
    var eu = moment.utc(animationEndTime).unix();
    var targetTime = su + (eu - su) * relativeX;
    onSetAnimationStartTime(moment.utc(((su - targetTime) * ZOOM_RATIO + targetTime) * 1000).format(dateFormat));
    onSetAnimationEndTime(moment.utc(((eu - targetTime) * ZOOM_RATIO + targetTime) * 1000).format(dateFormat));
  };

  var zoomIn = function zoomIn(relativeX) {
    var su = moment.utc(animationStartTime).unix();
    var eu = moment.utc(animationEndTime).unix();
    var targetTime = su + (eu - su) * relativeX;
    onSetAnimationStartTime(moment.utc(((su - targetTime) / ZOOM_RATIO + targetTime) * 1000).format(dateFormat));
    onSetAnimationEndTime(moment.utc(((eu - targetTime) / ZOOM_RATIO + targetTime) * 1000).format(dateFormat));
  };

  var curTime = selectedTime !== undefined ? selectedTime.toISOString() : moment.utc().toISOString();

  var _React$useState = React.useState(animationStartTime && moment.utc(animationStartTime).unix()),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      localAnimationStartTime = _React$useState2[0],
      setLocalAnimationStartTime = _React$useState2[1];

  var _React$useState3 = React.useState(animationEndTime && moment.utc(animationEndTime).unix()),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      localAnimationEndTime = _React$useState4[0],
      setLocalAnimationEndTime = _React$useState4[1];

  var _React$useState5 = React.useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      isLeftMarkerDragging = _React$useState6[0],
      setLeftMarkerDragging = _React$useState6[1];

  var _React$useState7 = React.useState(false),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      isRightMarkerDragging = _React$useState8[0],
      setRightMarkerDragging = _React$useState8[1];

  var _React$useState9 = React.useState('auto'),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      cursorStyle = _React$useState10[0],
      setCursorStyle = _React$useState10[1];

  var _React$useState11 = React.useState(false),
      _React$useState12 = _slicedToArray(_React$useState11, 2),
      isAnimationDragged = _React$useState12[0],
      setAnimationDragged = _React$useState12[1];

  var onWheel = function onWheel(_ref2) {
    var event = _ref2.event,
        deltaY = _ref2.deltaY,
        canvasWidth = _ref2.canvasWidth,
        mouseX = _ref2.mouseX;

    if (event.altKey) {
      var relativeX = mouseX / canvasWidth;

      if (deltaY > 0) {
        zoomIn(relativeX);
      } else {
        zoomOut(relativeX);
      }
    } else if (deltaY > 0) {
      setPreviousTimeStep(timeStep, curTime, dataStartTime, onSetNewDate);
    } else {
      setNextTimeStep(timeStep, curTime, dataEndTime, onSetNewDate);
    }
  };

  var onMouseDownTouchStartActions = function onMouseDownTouchStartActions(x, y, width) {
    if (!animationStartTime || !animationEndTime || !onSetAnimationStartTime || !onSetAnimationEndTime) return;

    var _map = [localAnimationStartTime, localAnimationEndTime].map(function (timestamp) {
      return timestampToPixel(timestamp, centerTime, width, secondsPerPx);
    }),
        _map2 = _slicedToArray(_map, 2),
        leftMarkerPx = _map2[0],
        rightMarkerPx = _map2[1]; // start dragging either marker


    if (x > leftMarkerPx - DRAG_HANDLER_AREA_WIDTH && x < leftMarkerPx + DRAG_HANDLER_AREA_WIDTH && !isRightMarkerDragging) {
      setLeftMarkerDragging(true);
    }

    if (x > rightMarkerPx - DRAG_HANDLER_AREA_WIDTH && x < rightMarkerPx + DRAG_HANDLER_AREA_WIDTH && !isLeftMarkerDragging) {
      setRightMarkerDragging(true);
    }
  };

  var onMouseDown = function onMouseDown(x, y, width) {
    onMouseDownTouchStartActions(x, y, width);
  };

  var onTouchStart = function onTouchStart(event, width) {
    var x = event.touches[0].clientX - event.touches[0].target.offsetLeft;
    var y = event.touches[0].clientY;
    event.preventDefault();
    onMouseDownTouchStartActions(x, y, width);
  };

  var onMouseUpTouchEnd = function onMouseUpTouchEnd() {
    // Dispatch changes when releasing mouse
    if (isLeftMarkerDragging) {
      onSetAnimationStartTime(moment.utc(localAnimationStartTime * 1000).format(dateFormat));
      setAnimationDragged(true);
    }

    if (isRightMarkerDragging) {
      onSetAnimationEndTime(moment.utc(localAnimationEndTime * 1000).format(dateFormat));
      setAnimationDragged(true);
    }

    setLeftMarkerDragging(false);
    setRightMarkerDragging(false);
  };

  var onMouseTouchMoveActions = function onMouseTouchMoveActions(x, y, width) {
    if (!localAnimationStartTime || !localAnimationEndTime) return; // change local time bounds according to either dragged marker

    var _map3 = [x, 0, width].map(function (t) {
      return pixelToTimestamp(t, centerTime, width, secondsPerPx);
    }),
        _map4 = _slicedToArray(_map3, 3),
        mouseTimeUnix = _map4[0],
        startTimeUnix = _map4[1],
        endTimeUnix = _map4[2];

    if (isLeftMarkerDragging) {
      // Prevent dragging if it would cause markers to cross over, except if the markers
      // are moved away from being crossed over
      if (mouseTimeUnix >= localAnimationEndTime || mouseTimeUnix <= startTimeUnix) return;
      setLocalAnimationStartTime(mouseTimeUnix);
      return;
    }

    if (isRightMarkerDragging) {
      // Similar condition for other marker
      if (mouseTimeUnix <= localAnimationStartTime || mouseTimeUnix >= endTimeUnix) return;
      setLocalAnimationEndTime(mouseTimeUnix);
    }
  };

  var onMouseMove = function onMouseMove(x, y, event, width) {
    var _map5 = [localAnimationStartTime, localAnimationEndTime].map(function (timestamp) {
      return timestampToPixel(timestamp, centerTime, width, secondsPerPx);
    }),
        _map6 = _slicedToArray(_map5, 2),
        leftMarkerPx = _map6[0],
        rightMarkerPx = _map6[1]; // Adjust mouse cursor while hovering on either marker,
    // or while dragging (even when the cursor is not above a marker)


    if (x > leftMarkerPx - DRAG_AREA_WIDTH && x < leftMarkerPx + DRAG_AREA_WIDTH || x > rightMarkerPx - DRAG_AREA_WIDTH && x < rightMarkerPx + DRAG_AREA_WIDTH || isLeftMarkerDragging || isRightMarkerDragging) {
      setCursorStyle('ew-resize');
    } else {
      setCursorStyle('auto');
    }

    var isDragging = isLeftMarkerDragging || isRightMarkerDragging;

    if (isTimeSliderHoverOn && !isDragging) {
      setNewRoundedTime(x, centerTime, width, secondsPerPx, timeStep, dataStartTime, dataEndTime, onSetNewDate);
    }
  };

  React.useEffect(function () {
    setLocalAnimationStartTime(animationStartTime && moment.utc(animationStartTime).unix());
    setLocalAnimationEndTime(animationEndTime && moment.utc(animationEndTime).unix());
  }, [animationStartTime, animationEndTime]);
  var handleKeyDown = React.useCallback(function (event) {
    if (event.ctrlKey && dataStartTime && dataEndTime && mapIsActive) {
      switch (event.code) {
        case 'ArrowLeft':
          setPreviousTimeStep(timeStep, curTime, dataStartTime, onSetNewDate);
          break;

        case 'ArrowRight':
          setNextTimeStep(timeStep, curTime, dataEndTime, onSetNewDate);
          break;
      }
    }
  }, [curTime, onSetNewDate, timeStep, dataStartTime, dataEndTime, mapIsActive]);
  React.useEffect(function () {
    document.addEventListener('keydown', handleKeyDown);
    return function () {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]); // Only add/remove event listener when listener changes, that is, NOT necessarily between every re-render.

  var _useCanvasTarget = useCanvasTarget('mousedown'),
      _useCanvasTarget2 = _slicedToArray(_useCanvasTarget, 2),
      isAllowedCanvasNodePointed = _useCanvasTarget2[0],
      node = _useCanvasTarget2[1];

  var _React$useState13 = React.useState(-1),
      _React$useState14 = _slicedToArray(_React$useState13, 2),
      width = _React$useState14[0],
      setWidth = _React$useState14[1]; // Move the time slider if selected time has moved too close to the edge


  var selectedTimeUnix = selectedTime.unix();
  var autoMoveAreaWidth = getAutoMoveAreaWidth(scale);
  React.useLayoutEffect(function () {
    if (width === -1) return;
    var selectedTimePx = timestampToPixel(selectedTimeUnix, centerTime, width, secondsPerPx);

    if (selectedTimePx <= autoMoveAreaWidth) {
      onSetCenterTime(moveRelativeToTimePoint(selectedTimeUnix, autoMoveAreaWidth, secondsPerPx, width));
    }

    if (width - selectedTimePx <= autoMoveAreaWidth) {
      onSetCenterTime(moveRelativeToTimePoint(selectedTimeUnix, width - autoMoveAreaWidth, secondsPerPx, width));
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [selectedTimeUnix]);
  var theme = useTheme();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.timeSliderRail,
    style: {
      cursor: cursorStyle
    },
    "data-testid": "timeSliderRail"
  }, /*#__PURE__*/React.createElement(CanvasComponent, {
    ref: node,
    onMouseDown: onMouseDown,
    onMouseMove: onMouseMove,
    onMouseUp: onMouseUpTouchEnd,
    onTouchStart: onTouchStart,
    onTouchEnd: onMouseUpTouchEnd,
    onWheel: onWheel,
    resizeCallback: function resizeCallback(newWidth) {
      return setWidth(newWidth);
    },
    onCanvasClick: function onCanvasClick(x, y, width) {
      var isCanvasArea = x >= 0 && x < width;
      var isDragging = isLeftMarkerDragging || isRightMarkerDragging;

      if (isCanvasArea) {
        if (!isDragging) {
          var _map7 = [localAnimationStartTime, localAnimationEndTime].map(function (timestamp) {
            return timestampToPixel(timestamp, centerTime, width, secondsPerPx);
          }),
              _map8 = _slicedToArray(_map7, 2),
              leftMarkerPx = _map8[0],
              rightMarkerPx = _map8[1];

          var isAnimationDraggingArea = x > leftMarkerPx - DRAG_AREA_WIDTH && x < leftMarkerPx + DRAG_AREA_WIDTH || x > rightMarkerPx - DRAG_AREA_WIDTH && x < rightMarkerPx + DRAG_AREA_WIDTH;

          if (!isAnimationDraggingArea && !isAnimationDragged && isAllowedCanvasNodePointed) {
            setNewRoundedTime(x, centerTime, width, secondsPerPx, timeStep, dataStartTime, dataEndTime, onSetNewDate);
          }

          setAnimationDragged(false);
        }

        if (isDragging) {
          onMouseTouchMoveActions(x, y, width);
        }
      }
    },
    onRenderCanvas: function onRenderCanvas(ctx, width, height) {
      renderTimeSliderRailWithNeedle(ctx, theme, width, height, centerTime, selectedTime.unix(), secondsPerPx, scale, localAnimationStartTime, localAnimationEndTime, dataStartTime, dataEndTime, currentTime);
    }
  }));
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */
var useStyles$6 = makeStyles({
  container: {
    display: 'grid',
    gridTemplateColumns: 'minmax(100px, 210px) minmax(66%, 1fr)',
    gridTemplateRows: '50px'
  },
  scaleSlider: {
    height: '50px'
  }
});

var useTimeSliderKeyBoardControl = function useTimeSliderKeyBoardControl(mapIsActive, isVisible, onToggleTimeSlider) {
  React.useEffect(function () {
    var handleKeyDown = function handleKeyDown(event) {
      var target = event.target;

      if (target.tagName !== 'INPUT' && event.key === 't' && mapIsActive) {
        onToggleTimeSlider(!isVisible);
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return function () {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [mapIsActive, isVisible, onToggleTimeSlider]);
};

var defaultProps = {
  centerTime: moment.utc().startOf('day').hours(12).unix(),
  secondsPerPx: 5,
  selectedTime: moment.utc().startOf('day').hours(12),
  dataScaleToSecondsPerPx: defaultDataScaleToSecondsPerPx
};

var TimeSlider = function TimeSlider(_ref) {
  var buttons = _ref.buttons,
      rail = _ref.rail,
      scaleSlider = _ref.scaleSlider,
      legend = _ref.legend,
      _ref$mapIsActive = _ref.mapIsActive,
      mapIsActive = _ref$mapIsActive === void 0 ? true : _ref$mapIsActive,
      _ref$isVisible = _ref.isVisible,
      isVisible = _ref$isVisible === void 0 ? true : _ref$isVisible,
      _ref$onToggleTimeSlid = _ref.onToggleTimeSlider,
      onToggleTimeSlider = _ref$onToggleTimeSlid === void 0 ? function () {} : _ref$onToggleTimeSlid;
  var styles = useStyles$6();
  useTimeSliderKeyBoardControl(mapIsActive, isVisible, onToggleTimeSlider);
  return isVisible ? /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: styles.container,
    "data-testid": "timeSlider"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, " ", buttons || /*#__PURE__*/React.createElement(TimeSliderButtons, null), " "), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, rail || /*#__PURE__*/React.createElement(TimeSliderRail, Object.assign({}, defaultProps, {
    selectedTime: defaultProps.selectedTime,
    mapIsActive: mapIsActive
  })), ' '), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    className: styles.scaleSlider
  }, scaleSlider || /*#__PURE__*/React.createElement(TimeSliderScaleSlider, Object.assign({}, defaultProps, {
    selectedTime: defaultProps.selectedTime.unix(),
    timeSliderScale: Scale.Hour,
    onChangeTimeSliderScale: function onChangeTimeSliderScale() {
      return null;
    }
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, legend || /*#__PURE__*/React.createElement(TimeSliderLegend, Object.assign({}, defaultProps, {
    selectedTime: defaultProps.selectedTime.unix(),
    mapIsActive: mapIsActive
  })), ' ')) : null;
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */
var connectRedux$4 = connect(function (store, props) {
  return {
    isAutoUpdating: isAutoUpdating(store, props.mapId)
  };
}, {
  toggleAutoUpdate: mapActions$1.toggleAutoUpdate
});
var AutoUpdateButtonConnectComponent = connectRedux$4(function (_ref) {
  var mapId = _ref.mapId,
      isAutoUpdating = _ref.isAutoUpdating,
      toggleAutoUpdate = _ref.toggleAutoUpdate;

  var onClick = function onClick() {
    toggleAutoUpdate({
      mapId: mapId,
      shouldAutoUpdate: !isAutoUpdating,
      origin: MapActionOrigin.map
    });
  };

  return /*#__PURE__*/React.createElement(AutoUpdateButton, {
    isAutoUpdating: isAutoUpdating,
    toggleAutoUpdate: onClick,
    disabled: false
  });
});
var AutoUpdateButtonConnect = connectRedux$4(AutoUpdateButtonConnectComponent);

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */
var connectRedux$3 = connect(function (store, props) {
  return {
    animationDelay: getMapAnimationDelay(store, props.mapId)
  };
}, {
  setMapAnimationDelay: mapActions$1.setAnimationDelay
});
var SpeedButtonConnect = connectRedux$3(function (_ref) {
  var animationDelay = _ref.animationDelay,
      mapId = _ref.mapId,
      setMapAnimationDelay = _ref.setMapAnimationDelay;

  var onSetAnimationDelay = function onSetAnimationDelay(_animationDelay) {
    setMapAnimationDelay({
      mapId: mapId,
      animationDelay: _animationDelay,
      origin: MapActionOrigin.map
    });
  };

  return /*#__PURE__*/React.createElement(SpeedButton, {
    animationDelay: animationDelay,
    setMapAnimationDelay: onSetAnimationDelay
  });
});

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */

var TimeStepButtonComponent = function TimeStepButtonComponent(_ref) {
  var mapId = _ref.mapId;
  var dispatch = useDispatch();
  var timeStep = useSelector(function (store) {
    return getMapTimeStep(store, mapId);
  });
  var isAnimating$1 = useSelector(function (store) {
    return isAnimating(store, mapId);
  });
  var isTimestepAuto$1 = useSelector(function (store) {
    return isTimestepAuto(store, mapId);
  });
  var activeLayerId = useSelector(function (store) {
    return getActiveLayerId(store, mapId);
  });
  var activeLayerTimeDimension = useSelector(function (store) {
    return getLayerTimeDimension(store, activeLayerId);
  });
  var onToggleTimestepAuto = React.useCallback(function () {
    dispatch(mapActions$1.toggleTimestepAuto({
      mapId: mapId,
      timestepAuto: !isTimestepAuto$1,
      origin: MapActionOrigin.map
    }));
  }, [dispatch, isTimestepAuto$1, mapId]);
  var onSetTimeStep = React.useCallback(function (timeStep, origin) {
    dispatch(mapActions$1.setTimeStep(Object.assign({
      mapId: mapId,
      timeStep: timeStep
    }, origin && {
      origin: origin
    })));
  }, [dispatch, mapId]);
  return /*#__PURE__*/React.createElement(TimeStepButton, {
    timeStep: timeStep,
    onChangeTimeStep: onSetTimeStep,
    disabled: isAnimating$1,
    isTimestepAuto: isTimestepAuto$1,
    onToggleTimestepAuto: onToggleTimestepAuto,
    timeDimension: activeLayerTimeDimension
  });
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */
/**
 * OptionsMenuButtonConnect component with components connected to the store displaying the options menu button
 *
 * Expects the following props:
 * @param {string} mapId mapId: string - Id of the map
 * @example
 * ``` <OptionsMenuButtonConnect mapId={mapId} />```
 */

var OptionsMenuButtonConnect = function OptionsMenuButtonConnect(_ref) {
  var mapId = _ref.mapId;
  return /*#__PURE__*/React.createElement(OptionsMenuButton, {
    autoUpdateBtn: /*#__PURE__*/React.createElement(AutoUpdateButtonConnect, {
      mapId: mapId
    }),
    speedBtn: /*#__PURE__*/React.createElement(SpeedButtonConnect, {
      mapId: mapId
    }),
    timeStepBtn: /*#__PURE__*/React.createElement(TimeStepButtonComponent, {
      mapId: mapId
    })
  });
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */
/**
 * TimeSliderButtons component with components connected to the store displaying the time slider buttons
 *
 * Expects the following props:
 * @param {string} mapId mapId: string - Id of the map
 * @example
 * ``` <TimeSliderButtonsConnect mapId={mapId} />```
 */

var TimeSliderButtonsConnect = function TimeSliderButtonsConnect(_ref) {
  var mapId = _ref.mapId;
  return /*#__PURE__*/React.createElement(TimeSliderButtons, {
    autoUpdateBtn: /*#__PURE__*/React.createElement(AutoUpdateButtonConnect, {
      mapId: mapId
    }),
    optionsMenuBtn: /*#__PURE__*/React.createElement(OptionsMenuButtonConnect, {
      mapId: mapId
    }),
    playBtn: /*#__PURE__*/React.createElement(PlayButtonConnect, {
      mapId: mapId
    }),
    speedBtn: /*#__PURE__*/React.createElement(SpeedButtonConnect, {
      mapId: mapId
    }),
    timeStepBtn: /*#__PURE__*/React.createElement(TimeStepButtonComponent, {
      mapId: mapId
    })
  });
};

var connectRedux$2 = connect(function (store, props) {
  return {
    layers: getMapLayers(store, props.mapId),
    dimensions: getMapDimensions(store, props.mapId),
    scale: getMapTimeSliderScale(store, props.mapId),
    centerTime: getMapTimeSliderCenterTime(store, props.mapId),
    secondsPerPx: getMapTimeSliderSecondsPerPx(store, props.mapId),
    dataScaleToSecondsPerPx: getMapTimeSliderDataScaleToSecondsPerPx(store, props.mapId),
    isAnimating: isAnimating(store, props.mapId),
    timeStep: getMapTimeStep(store, props.mapId),
    isTimeSliderHoverOn: isTimeSliderHoverOn(store, props.mapId),
    timeValue: getTime(getSynchronizationGroupStore(store), props.sourceId),
    animationStartTime: getAnimationStartTime(store, props.mapId),
    animationEndTime: getAnimationEndTime(store, props.mapId),
    activeWindowId: getActiveWindowId(store)
  };
}, {
  stopMapAnimation: mapActions$1.mapStopAnimation,
  setTime: genericActions.setTime,
  syncGroupAddSource: genericActions.syncGroupAddSource,
  syncGroupRemoveSource: genericActions.syncGroupRemoveSource,
  mapSetTimeSliderCenterTime: mapActions$1.setTimeSliderCenterTime,
  mapSetTimeSliderSecondsPerPx: mapActions$1.setTimeSliderSecondsPerPx
});

var TimeSliderLegendConnect = function TimeSliderLegendConnect(_ref) {
  var sourceId = _ref.sourceId,
      mapId = _ref.mapId,
      dimensions = _ref.dimensions,
      scale = _ref.scale,
      centerTime = _ref.centerTime,
      secondsPerPx = _ref.secondsPerPx,
      dataScaleToSecondsPerPx = _ref.dataScaleToSecondsPerPx,
      layers = _ref.layers,
      isAnimating = _ref.isAnimating,
      timeStep = _ref.timeStep,
      isTimeSliderHoverOn = _ref.isTimeSliderHoverOn,
      animationStartTime = _ref.animationStartTime,
      animationEndTime = _ref.animationEndTime,
      activeWindowId = _ref.activeWindowId,
      stopMapAnimation = _ref.stopMapAnimation,
      setTime = _ref.setTime,
      syncGroupAddSource = _ref.syncGroupAddSource,
      syncGroupRemoveSource = _ref.syncGroupRemoveSource,
      mapSetTimeSliderCenterTime = _ref.mapSetTimeSliderCenterTime,
      mapSetTimeSliderSecondsPerPx = _ref.mapSetTimeSliderSecondsPerPx;

  var _getTimeBounds = getTimeBounds(dimensions),
      selectedTime = _getTimeBounds.selectedTime;

  var currentTime = moment.utc().unix();

  var _getDataLimitsFromLay = getDataLimitsFromLayers(layers),
      _getDataLimitsFromLay2 = _slicedToArray(_getDataLimitsFromLay, 2),
      dataStartTime = _getDataLimitsFromLay2[0],
      dataEndTime = _getDataLimitsFromLay2[1];

  var mapIsActive = mapId === activeWindowId;
  React.useEffect(function () {
    syncGroupAddSource({
      id: sourceId,
      type: [SYNCGROUPS_TYPE_SETTIME]
    });
    return function () {
      syncGroupRemoveSource({
        id: sourceId
      });
    };
  }, [sourceId, syncGroupAddSource, syncGroupRemoveSource]);
  return /*#__PURE__*/React.createElement(TimeSliderLegend, {
    centerTime: centerTime,
    secondsPerPx: secondsPerPx,
    dataScaleToSecondsPerPx: dataScaleToSecondsPerPx,
    selectedTime: selectedTime,
    scale: scale,
    currentTime: currentTime,
    isTimeSliderHoverOn: isTimeSliderHoverOn,
    dataStartTime: dataStartTime,
    dataEndTime: dataEndTime,
    animationStartTime: animationStartTime,
    animationEndTime: animationEndTime,
    timeStep: timeStep,
    mapIsActive: mapIsActive,
    onSetNewDate: function onSetNewDate(newDate) {
      if (isAnimating) {
        stopMapAnimation({
          mapId: mapId
        });
      }

      setTime({
        sourceId: sourceId,
        origin: 'TimeSliderConnect, 139',
        value: handleMomentISOString(newDate)
      });
    },
    onSetCenterTime: function onSetCenterTime(newTime) {
      mapSetTimeSliderCenterTime({
        mapId: mapId,
        timeSliderCenterTime: newTime
      });
    },
    onZoom: function onZoom(newSecondsPerPx, newCenterTime) {
      mapSetTimeSliderSecondsPerPx({
        mapId: mapId,
        timeSliderSecondsPerPx: newSecondsPerPx
      });
      mapSetTimeSliderCenterTime({
        mapId: mapId,
        timeSliderCenterTime: newCenterTime
      });
    }
  });
};
/**
 * TimeSliderLegend component connected to the store displaying a legend of the time slider
 *
 * Expects the following props:
 * @param {string} mapId mapId: string - Id of the map
 * @example
 * ``` <TimeSliderLegendConnect mapId={mapId} />```
 */


var TimeSliderLegendConnect$1 = connectRedux$2(TimeSliderLegendConnect);

var connectRedux$1 = connect(function (store, props) {
  return {
    timeStep: getMapTimeStep(store, props.mapId),
    layers: getMapLayers(store, props.mapId),
    dimensions: getMapDimensions(store, props.mapId),
    animationStartTime: getAnimationStartTime(store, props.mapId),
    animationEndTime: getAnimationEndTime(store, props.mapId),
    isAnimating: isAnimating(store, props.mapId),
    centerTime: getMapTimeSliderCenterTime(store, props.mapId),
    secondsPerPx: getMapTimeSliderSecondsPerPx(store, props.mapId),
    isTimeSliderHoverOn: isTimeSliderHoverOn(store, props.mapId),
    scale: getMapTimeSliderScale(store, props.mapId),
    timeValue: getTime(getSynchronizationGroupStore(store), props.sourceId),
    activeWindowId: getActiveWindowId(store)
  };
}, {
  setAnimationStartTime: mapActions$1.setAnimationStartTime,
  setAnimationEndTime: mapActions$1.setAnimationEndTime,
  setTime: genericActions.setTime,
  stopMapAnimation: mapActions$1.mapStopAnimation,
  syncGroupAddSource: genericActions.syncGroupAddSource,
  syncGroupRemoveSource: genericActions.syncGroupRemoveSource,
  mapSetTimeSliderCenterTime: mapActions$1.setTimeSliderCenterTime
});

var TimeSliderRailConnectComponent = function TimeSliderRailConnectComponent(_ref) {
  var sourceId = _ref.sourceId,
      mapId = _ref.mapId,
      dimensions = _ref.dimensions,
      timeStep = _ref.timeStep,
      layers = _ref.layers,
      animationStartTime = _ref.animationStartTime,
      animationEndTime = _ref.animationEndTime,
      isAnimating = _ref.isAnimating,
      centerTime = _ref.centerTime,
      secondsPerPx = _ref.secondsPerPx,
      isTimeSliderHoverOn = _ref.isTimeSliderHoverOn,
      scale = _ref.scale,
      activeWindowId = _ref.activeWindowId,
      setAnimationStartTime = _ref.setAnimationStartTime,
      setAnimationEndTime = _ref.setAnimationEndTime,
      stopMapAnimation = _ref.stopMapAnimation,
      setTime = _ref.setTime,
      syncGroupAddSource = _ref.syncGroupAddSource,
      syncGroupRemoveSource = _ref.syncGroupRemoveSource,
      mapSetTimeSliderCenterTime = _ref.mapSetTimeSliderCenterTime;

  var _getMomentTimeBounds = getMomentTimeBounds(dimensions),
      selectedTime = _getMomentTimeBounds.selectedTime;

  var currentTime = moment.utc().unix();

  var _getDataLimitsFromLay = getDataLimitsFromLayers(layers),
      _getDataLimitsFromLay2 = _slicedToArray(_getDataLimitsFromLay, 2),
      dataStartTime = _getDataLimitsFromLay2[0],
      dataEndTime = _getDataLimitsFromLay2[1];

  var mapIsActive = activeWindowId === mapId;
  React.useEffect(function () {
    syncGroupAddSource({
      id: sourceId,
      type: [SYNCGROUPS_TYPE_SETTIME]
    });
    return function () {
      syncGroupRemoveSource({
        id: sourceId
      });
    };
  }, [sourceId, syncGroupAddSource, syncGroupRemoveSource]);
  return /*#__PURE__*/React.createElement(TimeSliderRail, {
    centerTime: centerTime,
    secondsPerPx: secondsPerPx,
    timeStep: timeStep,
    selectedTime: selectedTime,
    animationStartTime: animationStartTime,
    animationEndTime: animationEndTime,
    currentTime: currentTime,
    dataStartTime: dataStartTime,
    dataEndTime: dataEndTime,
    scale: scale,
    onSetAnimationStartTime: function onSetAnimationStartTime(animationStartTime) {
      setAnimationStartTime({
        mapId: mapId,
        animationStartTime: animationStartTime
      });
    },
    onSetAnimationEndTime: function onSetAnimationEndTime(animationEndTime) {
      setAnimationEndTime({
        mapId: mapId,
        animationEndTime: animationEndTime
      });
    },
    onSetNewDate: function onSetNewDate(newDate) {
      if (isAnimating) {
        stopMapAnimation({
          mapId: mapId
        });
      }

      setTime({
        sourceId: sourceId,
        origin: 'TimeSliderRailConnect, 153',
        value: handleMomentISOString(newDate)
      });
    },
    isTimeSliderHoverOn: isTimeSliderHoverOn,
    onSetCenterTime: function onSetCenterTime(newTime) {
      mapSetTimeSliderCenterTime({
        mapId: mapId,
        timeSliderCenterTime: newTime
      });
    },
    mapIsActive: mapIsActive
  });
};

var TimeSliderRailConnect = connectRedux$1(TimeSliderRailConnectComponent);

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */
var connectReduxTimeSliderScaleSlider = connect(function (store, props) {
  return {
    layers: getMapLayers(store, props.mapId),
    timeSliderScale: getMapTimeSliderScale(store, props.mapId),
    centerTime: getMapTimeSliderCenterTime(store, props.mapId),
    secondsPerPx: getMapTimeSliderSecondsPerPx(store, props.mapId),
    dimensions: getMapDimensions(store, props.mapId)
  };
}, {
  mapSetTimeSliderScale: mapActions$1.setTimeSliderScale,
  mapSetTimeSliderDataScaleToSecondsPerPx: mapActions$1.setTimeSliderDataScaleToSecondsPerPx,
  mapSetTimeSliderCenterTime: mapActions$1.setTimeSliderCenterTime
});

var TimeSliderScaleSliderComponent = function TimeSliderScaleSliderComponent(_ref) {
  var timeSliderScale = _ref.timeSliderScale,
      mapId = _ref.mapId,
      layers = _ref.layers,
      centerTime = _ref.centerTime,
      secondsPerPx = _ref.secondsPerPx,
      dimensions = _ref.dimensions,
      mapSetTimeSliderScale = _ref.mapSetTimeSliderScale,
      mapSetTimeSliderDataScaleToSecondsPerPx = _ref.mapSetTimeSliderDataScaleToSecondsPerPx,
      mapSetTimeSliderCenterTime = _ref.mapSetTimeSliderCenterTime;

  var onSetTimeSliderScale = function onSetTimeSliderScale(scale, newCenterTime, scaleToSecPerPx) {
    if (scale === Scale.DataScale) {
      mapSetTimeSliderDataScaleToSecondsPerPx({
        mapId: mapId,
        timeSliderDataScaleToSecondsPerPx: scaleToSecPerPx
      });
    }

    mapSetTimeSliderScale({
      mapId: mapId,
      timeSliderScale: scale
    });
    mapSetTimeSliderCenterTime({
      mapId: mapId,
      timeSliderCenterTime: newCenterTime
    });
  };

  var _getTimeBounds = getTimeBounds(dimensions),
      selectedTime = _getTimeBounds.selectedTime;

  return /*#__PURE__*/React.createElement(TimeSliderScaleSlider, {
    layers: layers,
    timeSliderScale: timeSliderScale,
    onChangeTimeSliderScale: onSetTimeSliderScale,
    secondsPerPx: secondsPerPx,
    centerTime: centerTime,
    selectedTime: selectedTime
  });
};
/**
 * TimeSliderScaleSlider component connected to the store displaying a scale slider of the time slider
 *
 * Expects the following props:
 * @param {string} mapId mapId: string - Id of the map
 * @example
 * ``` <TimeSliderScaleSliderConnect mapId={mapId} />```
 */


var TimeSliderScaleSliderConnect = connectReduxTimeSliderScaleSlider(TimeSliderScaleSliderComponent);

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */
var connectRedux = connect(function (store, props) {
  return {
    isTimeSliderHoverOn: isTimeSliderHoverOn(store, props.mapId),
    activeWindowId: getActiveWindowId(store),
    isTimeSliderVisible: isTimeSliderVisible(store, props.mapId)
  };
}, {
  toggleTimeSliderHover: mapActions$1.toggleTimeSliderHover,
  toggleTimeSliderIsVisible: mapActions$1.toggleTimeSliderIsVisible
});

var ConnectedTimeSlider = function ConnectedTimeSlider(_ref) {
  var sourceId = _ref.sourceId,
      mapId = _ref.mapId,
      isTimeSliderHoverOn = _ref.isTimeSliderHoverOn,
      toggleTimeSliderHover = _ref.toggleTimeSliderHover,
      activeWindowId = _ref.activeWindowId,
      isTimeSliderVisible = _ref.isTimeSliderVisible,
      toggleTimeSliderIsVisible = _ref.toggleTimeSliderIsVisible,
      _ref$isAlwaysVisible = _ref.isAlwaysVisible,
      isAlwaysVisible = _ref$isAlwaysVisible === void 0 ? false : _ref$isAlwaysVisible;
  // don't use redux state if isAlwaysVisible
  var isVisible = isAlwaysVisible || isTimeSliderVisible;
  var mapIsActive = mapId === activeWindowId; // TODO: move keyboard logic to TimeSlider.tsx

  React.useEffect(function () {
    var handleKeyDown = function handleKeyDown(event) {
      if (event.ctrlKey && event.altKey && event.key === 'h') {
        toggleTimeSliderHover({
          mapId: mapId,
          isTimeSliderHoverOn: !isTimeSliderHoverOn
        });
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return function () {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [mapId, isTimeSliderHoverOn, toggleTimeSliderHover]);

  var onToggleTimeSliderVisibility = function onToggleTimeSliderVisibility(isTimeSliderVisible) {
    toggleTimeSliderIsVisible({
      mapId: mapId,
      isTimeSliderVisible: isTimeSliderVisible,
      origin: MapActionOrigin.map
    });
  };

  return /*#__PURE__*/React.createElement(TimeSlider, {
    buttons: /*#__PURE__*/React.createElement(TimeSliderButtonsConnect, {
      mapId: mapId
    }),
    rail: /*#__PURE__*/React.createElement(TimeSliderRailConnect, {
      mapId: mapId,
      sourceId: sourceId
    }),
    scaleSlider: /*#__PURE__*/React.createElement(TimeSliderScaleSliderConnect, {
      mapId: mapId
    }),
    legend: /*#__PURE__*/React.createElement(TimeSliderLegendConnect$1, {
      mapId: mapId,
      sourceId: sourceId
    }),
    mapIsActive: mapIsActive,
    onToggleTimeSlider: onToggleTimeSliderVisibility,
    isVisible: isVisible
  });
};
/**
 * TimeSlider component with components connected to the store displaying the time slider
 *
 * Expects the following props:
 * @param {string} mapId mapId: string - Id of the map
 * @param {string} sourceId sourceId: string - Source Id of the timeslider
 * @example
 * ``` <TimeSliderConnect sourceId="timeslider-1" mapId={mapId} />```
 */


var TimeSliderConnect = connectRedux(ConnectedTimeSlider);

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */
var useStyles$5 = makeStyles({
  MapViewLayer: {
    width: '100%',
    padding: '2px',
    margin: 0,
    wordWrap: 'break-word',
    border: '1px solid rgba(0, 0, 0, 0.5)',
    lineHeight: '14px',
    fontSize: '10px',
    background: 'rgba(255, 255, 255, 0.5)',
    display: 'none'
  }
});

var MapViewLayer = function MapViewLayer(props) {
  var id = props.id;
  var classes = useStyles$5();
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "mapViewLayer",
    className: classes.MapViewLayer
  }, /*#__PURE__*/React.createElement("div", null, id), /*#__PURE__*/React.createElement("div", {
    // eslint-disable-next-line react/no-danger
    dangerouslySetInnerHTML: {
      __html: JSON.stringify(props, null, '--').replace(new RegExp('\\n', 'g'), '<br/>')
    }
  }));
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */

var ReactMapViewLayer = function ReactMapViewLayer(props) {
  var id = props.id;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      width: '100%',
      padding: '2px',
      margin: 0,
      wordWrap: 'break-word',
      border: '1px solid rgba(0, 0, 0, 0.5)',
      lineHeight: '14px',
      fontSize: '10px',
      background: 'rgba(255, 255, 255, 0.5)',
      display: 'none'
    }
  }, /*#__PURE__*/React.createElement("div", null, id), /*#__PURE__*/React.createElement("div", {
    // eslint-disable-next-line react/no-danger
    dangerouslySetInnerHTML: {
      __html: JSON.stringify(props, null, '--').replace(new RegExp('\\n', 'g'), '<br/>')
    }
  }));
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */
var tileRenderSettings = {
  WorldMap_Light_Grey_Canvas: {
    'EPSG:3857': {
      home: 'https://knmi-geoweb-assets.s3-eu-west-1.amazonaws.com/WorldMap_Light_Grey_Canvas/EPSG3857/',
      minLevel: 0,
      maxLevel: 9,
      tileServerType: 'osm',
      copyRight: 'Natural Earth II | Ingmapping'
    }
  },
  OpenStreetMap_NL: {
    'EPSG:3857': {
      home: 'https://knmi-geoweb-assets.s3-eu-west-1.amazonaws.com/OpenStreetMap_NL/EPSG3857/',
      minLevel: 0,
      maxLevel: 16,
      tileServerType: 'osm',
      copyRight: 'OpenStreetMap - contributors | Ingmapping'
    }
  },
  OpenStreets_NL: {
    'EPSG:3857': {
      home: 'https://knmi-geoweb-assets.s3-eu-west-1.amazonaws.com/OpenStreets_NL/EPSG3857/',
      minLevel: 0,
      maxLevel: 16,
      tileServerType: 'osm',
      copyRight: 'OpenStreetMap - contributors | Ingmapping'
    },
    'EPSG:28992': {
      home: 'https://knmi-geoweb-assets.s3-eu-west-1.amazonaws.com/OpenStreets_NL/EPSG28992/',
      minLevel: 0,
      maxLevel: 16,
      tileServerType: 'osm',
      copyRight: 'Natural Earth II | Ingmapping'
    }
  },
  Positron_NL: {
    'EPSG:3857': {
      home: 'https://knmi-geoweb-assets.s3-eu-west-1.amazonaws.com/Positron_NL/EPSG3857/',
      minLevel: 0,
      maxLevel: 16,
      tileServerType: 'osm',
      copyRight: 'OpenStreetMap - contributors | OpenMapTiles | Ingmapping'
    }
  },
  Positron_NL_NoLabels: {
    'EPSG:3857': {
      home: 'https://knmi-geoweb-assets.s3-eu-west-1.amazonaws.com/Positron_NL_NoLabels/EPSG3857/',
      minLevel: 0,
      maxLevel: 16,
      tileServerType: 'osm',
      copyRight: 'OpenStreetMap - contributors | OpenMapTiles | Ingmapping'
    }
  },
  Klokantech_Basic_NL: {
    'EPSG:3857': {
      home: 'https://knmi-geoweb-assets.s3-eu-west-1.amazonaws.com/Klokantech_Basic_NL/EPSG3857/',
      minLevel: 0,
      maxLevel: 16,
      tileServerType: 'osm',
      copyRight: 'OpenStreetMap - contributors | OpenMapTiles | Ingmapping'
    }
  },
  Klokantech_Basic_NL_NoLabels: {
    'EPSG:3857': {
      home: 'https://knmi-geoweb-assets.s3-eu-west-1.amazonaws.com/Klokantech_Basic_NL_NoLabels/EPSG3857/',
      minLevel: 0,
      maxLevel: 16,
      tileServerType: 'osm',
      copyRight: 'OpenStreetMap - contributors | OpenMapTiles | Ingmapping'
    }
  },
  OSM_Blossom_NL: {
    'EPSG:3857': {
      home: 'https://knmi-geoweb-assets.s3-eu-west-1.amazonaws.com/OSM_Blossom_NL/EPSG3857/',
      minLevel: 0,
      maxLevel: 16,
      tileServerType: 'osm',
      copyRight: 'OpenStreetMap - contributors | Ingmapping'
    }
  },
  WorldMap: {
    'EPSG:3857': {
      home: 'https://knmi-geoweb-assets.s3-eu-west-1.amazonaws.com/WorldMap/EPSG3857/',
      minLevel: 0,
      maxLevel: 9,
      tileServerType: 'osm',
      copyRight: 'Natural Earth II | Ingmapping'
    },
    'TODO__EPSG:4326': {
      home: 'https://knmi-geoweb-assets.s3-eu-west-1.amazonaws.com/WorldMap/EPSG4326/',
      minLevel: 0,
      maxLevel: 9,
      origX: -180,
      origY: 90,
      resolution: 1.422222,
      tileServerType: 'osm',
      copyRight: 'Natural Earth II | Ingmapping'
    },
    'EPSG:3411': {
      home: 'https://knmi-geoweb-assets.s3-eu-west-1.amazonaws.com/WorldMap/EPSG3411/',
      minLevel: 3,
      maxLevel: 9,
      tileServerType: 'osm',
      copyRight: 'Natural Earth II | Ingmapping'
    },
    'EPSG:28992': {
      home: 'https://knmi-geoweb-assets.s3-eu-west-1.amazonaws.com/WorldMap/EPSG28992/',
      minLevel: 5,
      maxLevel: 9,
      tileServerType: 'osm',
      copyRight: 'Natural Earth II | Ingmapping'
    },
    'EPSG:3412': {
      home: 'https://knmi-geoweb-assets.s3-eu-west-1.amazonaws.com/WorldMap/EPSG3412/',
      minLevel: 3,
      maxLevel: 9,
      tileServerType: 'osm',
      copyRight: 'Natural Earth II | Ingmapping'
    },
    'EPSG:32661': {
      home: 'https://knmi-geoweb-assets.s3-eu-west-1.amazonaws.com/WorldMap/EPSG32661/',
      minLevel: 4,
      maxLevel: 9,
      tileServerType: 'osm',
      copyRight: 'Natural Earth II | Ingmapping'
    },
    'EPSG:54030': {
      home: 'https://knmi-geoweb-assets.s3-eu-west-1.amazonaws.com/WorldMap/EPSG54030/',
      minLevel: 3,
      maxLevel: 9,
      tileServerType: 'osm',
      copyRight: 'Natural Earth II | Ingmapping'
    },
    'EPSG:3575': {
      home: 'https://knmi-geoweb-assets.s3-eu-west-1.amazonaws.com/WorldMap/EPSG3575/',
      minLevel: 5,
      maxLevel: 9,
      tileServerType: 'osm',
      copyRight: 'Natural Earth II | Ingmapping'
    }
  },
  OSM_Antarctica: {
    'EPSG:3412': {
      home: 'https://knmi-geoweb-assets.s3-eu-west-1.amazonaws.com/OSM_Antarctica/EPSG3412/',
      minLevel: 1,
      maxLevel: 7,
      origX: -3000000,
      origY: 3000000,
      resolution: 23437.5,
      tileServerType: 'osm',
      copyRight: 'OpenStreetMap - contributors | Ingmapping'
    }
  },
  arcGisCanvas: {
    title: 'ArcGIS canvas map',
    'EPSG:3857': {
      home: 'https://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/',
      minLevel: 1,
      maxLevel: 16,
      tileServerType: 'arcgisonline',
      copyRight: 'Basemap copyright: 2013 ESRI, DeLorme, NAVTEQ'
    },
    'EPSG:28992': {
      home: 'https://services.arcgisonline.com/arcgis/rest/services/Basiskaarten/Canvas/MapServer/tile/',
      minLevel: 1,
      maxLevel: 12,
      origX: -285401.92,
      origY: 903401.92,
      resolution: 3440.64,
      tileServerType: 'arcgisonline',
      copyRight: 'Basiskaart bronnen: ESRI Nederland, ESRI, Kadaster, CBS en Rijkswaterstaat'
    }
  },
  arcGisTopo: {
    title: 'ArcGIS topo map',
    'EPSG:3857': {
      home: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/',
      minLevel: 1,
      maxLevel: 19,
      tileServerType: 'arcgisonline',
      copyRight: 'Basemap sources: ESRI, DeLorme, NAVTEQ, TomTom, Intermap, increment P Corp., GEBCO, USGS, FAO, NPS, NRCAN, GeoBase, IGN, Kadaster NL, Ordnance Survey, ESRI Japan, METI, ESRI China (Hong Kong), and the GIS User Community'
    },
    'EPSG:28992': {
      home: 'https://services.arcgisonline.com/arcgis/rest/services/Basiskaarten/Topo/MapServer/tile/',
      minLevel: 1,
      maxLevel: 12,
      origX: -285401.92,
      origY: 903401.92,
      resolution: 3440.64,
      tileServerType: 'arcgisonline',
      copyRight: 'Basiskaart bronnen: ESRI Nederland, ESRI, Kadaster, CBS, Min VROM, Rijkswaterstaat en gemeenten: Rotterdam, Breda, Tilburg'
    }
  },
  arcGisOceanBaseMap: {
    'EPSG:3857': {
      title: 'ArcGIS ocean map',
      home: 'https://services.arcgisonline.com/ArcGIS/rest/services/Ocean_Basemap/MapServer/tile/',
      minLevel: 1,
      maxLevel: 19,
      tileServerType: 'arcgisonline',
      copyRight: 'Basemap sources: ESRI, GEBCO, NOAA, National Geographic, DeLorme, NAVTEQ, Geonames.org, and other contributors'
    }
  },
  arcGisSat: {
    title: 'ArcGIS satellite map',
    'EPSG:4326': {
      home: 'https://services.arcgisonline.com/ArcGIS/rest/services/ESRI_Imagery_World_2D/MapServer/tile/',
      minLevel: 1,
      maxLevel: 15,
      tileServerType: 'arcgisonline',
      origX: -180,
      origY: 90,
      resolution: 0.3515625,
      tileSize: 512,
      copyRight: 'ESRI'
    },
    'EPSG:3857': {
      home: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/',
      minLevel: 1,
      maxLevel: 18,
      tileServerType: 'arcgisonline',
      copyRight: 'ESRI'
    }
  },
  OpenStreetMap_Service: {
    title: 'OpenStreetMap Service',
    'EPSG:3857': {
      home: 'https://b.tile.openstreetmap.org/',
      minLevel: 1,
      maxLevel: 16,
      tileServerType: 'osm',
      copyRight: 'OpenStreetMap - contributors'
    },
    'EPSG:28992': {
      home: 'https://services.arcgisonline.com/ArcGIS/rest/services/Basiskaarten/PDOK_BRT/MapServer/tile/',
      minLevel: 1,
      maxLevel: 12,
      origX: -285401.92,
      origY: 903401.92,
      resolution: 3440.64,
      tileServerType: 'arcgisonline',
      copyRight: 'Basiskaart bronnen: PDOK, Kadaster, OpenStreetMap'
    }
  },
  NaturalEarth2: {
    'EPSG:3411': {
      home: 'https://knmi-geoweb-assets.s3-eu-west-1.amazonaws.com/NaturalEarth2/EPSG3411/',
      minLevel: 1,
      maxLevel: 6,
      origX: -12400000,
      origY: 12400000,
      resolution: 96875,
      tileServerType: 'wmst',
      copyRight: 'NPS - Natural Earth II'
    },
    'EPSG:3412': {
      home: 'https://knmi-geoweb-assets.s3-eu-west-1.amazonaws.com/NaturalEarth2/EPSG3412/',
      minLevel: 1,
      maxLevel: 6,
      origX: -12400000,
      origY: 12400000,
      resolution: 96875,
      tileServerType: 'wmst',
      copyRight: 'NPS - Natural Earth II'
    },
    'EPSG:3575': {
      home: 'https://knmi-geoweb-assets.s3-eu-west-1.amazonaws.com/NaturalEarth2/EPSG3575/',
      minLevel: 1,
      maxLevel: 6,
      origX: -13000000,
      origY: 13000000,
      resolution: 101562.5,
      tileServerType: 'wmst',
      copyRight: 'NPS - Natural Earth II'
    },
    'EPSG:3857': {
      home: 'https://knmi-geoweb-assets.s3-eu-west-1.amazonaws.com/NaturalEarth2/EPSG3857/',
      minLevel: 1,
      maxLevel: 7,
      tileServerType: 'wmst',
      copyRight: 'NPS - Natural Earth II'
    },
    'EPSG:4258': {
      home: 'https://knmi-geoweb-assets.s3-eu-west-1.amazonaws.com/NaturalEarth2/EPSG4326/',
      minLevel: 1,
      maxLevel: 6,
      origX: -180,
      origY: 90,
      resolution: 0.703125,
      tileServerType: 'wmst',
      copyRight: 'NPS - Natural Earth II'
    },
    'EPSG:4326': {
      home: 'https://knmi-geoweb-assets.s3-eu-west-1.amazonaws.com/NaturalEarth2/EPSG4326/',
      minLevel: 1,
      maxLevel: 6,
      origX: -180,
      origY: 90,
      resolution: 0.703125,
      tileServerType: 'wmst',
      copyRight: 'NPS - Natural Earth II'
    },
    'EPSG:28992': {
      home: 'https://knmi-geoweb-assets.s3-eu-west-1.amazonaws.com/NaturalEarth2/EPSG28992/',
      minLevel: 1,
      maxLevel: 5,
      origX: -2999000,
      origY: 2995500,
      resolution: 23437,
      tileServerType: 'wmst',
      copyRight: 'NPS - Natural Earth II'
    },
    'EPSG:32661': {
      home: 'https://knmi-geoweb-assets.s3-eu-west-1.amazonaws.com/NaturalEarth2/EPSG32661/',
      minLevel: 1,
      maxLevel: 7,
      origX: -5000000,
      origY: 4000000,
      resolution: 58593.75,
      tileServerType: 'wmst',
      copyRight: 'NPS - Natural Earth II'
    },
    'EPSG:54030': {
      home: 'https://knmi-geoweb-assets.s3-eu-west-1.amazonaws.com/NaturalEarth2/EPSG54030/',
      minLevel: 1,
      maxLevel: 7,
      origX: -17000000,
      origY: 8625830,
      resolution: 132812.5,
      tileServerType: 'wmst',
      copyRight: 'NPS - Natural Earth II'
    }
  }
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */
var getCurrentDimensionValue = function getCurrentDimensionValue() {
  var dimensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var name = arguments.length > 1 ? arguments[1] : undefined;
  var currentDimension = dimensions.find(function (dim) {
    return dim.name === name;
  });
  return currentDimension === null || currentDimension === void 0 ? void 0 : currentDimension.currentValue;
};
var setServiceMetadata = function setServiceMetadata(wmLayer, mapId, webMapJSInstance, mapProperties, onUpdateLayerInformation) {
  var origin = LayerActionOrigin.ReactMapViewParseLayer;
  var service = WMGetServiceFromStore(wmLayer.service);
  /* Update list of layers for service */

  var done = function done(layers) {
    var updateObject = {
      origin: origin,
      serviceLayers: {
        name: wmLayer.title,
        id: service.id,
        serviceUrl: wmLayer.service,
        layers: layers,
        isUserAddedService: false
      },
      layerStyle: {
        origin: origin,
        layerId: wmLayer.ReactWMJSLayerId,
        style: wmLayer.currentStyle
      },
      mapDimensions: {
        origin: origin,
        mapId: mapId,
        dimensions: webMapJSInstance.mapdimensions.map(function (_ref) {
          var name = _ref.name,
              units = _ref.units,
              currentValue = _ref.currentValue,
              synced = _ref.synced;
          var reactDim = mapProperties.dimensions && mapProperties.dimensions.find(function (dim) {
            return dim.name === name;
          });
          var newDimValue = reactDim && reactDim.currentValue || currentValue;
          var newDimSynced = reactDim && reactDim.synced || synced;
          return {
            name: name,
            units: units,
            currentValue: newDimValue,
            synced: newDimSynced
          };
        })
      },
      layerDimensions: {
        origin: origin,
        layerId: wmLayer.id,
        dimensions: wmLayer.dimensions.map(function (dim) {
          var name = dim.name,
              units = dim.units,
              synced = dim.synced;
          var currentDimensionValue = getCurrentDimensionValue(wmLayer.dimensions, name);
          var newDimensionValue = currentDimensionValue || dim.getValue();
          return {
            name: name,
            units: units,
            currentValue: newDimensionValue,
            minValue: dim.getFirstValue(),
            maxValue: dim.getLastValue(),
            timeInterval: dim.getDimInterval(),
            values: dim.getValues(),
            synced: synced
          };
        })
      }
    };
    onUpdateLayerInformation && onUpdateLayerInformation(updateObject);
  };

  service.getLayerObjectsFlat(done, function () {// do nothing
  }, false, {
    headers: wmLayer.headers
  });
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */
/* Function which calculates the distance between two points */
// eslint-disable-next-line class-methods-use-this

var distance = function distance(a, b) {
  return Math.sqrt((a.x - b.x) * (a.x - b.x) + (a.y - b.y) * (a.y - b.y));
};

var checkHoverVertice = function checkHoverVertice(feature, mouseX, mouseY, convertGeoCoordsToScreenCoords, ignoreCoordinateIndexInFeature) {
  var maxDistance = 20;

  if (feature.geometry.type === 'Point') {
    var featureCoords = feature.geometry.coordinates;
    /* Get all vertexes */

    var XYCoords = convertGeoCoordsToScreenCoords([featureCoords]);

    if (XYCoords.length > 0 && distance(XYCoords[0], {
      x: mouseX,
      y: mouseY
    }) < maxDistance) {
      return {
        coordinateIndexInFeature: 0
      };
    }
  }

  if (feature.geometry.type === 'MultiPoint') {
    for (var polygonIndex = feature.geometry.coordinates.length - 1; polygonIndex >= 0; polygonIndex -= 1) {
      var _featureCoords = feature.geometry.coordinates[polygonIndex];

      if (_featureCoords === undefined) {
        // eslint-disable-next-line no-continue
        continue;
      }
      /* Get all vertexes */


      var _XYCoords = convertGeoCoordsToScreenCoords([_featureCoords]);

      if (_XYCoords.length > 0 && distance(_XYCoords[0], {
        x: mouseX,
        y: mouseY
      }) < maxDistance) {
        return {
          coordinateIndexInFeature: polygonIndex
        };
      }
    }
  }

  if (feature.geometry.type === 'Polygon') {
    var point = [mouseX, mouseY];

    for (var _polygonIndex = feature.geometry.coordinates.length - 1; _polygonIndex >= 0; _polygonIndex -= 1) {
      var _featureCoords2 = feature.geometry.coordinates[_polygonIndex];

      if (_featureCoords2 === undefined) {
        // eslint-disable-next-line no-continue
        continue;
      }
      /* Get all vertexes */


      var poly = [convertGeoCoordsToScreenCoords(_featureCoords2).map(function (coord) {
        return [coord.x, coord.y];
      })];

      try {
        var isPointInPoly = turf.booleanPointInPolygon(turf.point(point), turf.polygon(poly));

        if (isPointInPoly) {
          if (ignoreCoordinateIndexInFeature) {
            return {
              coordinateIndexInFeature: 0
            };
          }

          return {
            coordinateIndexInFeature: _polygonIndex
          };
        } // eslint-disable-next-line no-empty

      } catch (e) {}
    }
  }

  if (feature.geometry.type === 'MultiPolygon') {
    var _point = [mouseX, mouseY];

    for (var _polygonIndex2 = feature.geometry.coordinates.length - 1; _polygonIndex2 >= 0; _polygonIndex2 -= 1) {
      var _featureCoords3 = feature.geometry.coordinates[_polygonIndex2][0];

      if (_featureCoords3 === undefined) {
        // eslint-disable-next-line no-continue
        continue;
      }

      var _poly = [convertGeoCoordsToScreenCoords(_featureCoords3).map(function (coord) {
        return [coord.x, coord.y];
      })];

      try {
        var _isPointInPoly = turf.booleanPointInPolygon(turf.point(_point), turf.polygon(_poly));

        if (_isPointInPoly) {
          return {
            coordinateIndexInFeature: _polygonIndex2
          };
        } // eslint-disable-next-line no-empty

      } catch (e) {}
    }
  }

  if (feature.geometry.type === 'LineString') {
    var _featureCoords4 = feature.geometry.coordinates;
    /* Get all vertexes */

    var _XYCoords2 = convertGeoCoordsToScreenCoords(_featureCoords4);
    /* Snap to the vertex closer than specified pixels */


    for (var j = 0; j < _XYCoords2.length; j += 1) {
      var coord = _XYCoords2[j];

      if (distance(coord, {
        x: mouseX,
        y: mouseY
      }) < maxDistance) {
        return {
          coordinateIndexInFeature: j
        };
      }
    }
  }

  return null;
};

var checkHoverFeatures = function checkHoverFeatures(geojson, mouseX, mouseY, convertGeoCoordsToScreenCoords, ignoreCoordinateIndexInFeature) {
  for (var j = 0; j < geojson.features.length; j += 1) {
    var feature = geojson.features[j];
    var hoverResult = checkHoverVertice(feature, mouseX, mouseY, convertGeoCoordsToScreenCoords, ignoreCoordinateIndexInFeature);

    if (hoverResult != null) {
      return {
        coordinateIndexInFeature: hoverResult.coordinateIndexInFeature,
        featureIndex: j,
        feature: feature
      };
    }
  }

  return null;
};

var Proj4js = proj4; // Cache for for storing and reusing Proj4 instances

var projectorCache = {}; // Ensure that you have a Proj4 object, pulling from the cache if necessary

var getProj4 = function getProj4(projection) {
  if (projection instanceof Proj4js.Proj) {
    return projection;
  }

  if (projection in projectorCache) {
    return projectorCache[projection];
  } // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore


  projectorCache[projection] = new Proj4js.Proj(projection);
  return projectorCache[projection];
};

var emptyGeoJSON = {
  type: 'FeatureCollection',
  features: []
};
var featurePoint = {
  type: 'Feature',
  properties: {},
  geometry: {
    type: 'Point',
    coordinates: []
  }
};
var featureMultiPoint = {
  type: 'Feature',
  properties: {},
  geometry: {
    type: 'MultiPoint',
    coordinates: [[]]
  }
};
var featurePolygon = {
  type: 'Feature',
  properties: {},
  geometry: {
    type: 'Polygon',
    coordinates: [[]]
  }
};
var featureBox = {
  type: 'Feature',
  properties: {
    _adaguctype: 'box'
  },
  geometry: {
    type: 'Polygon',
    coordinates: [[]]
  }
};
var lineString = {
  type: 'FeatureCollection',
  features: [{
    type: 'Feature',
    properties: {
      stroke: '#66F',
      'stroke-width': 5,
      'stroke-opacity': '1'
    },
    geometry: {
      type: 'LineString',
      coordinates: [[]]
    }
  }]
};
var EDITMODE;

(function (EDITMODE) {
  EDITMODE["EMPTY"] = "EMPTY";
  EDITMODE["DELETE_FEATURES"] = "DELETE_FEATURES";
  EDITMODE["ADD_FEATURE"] = "ADD_FEATURE";
})(EDITMODE || (EDITMODE = {}));

var DRAWMODE;

(function (DRAWMODE) {
  DRAWMODE["POLYGON"] = "POLYGON";
  DRAWMODE["BOX"] = "BOX";
  DRAWMODE["MULTIPOINT"] = "MULTIPOINT";
  DRAWMODE["POINT"] = "POINT";
  DRAWMODE["LINESTRING"] = "LINESTRING";
})(DRAWMODE || (DRAWMODE = {}));

var VERTEX;

(function (VERTEX) {
  VERTEX["NONE"] = "NONE";
  VERTEX["MIDDLE_POINT_OF_FEATURE"] = "MIDDLE_POINT_OF_FEATURE";
})(VERTEX || (VERTEX = {}));

var EDGE;

(function (EDGE) {
  EDGE["NONE"] = "NONE";
})(EDGE || (EDGE = {}));

var SNAPPEDFEATURE;

(function (SNAPPEDFEATURE) {
  SNAPPEDFEATURE["NONE"] = "NONE";
})(SNAPPEDFEATURE || (SNAPPEDFEATURE = {}));

var DRAGMODE;

(function (DRAGMODE) {
  DRAGMODE["NONE"] = "NONE";
  DRAGMODE["VERTEX"] = "VERTEX";
  DRAGMODE["FEATURE"] = "FEATURE";
})(DRAGMODE || (DRAGMODE = {}));

var AdagucMapDraw = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(AdagucMapDraw, _React$PureComponent);

  var _super = _createSuper(AdagucMapDraw);

  function AdagucMapDraw(props) {
    var _this;

    _classCallCheck(this, AdagucMapDraw);

    _this = _super.call(this, props);

    _this.handleGeoJSONUpdate = function (newGeoJSON) {
      var featureNrToEdit = _this.props.featureNrToEdit;
      _this.geojson = cloneDeep(newGeoJSON);
      /* Ensure that this.snappedPolygonIndex is still within the coordinates array */

      if (_this.geojson && _this.geojson.features && featureNrToEdit < _this.geojson.features.length) {
        var feature = _this.geojson.features[featureNrToEdit];

        if (feature.geometry) {
          var coordinates = feature.geometry.coordinates;

          if (_this.snappedPolygonIndex > coordinates.length - 1) {
            _this.snappedPolygonIndex = coordinates.length - 1;
          }
        }
      }
    };

    _this.myEditMode = EDITMODE.EMPTY;
    _this.myDrawMode = DRAWMODE.POLYGON;
    _this.adagucBeforeDraw = _this.adagucBeforeDraw.bind(_assertThisInitialized(_this));
    _this.adagucMouseMove = _this.adagucMouseMove.bind(_assertThisInitialized(_this));
    _this.adagucMouseDown = _this.adagucMouseDown.bind(_assertThisInitialized(_this));
    _this.deleteFeature = _this.deleteFeature.bind(_assertThisInitialized(_this));
    _this.adagucMouseUp = _this.adagucMouseUp.bind(_assertThisInitialized(_this));
    _this.cancelEdit = _this.cancelEdit.bind(_assertThisInitialized(_this));
    _this.distance = _this.distance.bind(_assertThisInitialized(_this));
    _this.isBetween = _this.isBetween.bind(_assertThisInitialized(_this));
    _this.checkDist = _this.checkDist.bind(_assertThisInitialized(_this));
    _this.hoverEdge = _this.hoverEdge.bind(_assertThisInitialized(_this));
    _this.drawPolygon = _this.drawPolygon.bind(_assertThisInitialized(_this));
    _this.moveVertex = _this.moveVertex.bind(_assertThisInitialized(_this));
    _this.featureHasChanged = _this.featureHasChanged.bind(_assertThisInitialized(_this));
    _this.handleKeyDown = _this.handleKeyDown.bind(_assertThisInitialized(_this));
    _this.hoverVertex = _this.hoverVertex.bind(_assertThisInitialized(_this));
    _this.transposePolygon = _this.transposePolygon.bind(_assertThisInitialized(_this));
    _this.transposeVertex = _this.transposeVertex.bind(_assertThisInitialized(_this));
    _this.triggerMouseDownTimer = _this.triggerMouseDownTimer.bind(_assertThisInitialized(_this));
    _this.adagucMouseDoubleClick = _this.adagucMouseDoubleClick.bind(_assertThisInitialized(_this));
    _this.handleDrawMode = _this.handleDrawMode.bind(_assertThisInitialized(_this));
    _this.componentCleanup = _this.componentCleanup.bind(_assertThisInitialized(_this));
    _this.initializeFeature = _this.initializeFeature.bind(_assertThisInitialized(_this));
    _this.validatePolys = _this.validatePolys.bind(_assertThisInitialized(_this));
    _this.insertVertexInEdge = _this.insertVertexInEdge.bind(_assertThisInitialized(_this));
    _this.createNewFeature = _this.createNewFeature.bind(_assertThisInitialized(_this));
    _this.addPointToMultiPointFeature = _this.addPointToMultiPointFeature.bind(_assertThisInitialized(_this));
    _this.addVerticesToPolygonFeature = _this.addVerticesToPolygonFeature.bind(_assertThisInitialized(_this));
    _this.checkIfFeatureIsBox = _this.checkIfFeatureIsBox.bind(_assertThisInitialized(_this));

    _this.handleDrawMode(props.drawMode);

    _this.textPositions = [];
    _this.mouseOverPolygonCoordinates = [];
    _this.defaultPolyProps = {
      stroke: '#000',
      'stroke-width': 0.4,
      'stroke-opacity': 1,
      fill: '#33cc00',
      'fill-opacity': 1
    };
    _this.defaultLineStringProps = {
      stroke: '#000',
      'stroke-width': 1.5,
      'stroke-opacity': 1,
      fill: '#33cc00',
      'fill-opacity': 1
    };
    _this.defaultIconProps = {
      imageWidth: 30,
      imageHeight: 30
    };
    _this.somethingWasDragged = DRAGMODE.NONE;
    _this.mouseIsOverVertexNr = VERTEX.NONE;
    _this.selectedEdge = EDGE.NONE;

    if (props.geojson) {
      _this.geojson = cloneDeep(props.geojson);
    } else {
      _this.geojson = cloneDeep(emptyGeoJSON);

      _this.featureHasChanged('new');
    }

    _this.validatePolys(true);

    return _this;
  }

  _createClass(AdagucMapDraw, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          geojson = _this$props.geojson,
          isInEditMode = _this$props.isInEditMode,
          isInDeleteMode = _this$props.isInDeleteMode,
          drawMode = _this$props.drawMode;
      var prevGeojson = prevProps && prevProps.geojson;
      var prevIsInEditMode = prevProps && prevProps.isInEditMode;
      var prevIsInDeleteMode = prevProps && prevProps.isInDeleteMode;
      var prevDrawMode = prevProps && prevProps.drawMode;
      /* Handle geojson update */

      if (geojson !== prevGeojson) {
        this.handleGeoJSONUpdate(geojson);
      }
      /* Handle toggle edit */


      if (isInEditMode !== prevIsInEditMode) {
        if (isInEditMode === false && this.myEditMode !== EDITMODE.EMPTY) {
          this.cancelEdit(true);
          /* Throw away last vertice */

          if (this.myEditMode === EDITMODE.DELETE_FEATURES) {
            this.myEditMode = EDITMODE.EMPTY;
            return;
          }
        }
      }
      /* Handle toggle delete */


      if (isInDeleteMode !== prevIsInDeleteMode) {
        if (isInDeleteMode === true) {
          this.myEditMode = EDITMODE.DELETE_FEATURES;
        } else if (this.myEditMode === EDITMODE.DELETE_FEATURES) {
          this.myEditMode = EDITMODE.EMPTY;
        }
      }

      if (isInEditMode !== prevIsInEditMode || isInDeleteMode !== prevIsInDeleteMode) {
        if (isInEditMode === false && isInDeleteMode === false) {
          this.myEditMode = EDITMODE.EMPTY;
        }
      }
      /* Handle new drawmode */


      if (drawMode !== prevDrawMode) {
        /* Handle drawmode */
        this.handleDrawMode(drawMode);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.componentCleanup();
    }
  }, {
    key: "getPixelCoordFromGeoCoord",
    value: function getPixelCoordFromGeoCoord(featureCoords) {
      var webmapjs = this.props.webmapjs;

      var _webmapjs$getSize = webmapjs.getSize(),
          width = _webmapjs$getSize.width,
          height = _webmapjs$getSize.height;

      var bbox = webmapjs.getBBOX();
      var proj = webmapjs.getProj4();
      var XYCoords = [];
      var from = getProj4(proj.lonlat);
      var to = getProj4(proj.crs);

      for (var j = 0; j < featureCoords.length; j += 1) {
        // eslint-disable-next-line no-continue
        if (featureCoords[j].length < 2) continue;
        var coordinates = {
          x: featureCoords[j][0],
          y: featureCoords[j][1]
        };
        coordinates = proj.proj4.transform(from, to, coordinates);
        var x = width * (coordinates.x - bbox.left) / (bbox.right - bbox.left);
        var y = height * (coordinates.y - bbox.top) / (bbox.bottom - bbox.top);
        XYCoords.push({
          x: x,
          y: y
        });
      }

      return XYCoords;
    }
  }, {
    key: "componentCleanup",
    value: function componentCleanup() {
      // this will hold the cleanup code
      document.removeEventListener('keydown', this.handleKeyDown);
      var webmapjs = this.props.webmapjs;

      if (webmapjs !== undefined && this.listenersInitialized === true) {
        this.listenersInitialized = undefined;
        webmapjs.removeListener('beforecanvasdisplay', this.adagucBeforeDraw);
        webmapjs.removeListener('beforemousemove', this.adagucMouseMove);
        webmapjs.removeListener('beforemousedown', this.adagucMouseDown);
        webmapjs.removeListener('beforemouseup', this.adagucMouseUp);
        webmapjs.draw();
      }
    }
  }, {
    key: "transposePolygon",
    value: function transposePolygon(featureCoords) {
      var incX = this.mouseGeoCoord.x - this.snappedGeoCoords.x;
      var incY = this.mouseGeoCoord.y - this.snappedGeoCoords.y;

      for (var j = 0; j < featureCoords.length; j += 1) {
        /* eslint-disable-next-line no-param-reassign */
        featureCoords[j][0] += incX;
        /* eslint-disable-next-line no-param-reassign */

        featureCoords[j][1] += incY;
        this.snappedGeoCoords.x = this.mouseGeoCoord.x;
        this.snappedGeoCoords.y = this.mouseGeoCoord.y;
      }

      if (this.myEditMode !== EDITMODE.ADD_FEATURE) {
        this.somethingWasDragged = DRAGMODE.FEATURE;
      }
    }
  }, {
    key: "transposeVertex",
    value: function transposeVertex(featureCoords) {
      if (this.myEditMode !== EDITMODE.ADD_FEATURE) {
        this.somethingWasDragged = DRAGMODE.VERTEX;
      }

      if (this.myDrawMode === DRAWMODE.POINT) {
        /* eslint-disable-next-line no-param-reassign */
        featureCoords[0] = this.mouseGeoCoord.x;
        /* eslint-disable-next-line no-param-reassign */

        featureCoords[1] = this.mouseGeoCoord.y;
        return;
      }

      if (this.myDrawMode === DRAWMODE.LINESTRING) {
        // eslint-disable-next-line no-param-reassign
        featureCoords[this.mouseIsOverVertexNr][0] = this.mouseGeoCoord.x; // eslint-disable-next-line no-param-reassign

        featureCoords[this.mouseIsOverVertexNr][1] = this.mouseGeoCoord.y;
        return;
      }

      if (this.myDrawMode === DRAWMODE.MULTIPOINT) {
        if (this.mouseIsOverVertexNr !== SNAPPEDFEATURE.NONE) {
          // eslint-disable-next-line no-param-reassign
          featureCoords[this.mouseIsOverVertexNr][0] = this.mouseGeoCoord.x; // eslint-disable-next-line no-param-reassign

          featureCoords[this.mouseIsOverVertexNr][1] = this.mouseGeoCoord.y;
        }

        return;
      }

      if (this.myDrawMode === DRAWMODE.BOX && (featureCoords.length === 4 || featureCoords.length === 5)) {
        while (featureCoords.length < 4) {
          featureCoords.push([this.mouseGeoCoord.x, this.mouseGeoCoord.y]);
        }

        if (this.mouseIsOverVertexNr === 0) {
          featureCoords[0][0] = this.mouseGeoCoord.x;
          featureCoords[0][1] = this.mouseGeoCoord.y;
          featureCoords[1][0] = this.mouseGeoCoord.x;
          featureCoords[3][1] = this.mouseGeoCoord.y;
        }

        if (this.mouseIsOverVertexNr === 1) {
          featureCoords[1][0] = this.mouseGeoCoord.x;
          featureCoords[1][1] = this.mouseGeoCoord.y;
          featureCoords[0][0] = this.mouseGeoCoord.x;
          featureCoords[4][0] = this.mouseGeoCoord.x;
          featureCoords[2][1] = this.mouseGeoCoord.y;
        }

        if (this.mouseIsOverVertexNr === 2) {
          featureCoords[2][0] = this.mouseGeoCoord.x;
          featureCoords[2][1] = this.mouseGeoCoord.y;
          featureCoords[1][1] = this.mouseGeoCoord.y;
          featureCoords[3][0] = this.mouseGeoCoord.x;
        }

        if (this.mouseIsOverVertexNr === 3) {
          featureCoords[3][0] = this.mouseGeoCoord.x;
          featureCoords[3][1] = this.mouseGeoCoord.y;
          featureCoords[0][1] = this.mouseGeoCoord.y;
          featureCoords[4][1] = this.mouseGeoCoord.y;
          featureCoords[2][0] = this.mouseGeoCoord.x;
        }
        /* Ensure the box square shape */

        /* A: Left edge should be vertical */


        var _featureCoords = _slicedToArray(featureCoords, 4),
            _featureCoords$ = _slicedToArray(_featureCoords[0], 2),
            featureCoord0X = _featureCoords$[0],
            featureCoord0Y = _featureCoords$[1],
            _featureCoords$2 = _slicedToArray(_featureCoords[1], 1),
            featureCoord1X = _featureCoords$2[0],
            _featureCoords$3 = _slicedToArray(_featureCoords[2], 2),
            featureCoord2X = _featureCoords$3[0],
            featureCoord2Y = _featureCoords$3[1],
            _featureCoords$4 = _slicedToArray(_featureCoords[3], 2),
            featureCoord3Y = _featureCoords$4[1];

        featureCoords[0][0] = featureCoord1X;
        /* B: Top edge should be horizontal */

        featureCoords[0][1] = featureCoord3Y;
        /* C: Right edge should be vertical */

        featureCoords[3][0] = featureCoord2X;
        /* D: Bottom Edge should be horizontal */

        featureCoords[1][1] = featureCoord2Y;
        /* Close the box: Last point (point 5 of the box) should have the same coordinates as the starting point */

        featureCoords[4][0] = featureCoord0X;
        featureCoords[4][1] = featureCoord0Y;
      }

      if (this.myDrawMode === DRAWMODE.POLYGON) {
        featureCoords[this.mouseIsOverVertexNr][0] = this.mouseGeoCoord.x;
        featureCoords[this.mouseIsOverVertexNr][1] = this.mouseGeoCoord.y;
        /* Transpose begin and end vertice */

        if (this.mouseIsOverVertexNr === 0) {
          featureCoords[featureCoords.length - 1][0] = this.mouseGeoCoord.x;
          featureCoords[featureCoords.length - 1][1] = this.mouseGeoCoord.y;
        }
      }
    }
  }, {
    key: "moveVertex",
    value: function moveVertex(feature, mouseDown) {
      var featureType = feature.geometry.type;
      var featureCoords = feature.geometry.coordinates[this.snappedPolygonIndex];

      if (featureType === 'Point' || featureType === 'MultiPoint' || featureType === 'LineString') {
        featureCoords = feature.geometry.coordinates;
      }

      if (!featureCoords) {
        return;
      }

      var vertexSelected = mouseDown === true && this.mouseIsOverVertexNr !== VERTEX.NONE;

      if (vertexSelected || this.myEditMode === EDITMODE.ADD_FEATURE) {
        if (featureType === 'LineString') {
          this.transposeVertex(featureCoords); // eslint-disable-next-line consistent-return

          return false;
        }
        /* In case middle point is selected, transpose whole polygon */


        if (this.mouseIsOverVertexNr === VERTEX.MIDDLE_POINT_OF_FEATURE && this.snappedGeoCoords) {
          this.transposePolygon(featureCoords);
        } else if (this.mouseIsOverVertexNr !== VERTEX.NONE) {
          /* Transpose polygon vertex */
          this.transposeVertex(featureCoords);
        } // eslint-disable-next-line consistent-return


        return false;
      }
    }
  }, {
    key: "hoverVertex",
    value: function hoverVertex(feature, mouseX, mouseY) {
      var foundVertex = VERTEX.NONE;
      this.mouseIsOverVertexNr = VERTEX.NONE;

      if (feature.geometry.type === 'Point') {
        this.snappedPolygonIndex = SNAPPEDFEATURE.NONE;
        var featureCoords = feature.geometry.coordinates;
        /* Get all vertexes */

        var XYCoords = this.convertGeoCoordsToScreenCoords([featureCoords]);

        if (XYCoords.length > 0 && this.checkDist(XYCoords[0], 0, mouseX, mouseY)) {
          this.mouseIsOverVertexNr = 0;
          return;
        }
      }

      if (feature.geometry.type === 'MultiPoint') {
        this.snappedPolygonIndex = SNAPPEDFEATURE.NONE;

        for (var polygonIndex = feature.geometry.coordinates.length - 1; polygonIndex >= 0; polygonIndex -= 1) {
          var _featureCoords2 = feature.geometry.coordinates[polygonIndex];

          if (_featureCoords2 === undefined) {
            // eslint-disable-next-line no-continue
            continue;
          }
          /* Get all vertexes */


          var _XYCoords = this.convertGeoCoordsToScreenCoords([_featureCoords2]);

          if (_XYCoords.length > 0 && this.checkDist(_XYCoords[0], polygonIndex, mouseX, mouseY)) {
            this.mouseIsOverVertexNr = polygonIndex;
            return;
          }
        }
      }

      if (feature.geometry.type === 'Polygon') {
        for (var _polygonIndex = feature.geometry.coordinates.length - 1; _polygonIndex >= 0; _polygonIndex -= 1) {
          var _featureCoords3 = feature.geometry.coordinates[_polygonIndex];

          if (_featureCoords3 === undefined) {
            // eslint-disable-next-line no-continue
            continue;
          }
          /* Get all vertexes */


          var _XYCoords2 = this.convertGeoCoordsToScreenCoords(_featureCoords3);

          var middle = {
            x: 0,
            y: 0
          };
          /* Snap to the vertex closer than specified pixels */

          for (var j = 0; j < _XYCoords2.length - 1; j += 1) {
            var coord = _XYCoords2[j];
            middle.x += coord.x;
            middle.y += coord.y;

            if (this.checkDist(coord, _polygonIndex, mouseX, mouseY)) {
              foundVertex = j;
              break;
            }
          } // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore


          middle.x = parseInt(middle.x / (_XYCoords2.length - 1), 10); // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore

          middle.y = parseInt(middle.y / (_XYCoords2.length - 1), 10);
          /* Check if the mouse hovers the middle vertex */

          if (foundVertex === VERTEX.NONE && this.checkDist(middle, _polygonIndex, mouseX, mouseY)) {
            foundVertex = VERTEX.MIDDLE_POINT_OF_FEATURE;
          }

          this.mouseIsOverVertexNr = foundVertex;
        }
      }

      if (feature.geometry.type === 'LineString') {
        var lineStringIndex = 0;
        var _featureCoords4 = feature.geometry.coordinates;
        /* Get all vertexes */

        var _XYCoords3 = this.convertGeoCoordsToScreenCoords(_featureCoords4);
        /* Snap to the vertex closer than specified pixels */


        for (var _j = 0; _j < _XYCoords3.length; _j += 1) {
          var _coord2 = _XYCoords3[_j]; // if (!coord || coord.length < 2) continue;

          if (this.checkDist(_coord2, lineStringIndex, mouseX, mouseY)) {
            foundVertex = _j;
            break;
          }
        }

        this.mouseIsOverVertexNr = foundVertex;
      }
    }
  }, {
    key: "adagucMouseMove",
    value: function adagucMouseMove(event) {
      var _this2 = this;

      var _this$props2 = this.props,
          isInEditMode = _this$props2.isInEditMode,
          featureNrToEdit = _this$props2.featureNrToEdit,
          onHoverFeature = _this$props2.onHoverFeature;
      if (event && event.rightButton === true) return;
      /* adagucMouseMove is an event callback function which is triggered when the mouse moves over the map
        This event is only triggered if the map is in hover state.
        E.g. when the map is dragging/panning, this event is not triggerd
      */

      var mouseX = event.mouseX,
          mouseY = event.mouseY,
          mouseDown = event.mouseDown;
      this.mouseX = mouseX;
      this.mouseY = mouseY;

      if (onHoverFeature) {
        var handleMouseStoppedTimer = function handleMouseStoppedTimer() {
          var result = checkHoverFeatures(_this2.geojson, mouseX, mouseY, function (coordinates) {
            return _this2.convertGeoCoordsToScreenCoords(coordinates);
          });

          if (result) {
            var featureEvent = {
              coordinateIndexInFeature: result.coordinateIndexInFeature,
              featureIndex: result.featureIndex,
              mouseX: mouseX,
              mouseY: mouseY,
              isInEditMode: isInEditMode,
              feature: result.feature
            };
            onHoverFeature(featureEvent);
          }
        };

        window.clearTimeout(this.mouseStoppedTimer);
        this.mouseStoppedTimer = window.setTimeout(handleMouseStoppedTimer, 20);
      }

      if (isInEditMode === false) {
        return;
      }

      var feature = this.geojson.features[featureNrToEdit];
      if (!feature) return;
      var webmapjs = this.props.webmapjs;
      this.mouseGeoCoord = webmapjs.getLatLongFromPixelCoord({
        x: mouseX,
        y: mouseY
      });
      /* The mouse is hovering a vertice, and the mousedown is into effect, move vertice accordingly */

      var ret = this.moveVertex(feature, mouseDown);

      if (ret === false) {
        webmapjs.draw('AdagucMapDraw::adagucMouseMove'); // eslint-disable-next-line consistent-return

        return false;
      }
      /* Check if the mouse hovers any vertice of any polygon */


      this.hoverVertex(feature, mouseX, mouseY);

      if (this.mouseIsOverVertexNr !== VERTEX.NONE) {
        /* We found a vertex */
        this.selectedEdge = EDGE.NONE;
        /* We found a vertex, not an edge: reset it */

        webmapjs.setCursor('move');
        webmapjs.draw('AdagucMapDraw::hoverVertex'); // eslint-disable-next-line consistent-return

        return false;
      }

      webmapjs.setCursor();
      /* Check if the mouse hovers an edge of a polygon */

      this.selectedEdge = EDGE.NONE;

      if (this.myEditMode !== EDITMODE.DELETE_FEATURES && !this.checkIfFeatureIsBox(feature)) {
        var retObj = this.hoverEdge(feature.geometry, mouseX, mouseY); // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore

        this.selectedEdge = retObj.selectedEdge;
        this.snappedPolygonIndex = retObj.snappedPolygonIndex;
      }

      if (this.selectedEdge !== EDGE.NONE) {
        webmapjs.draw('AdagucMapDraw::adagucMouseMove'); // eslint-disable-next-line consistent-return

        return false;
      }

      if (this.myEditMode === EDITMODE.ADD_FEATURE) {
        // eslint-disable-next-line consistent-return
        return false;
      }
      /* We did not find anything under the mousecursor,
        return true means that the map will continue with its own mousehandling
      */


      if (this.mouseIsOverVertexNr === VERTEX.NONE && this.selectedEdge === EDGE.NONE) {
        webmapjs.draw('AdagucMapDraw::adagucMouseMove'); // eslint-disable-next-line consistent-return

        return true;
        /* False means that this component will take over entire controll.
          True means that it is still possible to pan and drag the map while editing */
      }
    }
    /* Returns true if double click is detected */

  }, {
    key: "triggerMouseDownTimer",
    value: function triggerMouseDownTimer(event) {
      var _this3 = this;

      if (!this.doubleClickTimer) this.doubleClickTimer = {};
      var mouseX = event.mouseX,
          mouseY = event.mouseY;

      var checkTimeOut = function checkTimeOut() {
        _this3.doubleClickTimer.isRunning = false;
      };
      /* Reset the timer */


      if (this.doubleClickTimer.timer) {
        clearTimeout(this.doubleClickTimer.timer);
        this.doubleClickTimer.timer = null;
      }
      /* Check if double click on this location occured */


      if (this.doubleClickTimer.isRunning === true) {
        if (mouseX === this.doubleClickTimer.mouseX && mouseY === this.doubleClickTimer.mouseY) {
          this.doubleClickTimer.isRunning = false;
          return true;
        }
      }
      /* Create new timer */


      this.doubleClickTimer.isRunning = true;
      this.doubleClickTimer.mouseX = mouseX;
      this.doubleClickTimer.mouseY = mouseY;
      this.doubleClickTimer.timer = window.setTimeout(checkTimeOut, 300);
      /* No double click detected, return false */

      return false;
    }
  }, {
    key: "adagucMouseDoubleClick",
    value: function adagucMouseDoubleClick() {
      this.handleKeyDown({
        keyCode: 27
      });
      return true;
    }
    /* Insert a new vertex into an edge, e.g a line is clicked and a point is added */

  }, {
    key: "insertVertexInEdge",
    value: function insertVertexInEdge(event) {
      var mouseX = event.mouseX,
          mouseY = event.mouseY;
      var _this$props3 = this.props,
          webmapjs = _this$props3.webmapjs,
          featureNrToEdit = _this$props3.featureNrToEdit;

      if (this.myDrawMode === DRAWMODE.POLYGON) {
        if (this.selectedEdge !== EDGE.NONE && this.myEditMode !== EDITMODE.DELETE_FEATURES) {
          this.mouseGeoCoord = webmapjs.getLatLongFromPixelCoord({
            x: mouseX,
            y: mouseY
          });
          var feature = this.geojson.features[featureNrToEdit];

          if (this.checkIfFeatureIsBox(feature)) {
            return false;
          }

          var featureCoords = feature.geometry.coordinates[this.snappedPolygonIndex];

          if (featureCoords === undefined) {
            return false;
          }

          featureCoords.splice(this.selectedEdge + 1, 0, [this.mouseGeoCoord.x, this.mouseGeoCoord.y]);
          this.featureHasChanged('insert vertex into line');
          this.adagucMouseMove(event);
          return false;
        }
      }

      if (this.myDrawMode === DRAWMODE.LINESTRING) {
        if (this.selectedEdge !== EDGE.NONE && this.myEditMode !== EDITMODE.DELETE_FEATURES) {
          this.mouseGeoCoord = webmapjs.getLatLongFromPixelCoord({
            x: mouseX,
            y: mouseY
          });
          var _feature = this.geojson.features[featureNrToEdit];

          if (this.checkIfFeatureIsBox(_feature)) {
            return false;
          }

          var _featureCoords5 = _feature.geometry.coordinates;

          if (_featureCoords5 === undefined) {
            return false;
          }

          _featureCoords5.splice(this.selectedEdge + 1, 0, [this.mouseGeoCoord.x, this.mouseGeoCoord.y]);

          this.featureHasChanged('insert vertex into line');
          this.adagucMouseMove(event);
          return false;
        }
      }

      return true;
    }
    /* This is trigged when a new feature is created.  */

  }, {
    key: "createNewFeature",
    value: function createNewFeature(event) {
      var mouseX = event.mouseX,
          mouseY = event.mouseY;
      var _this$props4 = this.props,
          webmapjs = _this$props4.webmapjs,
          featureNrToEdit = _this$props4.featureNrToEdit;

      if (this.myEditMode === EDITMODE.EMPTY) {
        this.myEditMode = EDITMODE.ADD_FEATURE;
        var feature = this.geojson.features[featureNrToEdit]; // eslint-disable-next-line no-multi-assign

        feature = this.geojson.features[featureNrToEdit] = this.initializeFeature(feature, this.myDrawMode);
        this.mouseGeoCoord = webmapjs.getLatLongFromPixelCoord({
          x: mouseX,
          y: mouseY
        });

        if (this.myDrawMode === DRAWMODE.POINT || this.myDrawMode === DRAWMODE.MULTIPOINT) {
          /* Create points */
          var pointGeometry = feature.geometry;
          if (pointGeometry) if (pointGeometry.coordinates === undefined) {
            pointGeometry.coordinates = [];
          }
          var multiPointGeometry = feature.geometry;
          if (multiPointGeometry) if (multiPointGeometry.coordinates === undefined) {
            multiPointGeometry.coordinates = [[]];
          }

          if (this.myDrawMode === DRAWMODE.POINT) {
            var featureCoords = pointGeometry.coordinates;
            featureCoords[0] = this.mouseGeoCoord.x;
            featureCoords[1] = this.mouseGeoCoord.y;
            this.snappedPolygonIndex = pointGeometry.coordinates.length - 1;
            /* For type POINT it is not possible to add multiple points to the same feature */

            this.myEditMode = EDITMODE.EMPTY;
            this.featureHasChanged('new point created');
          }

          if (this.myDrawMode === DRAWMODE.MULTIPOINT) {
            this.myEditMode = EDITMODE.EMPTY;
            var _featureCoords6 = multiPointGeometry.coordinates;

            if (_featureCoords6 === undefined) {
              _featureCoords6 = [];
            }

            if (_featureCoords6[0] === undefined || _featureCoords6[0].length === 0) {
              _featureCoords6[0] = [];
              /* Used to create the first polygon */
            } else {
              _featureCoords6.push([]);
              /* Used to create extra polygons in the same feature */

            } // featureCoords.push([this.mouseGeoCoord.x, this.mouseGeoCoord.y]);


            _featureCoords6[_featureCoords6.length - 1] = [this.mouseGeoCoord.x, this.mouseGeoCoord.y];
            this.snappedPolygonIndex = multiPointGeometry.coordinates.length - 1;
            this.featureHasChanged('new point in multipoint created');
          }
        }

        if (this.myDrawMode === DRAWMODE.POLYGON || this.myDrawMode === DRAWMODE.BOX) {
          /* Create poly's and boxes */
          this.myEditMode = EDITMODE.ADD_FEATURE;
          if (feature.geometry) if (feature.geometry.coordinates === undefined) {
            feature.geometry.coordinates = [[]];
          }

          if (feature.geometry.coordinates[0] === undefined || feature.geometry.coordinates[0].length === 0) {
            feature.geometry.coordinates[0] = [];
            /* Used to create the first polygon */
          } else {
            feature.geometry.coordinates.push([]);
            /* Used to create extra polygons in the same feature */
          }

          this.snappedPolygonIndex = feature.geometry.coordinates.length - 1;
          var _featureCoords7 = feature.geometry.coordinates[this.snappedPolygonIndex];

          _featureCoords7.push([this.mouseGeoCoord.x, this.mouseGeoCoord.y]);

          _featureCoords7.push([this.mouseGeoCoord.x, this.mouseGeoCoord.y]);
          /* This is triggered when a bounding box is created. Five points are added at once */


          if (this.myDrawMode === DRAWMODE.BOX) {
            _featureCoords7.push([this.mouseGeoCoord.x, this.mouseGeoCoord.y]);

            _featureCoords7.push([this.mouseGeoCoord.x, this.mouseGeoCoord.y]);

            _featureCoords7.push([this.mouseGeoCoord.x, this.mouseGeoCoord.y]);
          }

          if (this.myDrawMode === DRAWMODE.BOX) {
            this.mouseIsOverVertexNr = 3;
          } else {
            this.mouseIsOverVertexNr = _featureCoords7.length - 1;
          }

          this.featureHasChanged('new feature created');
        }

        if (this.myDrawMode === DRAWMODE.LINESTRING) {
          this.myEditMode = EDITMODE.EMPTY;
          /* Create linestring */

          this.myEditMode = EDITMODE.ADD_FEATURE;
          var _featureCoords8 = feature.geometry.coordinates;

          if (_featureCoords8 === undefined || _featureCoords8.length === 0) {
            _featureCoords8 = [[this.mouseGeoCoord.x, this.mouseGeoCoord.y]];
          }

          if (_featureCoords8[0].length === 0) {
            _featureCoords8[0] = [this.mouseGeoCoord.x, this.mouseGeoCoord.y];
          }

          _featureCoords8.push([this.mouseGeoCoord.x, this.mouseGeoCoord.y]);

          this.snappedPolygonIndex = 0;
          this.featureHasChanged('new point in LineString created');
          this.mouseIsOverVertexNr = _featureCoords8.length - 1;
        }

        webmapjs.draw('AdagucMapDraw::adagucMouseDown'); // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore

        return false;
      } // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore


      return true;
    }
    /* This is triggered when new points are added during the addmultipoint mode. One point is added per time */

  }, {
    key: "addPointToMultiPointFeature",
    value: function addPointToMultiPointFeature(event) {
      var mouseX = event.mouseX,
          mouseY = event.mouseY;
      var _this$props5 = this.props,
          webmapjs = _this$props5.webmapjs,
          featureNrToEdit = _this$props5.featureNrToEdit;

      if (this.myDrawMode === DRAWMODE.MULTIPOINT) {
        if (this.myEditMode === EDITMODE.ADD_FEATURE && this.snappedPolygonIndex !== SNAPPEDFEATURE.NONE) {
          this.mouseGeoCoord = webmapjs.getLatLongFromPixelCoord({
            x: mouseX,
            y: mouseY
          });
          var feature = this.geojson.features[featureNrToEdit];
          var featureCoords = feature.geometry.coordinates;
          featureCoords.push([this.mouseGeoCoord.x, this.mouseGeoCoord.y]);
          this.featureHasChanged('point added to multipoint');
          this.mouseIsOverVertexNr = VERTEX.NONE;
          this.adagucMouseMove(event);
          return false;
        }
      }

      return true;
    }
  }, {
    key: "addVerticesToPolygonFeature",
    value: function addVerticesToPolygonFeature(event) {
      var mouseX = event.mouseX,
          mouseY = event.mouseY;
      var _this$props6 = this.props,
          webmapjs = _this$props6.webmapjs,
          featureNrToEdit = _this$props6.featureNrToEdit;

      if (this.myDrawMode === DRAWMODE.POLYGON) {
        if (this.myEditMode === EDITMODE.ADD_FEATURE && this.snappedPolygonIndex !== SNAPPEDFEATURE.NONE) {
          this.mouseGeoCoord = webmapjs.getLatLongFromPixelCoord({
            x: mouseX,
            y: mouseY
          });
          var feature = this.geojson.features[featureNrToEdit];
          var featureCoords = feature.geometry.coordinates[this.snappedPolygonIndex];
          featureCoords.push([this.mouseGeoCoord.x, this.mouseGeoCoord.y]);
          this.featureHasChanged('vertex added to polygon');
          this.mouseIsOverVertexNr = featureCoords.length - 1;
          this.adagucMouseMove(event);
          return false;
        }
      }
    }
  }, {
    key: "addPointToLineStringFeature",
    value: function addPointToLineStringFeature(event) {
      var mouseX = event.mouseX,
          mouseY = event.mouseY;
      var _this$props7 = this.props,
          webmapjs = _this$props7.webmapjs,
          featureNrToEdit = _this$props7.featureNrToEdit;

      if (this.myDrawMode === DRAWMODE.LINESTRING) {
        if (this.myEditMode === EDITMODE.ADD_FEATURE) {
          this.mouseGeoCoord = webmapjs.getLatLongFromPixelCoord({
            x: mouseX,
            y: mouseY
          });
          var feature = this.geojson.features[featureNrToEdit];
          var featureCoords = feature.geometry.coordinates;
          featureCoords.push([this.mouseGeoCoord.x, this.mouseGeoCoord.y]);
          this.featureHasChanged('vertex added to LineString');
          this.mouseIsOverVertexNr = featureCoords.length - 1;
          this.adagucMouseMove(event);
          return false;
        }
      }

      return true;
    }
  }, {
    key: "adagucMouseDown",
    value: function adagucMouseDown(event) {
      var isInEditMode = this.props.isInEditMode;
      if (event && event.rightButton === true) return;

      if (isInEditMode === false) {
        return;
      }

      if (this.triggerMouseDownTimer(event)) {
        // eslint-disable-next-line consistent-return
        return this.adagucMouseDoubleClick();
      }

      if (this.myEditMode === EDITMODE.ADD_FEATURE && this.myDrawMode === DRAWMODE.BOX) {
        // eslint-disable-next-line consistent-return
        return this.adagucMouseDoubleClick();
      }

      this.somethingWasDragged = DRAGMODE.NONE;

      if (this.mouseIsOverVertexNr !== VERTEX.NONE && this.myEditMode === EDITMODE.EMPTY) {
        // eslint-disable-next-line consistent-return
        return false;
      }
      /* Insert a new vertex into an edge, e.g a line is clicked and a point is added */
      // eslint-disable-next-line consistent-return


      if (this.insertVertexInEdge(event) === false) return false;
      /* This is trigged when a new feature is created.  */
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore

      if (this.createNewFeature(event) === false) {
        /* Start with mouse move from this mouse down location,  enables sizing the box while moving the mouse */
        this.adagucMouseMove(event);
        return false;
      }
      /* This is triggered when new points are added during the addmultipoint mode. One point is added per time */


      if (this.addPointToMultiPointFeature(event) === false) return false;
      /* This is triggered when new points are added during the addpolygon mode. One point is added per time */

      if (this.addVerticesToPolygonFeature(event) === false) return false;
      /* This is triggered when new points are added to a linestring */

      if (this.addPointToLineStringFeature(event) === false) return false;
      return false;
      /* False means that this component will take over entire controll.
         True means that it is still possible to pan and drag the map while editing */
    }
  }, {
    key: "deletePolygon",
    value: function deletePolygon(index) {
      var _this$props8 = this.props,
          featureNrToEdit = _this$props8.featureNrToEdit,
          deletePolygonCallback = _this$props8.deletePolygonCallback;
      var feature = this.geojson.features[featureNrToEdit];
      feature.geometry.coordinates.splice(index, 1);

      if (deletePolygonCallback) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        deletePolygonCallback();
      }
    }
  }, {
    key: "deleteFeature",
    value: function deleteFeature() {
      /* Deletes any features under the mousecursor */
      var _this$props9 = this.props,
          webmapjs = _this$props9.webmapjs,
          featureNrToEdit = _this$props9.featureNrToEdit;

      if (this.mouseIsOverVertexNr === VERTEX.NONE) {
        return;
      }

      var feature = this.geojson.features[featureNrToEdit];
      var featureCoords = feature.geometry.coordinates[this.snappedPolygonIndex];

      if (featureCoords === undefined) {
        return;
      }

      if (this.mouseIsOverVertexNr !== VERTEX.MIDDLE_POINT_OF_FEATURE) {
        /* Remove edge of polygon */
        if (featureCoords.length <= 3) {
          /* Remove the polygon completely if it can not have an area */
          this.deletePolygon(this.snappedPolygonIndex);
        } else {
          /* Remove edge of polygon */
          // eslint-disable-next-line no-lonely-if
          if (!this.checkIfFeatureIsBox(feature)) {
            featureCoords.splice(this.mouseIsOverVertexNr, 1);
          }
        }
      } else {
        /* Remove the polygon completely */
        this.deletePolygon(this.snappedPolygonIndex);
      }

      this.featureHasChanged('deleteFeature');
      this.selectedEdge = EDGE.NONE;
      this.mouseIsOverVertexNr = VERTEX.NONE;
      webmapjs.draw('AdagucMapDraw::deletefeatures');
    }
  }, {
    key: "adagucMouseUp",
    value: function adagucMouseUp(event) {
      var _this4 = this;

      var _this$props10 = this.props,
          isInEditMode = _this$props10.isInEditMode,
          onClickFeature = _this$props10.onClickFeature;
      if (event && event.rightButton === true) return;

      if (onClickFeature) {
        var mouseX = event.mouseX,
            mouseY = event.mouseY;
        var ignoreCoordinateIndexInFeature = true;
        var result = checkHoverFeatures(this.geojson, mouseX, mouseY, function (coordinates) {
          return _this4.convertGeoCoordsToScreenCoords(coordinates);
        }, ignoreCoordinateIndexInFeature);

        if (result) {
          var featureEvent = {
            coordinateIndexInFeature: result.coordinateIndexInFeature,
            featureIndex: result.featureIndex,
            mouseX: mouseX,
            mouseY: mouseY,
            isInEditMode: isInEditMode,
            feature: result.feature
          };
          onClickFeature(featureEvent);
        } else {
          onClickFeature(null);
        }
      }

      if (isInEditMode === false) {
        return;
      }
      /* Keep the mouse down to drag a box */


      if (this.myDrawMode === DRAWMODE.BOX && this.myEditMode === EDITMODE.ADD_FEATURE) {
        this.cancelEdit(false);
        return false;
      }

      if (this.somethingWasDragged !== DRAGMODE.NONE) {
        this.featureHasChanged("A ".concat(this.somethingWasDragged.toString(), " was dragged"));
      }
      /* Delete a vertex or feature on mouseUp */


      if (this.myEditMode === EDITMODE.DELETE_FEATURES) {
        this.deleteFeature();
        return false;
      }

      if (this.mouseIsOverVertexNr !== VERTEX.NONE || this.selectedEdge !== EDGE.NONE) {
        return false;
      }

      if (this.myEditMode === EDITMODE.ADD_FEATURE) {
        return false;
      }
    }
  }, {
    key: "cancelEdit",
    value: function cancelEdit(cancelLastPoint) {
      var _this$props11 = this.props,
          isInEditMode = _this$props11.isInEditMode,
          featureNrToEdit = _this$props11.featureNrToEdit;

      if (isInEditMode === false) {
        return;
      }

      var webmapjs = this.props.webmapjs;
      /* When in addpolygon mode, finish the polygon */

      if (this.myEditMode === EDITMODE.ADD_FEATURE) {
        this.myEditMode = EDITMODE.EMPTY;

        if (this.drawMode === DRAWMODE.POLYGON || this.drawMode === DRAWMODE.BOX) {
          if (this.snappedPolygonIndex === SNAPPEDFEATURE.NONE) {
            return;
          }

          var feature = this.geojson.features[featureNrToEdit];
          var coordinates = feature.geometry.coordinates;
          var polygon = coordinates[this.snappedPolygonIndex];

          if (!polygon) {
            coordinates[this.snappedPolygonIndex] = [];
            return;
          }

          if (polygon.length === 0) {
            return;
          }

          if (!this.checkIfFeatureIsBox(feature)) {
            if (cancelLastPoint === true) {
              polygon.pop();
            }

            if (polygon.length < 3) {
              coordinates.pop();
            }
          }
        }

        if (this.myDrawMode === DRAWMODE.LINESTRING) {
          var _feature2 = this.geojson.features[featureNrToEdit];
          var featureCoords = _feature2.geometry.coordinates;
          featureCoords.pop();
        }

        this.featureHasChanged('cancelEdit');
        webmapjs.draw('AdagucMapDraw::cancelEdit');
      } else {
        /* When in standard mode or deletefeatures mode, remove any vertex under the mousecursor */
        // eslint-disable-next-line no-lonely-if
        if (this.myEditMode === EDITMODE.EMPTY || this.myEditMode === EDITMODE.DELETE_FEATURES) {
          this.deleteFeature();
        }
      }
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(event) {
      var ESCAPE_KEY = 27;
      var exitDrawModeCallback = this.props.exitDrawModeCallback;

      if (event.keyCode === ESCAPE_KEY) {
        if (exitDrawModeCallback && (this.myEditMode === EDITMODE.EMPTY || this.myEditMode === EDITMODE.DELETE_FEATURES)) {
          exitDrawModeCallback();
        }

        this.cancelEdit(this.myDrawMode !== DRAWMODE.BOX);

        if (this.myDrawMode === DRAWMODE.POLYGON && exitDrawModeCallback) {
          exitDrawModeCallback();
        }

        if (this.myDrawMode === DRAWMODE.LINESTRING && exitDrawModeCallback) {
          exitDrawModeCallback();
        }
      }
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "validateFeature",
    value: function validateFeature(feature) {
      if (!feature.properties) feature.properties = {};
      if (!feature.geometry) feature.geometry = {};
      if (!feature.type) feature.type = 'Feature';
      if (!feature.geometry.coordinates) feature.geometry.coordinates = [];
    }
  }, {
    key: "validatePolys",
    value: function validatePolys(fixPolys) {
      if (!this.geojson || !this.geojson.features || !this.geojson.features.length) return;

      for (var featureIndex = 0; featureIndex < this.geojson.features.length; featureIndex += 1) {
        if (!this.geojson.features) this.geojson.features = [];
        var feature = this.geojson.features[featureIndex];
        this.validateFeature(feature);
        var featureType = feature.geometry.type;

        if (featureType === 'Polygon') {
          /* Loop through all polygons of the same feature */
          var polygonGeometry = feature.geometry;

          for (var polygonIndex = 0; polygonIndex < polygonGeometry.coordinates.length; polygonIndex += 1) {
            var featureCoords = polygonGeometry.coordinates[polygonIndex];
            /* Remove duplicates */

            if (!this.checkIfFeatureIsBox(feature)) {
              for (var coordIndex = featureCoords.length - 2; coordIndex >= 0; coordIndex -= 1) {
                var _startCoord = featureCoords[coordIndex];
                var _endCoord = featureCoords[coordIndex + 1];

                if (_startCoord && _endCoord) {
                  if (_startCoord[0] === _endCoord[0] && _startCoord[1] === _endCoord[1]) {
                    featureCoords.splice(coordIndex, 1);
                  }
                }
              }
              /* Add begin to end to make closed polygon */


              var startCoord = featureCoords[0];
              var endCoord = featureCoords[featureCoords.length - 1];

              if (startCoord && endCoord) {
                if (startCoord[0] !== endCoord[0] || startCoord[1] !== endCoord[1]) {
                  featureCoords.push(cloneDeep(startCoord));

                  if (this.mouseIsOverVertexNr !== VERTEX.NONE && this.mouseIsOverVertexNr !== VERTEX.MIDDLE_POINT_OF_FEATURE) {
                    /* This means that our selected vertex is one lower */
                    this.mouseIsOverVertexNr -= 1;
                  }
                }
              }
            }
            /* Sort clockwise */


            if (fixPolys) {
              var checkClockwiseOrder = function checkClockwiseOrder(featureCoordinates) {
                var sum = 0;

                for (var j = 0; j < featureCoordinates.length - 1; j += 1) {
                  var currentPoint = featureCoordinates[j];
                  var nextPoint = featureCoordinates[(j + 1) % featureCoordinates.length];
                  sum += (nextPoint[0] - currentPoint[0]) * (nextPoint[1] + currentPoint[1]);
                }

                return sum;
              };

              var sum = checkClockwiseOrder(featureCoords);

              if (sum < 0) {
                featureCoords = featureCoords.reverse();
                /* The lastly selected vertex is now aways the second in the array */

                if (this.mouseIsOverVertexNr !== VERTEX.NONE && this.mouseIsOverVertexNr !== VERTEX.MIDDLE_POINT_OF_FEATURE) {
                  this.mouseIsOverVertexNr = 1;
                }
              }
            }
          }
        }
      }
    }
  }, {
    key: "adagucBeforeDraw",
    value: function adagucBeforeDraw(ctx) {
      /* adagucBeforeDraw is an event callback function which is triggered
       just before adagucviewer will flip the back canvas buffer to the front.
       You are free to draw anything you like on the canvas.
      */
      var _this$props12 = this.props,
          featureNrToEdit = _this$props12.featureNrToEdit,
          isInEditMode = _this$props12.isInEditMode;
      if (!this.geojson || !this.geojson.features || !this.geojson.features.length) return;
      this.textPositions = [];
      this.mouseOverPolygonCoordinates = [];
      this.mouseOverPolygonFeatureIndex = -1;
      this.mouseOverPolygonIndex = -1;
      /* Current selected feature from GeoJSON */

      for (var featureIndex = 0; featureIndex < this.geojson.features.length; featureIndex += 1) {
        var feature = this.geojson.features[featureIndex];
        var featureType = feature.geometry.type;
        var totalmiddle = {
          x: 0,
          y: 0,
          nr: 0
        };

        if (featureType === 'Point') {
          var featureCoords = feature.geometry.coordinates;
          var XYCoords = this.getPixelCoordFromGeoCoord([featureCoords]);

          if (XYCoords.length === 0) {
            // eslint-disable-next-line no-continue
            continue;
          }

          for (var j = 0; j < XYCoords.length; j += 1) {
            this.drawPoint(ctx, XYCoords[j], this.mouseIsOverVertexNr === j && featureNrToEdit === featureIndex, false, isInEditMode && featureNrToEdit === featureIndex, feature, featureIndex);
          }
        }

        if (featureType === 'MultiPoint') {
          var _featureCoords9 = feature.geometry.coordinates;

          var _XYCoords4 = this.getPixelCoordFromGeoCoord(_featureCoords9);

          if (_XYCoords4.length === 0) {
            // eslint-disable-next-line no-continue
            continue;
          }

          for (var _j2 = 0; _j2 < _XYCoords4.length; _j2 += 1) {
            this.drawPoint(ctx, _XYCoords4[_j2], this.mouseIsOverVertexNr === _j2 && featureNrToEdit === featureIndex, false, isInEditMode && featureNrToEdit === featureIndex, feature, featureIndex);
          }
        }

        if (featureType === 'MultiPolygon') {
          var multiPolygonGeometry = feature.geometry;

          for (var multiPolygonIndex = 0; multiPolygonIndex < multiPolygonGeometry.coordinates.length; multiPolygonIndex += 1) {
            var multiPoly = multiPolygonGeometry.coordinates[multiPolygonIndex];

            for (var polygonIndex = 0; polygonIndex < multiPoly.length; polygonIndex += 1) {
              var _featureCoords10 = multiPoly[polygonIndex];

              var _XYCoords5 = this.getPixelCoordFromGeoCoord(_featureCoords10);
              /* Only draw if there is stuff to show */


              if (_XYCoords5.length === 0) {
                // eslint-disable-next-line no-continue
                continue;
              }

              var middle = this.drawPolygon(ctx, _XYCoords5, featureIndex, polygonIndex);

              if (middle) {
                totalmiddle.x += middle.x * middle.nr;
                totalmiddle.y += middle.y * middle.nr;
                totalmiddle.nr += middle.nr;
              }

              if (isInEditMode) {
                /* Draw all vertices on the edges of the polygons */
                for (var _j3 = 0; _j3 < _XYCoords5.length; _j3 += 1) {
                  this.drawVertice(ctx, _XYCoords5[_j3], this.snappedPolygonIndex === polygonIndex && this.mouseIsOverVertexNr === _j3 && featureNrToEdit === featureIndex, false, isInEditMode && featureNrToEdit === featureIndex);
                }

                if (middle && isInEditMode === true && _XYCoords5.length >= 3) {
                  /* Draw middle vertice for the poly if poly covers an area, e.g. when it contains more than three points */
                  this.drawVertice(ctx, middle, this.snappedPolygonIndex === polygonIndex && this.mouseIsOverVertexNr === VERTEX.MIDDLE_POINT_OF_FEATURE && featureNrToEdit === featureIndex, true, isInEditMode && featureNrToEdit === featureIndex);
                }
              }
            }
          }

          if (totalmiddle.nr > 0) {
            var mx = totalmiddle.x / totalmiddle.nr;
            var my = totalmiddle.y / totalmiddle.nr;

            if (feature.properties && feature.properties.text) {
              this.textPositions.push({
                x: mx,
                y: my,
                text: feature.properties.text
              });
            }
          }
        }

        if (featureType === 'Polygon') {
          var polygonGeometry = feature.geometry;
          /* Loop through all polygons of the same feature */

          for (var _polygonIndex2 = 0; _polygonIndex2 < polygonGeometry.coordinates.length; _polygonIndex2 += 1) {
            var _featureCoords11 = polygonGeometry.coordinates[_polygonIndex2];

            var _XYCoords6 = this.getPixelCoordFromGeoCoord(_featureCoords11);
            /* Only draw if there is stuff to show */


            if (_XYCoords6.length === 0) {
              // eslint-disable-next-line no-continue
              continue;
            }

            var _middle = this.drawPolygon(ctx, _XYCoords6, featureIndex, _polygonIndex2);

            if (_middle && feature.properties && feature.properties.text) {
              this.textPositions.push({
                x: _middle.x,
                y: _middle.y,
                text: feature.properties.text
              });
            }

            if (isInEditMode) {
              /* Draw all vertices on the edges of the polygons */
              for (var _j4 = 0; _j4 < _XYCoords6.length; _j4 += 1) {
                this.drawVertice(ctx, _XYCoords6[_j4], this.snappedPolygonIndex === _polygonIndex2 && this.mouseIsOverVertexNr === _j4 && featureNrToEdit === featureIndex, false, isInEditMode && featureNrToEdit === featureIndex);
              }

              if (_middle && isInEditMode === true && _XYCoords6.length >= 3) {
                /* Draw middle vertice for the poly if poly covers an area, e.g. when it contains more than three points */
                this.drawVertice(ctx, _middle, this.snappedPolygonIndex === _polygonIndex2 && this.mouseIsOverVertexNr === VERTEX.MIDDLE_POINT_OF_FEATURE && featureNrToEdit === featureIndex, true, isInEditMode && featureNrToEdit === featureIndex);
              }
            }
          }
        }

        if (featureType === 'LineString') {
          /* Loop through all line pints of the same feature */
          var _featureCoords12 = feature.geometry.coordinates;

          if (!_featureCoords12 || !_featureCoords12.length) {
            // eslint-disable-next-line no-continue
            continue;
          }

          var _XYCoords7 = this.getPixelCoordFromGeoCoord(_featureCoords12);
          /* Only draw if there is stuff to show */


          if (_XYCoords7.length === 0) {
            // eslint-disable-next-line no-continue
            continue;
          }

          var _middle2 = this.drawLine(ctx, _XYCoords7, featureIndex, 0);

          if (_middle2 && feature.properties && feature.properties.text) {
            this.textPositions.push({
              x: _middle2.x,
              y: _middle2.y,
              text: feature.properties.text
            });
          }

          if (isInEditMode) {
            /* Draw all vertices on the edges of the polygons */
            for (var _j5 = 0; _j5 < _XYCoords7.length; _j5 += 1) {
              this.drawVertice(ctx, _XYCoords7[_j5], this.mouseIsOverVertexNr === _j5 && featureNrToEdit === featureIndex, false, isInEditMode && featureNrToEdit === featureIndex);
            }
          }
        }
      }
      /* Higlight polygon with mousehover */


      if (isInEditMode === true && this.mouseOverPolygonFeatureIndex === featureNrToEdit && this.mouseIsOverVertexNr === VERTEX.NONE && this.snappedPolygonIndex === SNAPPEDFEATURE.NONE && this.selectedEdge === EDGE.NONE || this.mouseIsOverVertexNr === VERTEX.MIDDLE_POINT_OF_FEATURE) {
        if (this.mouseOverPolygonCoordinates.length >= 2) {
          ctx.beginPath();
          ctx.moveTo(this.mouseOverPolygonCoordinates[0].x, this.mouseOverPolygonCoordinates[0].y);

          for (var _j6 = 1; _j6 < this.mouseOverPolygonCoordinates.length; _j6 += 1) {
            var coord = this.mouseOverPolygonCoordinates[_j6];
            ctx.lineTo(coord.x, coord.y);
          }

          ctx.closePath();
          ctx.strokeStyle = 'blue';
          ctx.lineWidth = 1;
          ctx.fillStyle = '#88F';
          ctx.globalAlpha = 0.3;
          ctx.fill();
          ctx.globalAlpha = 1;
          ctx.stroke();
        }
      }
      /* Draw labels */


      for (var _j7 = 0; _j7 < this.textPositions.length; _j7 += 1) {
        var _this$textPositions$_ = this.textPositions[_j7],
            x = _this$textPositions$_.x,
            y = _this$textPositions$_.y,
            text = _this$textPositions$_.text;
        ctx.fillStyle = 'black';
        ctx.font = '12px Arial';
        ctx.fillText(text, x, y);
      }
    }
    /* Function which calculates the distance between two points */
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: "distance",
    value: function distance(a, b) {
      return Math.sqrt((a.x - b.x) * (a.x - b.x) + (a.y - b.y) * (a.y - b.y));
    }
    /* Function which calculates if a point is between two other points */

  }, {
    key: "isBetween",
    value: function isBetween(a, c, b) {
      var da = this.distance(a, c) + this.distance(c, b);
      var db = this.distance(a, b);
      return Math.abs(da - db) < 1;
    }
    /* Checks if mouse is in proximity of given coordinate */

  }, {
    key: "checkDist",
    value: function checkDist(coord, polygonIndex, mouseX, mouseY) {
      var VERTEX = this.distance(coord, {
        x: mouseX,
        y: mouseY
      });

      if (VERTEX < 10) {
        this.snappedGeoCoords = Object.assign({}, this.mouseGeoCoord);
        this.snappedPolygonIndex = polygonIndex;
        return true;
      }

      return false;
    }
  }, {
    key: "hoverEdge",
    value: function hoverEdge(geometry, mouseX, mouseY) {
      var coordinates = geometry.coordinates,
          type = geometry.type;

      if (type === 'Polygon') {
        for (var polygonIndex = coordinates.length - 1; polygonIndex >= 0; polygonIndex -= 1) {
          var featureCoords = coordinates[polygonIndex];

          if (featureCoords === undefined) {
            // eslint-disable-next-line no-continue
            continue;
          }
          /* Get all vertexes */


          var XYCoords = this.convertGeoCoordsToScreenCoords(featureCoords);

          for (var j = 0; j < XYCoords.length; j += 1) {
            var startV = XYCoords[j];
            var stopV = XYCoords[(j + 1) % XYCoords.length];

            if (this.isBetween(startV, {
              x: mouseX,
              y: mouseY
            }, stopV)) {
              return {
                selectedEdge: j,
                snappedPolygonIndex: polygonIndex
              };
            }
          }
        }

        return {
          selectedEdge: EDGE.NONE,
          snappedPolygonIndex: SNAPPEDFEATURE.NONE
        };
      }

      if (type === 'LineString') {
        var _featureCoords13 = coordinates;

        if (_featureCoords13 === undefined) {
          return {
            selectedEdge: EDGE.NONE,
            snappedPolygonIndex: SNAPPEDFEATURE.NONE
          };
        }
        /* Get all vertexes */


        var _XYCoords8 = this.convertGeoCoordsToScreenCoords(_featureCoords13);

        for (var _j8 = 0; _j8 < _XYCoords8.length - 1; _j8 += 1) {
          var _startV = _XYCoords8[_j8];
          var _stopV = _XYCoords8[(_j8 + 1) % _XYCoords8.length];

          if (this.isBetween(_startV, {
            x: mouseX,
            y: mouseY
          }, _stopV)) {
            return {
              selectedEdge: _j8,
              snappedPolygonIndex: 0
            };
          }
        }

        return {
          selectedEdge: EDGE.NONE,
          snappedPolygonIndex: SNAPPEDFEATURE.NONE
        };
      }

      return {
        selectedEdge: EDGE.NONE,
        snappedPolygonIndex: SNAPPEDFEATURE.NONE
      };
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "drawVertice",
    value: function drawVertice(ctx, _coord, selected, middle, isInEditMode) {
      var w = 7;
      var coord = {
        x: parseInt(_coord.x, 10),
        y: parseInt(_coord.y, 10)
      };

      if (isInEditMode === false) {
        return;
      }

      if (selected === false) {
        if (middle === true) {
          /* Style for middle editable vertice */
          ctx.strokeStyle = '#000';
          ctx.fillStyle = '#D87502';
          ctx.lineWidth = 1.0;
        } else {
          /* Style for standard editable vertice */
          ctx.strokeStyle = '#000';
          ctx.fillStyle = '#0275D8';
          ctx.lineWidth = 1.0;
        }
      } else {
        /* Style for selected editable vertice */
        ctx.strokeStyle = '#000';
        ctx.fillStyle = '#FF0';
        ctx.lineWidth = 1.0;
        w = 11;
      }

      ctx.globalAlpha = 1.0;
      ctx.fillRect(coord.x - w / 2, coord.y - w / 2, w, w);
      ctx.strokeRect(coord.x - w / 2, coord.y - w / 2, w, w);

      if (isInEditMode) {
        ctx.strokeRect(coord.x - 0.5, coord.y - 0.5, 1, 1);
      }
    }
  }, {
    key: "drawPoint",
    value: function drawPoint(ctx, _coord, selected, middle, isInEditMode, feature, featureIndex) {
      var featureProperties = feature.properties;

      if (featureProperties && featureProperties.imageURL) {
        this.drawIcon(ctx, _coord, featureProperties);
      }

      var drawStyledMarker = featureProperties ? featureProperties.stroke || featureProperties['stroke-width'] || featureProperties.fill : null;
      var drawMarkerByDefault = !featureProperties || !featureProperties.imageURL || !featureProperties.drawFunction;

      if (featureProperties.drawFunction) {
        featureProperties.drawFunction({
          context: ctx,
          featureIndex: featureIndex,
          coord: _coord,
          selected: selected,
          middle: middle,
          isInEditMode: isInEditMode,
          feature: feature,
          mouseX: this.mouseX,
          mouseY: this.mouseY
        });
      } else if (drawStyledMarker || drawMarkerByDefault) {
        this.drawMarker(ctx, _coord, selected, middle, isInEditMode, featureProperties);
      }
    }
  }, {
    key: "drawIcon",
    value: function drawIcon(ctx, _coord, featureProperties) {
      var image = getMapImageStore.getImage(featureProperties.imageURL);

      if (image.isLoaded() === false && image.hasError() === false && image.isLoading() === false) {
        image.load();
        /* After the image is loaded the canvas will be redrawn and drawIcon will be triggered again
        via the beforecanvasdisplay listener. */

        return;
      }

      if (image.isLoaded()) {
        var imageWidth = featureProperties && featureProperties.imageWidth || this.defaultIconProps.imageWidth;
        var imageHeight = featureProperties && featureProperties.imageHeight || this.defaultIconProps.imageHeight;
        ctx.drawImage(image.getElement(), parseInt(_coord.x, 10) - imageWidth / 2, parseInt(_coord.y, 10) - imageHeight / 2, imageWidth, imageHeight);

        if (featureProperties.imageBorderWidth && featureProperties.imageBorderWidth > 0) {
          ctx.lineWidth = featureProperties.imageBorderWidth;
          ctx.strokeRect(parseInt(_coord.x, 10) - imageWidth / 2, parseInt(_coord.y, 10) - imageHeight / 2, imageWidth, imageHeight);
        }
      }
    }
  }, {
    key: "drawMarker",
    value: function drawMarker(ctx, _coord, selected, middle, isInEditMode, featureProperties) {
      var strokeStyle = featureProperties && featureProperties.stroke || this.defaultPolyProps.stroke;
      var lineWidth = featureProperties && featureProperties['stroke-width'] || this.defaultPolyProps['stroke-width'];
      var fillStyle = featureProperties && featureProperties.fill || this.defaultPolyProps.fill;

      if (isInEditMode === false) {
        /* Standard style, no editing, just display location of vertices */
        ctx.strokeStyle = strokeStyle;
        ctx.fillStyle = fillStyle;
        ctx.lineWidth = lineWidth;
      } else if (selected === false) {
        /* Style for standard editable vertice */
        ctx.strokeStyle = '#000';
        ctx.fillStyle = '#0275D8';
        ctx.lineWidth = 1.0;
      } else {
        /* Style for selected editable vertice */
        ctx.strokeStyle = '#000';
        ctx.fillStyle = '#FF0';
        ctx.lineWidth = 1.0;
      }

      var coord = {
        x: parseInt(_coord.x, 10),
        y: parseInt(_coord.y, 10)
      };
      ctx.globalAlpha = 1.0;
      ctx.beginPath();
      var topRadius = 9;
      var topHeight = 2.5 * topRadius;
      ctx.arc(coord.x, coord.y - topHeight, topRadius, Math.PI, Math.PI * 2);
      ctx.bezierCurveTo(coord.x + topRadius, coord.y - topHeight, coord.x + topRadius / 1.6, coord.y - topRadius, coord.x, coord.y);
      ctx.bezierCurveTo(coord.x, coord.y, coord.x - topRadius / 1.6, coord.y - topRadius, coord.x - topRadius, coord.y - topHeight);
      ctx.stroke();
      ctx.fill();
      /* Fill center circle */

      ctx.fillStyle = '#FFF';
      ctx.beginPath();
      ctx.arc(coord.x, coord.y - topHeight, topRadius / 2, Math.PI * 2, 0);
      ctx.fill();
      /* Fill marker exact location */

      ctx.fillStyle = '#000';
      ctx.beginPath();
      ctx.arc(coord.x, coord.y, 2, Math.PI * 2, 0);
      ctx.fill();
    }
  }, {
    key: "drawLine",
    value: function drawLine(ctx, XYCoords, featureIndex, lineStringIndex) {
      var _this$props13 = this.props,
          isInEditMode = _this$props13.isInEditMode,
          featureNrToEdit = _this$props13.featureNrToEdit;
      var feature = this.geojson.features[featureIndex];
      if (!feature || !feature.geometry) return;
      if (feature.geometry.type !== 'LineString') return;
      var lineProps = feature.properties;
      if (!lineProps) lineProps = this.defaultLineStringProps;
      /* Draw polygons and calculate center of poly */

      var middle = {
        x: 0,
        y: 0,
        nr: 0
      };
      ctx.beginPath();
      ctx.strokeStyle = lineProps.stroke || this.defaultLineStringProps.stroke;
      ctx.lineWidth = lineProps['stroke-width'] || this.defaultLineStringProps['stroke-width'];
      ctx.fillStyle = lineProps.fill || this.defaultLineStringProps.fill;
      var startCoord = XYCoords[0];
      ctx.moveTo(startCoord.x, startCoord.y);
      middle.x += startCoord.x;
      middle.y += startCoord.y;

      for (var j = 1; j < XYCoords.length; j += 1) {
        var coord = XYCoords[j];
        ctx.lineTo(coord.x, coord.y);

        if (j < XYCoords.length - 1) {
          middle.x += coord.x;
          middle.y += coord.y;
        }
      }

      ctx.globalAlpha = lineProps['fill-opacity'] || this.defaultLineStringProps['fill-opacity'];

      if (lineProps['fill-opacity'] === 0) {
        ctx.globalAlpha = 0;
      } // ctx.fill();


      ctx.globalAlpha = lineProps['stroke-opacity'] || this.defaultLineStringProps['stroke-opacity'];
      ctx.stroke(); // let test = ctx.isPointInPath(this.mouseX, this.mouseY);
      // if (test) {

      this.mouseOverPolygonCoordinates = 0;
      this.mouseOverPolygonFeatureIndex = 0;
      this.mouseOverPolygonIndex = 0; // }
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore

      middle.x = parseInt(middle.x / (XYCoords.length - 1), 10); // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore

      middle.y = parseInt(middle.y / (XYCoords.length - 1), 10);

      if (isInEditMode === true && this.snappedPolygonIndex === lineStringIndex && this.selectedEdge !== EDGE.NONE && featureNrToEdit === featureIndex) {
        /* Higlight selected edge of a LineString, previousely detected by mouseover event */
        ctx.beginPath();
        ctx.strokeStyle = '#FF0';
        ctx.lineWidth = 5;
        ctx.moveTo(XYCoords[this.selectedEdge].x, XYCoords[this.selectedEdge].y);
        ctx.lineTo( // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        XYCoords[(this.selectedEdge + 1) % XYCoords.length].x, // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        XYCoords[(this.selectedEdge + 1) % XYCoords.length].y);
        ctx.stroke();
      }

      middle.nr = XYCoords.length - 1;
      return middle;
    }
  }, {
    key: "drawPolygon",
    value: function drawPolygon(ctx, XYCoords, featureIndex, polygonIndex) {
      var _this$props14 = this.props,
          isInEditMode = _this$props14.isInEditMode,
          featureNrToEdit = _this$props14.featureNrToEdit;
      var feature = this.geojson.features[featureIndex];
      if (!feature || !feature.geometry) return;
      if (feature.geometry.type !== 'Polygon' && feature.geometry.type !== 'MultiPolygon') return;
      var polyProps = feature.properties;
      if (!polyProps) polyProps = this.defaultPolyProps;
      /* Draw polygons and calculate center of poly */

      var middle = {
        x: 0,
        y: 0,
        nr: 0
      };
      ctx.beginPath();
      ctx.strokeStyle = polyProps.stroke || this.defaultPolyProps.stroke;
      ctx.lineWidth = polyProps['stroke-width'] || this.defaultPolyProps['stroke-width'];
      ctx.fillStyle = polyProps.fill || this.defaultPolyProps.fill;
      var startCoord = XYCoords[0];
      ctx.moveTo(startCoord.x, startCoord.y);
      middle.x += startCoord.x;
      middle.y += startCoord.y;

      for (var j = 1; j < XYCoords.length; j += 1) {
        var coord = XYCoords[j];
        ctx.lineTo(coord.x, coord.y);

        if (j < XYCoords.length - 1) {
          middle.x += coord.x;
          middle.y += coord.y;
        }
      }

      ctx.closePath();
      ctx.globalAlpha = polyProps['fill-opacity'] || this.defaultPolyProps['fill-opacity'];

      if (polyProps['fill-opacity'] === 0) {
        ctx.globalAlpha = 0;
      }

      ctx.fill();
      ctx.globalAlpha = polyProps['stroke-opacity'] || this.defaultPolyProps['stroke-opacity'];
      ctx.stroke();
      var test = ctx.isPointInPath(this.mouseX, this.mouseY);

      if (test) {
        this.mouseOverPolygonCoordinates = XYCoords;
        this.mouseOverPolygonFeatureIndex = featureIndex;
        this.mouseOverPolygonIndex = polygonIndex;
      } // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore


      middle.x = parseInt(middle.x / (XYCoords.length - 1), 10); // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore

      middle.y = parseInt(middle.y / (XYCoords.length - 1), 10);

      if (isInEditMode === true && this.snappedPolygonIndex === polygonIndex && this.selectedEdge !== EDGE.NONE && featureNrToEdit === featureIndex) {
        /* Higlight selected edge of a polygon, previousely detected by mouseover event */
        ctx.strokeStyle = '#FF0';
        ctx.lineWidth = 5;
        ctx.beginPath();
        ctx.moveTo(XYCoords[this.selectedEdge].x, XYCoords[this.selectedEdge].y);
        ctx.lineTo( // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        XYCoords[(this.selectedEdge + 1) % XYCoords.length].x, // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        XYCoords[(this.selectedEdge + 1) % XYCoords.length].y);
        ctx.stroke();
      }

      middle.nr = XYCoords.length - 1;
      return middle;
    }
  }, {
    key: "convertGeoCoordsToScreenCoords",
    value: function convertGeoCoordsToScreenCoords(featureCoords) {
      var webmapjs = this.props.webmapjs;
      var XYCoords = [];

      for (var j = 0; j < featureCoords.length; j += 1) {
        // eslint-disable-next-line no-continue
        if (featureCoords[j].length < 2) continue;
        var coord = webmapjs.getPixelCoordFromLatLong({
          x: featureCoords[j][0],
          y: featureCoords[j][1]
        });
        XYCoords.push(coord);
      }

      return XYCoords;
    }
  }, {
    key: "initializeFeature",
    value: function initializeFeature(feature, type) {
      if (!feature) {
        switch (type) {
          case DRAWMODE.POINT:
            return cloneDeep(featurePoint);

          case DRAWMODE.MULTIPOINT:
            return cloneDeep(featureMultiPoint);

          case DRAWMODE.POLYGON:
            return cloneDeep(featurePolygon);

          case DRAWMODE.BOX:
            return cloneDeep(featureBox);

          case DRAWMODE.LINESTRING:
            return cloneDeep(lineString);
        }
      } else {
        this.validateFeature(feature); // eslint-disable-next-line no-underscore-dangle

        if (feature.properties._adaguctype) delete feature.properties._adaguctype; // eslint-disable-next-line default-case

        switch (type) {
          case DRAWMODE.POINT:
            feature.geometry.type = 'Point';
            break;

          case DRAWMODE.MULTIPOINT:
            feature.geometry.type = 'MultiPoint';
            if (feature.geometry.coordinates.length === 0) // eslint-disable-next-line @typescript-eslint/no-explicit-any
              feature.geometry.coordinates.push([]);
            break;

          case DRAWMODE.BOX:
            feature.geometry.type = 'Polygon'; // eslint-disable-next-line no-underscore-dangle

            feature.properties._adaguctype = 'box';
            break;

          case DRAWMODE.POLYGON:
            feature.geometry.type = 'Polygon';
            if (feature.geometry.coordinates.length === 0) // eslint-disable-next-line @typescript-eslint/no-explicit-any
              feature.geometry.coordinates.push([]);
            break;

          case DRAWMODE.LINESTRING:
            feature.geometry.type = 'LineString';
            if (feature.geometry.coordinates.length === 0) // eslint-disable-next-line @typescript-eslint/no-explicit-any
              feature.geometry.coordinates.push([]);
            break;
        }
      }

      return feature;
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "checkIfFeatureIsBox",
    value: function checkIfFeatureIsBox(feature) {
      if (!feature || !feature.properties || !feature.properties._adaguctype) return false;
      return feature.properties._adaguctype === 'box';
    }
  }, {
    key: "featureHasChanged",
    value: function featureHasChanged(text) {
      var updateGeojson = this.props.updateGeojson;

      if (text !== 'new feature created') {
        this.validatePolys(text === 'cancelEdit');
      }

      if (updateGeojson && this.geojson) {
        updateGeojson(cloneDeep(this.geojson), text);
      }
    }
    /* Converts string input into right drawmode */

  }, {
    key: "handleDrawMode",
    value: function handleDrawMode(_drawMode) {
      if (_drawMode) {
        var drawMode = _drawMode.toUpperCase();

        if (drawMode === 'POINT') {
          this.myDrawMode = DRAWMODE.POINT;
        }

        if (drawMode === 'MULTIPOINT') {
          this.myDrawMode = DRAWMODE.MULTIPOINT;
        }

        if (drawMode === 'BOX') {
          this.myDrawMode = DRAWMODE.BOX;
        }

        if (drawMode === 'POLYGON') {
          this.myDrawMode = DRAWMODE.POLYGON;
        }

        if (drawMode === 'LINESTRING') {
          this.myDrawMode = DRAWMODE.LINESTRING;
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props15 = this.props,
          webmapjs = _this$props15.webmapjs,
          isInDeleteMode = _this$props15.isInDeleteMode;

      if (this.disabled === undefined) {
        this.disabled = isInDeleteMode;
      }

      if (webmapjs !== undefined && this.listenersInitialized !== true) {
        this.listenersInitialized = true;
        webmapjs.addListener('beforecanvasdisplay', this.adagucBeforeDraw, true);
        webmapjs.addListener('beforemousemove', this.adagucMouseMove, true);
        webmapjs.addListener('beforemousedown', this.adagucMouseDown, true);
        webmapjs.addListener('beforemouseup', this.adagucMouseUp, true);
        this.disabled = false;
      }

      if (webmapjs !== undefined) {
        webmapjs.draw();
      }

      return /*#__PURE__*/React.createElement("div", null);
    }
  }]);

  return AdagucMapDraw;
}(React.PureComponent); // eslint-disable-next-line react/static-property-placement
AdagucMapDraw.defaultProps = {
  isInEditMode: false,
  isInDeleteMode: false,
  webmapjs: undefined,
  featureNrToEdit: 0
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */

var AdagucMapDrawContainer = function AdagucMapDrawContainer(_ref) {
  var featureLayers = _ref.featureLayers,
      webMapJS = _ref.webMapJS;
  return /*#__PURE__*/React.createElement(React.Fragment, null, featureLayers.map(function (layer) {
    return /*#__PURE__*/React.createElement("div", {
      "data-testid": "featureLayer-".concat(layer.id),
      key: layer.id,
      style: {
        display: 'none'
      }
    }, /*#__PURE__*/React.createElement(AdagucMapDraw, {
      geojson: layer.geojson,
      isInEditMode: layer.isInEditMode,
      isInDeleteMode: layer.isInDeleteMode,
      drawMode: layer.drawMode,
      webmapjs: webMapJS,
      onHoverFeature: function onHoverFeature(hoverInfo) {
        if (layer.onHoverFeature) {
          layer.onHoverFeature(hoverInfo);
        }
      },
      onClickFeature: function onClickFeature(hoverInfo) {
        if (layer.onClickFeature) {
          layer.onClickFeature(hoverInfo);
        }
      },
      updateGeojson: function updateGeojson(geojson) {
        if (layer.updateGeojson) {
          layer.updateGeojson(geojson);
        }
      },
      exitDrawModeCallback: function exitDrawModeCallback() {
        if (layer.exitDrawModeCallback) layer.exitDrawModeCallback();
      },
      featureNrToEdit: parseInt(layer.featureNrToEdit || '0', 10)
    }));
  }));
};

/**
 * Returns filtered list of props with geoJson
 * @param children React.ReactNode, layers with geoJson
 */

var getFeatureLayers = function getFeatureLayers(children) {
  return children && Array.isArray(children) ? children // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  .reduce(function (acc, val) {
    return acc.concat(val);
  }, []).filter(function (c) {
    return c && c.props && c.props.geojson;
  }).map(function (c) {
    return c.props;
  }).reverse() : [];
};
/**
 * Returns true if this is a maplayer and not a baselayer or overlayer
 * @param layer The Layer object, or the props from the ReactWMJSLayer
 */

var isAMapLayer = function isAMapLayer(layer) {
  return layer.layerType === LayerType.mapLayer;
};
/**
 * Returns true if this is a geojsonlayer (layer containing geojson field)
 * @param layer The Layer object, or the props from the ReactWMJSLayer
 */

var isAGeoJSONLayer = function isAGeoJSONLayer(layer) {
  return layer.geojson !== undefined;
};

var getDisplayText = function getDisplayText(currentAdagucTime) {
  var timeFormat = 'ddd DD MMM YYYY HH:mm [UTC]';
  var adagucTime = moment.utc(currentAdagucTime);
  var adagucTimeFormatted = adagucTime.format(timeFormat).toString();
  return adagucTimeFormatted;
};

var ORIGIN_REACTMAPVIEW_ONMAPCHANGEDIMENSION = 'ORIGIN_REACTMAPVIEW_ONMAPCHANGEDIMENSION';
var ORIGIN_REACTMAPVIEW_ONUPDATELAYERINFO = 'ORIGIN_REACTMAPVIEW_ONUPDATELAYERINFO';

var ReactMapView = /*#__PURE__*/function (_React$Component) {
  _inherits(ReactMapView, _React$Component);

  var _super = _createSuper(ReactMapView);

  function ReactMapView(props) {
    var _this;

    _classCallCheck(this, ReactMapView);

    _this = _super.call(this, props);
    _this.adaguc = {
      webMapJSCreated: false,
      initialized: false,
      baseLayers: [],
      webMapJS: undefined,
      oldbbox: undefined
    };
    _this.mapTimer = undefined;
    _this.featureLayerUpdateTimer = undefined;
    _this.currentWidth = undefined;
    _this.currentHeight = undefined;
    _this.refetchTimer = null;

    _this.componentDidUpdate = function (prevProps) {
      _this.checkNewProps(prevProps, _this.props);
    };

    _this.onStartRefetchTimer = function () {
      /*
        TODO, Maarten Plieger, 2021-09-02, https://gitlab.com/opengeoweb/opengeoweb/-/issues/1159:
        This causes many issues, we should improve the update strategy.
        Certain presets have >20 layers. This causes 20 times parsing the GetCapabilities for a minor update of the store.
           
      */
      _this.clearRefetchTimer();

      var fetchSpeed = 60000; // 1 minute

      _this.refetchTimer = setInterval(function () {
        var layers = _this.adaguc.webMapJS.getLayers();

        layers.forEach(function (layer) {
          if (layer.enabled !== false) {
            _this.parseWMJSLayer(layer, true);
          }
        });
      }, fetchSpeed);
    };

    _this.clearRefetchTimer = function () {
      if (_this.refetchTimer) {
        clearInterval(_this.refetchTimer);
      }
    };

    _this.parseWMJSLayer = function (wmLayer, forceReload, child) {
      var callback = function callback() {
        var _this$props = _this.props,
            onUpdateLayerInformation = _this$props.onUpdateLayerInformation,
            mapId = _this$props.mapId;
        setServiceMetadata(wmLayer, mapId, _this.adaguc.webMapJS, _this.props, onUpdateLayerInformation);

        if (child) {
          if (wmLayer.hasError) {
            if (child.props.onLayerError) {
              child.props.onLayerError(wmLayer, new Error(wmLayer.lastError), _this.adaguc.webMapJS);
            }
          } else if (child.props.onLayerReady) {
            child.props.onLayerReady(wmLayer, _this.adaguc.webMapJS);
          }
        }
      };

      wmLayer.parseLayer(callback, forceReload, 'ReactMapView parseWMJSLayer');
    };

    _this.state = {
      adagucInitialised: false
    };
    _this.resize = _this.resize.bind(_assertThisInitialized(_this));
    _this.handleWindowResize = _this.handleWindowResize.bind(_assertThisInitialized(_this));
    _this.drawDebounced = debounce$1(600, _this.drawDebounced);
    _this.checkNewProps = _this.checkNewProps.bind(_assertThisInitialized(_this));
    _this.checkAdaguc = _this.checkAdaguc.bind(_assertThisInitialized(_this));
    _this.onAfterSetBBoxListener = _this.onAfterSetBBoxListener.bind(_assertThisInitialized(_this));
    _this.onUpdateBBoxListener = _this.onUpdateBBoxListener.bind(_assertThisInitialized(_this));
    _this.onDimChangeListener = _this.onDimChangeListener.bind(_assertThisInitialized(_this));
    _this.currentMapProps = {};
    _this.adagucContainerRef = /*#__PURE__*/React.createRef();
    _this.adagucWebMapJSRef = /*#__PURE__*/React.createRef();
    return _this;
  }

  _createClass(ReactMapView, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
          onMount = _this$props2.onMount,
          mapId = _this$props2.mapId,
          onRegisterAdaguc = _this$props2.onRegisterAdaguc,
          shouldAutoFetch = _this$props2.shouldAutoFetch;
      this.checkAdaguc();
      this.checkNewProps(null, this.props);
      window.addEventListener('resize', this.handleWindowResize);

      if (this.adaguc.initialized === false && this.adaguc.webMapJS) {
        this.adaguc.initialized = true;

        if (onRegisterAdaguc) {
          onRegisterAdaguc(this.adaguc.webMapJS);
        }
      }

      onMount(mapId, this.adaguc.webMapJS);

      if (shouldAutoFetch) {
        this.onStartRefetchTimer();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props3 = this.props,
          onUnMount = _this$props3.onUnMount,
          mapId = _this$props3.mapId;
      window.removeEventListener('resize', this.handleWindowResize);
      onUnMount(mapId, this.adaguc.webMapJS);
      this.adaguc.webMapJS.getListener().suspendEvents();

      if (typeof this.adaguc.webMapJS.stopAnimating === 'function') {
        this.adaguc.webMapJS.stopAnimating();
        this.adaguc.webMapJS.destroy();
        this.adaguc.webMapJSCreated = false;
      }

      this.clearRefetchTimer();
    }
  }, {
    key: "onDimChangeListener",
    value: function onDimChangeListener() {
      var _this$props4 = this.props,
          mapId = _this$props4.mapId,
          onMapChangeDimension = _this$props4.onMapChangeDimension;

      if (this.adaguc && this.adaguc.webMapJS) {
        var timeDimension = this.adaguc.webMapJS.getDimension('time');

        if (timeDimension) {
          onMapChangeDimension({
            mapId: mapId,
            origin: ORIGIN_REACTMAPVIEW_ONMAPCHANGEDIMENSION,
            dimension: {
              name: 'time',
              currentValue: timeDimension.currentValue
            }
          });
        }
      }
    }
  }, {
    key: "onAfterSetBBoxListener",
    value: function onAfterSetBBoxListener(wmjsMap) {
      var _this2 = this;

      var _this$props5 = this.props,
          mapId = _this$props5.mapId,
          onMapZoomEnd = _this$props5.onMapZoomEnd;
      /* Update the map after 100 ms */

      window.setTimeout(function () {
        var MapViewBBOX = _this2.props.bbox;
        var projectionInfo = wmjsMap.getProjection();
        /* Trigger onMapZoomEnd callback */

        var mapBBOX = projectionInfo.bbox;

        if (MapViewBBOX.left !== mapBBOX.left || MapViewBBOX.right !== mapBBOX.right || MapViewBBOX.bottom !== mapBBOX.bottom || MapViewBBOX.top !== mapBBOX.top) {
          onMapZoomEnd({
            mapId: mapId,
            bbox: {
              left: projectionInfo.bbox.left,
              bottom: projectionInfo.bbox.bottom,
              right: projectionInfo.bbox.right,
              top: projectionInfo.bbox.top
            },
            srs: projectionInfo.srs
          });
        }
      }, 100);
    }
  }, {
    key: "onUpdateBBoxListener",
    value: function onUpdateBBoxListener(newBbox) {
      var oldbbox = this.adaguc.oldbbox || new WMBBOX(ReactMapView.defaultProps.bbox);

      if (oldbbox.left !== newBbox.left || oldbbox.right !== newBbox.right || oldbbox.top !== newBbox.top || oldbbox.bottom !== newBbox.bottom) {
        oldbbox.left = newBbox.left;
        oldbbox.right = newBbox.right;
        oldbbox.top = newBbox.top;
        oldbbox.bottom = newBbox.bottom;
        this.adaguc.oldbbox = new WMBBOX(oldbbox);
      }
    }
  }, {
    key: "getWMJSLayerFromReactLayer",
    value: function getWMJSLayerFromReactLayer(wmLayers, reactWebMapJSLayer, index) {
      var foundLayer = null;

      if (reactWebMapJSLayer.props.name && reactWebMapJSLayer.props.id) {
        if (index >= 0 && index < wmLayers.length) {
          for (var layerIndex = 0; layerIndex < wmLayers.length; layerIndex += 1) {
            var secondIndex = wmLayers.length - 1 - index;
            var layer = wmLayers[layerIndex];

            if (layer === getWMLayerById(reactWebMapJSLayer.props.id)) {
              foundLayer = layer;

              if (isAMapLayer(reactWebMapJSLayer.props) && layerIndex !== secondIndex) {
                this.adaguc.webMapJS.swapLayers(wmLayers[layerIndex], wmLayers[secondIndex]);
                this.adaguc.webMapJS.draw();
                return {
                  layer: foundLayer,
                  layerArrayMutated: true
                };
              }
            }
          }
        }
      }

      return {
        layer: foundLayer,
        layerArrayMutated: false
      };
    }
  }, {
    key: "checkNewProps",
    value: function checkNewProps(prevProps, props) {
      var _this3 = this;

      if (!props) {
        return;
      }

      var needsRedraw = false;
      /* Check map props */

      if (!prevProps || prevProps.showLegend !== props.showLegend) {
        this.adaguc.webMapJS.displayLegendInMap(props.showLegend !== false);
      }

      if (!prevProps || prevProps.showScaleBar !== props.showScaleBar) {
        this.adaguc.webMapJS.displayScaleBarInMap(props.showScaleBar !== false);
        needsRedraw = true;
      }
      /* Check map dimensions */


      if (!prevProps || prevProps.dimensions !== props.dimensions) {
        if (props.dimensions) {
          for (var d = 0; d < props.dimensions.length; d += 1) {
            var propDimension = props.dimensions[d];
            var mapDim = this.adaguc.webMapJS.getDimension(propDimension.name);

            if (mapDim && mapDim.currentValue !== propDimension.currentValue) {
              this.adaguc.webMapJS.setDimension(propDimension.name, propDimension.currentValue, false, false);
            }

            if (props.displayTimeInMap && propDimension.name === 'time' && propDimension.currentValue !== undefined) {
              needsRedraw = true;
              var displayText = getDisplayText(propDimension.currentValue);
              this.adaguc.webMapJS.setTimeOffset(displayText);
            }
          }
        }
      }
      /* Check if srs and BBOX is updated */


      if (!prevProps || prevProps.bbox !== props.bbox) {
        if (props.bbox.left !== undefined) {
          var projectionInfo = this.adaguc.webMapJS.getProjection();
          var mapBBOX = projectionInfo.bbox;

          if (props.bbox.left !== mapBBOX.left || props.bbox.right !== mapBBOX.right || props.bbox.bottom !== mapBBOX.bottom || props.bbox.top !== mapBBOX.top) {
            this.adaguc.webMapJS.suspendEvent('onupdatebbox');
            this.adaguc.webMapJS.setProjection(props.srs, new WMBBOX(props.bbox));
            this.adaguc.webMapJS.resumeEvent('onupdatebbox');
            this.adaguc.webMapJS.draw();
          }
        }
      }
      /* Check display/hide map cursor */


      if (!prevProps || prevProps.displayMapPin !== props.displayMapPin) {
        if (props.displayMapPin === true) {
          this.adaguc.webMapJS.getMapPin().showMapPin();
        } else if (props.displayMapPin === false) {
          this.adaguc.webMapJS.getMapPin().hideMapPin();
        }
      }
      /* Set map cursor location */


      if (!prevProps || prevProps.mapPinLocation !== props.mapPinLocation) {
        if (props.mapPinLocation) {
          this.adaguc.webMapJS.getMapPin().positionMapPinByLatLon({
            x: props.mapPinLocation.lon,
            y: props.mapPinLocation.lat
          });
        }
      }
      /* Set disable map pin */


      if (!prevProps || prevProps.disableMapPin !== props.disableMapPin) {
        if (props.disableMapPin === true) {
          this.adaguc.webMapJS.getMapPin().setMapPinDisabled();
        } else if (props.disableMapPin === false) {
          this.adaguc.webMapJS.getMapPin().setMapPinEnabled();
        }
      }
      /* Change the animation delay */


      if (!prevProps || prevProps.animationDelay !== props.animationDelay) {
        if (props.animationDelay) {
          if (typeof this.adaguc.webMapJS.setAnimationDelay === 'function') {
            this.adaguc.webMapJS.setAnimationDelay(props.animationDelay);
          }
        }
      }
      /* Check if layer metadata should be shown */


      if (!prevProps || prevProps.showLayerInfo !== props.showLayerInfo) {
        if (props.showLayerInfo) {
          this.adaguc.webMapJS.showLayerInfo = props.showLayerInfo;
        }
      }

      var children = props.children;

      if (children !== this.currentMapProps.children) {
        var _ret = function () {
          var myChildren = [];
          var takenIds = new Set();
          React.Children.forEach(children, function (child) {
            if (child) {
              var childProps = child.props;

              if (childProps && childProps.id) {
                if (!takenIds.has(childProps.id)) {
                  myChildren.push(child);
                  takenIds.add(childProps.id);
                } else {
                  childProps.onLayerError(childProps, new Error("Duplicate layer id \"".concat(childProps.id, "\" encountered within this WebMap")), _this3.adaguc.webMapJS);
                  console.warn('ReactWMJSLayer has a duplicate id', child);
                }
              } else {
                debug(DebugType.Warning, 'ReactElement child ignored: has no props or id', child);
              }
            }
          });
          myChildren.reverse();

          var wmjsLayers = _this3.adaguc.webMapJS.getLayers();
          /* ReactWMJSLayer Layer Childs: Detect all ReactLayers connected to WMJSLayers, remove WMJSLayer if there is no ReactLayer */


          var _loop = function _loop(l) {
            if (myChildren.filter(function (c) {
              return c && c.props && c.props.id === wmjsLayers[l].ReactWMJSLayerId;
            }).length === 0) {
              /* This will call the remove property of the WMJSLayer, which will adjust the layers array of WebMapJS */
              wmjsLayers[l].remove();
              /* Trigger update of all map dimensions */

              var onUpdateLayerInformation = props.onUpdateLayerInformation,
                  mapId = props.mapId;
              onUpdateLayerInformation && onUpdateLayerInformation({
                origin: ORIGIN_REACTMAPVIEW_ONUPDATELAYERINFO,
                serviceLayers: null,
                layerStyle: null,
                layerDimensions: null,
                mapDimensions: {
                  origin: origin,
                  mapId: mapId,
                  dimensions: _this3.adaguc.webMapJS.mapdimensions.map(function (_ref) {
                    var name = _ref.name,
                        units = _ref.units,
                        currentValue = _ref.currentValue,
                        synced = _ref.synced;
                    return {
                      name: name,
                      units: units,
                      currentValue: currentValue,
                      synced: synced
                    };
                  })
                }
              });

              _this3.checkNewProps(prevProps, props);

              return {
                v: {
                  v: void 0
                }
              };
            }
          };

          for (var l = 0; l < wmjsLayers.length; l += 1) {
            var _ret2 = _loop(l);

            if (_typeof(_ret2) === "object") return _ret2.v;
          }
          /* ReactWMJSLayer BaseLayer Childs: For the baseLayers, detect all ReactLayers connected to WMJSLayers, remove WMJSLayer if there is no ReactLayer */


          var webmapJSBaselayers = _this3.adaguc.webMapJS.getBaseLayers();

          var _loop2 = function _loop2(_l) {
            var wmjsBaseLayers = _this3.adaguc.webMapJS.getBaseLayers();

            if (myChildren.filter(function (c) {
              return c && c.props ? c.props.id === wmjsBaseLayers[_l].ReactWMJSLayerId : false;
            }).length === 0) {
              /*  TODO (Maarten Plieger, 2020-03-19):The remove property for the baselayer is not working yet */
              wmjsBaseLayers.splice(_l, 1);

              _this3.adaguc.webMapJS.setBaseLayers(wmjsBaseLayers);

              wmjsBaseLayers = _this3.adaguc.webMapJS.getBaseLayers();

              _this3.checkNewProps(prevProps, props);

              return {
                v: {
                  v: void 0
                }
              };
            }
          };

          for (var _l = 0; _l < webmapJSBaselayers.length; _l += 1) {
            var _ret3 = _loop2(_l);

            if (_typeof(_ret3) === "object") return _ret3.v;
          }
          /* Loop through all layers and update WMJSLayer properties where needed */


          var adagucWMJSLayerIndex = 0;
          var adagucWMJSBaseLayerIndex = 0;

          var _loop3 = function _loop3(c) {
            var child = myChildren[c];

            if (child && child.type) {
              /* Check layers */
              if (_typeof(child.type) === _typeof(MapViewLayer)) {
                /* Feature layer (with child.props.geojson), these are handled collectively by the setState commando above. */
                var isBaselayer = !isAMapLayer(child.props) && !isAGeoJSONLayer(child.props);
                var adagucWMJSLayers = isBaselayer ? _this3.adaguc.webMapJS.getBaseLayers() : _this3.adaguc.webMapJS.getLayers();

                var obj = _this3.getWMJSLayerFromReactLayer(adagucWMJSLayers, child, isBaselayer ? adagucWMJSBaseLayerIndex : adagucWMJSLayerIndex);

                if (obj.layerArrayMutated) {
                  _this3.checkNewProps(prevProps, props);

                  return {
                    v: {
                      v: void 0
                    }
                  };
                }

                var wmLayer = obj.layer;

                if (isBaselayer) {
                  adagucWMJSBaseLayerIndex += 1;
                } else {
                  adagucWMJSLayerIndex += 1;
                }

                if (wmLayer === null) {
                  var keepOnTop = child.props.layerType === LayerType.overLayer || false;
                  var newWMLayer = new WMLayer(Object.assign(Object.assign({}, child.props), {
                    keepOnTop: keepOnTop
                  }));
                  registerWMLayer(newWMLayer, child.props.id);
                  newWMLayer.ReactWMJSLayerId = child.props.id;

                  if (isBaselayer) {
                    /* Add ADAGUC WebMapJS Baselayer */
                    _this3.adaguc.baseLayers.push(newWMLayer);

                    _this3.adaguc.webMapJS.setBaseLayers(_this3.adaguc.baseLayers.reverse());
                  } else {
                    /* Add ADAGUC WebMapJS Layer */
                    _this3.adaguc.webMapJS.addLayer(newWMLayer).then(function () {
                      _this3.adaguc.webMapJS.draw();
                    });
                  }

                  if (!isBaselayer) {
                    _this3.parseWMJSLayer(newWMLayer, false, child);
                  }

                  needsRedraw = true;
                } else {
                  /* Set the name of the ADAGUC WMJSLayer */
                  if (child.props.name !== undefined && wmLayer.name !== child.props.name) {
                    wmLayer.setName(child.props.name).then(function () {
                      _this3.parseWMJSLayer(wmLayer, false, child);
                    });
                    needsRedraw = true;
                  }
                  /* Set the Opacity of the ADAGUC WMJSLayer */


                  if (child.props.opacity !== undefined && wmLayer.opacity !== parseFloat(child.props.opacity)) {
                    wmLayer.setOpacity(child.props.opacity);
                    needsRedraw = false;
                  }
                  /* Set the Style of the ADAGUC WMJSLayer */


                  if (child.props.style !== undefined && wmLayer.currentStyle !== child.props.style) {
                    wmLayer.setStyle(child.props.style);
                    needsRedraw = true;
                  }
                  /* Set the Enabled prop of the ADAGUC WMJSLayer */


                  if (child.props.enabled !== undefined && wmLayer.enabled !== child.props.enabled) {
                    wmLayer.display(child.props.enabled);
                    needsRedraw = true;
                  }
                  /* Set the dimensions of the ADAGUC WMJSLayer */


                  if (child.props.dimensions !== undefined) {
                    for (var _d = 0; _d < child.props.dimensions.length; _d += 1) {
                      var dim = child.props.dimensions[_d];
                      var wmjsDim = wmLayer.getDimension(dim.name);

                      if (wmjsDim) {
                        if (wmjsDim.currentValue !== dim.currentValue) {
                          wmLayer.setDimension(dim.name, dim.currentValue, false);
                          needsRedraw = true;
                        }

                        if (wmjsDim.synced !== dim.synced) {
                          wmjsDim.synced = dim.synced;
                          needsRedraw = true;
                        }
                      } else {
                        debug(DebugType.Warning, "MapView: Dimension does not exist, skipping ".concat(child.props.name, " :: ").concat(dim.name, " = ").concat(dim.currentValue));
                      }
                    }
                  }

                  if (child.props.isProfileLayer) {
                    var currentBbox = _this3.adaguc.webMapJS.getBBOX();

                    var newBbox = new WMBBOX(props.bbox);

                    if (currentBbox !== newBbox) {
                      _this3.adaguc.webMapJS.suspendEvent('onupdatebbox');

                      _this3.adaguc.webMapJS.setBBOX(new WMBBOX(props.bbox));

                      needsRedraw = true;

                      _this3.adaguc.webMapJS.resumeEvent('onupdatebbox');
                    }
                  }
                }
              }
            }
          };

          for (var c = 0; c < myChildren.length; c += 1) {
            var _ret4 = _loop3(c);

            if (_typeof(_ret4) === "object") return _ret4.v;
          }

          if (needsRedraw) {
            _this3.adaguc.webMapJS.draw();
          }
          /* Children have been processed */


          _this3.currentMapProps.children = children;
        }();

        if (_typeof(_ret) === "object") return _ret.v;
      }
    }
  }, {
    key: "drawDebounced",
    value: function drawDebounced() {
      this.adaguc.webMapJS.getListener().suspendEvents();
      this.adaguc.webMapJS.draw();
      this.adaguc.webMapJS.getListener().resumeEvents();
    }
  }, {
    key: "handleWindowResize",
    value: function handleWindowResize() {
      this.resize();
    }
  }, {
    key: "checkAdaguc",
    value: function checkAdaguc() {
      var _this4 = this;

      var _this$props6 = this.props,
          mapId = _this$props6.mapId,
          listeners = _this$props6.listeners,
          srs = _this$props6.srs,
          bbox = _this$props6.bbox,
          onMapPinChangeLocation = _this$props6.onMapPinChangeLocation;

      if (this.adaguc.webMapJSCreated) {
        return;
      }

      this.adaguc.webMapJSCreated = true;
      this.adaguc.webMapJS = new WMJSMap(this.adagucWebMapJSRef.current);
      this.adaguc.webMapJS.showLayerInfo = false;
      /* Enable to show actual layer properties in the map */

      registerWMJSMap(this.adaguc.webMapJS, mapId);
      this.adaguc.webMapJS.removeAllLayers();
      this.adaguc.webMapJS.setProjection(srs, new WMBBOX(bbox));
      this.adaguc.webMapJS.setWMTileRendererTileSettings(tileRenderSettings);

      if (listeners) {
        listeners.forEach(function (listener) {
          _this4.adaguc.webMapJS.addListener(listener.name, function (data) {
            listener.callbackfunction(_this4.adaguc.webMapJS, data);
          }, listener.keep);
        });
      }

      this.adaguc.webMapJS.addListener('ondimchange', function () {
        _this4.onDimChangeListener();
      }, true);
      this.adaguc.webMapJS.addListener('onmapready', function () {
        _this4.setState({
          adagucInitialised: true
        });
      });
      this.adaguc.webMapJS.addListener('aftersetbbox', function (wmjsMap) {
        _this4.onAfterSetBBoxListener(wmjsMap);
      }, true);
      this.adaguc.webMapJS.addListener('onupdatebbox', function (newBbox) {
        _this4.onUpdateBBoxListener(newBbox);
      }, true);
      this.adaguc.webMapJS.addListener('onsetmappin', function (mapPinLatLonCoordinate) {
        // only change location when mapPin is visible and enabled
        if (onMapPinChangeLocation && // eslint-disable-next-line react/destructuring-assignment
        _this4.props.displayMapPin && // eslint-disable-next-line react/destructuring-assignment
        !_this4.props.disableMapPin) {
          onMapPinChangeLocation({
            mapPinLocation: {
              lat: mapPinLatLonCoordinate.lat,
              lon: mapPinLatLonCoordinate.lon
            },
            mapId: mapId
          });
        }
      }, true);
      this.resize();
      this.adaguc.webMapJS.draw();
    }
  }, {
    key: "resize",
    value: function resize() {
      var element = this.adagucContainerRef.current;

      if (element) {
        var newWidth = element.clientWidth;
        var newHeight = element.clientHeight;

        if (this.currentWidth !== newWidth || this.currentHeight !== newHeight) {
          this.currentWidth = newWidth;
          this.currentHeight = newHeight;
          this.adaguc.webMapJS.setSize(newWidth, newHeight);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          passiveMap = _this$props7.passiveMap,
          children = _this$props7.children,
          onClick = _this$props7.onClick;
      var adagucInitialised = this.state.adagucInitialised;
      var featureLayers = getFeatureLayers(children);
      return /*#__PURE__*/React.createElement("div", {
        className: "MapView",
        style: {
          height: '100%',
          width: '100%',
          border: 'none',
          display: 'block',
          overflow: 'hidden'
        }
      }, /*#__PURE__*/React.createElement("div", {
        ref: this.adagucContainerRef,
        style: {
          minWidth: 'inherit',
          minHeight: 'inherit',
          width: 'inherit',
          height: 'inherit',
          overflow: 'hidden',
          display: 'block',
          border: 'none'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "MapViewComponent",
        style: {
          position: 'absolute',
          overflow: 'hidden',
          display: 'block',
          padding: '0',
          margin: '0',
          zIndex: 10
        }
      }, /*#__PURE__*/React.createElement("div", {
        ref: this.adagucWebMapJSRef
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'absolute',
          overflow: 'hidden',
          display: 'block',
          padding: '0',
          margin: '0',
          zIndex: 100
        }
      }, /*#__PURE__*/React.createElement("div", null, children), adagucInitialised && featureLayers && featureLayers.length ? /*#__PURE__*/React.createElement(AdagucMapDrawContainer, {
        featureLayers: featureLayers,
        webMapJS: this.adaguc.webMapJS
      }) : null), passiveMap &&
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/control-has-associated-label, jsx-a11y/interactive-supports-focus
      React.createElement("div", {
        style: {
          position: 'absolute',
          overflow: 'hidden',
          display: 'block',
          padding: '0',
          margin: '0',
          zIndex: 100,
          width: '100%',
          height: '100%'
        },
        onClick: onClick,
        role: "button"
      })));
    }
  }]);

  return ReactMapView;
}(React.Component);

ReactMapView.defaultProps = {
  srs: 'EPSG:3857',
  bbox: {
    left: -2324980.5498391856,
    bottom: 5890854.775012179,
    right: 6393377.702660825,
    top: 11652109.058827976
  },
  shouldAutoFetch: true,
  displayMapPin: false,
  disableMapPin: false,
  onMount: function onMount() {
    return null;
  },
  onUnMount: function onUnMount() {
    return null;
  },
  onMapChangeDimension: function onMapChangeDimension() {
    /* nothing */
  },
  onUpdateLayerInformation: function onUpdateLayerInformation() {
    /* nothing */
  },
  onMapZoomEnd: function onMapZoomEnd() {
    /* nothing */
  }
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */
var useStyles$4 = makeStyles(function () {
  return {
    mapTimeContainer: {
      zIndex: 10,
      justifySelf: 'center',
      bottom: 12,
      position: 'absolute'
    },
    mapTimeText: {
      fontWeight: 500
    }
  };
});
var getTimeDimension = function getTimeDimension(dimensions) {
  return dimensions.find(function (dimension) {
    return dimension.name === 'time' && dimension.currentValue !== undefined;
  });
};
var formatTime = function formatTime(time, timeFormat) {
  return moment.utc(time).format(timeFormat).toString();
};
var defaultTimeFormat = 'ddd DD MMM YYYY HH:mm [UTC]';

var MapTime = function MapTime(_ref) {
  var dimensions = _ref.dimensions,
      _ref$timeFormat = _ref.timeFormat,
      timeFormat = _ref$timeFormat === void 0 ? defaultTimeFormat : _ref$timeFormat;
  var classes = useStyles$4();
  var timeDimension = getTimeDimension(dimensions);

  if (!timeDimension) {
    return null;
  }

  var mapTime = formatTime(timeDimension.currentValue, timeFormat);
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "map-time",
    className: classes.mapTimeContainer
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    className: classes.mapTimeText
  }, mapTime)));
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */
var useStyles$3 = makeStyles(function () {
  return {
    mapViewContainer: {
      display: 'grid',
      width: '100%',
      height: '100%',
      position: 'relative',
      overflow: 'hidden'
    },
    mapView: {
      gridColumnStart: 1,
      gridRowStart: 1
    }
  };
});

var MapView = function MapView(_a) {
  var children = _a.children,
      _a$controls = _a.controls,
      controls = _a$controls === void 0 ? {
    zoomControls: true
  } : _a$controls,
      _a$displayTimeInMap = _a.displayTimeInMap,
      displayTimeInMap = _a$displayTimeInMap === void 0 ? true : _a$displayTimeInMap,
      props = __rest(_a, ["children", "controls", "displayTimeInMap"]);

  var classes = useStyles$3();
  var dimensions = props.dimensions;
  var adagucRef = React.useRef(null);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.mapViewContainer
  }, controls && controls.zoomControls && /*#__PURE__*/React.createElement(MapControls, {
    style: {
      top: 0,
      position: 'absolute'
    }
  }, /*#__PURE__*/React.createElement(ZoomControls, {
    onZoomIn: function onZoomIn() {
      return adagucRef.current.zoomIn();
    },
    onZoomOut: function onZoomOut() {
      return adagucRef.current.zoomOut();
    },
    onZoomReset: function onZoomReset() {
      return adagucRef.current.zoomToLayer(adagucRef.current.getActiveLayer());
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.mapView
  }, /*#__PURE__*/React.createElement(ReactMapView, Object.assign({}, props, {
    onRegisterAdaguc: function onRegisterAdaguc(adaguc) {
      adagucRef.current = adaguc;
    },
    showLegend: false,
    displayTimeInMap: false
  }), children)), displayTimeInMap && dimensions && /*#__PURE__*/React.createElement(MapTime, {
    dimensions: dimensions
  }));
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */
var ORIGIN_REACTMAPVIEWCONNECT_ONMAPCHANGEDIMENSION = 'ORIGIN_REACTMAPVIEWCONNECT_ONMAPCHANGEDIMENSION';
/**
 * Connected component used to display the map and selected layers.
 * Includes options to disable the map controls and legend.
 *
 * Expects the following props:
 * @param {string} mapId mapId: string - Id of the map
 * @param {object} [controls.zoomControls] **optional** controls: object - toggle the map controls, zoomControls defaults to true
 * @param {boolean} [displayTimeInMap] **optional** displayTimeInMap: boolean, toggles the mapTime, defaults to true
 * @param {boolean} [showScaleBar] **optional** showScaleBar: boolean, toggles the scaleBar, defaults to true
 * @example
 * ```<MapViewConnect mapId={mapId} controls={{ zoomControls: false }} displayTimeInMap={false} showScaleBar={false}/>```
 */

var MapViewConnect = function MapViewConnect(_a) {
  var mapId = _a.mapId,
      children = _a.children,
      props = __rest(_a, ["mapId", "children"]);

  var mapDimensions = useSelector(function (store) {
    return getMapDimensions(store, mapId);
  });
  var layers = useSelector(function (store) {
    return getMapLayers(store, mapId);
  });
  var baseLayers = useSelector(function (store) {
    return getMapBaseLayers(store, mapId);
  });
  var overLayers = useSelector(function (store) {
    return getMapOverLayers(store, mapId);
  });
  var bbox = useSelector(function (store) {
    return getBbox(store, mapId);
  });
  var srs = useSelector(function (store) {
    return getSrs(store, mapId);
  });
  var activeLayerId = useSelector(function (store) {
    return getActiveLayerId(store, mapId);
  });
  var animationDelay = useSelector(function (store) {
    return getMapAnimationDelay(store, mapId);
  });
  var mapPinLocation = useSelector(function (store) {
    return getPinLocation(store, mapId);
  });
  var disableMapPin = useSelector(function (store) {
    return getDisableMapPin(store, mapId);
  });
  var displayMapPin = useSelector(function (store) {
    return getDisplayMapPin(store, mapId);
  });
  var dispatch = useDispatch();
  var map = getWMJSMapById(mapId);
  var mapChangeDimension = React.useCallback(function (mapDimensionPayload) {
    if (mapDimensionPayload.dimension) {
      var dimension = map.getDimension(mapDimensionPayload.dimension.name);

      if (dimension && dimension.currentValue === mapDimensionPayload.dimension.currentValue) {
        return;
      }
    }

    dispatch(mapActions$1.mapChangeDimension(mapDimensionPayload));
  }, [dispatch, map]);
  var setTime = React.useCallback(function (setTimePayload) {
    /* Check if the map not already has this value set, otherwise this component will re-render */
    if (map.getDimension('time').currentValue === setTimePayload.value) {
      return;
    }

    dispatch(genericActions.setTime(setTimePayload));
  }, [dispatch, map]);
  var updateLayerInformation = React.useCallback(function (payload) {
    dispatch(layerActions.onUpdateLayerInformation(payload));
  }, [dispatch]);
  var registerMap = React.useCallback(function (payload) {
    dispatch(mapActions$1.registerMap(payload));
  }, [dispatch]);
  var unregisterMap = React.useCallback(function (payload) {
    dispatch(mapActions$1.unregisterMap(payload));
  }, [dispatch]);
  var genericSetBbox = React.useCallback(function (payload) {
    dispatch(genericActions.setBbox(payload));
  }, [dispatch]);
  var syncGroupAddSource = React.useCallback(function (payload) {
    dispatch(genericActions.syncGroupAddSource(payload));
  }, [dispatch]);
  var syncGroupRemoveSource = React.useCallback(function (payload) {
    dispatch(genericActions.syncGroupRemoveSource(payload));
  }, [dispatch]);
  var layerError = React.useCallback(function (payload) {
    dispatch(layerActions.layerError(payload));
  }, [dispatch]);
  var mapPinChangeLocation = React.useCallback(function (payload) {
    dispatch(mapActions$1.setMapPinLocation(payload));
  }, [dispatch]);
  var setSelectedFeature = React.useCallback(function (payload) {
    dispatch(mapActions$1.setSelectedFeature(payload));
  }, [dispatch]);
  useKeyboardZoomAndPan(mapId);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      height: '100%'
    }
  }, /*#__PURE__*/React.createElement(MapView, Object.assign({}, props, {
    mapId: mapId,
    onMount: function onMount() {
      registerMap({
        mapId: mapId
      });
      syncGroupAddSource({
        id: mapId,
        type: [SYNCGROUPS_TYPE_SETTIME, SYNCGROUPS_TYPE_SETBBOX]
      });
    },
    onUnMount: function onUnMount() {
      unregisterMap({
        mapId: mapId
      });
      syncGroupRemoveSource({
        id: mapId
      });
    },
    srs: srs,
    bbox: bbox,
    mapPinLocation: displayMapPin && mapPinLocation,
    dimensions: mapDimensions,
    activeLayerId: activeLayerId,
    animationDelay: animationDelay,
    displayMapPin: displayMapPin,
    disableMapPin: disableMapPin,
    onMapChangeDimension: function onMapChangeDimension(mapDimensionPayload) {
      if (mapDimensionPayload && mapDimensionPayload.dimension && mapDimensionPayload.dimension.name && mapDimensionPayload.dimension.name === 'time') {
        setTime({
          sourceId: mapId,
          origin: "".concat(mapDimensionPayload.origin, "==> ").concat(ORIGIN_REACTMAPVIEWCONNECT_ONMAPCHANGEDIMENSION),
          value: handleMomentISOString(mapDimensionPayload.dimension.currentValue)
        });
      } else {
        mapChangeDimension(mapDimensionPayload);
      }
    },
    onUpdateLayerInformation: updateLayerInformation,
    onMapPinChangeLocation: mapPinChangeLocation,
    onMapZoomEnd: function onMapZoomEnd(a) {
      genericSetBbox({
        bbox: a.bbox,
        srs: a.srs,
        sourceId: mapId,
        origin: MapActionOrigin.map,
        mapId: mapId
      });
    }
  }), baseLayers.map(function (layer) {
    return /*#__PURE__*/React.createElement(MapViewLayer, Object.assign({
      id: "baselayer-".concat(layer.id),
      key: layer.id,
      onLayerError: function onLayerError(_, error) {
        layerError({
          layerId: layer.id,
          error: error
        });
      }
    }, layer));
  }), layers.map(function (layer) {
    return /*#__PURE__*/React.createElement(MapViewLayer, Object.assign({
      id: "layer-".concat(layer.id),
      key: layer.id,
      onLayerError: function onLayerError(_, error) {
        layerError({
          layerId: layer.id,
          error: error
        });
      },
      onClickFeature: layer.geojson ? function (event) {
        setSelectedFeature({
          mapId: mapId,
          selectedFeatureIndex: event === null || event === void 0 ? void 0 : event.featureIndex
        });
      } : undefined
    }, layer));
  }), overLayers.map(function (layer) {
    return /*#__PURE__*/React.createElement(MapViewLayer, Object.assign({
      id: "baselayer-".concat(layer.id),
      key: layer.id,
      onLayerError: function onLayerError(_, error) {
        layerError({
          layerId: layer.id,
          error: error
        });
      }
    }, layer));
  }), children));
};

var useKeyboardZoomAndPan = function useKeyboardZoomAndPan(mapId) {
  var activeWindowId = useSelector(getActiveWindowId);
  var mapIsActive = activeWindowId === mapId;
  React.useEffect(function () {
    var keysPressedDown = {};

    var handleKeyPress = function handleKeyPress(event) {
      var target = event.target;
      var map = getWMJSMapById(mapId);

      if (map && target.tagName !== 'INPUT' && mapIsActive) {
        var key = event.key,
            type = event.type;
        keysPressedDown[key] = type === 'keydown';

        if (keysPressedDown['+']) {
          map.zoomIn(1);
        } else if (keysPressedDown['-']) {
          map.zoomOut();
        }

        var arrowRight = keysPressedDown['ArrowRight'];
        var arrowLeft = keysPressedDown['ArrowLeft'];
        var arrowUp = keysPressedDown['ArrowUp'];
        var arrowDown = keysPressedDown['ArrowDown'];
        var control = keysPressedDown['Control'];

        if (!control && (arrowRight || arrowLeft || arrowUp || arrowDown)) {
          var x = 0;
          var y = 0;

          if (arrowRight) {
            x -= PAN_STEP_PERCENTAGE;
          }

          if (arrowLeft) {
            x += PAN_STEP_PERCENTAGE;
          }

          if (arrowUp) {
            y -= PAN_STEP_PERCENTAGE;
          }

          if (arrowDown) {
            y += PAN_STEP_PERCENTAGE;
          }

          map.mapPanPercentage(x, y);
        }
      }
    };

    document.addEventListener('keydown', handleKeyPress);
    document.addEventListener('keyup', handleKeyPress);
    return function () {
      document.removeEventListener('keydown', handleKeyPress);
      document.removeEventListener('keyup', handleKeyPress);
    };
  }, [mapIsActive, mapId]);
};

var PAN_STEP_PERCENTAGE = 0.02;

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */

var LegendMapButtonConnect = function LegendMapButtonConnect(_ref) {
  var mapId = _ref.mapId,
      _ref$source = _ref.source,
      source = _ref$source === void 0 ? 'app' : _ref$source,
      _ref$multiLegend = _ref.multiLegend,
      multiLegend = _ref$multiLegend === void 0 ? false : _ref$multiLegend;
  var dispatch = useDispatch();
  var legendType = multiLegend ? "legend-".concat(mapId) : "legend";
  var currentActiveMapId = useSelector(function (store) {
    return getDialogMapId(store, legendType);
  });
  var isOpenInStore = useSelector(function (store) {
    return getisDialogOpen(store, legendType);
  });
  var openLegendDialog = React.useCallback(function () {
    dispatch(uiActions.setActiveMapIdForDialog({
      type: legendType,
      mapId: mapId,
      setOpen: currentActiveMapId !== mapId ? true : !isOpenInStore,
      source: source,
      origin: MapActionOrigin.map
    }));
  }, [currentActiveMapId, dispatch, isOpenInStore, mapId, source, legendType]);
  var isOpen = currentActiveMapId === mapId && isOpenInStore;
  return /*#__PURE__*/React.createElement(MapControlButton, {
    title: "Legend",
    "data-testid": "open-Legend",
    onClick: openLegendDialog,
    isActive: isOpen
  }, /*#__PURE__*/React.createElement(List$1, null));
};

var titleStyle = function titleStyle(theme) {
  return {
    position: 'absolute',
    padding: '5px',
    zIndex: 50,
    color: theme.palette.common.black,
    whiteSpace: 'nowrap'
  };
};

var defaultBbox = {
  srs: 'EPSG:3857',
  bbox: {
    left: 58703.6377,
    bottom: 6408480.4514,
    right: 3967387.5161,
    top: 11520588.9031
  }
};
var ConfigurableMapConnect = function ConfigurableMapConnect(_a) {
  var id = _a.id,
      title = _a.title,
      _a$layers = _a.layers,
      layers = _a$layers === void 0 ? [] : _a$layers,
      _a$shouldAutoUpdate = _a.shouldAutoUpdate,
      shouldAutoUpdate = _a$shouldAutoUpdate === void 0 ? false : _a$shouldAutoUpdate,
      _a$shouldAnimate = _a.shouldAnimate,
      shouldAnimate = _a$shouldAnimate === void 0 ? false : _a$shouldAnimate,
      _a$bbox = _a.bbox,
      bbox = _a$bbox === void 0 ? defaultBbox.bbox : _a$bbox,
      _a$srs = _a.srs,
      srs = _a$srs === void 0 ? defaultBbox.srs : _a$srs,
      _a$shouldShowZoomCont = _a.shouldShowZoomControls,
      shouldShowZoomControls = _a$shouldShowZoomCont === void 0 ? true : _a$shouldShowZoomCont,
      _a$displayMapPin = _a.displayMapPin,
      displayMapPin = _a$displayMapPin === void 0 ? false : _a$displayMapPin,
      _a$showTimeSlider = _a.showTimeSlider,
      showTimeSlider = _a$showTimeSlider === void 0 ? true : _a$showTimeSlider,
      _a$disableTimeSlider = _a.disableTimeSlider,
      disableTimeSlider = _a$disableTimeSlider === void 0 ? false : _a$disableTimeSlider,
      _a$displayTimeInMap = _a.displayTimeInMap,
      displayTimeInMap = _a$displayTimeInMap === void 0 ? false : _a$displayTimeInMap,
      _a$displayLayerManage = _a.displayLayerManagerAndLegendButtonInMap,
      displayLayerManagerAndLegendButtonInMap = _a$displayLayerManage === void 0 ? true : _a$displayLayerManage,
      _a$displayDimensionSe = _a.displayDimensionSelectButtonInMap,
      displayDimensionSelectButtonInMap = _a$displayDimensionSe === void 0 ? true : _a$displayDimensionSe,
      _a$multiLegend = _a.multiLegend,
      multiLegend = _a$multiLegend === void 0 ? true : _a$multiLegend,
      shouldShowLayerManager = _a.shouldShowLayerManager,
      props = __rest(_a, ["id", "title", "layers", "shouldAutoUpdate", "shouldAnimate", "bbox", "srs", "shouldShowZoomControls", "displayMapPin", "showTimeSlider", "disableTimeSlider", "displayTimeInMap", "displayLayerManagerAndLegendButtonInMap", "displayDimensionSelectButtonInMap", "multiLegend", "shouldShowLayerManager"]);

  var dispatch = useDispatch();
  var mapId = React__default.useRef(id || generateMapId()).current;
  React__default.useEffect(function () {
    var layersWithDefaultBaseLayer = layers.find(function (layer) {
      return layer.layerType === LayerType.baseLayer;
    }) ? layers : [].concat(_toConsumableArray(layers), [baseLayerGrey$1]);
    var layersWithDefaultOverLayer = layersWithDefaultBaseLayer.find(function (layer) {
      return layer.layerType === LayerType.overLayer;
    }) ? layersWithDefaultBaseLayer : [].concat(_toConsumableArray(layersWithDefaultBaseLayer), [overLayer$1]);
    var mapPreset = Object.assign({
      layers: layersWithDefaultOverLayer,
      proj: {
        bbox: bbox,
        srs: srs
      },
      shouldAutoUpdate: shouldAutoUpdate,
      shouldAnimate: shouldAnimate,
      shouldShowZoomControls: shouldShowZoomControls,
      displayMapPin: displayMapPin,
      showTimeSlider: showTimeSlider
    }, props);
    var initialProps = {
      mapPreset: mapPreset
    };
    dispatch(mapActions$1.setMapPreset({
      mapId: mapId,
      initialProps: initialProps
    }));

    if (shouldShowLayerManager !== undefined) {
      dispatch(uiActions.setActiveMapIdForDialog({
        type: 'layerManager',
        mapId: mapId,
        setOpen: shouldShowLayerManager,
        source: 'app'
      }));
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
  return /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      width: '100%',
      height: '100%',
      position: 'relative',
      overflow: 'hidden'
    },
    "data-testid": "ConfigurableMap"
  }, /*#__PURE__*/React__default.createElement(Typography, {
    "data-testid": "mapTitle",
    sx: titleStyle
  }, title || mapId), /*#__PURE__*/React__default.createElement(MapControls, {
    "data-testid": "mapControls",
    style: {
      top: 24
    }
  }, /*#__PURE__*/React__default.createElement(ZoomControlConnect, {
    mapId: id
  }), displayLayerManagerAndLegendButtonInMap && /*#__PURE__*/React__default.createElement(LayerManagerMapButtonConnect, {
    mapId: mapId
  }), displayLayerManagerAndLegendButtonInMap && /*#__PURE__*/React__default.createElement(LegendMapButtonConnect, {
    mapId: mapId,
    multiLegend: multiLegend
  }), displayDimensionSelectButtonInMap && /*#__PURE__*/React__default.createElement(MultiDimensionSelectMapButtonsConnect, {
    mapId: mapId
  })), !disableTimeSlider && /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      position: 'absolute',
      left: '0px',
      bottom: '0px',
      zIndex: 1000,
      width: '100%'
    }
  }, /*#__PURE__*/React__default.createElement(TimeSliderConnect, {
    mapId: id,
    sourceId: id
  })), /*#__PURE__*/React__default.createElement(MapViewConnect, {
    controls: {},
    displayTimeInMap: displayTimeInMap,
    showScaleBar: false,
    mapId: mapId
  }), multiLegend && /*#__PURE__*/React__default.createElement(LegendConnect, {
    showMapId: true,
    mapId: mapId,
    multiLegend: multiLegend
  }));
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */
var useStyles$2 = makeStyles(function (theme) {
  return {
    box: {
      boxSizing: 'border-box',
      "float": 'left',
      '& .MapViewComponent': {
        border: "1px solid ".concat(theme.palette.geowebColors.typographyAndIcons.iconLinkDisabled)
      }
    }
  };
});
var MultiMapViewConnect = function MultiMapViewConnect(_ref) {
  var maps = _ref.maps,
      rows = _ref.rows,
      cols = _ref.cols,
      _ref$showTimeSlider = _ref.showTimeSlider,
      showTimeSlider = _ref$showTimeSlider === void 0 ? true : _ref$showTimeSlider,
      _ref$showZoomControls = _ref.showZoomControls,
      showZoomControls = _ref$showZoomControls === void 0 ? true : _ref$showZoomControls,
      _ref$multiLegend = _ref.multiLegend,
      multiLegend = _ref$multiLegend === void 0 ? false : _ref$multiLegend;
  var classes = useStyles$2();
  var dispatch = useDispatch();
  var syncGroupAddTarget = React__default.useCallback(function (payload) {
    dispatch(genericActions.syncGroupAddTarget(payload));
  }, [dispatch]);
  React__default.useEffect(function () {
    maps.forEach(function (map) {
      map.syncGroupsIds && map.syncGroupsIds.forEach(function (syncGroupsId) {
        syncGroupAddTarget({
          groupId: syncGroupsId,
          targetId: map.id,
          linked: true
        });
      });
    });
  }, [maps, syncGroupAddTarget]);
  var mapStyle = {
    width: "".concat(Math.round(100 / cols), "%"),
    height: "".concat(Math.round(100 / rows), "%")
  };
  var firstMapId = maps[0].id;
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      height: '100%',
      position: 'relative'
    },
    "data-testid": "MultiMapViewSliderConnect"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: 'absolute',
      left: '0px',
      bottom: '0px',
      zIndex: 1000,
      width: '100%'
    }
  }, showTimeSlider && /*#__PURE__*/React__default.createElement(TimeSliderConnect, {
    sourceId: firstMapId,
    mapId: firstMapId,
    isAlwaysVisible: true
  })), !multiLegend && /*#__PURE__*/React__default.createElement(LegendConnect, {
    showMapId: true,
    mapId: firstMapId,
    multiLegend: multiLegend
  }), maps.map(function (map, mapIndex) {
    var mapId = map.id;
    return /*#__PURE__*/React__default.createElement("div", {
      className: classes.box,
      key: mapId,
      style: mapStyle
    }, /*#__PURE__*/React__default.createElement(ConfigurableMapConnect, {
      title: map.title,
      id: mapId,
      layers: map.layers || [],
      activeLayerId: map.activeLayerId || undefined,
      bbox: map.bbox,
      srs: map.srs,
      displayTimeInMap: map.displayTimeInMap || false,
      displayLayerManagerAndLegendButtonInMap: map.displayLayerManagerAndLegendButtonInMap,
      displayDimensionSelectButtonInMap: map.displayDimensionSelectButtonInMap,
      shouldShowZoomControls: showZoomControls && mapIndex === 0,
      showTimeSlider: false,
      disableTimeSlider: true,
      multiLegend: multiLegend
    }));
  }));
};

var useGetReferenceTimes = function useGetReferenceTimes(inputLayer) {
  var _React$useState = React.useState([]),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      referenceTimes = _React$useState2[0],
      setReferenceTimes = _React$useState2[1];

  React.useEffect(function () {
    var referenceTimes = [];
    var wmLayer = new WMLayer(Object.assign({}, inputLayer));
    wmLayer.parseLayerPromise().then(function (layer) {
      var refTimeDim = layer.getDimension('reference_time');
      /* Loop through all values of the dimension.
         A map cannot be used for iterating,  as the dimension values are not in an array (it is an API). */

      for (var j = 0; j < refTimeDim.size(); j += 1) {
        var referenceTimeValue = refTimeDim.getValueForIndex(j);
        referenceTimes.push(referenceTimeValue);
      }

      setReferenceTimes(referenceTimes);
    });
  }, [inputLayer]);
  return referenceTimes;
};

var HarmonieTempAndPrecipPreset = function HarmonieTempAndPrecipPreset(_ref) {
  var layers = _ref.layers,
      _ref$multiLegend = _ref.multiLegend,
      multiLegend = _ref$multiLegend === void 0 ? false : _ref$multiLegend;

  /* Get all the reference times for this layer */
  var referenceTimes = useGetReferenceTimes(layers.topRow);
  if (referenceTimes.length === 0) return /*#__PURE__*/React.createElement("div", null, "Loading...");
  /* Helper to make a map layer prest */

  var makeMapPreset = function makeMapPreset(referenceTime, uniqueId, layer, syncGroupsIds, col) {
    return {
      id: uniqueId,
      title: "Harmonie run ".concat("".concat(referenceTime.substring(8, 13).replace('T', ' / '))),
      bbox: {
        left: -450651.2255879827,
        bottom: 6490531.093143953,
        right: 1428345.8183648037,
        top: 7438773.776232235
      },
      srs: 'EPSG:3857',
      layers: [Object.assign(Object.assign({}, layer), {
        id: uniqueId,
        dimensions: [{
          name: 'reference_time',
          currentValue: referenceTime
        }]
      })],
      syncGroupsIds: syncGroupsIds,
      displayLayerManagerAndLegendButtonInMap: col === 0 || !syncGroupsIds,
      displayDimensionSelectButtonInMap: col === 0 || !syncGroupsIds
    };
  };
  /* Make the preset */


  var nCols = 5;
  /* Add the harmonie air temperature layers with the different referencetimes */

  var mapsTemperature = _toConsumableArray(Array(nCols)).map(function (_, index) {
    var refTime = referenceTimes[referenceTimes.length - nCols + index];
    return makeMapPreset(refTime, "harm_air".concat(index), layers.topRow, layers.topRowSyncGroups, index);
  });
  /* Add the harmonie precipitation layers with the different referencetimes */


  var mapsPrecipitation = _toConsumableArray(Array(nCols)).map(function (_, index) {
    var refTime = referenceTimes[referenceTimes.length - nCols + index];
    return makeMapPreset(refTime, "harm_precip".concat(index), layers.bottomRow, layers.bottomRowSyncGroups, index);
  });

  var maps = mapsTemperature.concat(mapsPrecipitation);
  return /*#__PURE__*/React.createElement(MultiMapViewConnect, {
    rows: 2,
    cols: 5,
    maps: maps,
    multiLegend: multiLegend
  });
};

var useGetLatestReferenceTime = function useGetLatestReferenceTime(inputLayer) {
  var _React$useState = React.useState(''),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      latestReferenceTime = _React$useState2[0],
      setLatestReferenceTime = _React$useState2[1];

  React.useEffect(function () {
    var wmLayer = new WMLayer(Object.assign({}, inputLayer));
    wmLayer.parseLayerPromise().then(function (layer) {
      var refTimeDim = layer.getDimension('reference_time');
      var lastRefTime = refTimeDim.getLastValue();
      setLatestReferenceTime(lastRefTime);
    });
  }, [inputLayer]);
  return latestReferenceTime;
};
/* Helper to make a map layer preset */


var makeMapPreset = function makeMapPreset(timeIncrement, uniqueId, referenceTime, layers, syncGroupsIds, displayLayerManagerAndLegendButtonInMap, displayDimensionSelectButtonInMap) {
  var mapTime = moment.utc(referenceTime).add(timeIncrement, 'h').format('YYYY-MM-DDTHH:mm:ss[Z]');
  return {
    id: uniqueId,
    syncGroupsIds: syncGroupsIds,
    title: "FC +".concat(timeIncrement),
    displayTimeInMap: true,
    bbox: {
      left: -129849.7860570465,
      bottom: 6180677.243149376,
      right: 1215891.3289626688,
      top: 7540256.313079321
    },
    srs: 'EPSG:3857',
    layers: layers.map(function (layer, index) {
      return Object.assign(Object.assign({}, layer), {
        id: "".concat(uniqueId, "-").concat(index),
        dimensions: [{
          name: 'reference_time',
          currentValue: referenceTime
        }, {
          name: 'time',
          currentValue: mapTime
        }]
      });
    }),
    displayLayerManagerAndLegendButtonInMap: displayLayerManagerAndLegendButtonInMap,
    displayDimensionSelectButtonInMap: displayDimensionSelectButtonInMap
  };
};
var ModelRunInterval = function ModelRunInterval(_ref) {
  var _ref$layers = _ref.layers,
      layers = _ref$layers === void 0 ? [harmoniePressure, harmonieWindFlags, harmoniePrecipitation] : _ref$layers,
      syncGroupsIds = _ref.syncGroupsIds,
      _ref$interval = _ref.interval,
      interval = _ref$interval === void 0 ? 3 : _ref$interval,
      _ref$startTimeIncreme = _ref.startTimeIncrement,
      startTimeIncrement = _ref$startTimeIncreme === void 0 ? 3 : _ref$startTimeIncreme,
      _ref$multiLegend = _ref.multiLegend,
      multiLegend = _ref$multiLegend === void 0 ? false : _ref$multiLegend;

  /* Get latest reference time for this layer */
  var latestReferenceTime = useGetLatestReferenceTime(layers[0]);
  if (latestReferenceTime === '') return /*#__PURE__*/React.createElement("div", null, "Loading...");
  /* Calculate the last time increment based on 15 maps */

  var lastTimeIncrement = startTimeIncrement + 15 * interval;
  /* Make the preset */

  var timeIncrements = _toConsumableArray(range(startTimeIncrement, lastTimeIncrement, interval));
  /* Add the layers with the different map times */


  var maps = timeIncrements.map(function (increment, index) {
    return makeMapPreset(increment, "harm_precip".concat(increment), latestReferenceTime, layers, syncGroupsIds, index === 0 || !syncGroupsIds, index === 0 || !syncGroupsIds);
  });
  return /*#__PURE__*/React.createElement(MultiMapViewConnect, {
    rows: 3,
    cols: 5,
    maps: maps,
    syncTime: false,
    showTimeSlider: false,
    multiLegend: multiLegend
  });
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */
var componentsLookUp = function componentsLookUp(_ref) {
  var componentType = _ref.componentType,
      initialProps = _ref.initialProps,
      id = _ref.id;

  switch (componentType) {
    case 'Map':
      {
        var mapPreset = initialProps.mapPreset;
        return /*#__PURE__*/React__default.createElement(ConfigurableMapConnect, Object.assign({}, mapPreset, {
          id: id,
          "data-testid": "coreConfigurableMapConnect"
        }));
      }

    case 'MultiMap':
      {
        var _mapPreset = initialProps.mapPreset,
            shouldShowZoomControls = initialProps.shouldShowZoomControls,
            syncGroupsIds = initialProps.syncGroupsIds;
        if (!_mapPreset || _mapPreset.length === 0) return null;
        return /*#__PURE__*/React__default.createElement(MultiMapViewConnect, {
          rows: 2,
          cols: 2,
          showZoomControls: shouldShowZoomControls,
          maps: _mapPreset.map(function (preset, index) {
            var _a, _b, _c, _d;

            return {
              id: "".concat(id, "_").concat(index),
              syncGroupsIds: syncGroupsIds,
              layers: preset.layers,
              activeLayerId: preset.activeLayerId,
              bbox: (_b = (_a = _mapPreset[0]) === null || _a === void 0 ? void 0 : _a.proj) === null || _b === void 0 ? void 0 : _b.bbox,
              srs: (_d = (_c = _mapPreset[0]) === null || _c === void 0 ? void 0 : _c.proj) === null || _d === void 0 ? void 0 : _d.srs
            };
          }),
          "data-testid": "coreMultiMapViewConnect"
        });
      }

    case 'HarmonieTempAndPrecipPreset':
      {
        var layers = initialProps.layers;
        return /*#__PURE__*/React__default.createElement(HarmonieTempAndPrecipPreset, {
          layers: layers || null,
          "data-testid": "coreHarmonieTempAndPrecipPreset"
        });
      }

    case 'ModelRunInterval':
      {
        return /*#__PURE__*/React__default.createElement(ModelRunInterval, Object.assign({}, initialProps, {
          "data-testid": "coreModelRunInterval"
        }));
      }

    case 'TimeSlider':
      {
        var sliderPreset = initialProps.sliderPreset;
        return /*#__PURE__*/React__default.createElement(TimeSliderConnect, Object.assign({}, sliderPreset, {
          sourceId: id,
          "data-testid": "coreTimeSliderConnect"
        }));
      }

    default:
      return null;
  }
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */
var SyncGroupListItem = function SyncGroupListItem(_ref) {
  var viewStateData = _ref.viewStateData,
      groupId = _ref.groupId,
      selected = _ref.selected,
      sourcesById = _ref.sourcesById,
      handleToggle = _ref.handleToggle;
  var classes = useStyles$1();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.listItem
  }, sourcesById.map(function (source) {
    var isChecked = selected.includes(source.id); // Check if checkbox is checked in another group

    var isNotCheckedElseWhere = viewStateData.groups.every(function (group) {
      return !(group.id !== groupId && group.selected.includes(source.id));
    });
    return /*#__PURE__*/React.createElement(ListItem, {
      key: source.id,
      dense: true,
      button: true,
      onClick: function onClick() {
        return handleToggle(source.id);
      },
      className: classes.listItem
    }, /*#__PURE__*/React.createElement(ListItemIcon, null, /*#__PURE__*/React.createElement(Checkbox, {
      edge: "start",
      checked: isChecked,
      tabIndex: -1,
      disableRipple: true,
      inputProps: {
        'aria-labelledby': source.name
      },
      className: isNotCheckedElseWhere ? classes.checkboxIsActive : classes.isDisabled,
      color: "default"
    })), /*#__PURE__*/React.createElement(Typography, {
      className: isNotCheckedElseWhere ? classes.isActive : classes.isDisabled
    }, source.name));
  }));
};
var useStyles$1 = makeStyles(function (theme) {
  return createStyles({
    listItem: {
      width: '80%',
      borderRadius: '5px'
    },
    isActive: {
      color: theme.palette.geowebColors.typographyAndIcons.icon
    },
    checkboxIsActive: {
      color: theme.palette.geowebColors.typographyAndIcons.iconLinkActive
    },
    isDisabled: {
      color: theme.palette.geowebColors.typographyAndIcons.iconLinkDisabled
    }
  });
});

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */
var SyncGroupList = function SyncGroupList(_ref) {
  var viewStateData = _ref.viewStateData,
      title = _ref.title,
      _handleToggle = _ref.handleToggle,
      addNewGroup = _ref.addNewGroup,
      removeGroup = _ref.removeGroup;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(List, {
    disablePadding: true
  }, viewStateData.groups.map(function (groupObject, index) {
    return /*#__PURE__*/React.createElement(Box, {
      key: groupObject.id,
      className: index === 0 ? null : classes.childListItem
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.syncGroupHeader
    }, /*#__PURE__*/React.createElement(Typography, null, title), /*#__PURE__*/React.createElement(Tooltip, {
      title: index === 0 ? 'Add new group to list' : 'Remove group from list'
    }, /*#__PURE__*/React.createElement(IconButton, {
      style: {
        right: '10px'
      },
      "data-testid": "testAddButton",
      onClick: index === 0 ? function () {
        return addNewGroup(groupObject.id);
      } : function () {
        return removeGroup(groupObject.id);
      },
      size: "large"
    }, index === 0 ? /*#__PURE__*/React.createElement(Add, null) : /*#__PURE__*/React.createElement(Delete, null)))), /*#__PURE__*/React.createElement(SyncGroupListItem, {
      viewStateData: viewStateData,
      groupId: groupObject.id,
      selected: groupObject.selected,
      sourcesById: viewStateData.sourcesById,
      handleToggle: function handleToggle(sourceId) {
        return _handleToggle(groupObject.id, sourceId);
      }
    }));
  }));
};
var useStyles = makeStyles(function (theme) {
  return createStyles({
    syncGroupHeader: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      color: theme.palette.geowebColors.typographyAndIcons.text,
      paddingLeft: '15px',
      paddingTop: '10px'
    },
    childListItem: {
      backgroundColor: theme.palette.geowebColors.syncGroups.drawerOpen.fill,
      boxShadow: 'inset 0px 7px 7px -7px, inset 0px -7px 7px -7px',
      color: '#000000'
    }
  });
});

var SyncGroupViewer = function SyncGroupViewer(_ref) {
  var onClose = _ref.onClose,
      isOpen = _ref.isOpen,
      syncGroupViewState = _ref.syncGroupViewState,
      syncGroupAddTarget = _ref.syncGroupAddTarget,
      syncGroupRemoveTarget = _ref.syncGroupRemoveTarget,
      syncGroupAddGroup = _ref.syncGroupAddGroup,
      syncGroupRemoveGroup = _ref.syncGroupRemoveGroup,
      onMouseDown = _ref.onMouseDown,
      _ref$order = _ref.order,
      order = _ref$order === void 0 ? 0 : _ref$order;

  /*
      _____ Handle Toggle _____
        - Handles checking, unchecking and toggling between in groups
        1. If checkbox is checked      -> uncheck it
        2. If checkbox is not checked  -> check if its checked elsewhere and uncheck it if found
  */
  var _handleToggle = function handleToggle(groupCategory, groupId, sourceId) {
    var _syncGroupViewState$g = syncGroupViewState[groupCategory].groups.find(function (groupObject) {
      return groupObject.id === groupId;
    }),
        selected = _syncGroupViewState$g.selected;

    var isChecked = selected.includes(sourceId);

    if (isChecked) {
      syncGroupRemoveTarget({
        groupId: String(groupId),
        targetId: String(sourceId)
      });
    } else {
      var groups = syncGroupViewState[groupCategory].groups; // Check all other groups and if checkmark is found -> uncheck it

      var _iterator = _createForOfIteratorHelper(groups),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var group = _step.value;

          if (group.id !== groupId && group.selected.includes(sourceId)) {
            syncGroupRemoveTarget({
              groupId: String(group.id),
              targetId: String(sourceId)
            });
          }
        } // Add new checkmark

      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      syncGroupAddTarget({
        groupId: String(groupId),
        targetId: String(sourceId)
      });
    }
  };
  /*
      _____ Add new group _____
        - Called when user clicks on + in the sidepane
        - Sends an action to add a new group in Redux
  */


  var _addNewGroup = function addNewGroup(groupCategory, groupId) {
    groupTypes.forEach(function (_ref2) {
      var title = _ref2.title,
          syncType = _ref2.syncType,
          groupType = _ref2.groupType;

      if (groupCategory === groupType) {
        syncGroupAddGroup({
          groupId: String(groupId + Math.floor(Math.random() * 1000)),
          title: title,
          type: syncType
        });
      }
    });
  };
  /*
      _____ Remove Group _____
        - Called when user clicks on the trashcan icon in sidepane
        - Send an action to remove the group in Redux
  */


  var _removeGroup = function removeGroup(groupCategory, groupId) {
    groupTypes.forEach(function (_ref3) {
      var groupType = _ref3.groupType;

      if (groupCategory === groupType) {
        syncGroupRemoveGroup({
          groupId: String(groupId)
        });
      }
    });
  };

  return /*#__PURE__*/React.createElement(ToolContainerDraggable, {
    title: "Sync",
    startSize: {
      width: 349,
      height: 800
    },
    headerSize: "medium",
    isOpen: isOpen,
    onClose: onClose,
    "data-testid": "syncGroupViewer",
    onMouseDown: onMouseDown,
    order: order
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SyncGroupList, {
    viewStateData: syncGroupViewState.zoompane,
    title: "ZoomPane",
    handleToggle: function handleToggle(groupId, sourceId) {
      return _handleToggle('zoompane', groupId, sourceId);
    },
    addNewGroup: function addNewGroup(groupId) {
      return _addNewGroup('zoompane', groupId);
    },
    removeGroup: function removeGroup(groupId) {
      return _removeGroup('zoompane', groupId);
    }
  }), /*#__PURE__*/React.createElement(SyncGroupList, {
    viewStateData: syncGroupViewState.timeslider,
    title: "Timeslider",
    handleToggle: function handleToggle(groupId, sourceId) {
      return _handleToggle('timeslider', groupId, sourceId);
    },
    addNewGroup: function addNewGroup(groupId) {
      return _addNewGroup('timeslider', groupId);
    },
    removeGroup: function removeGroup(groupId) {
      return _removeGroup('timeslider', groupId);
    }
  }), /*#__PURE__*/React.createElement(SyncGroupList, {
    viewStateData: syncGroupViewState.level,
    title: "Level",
    handleToggle: function handleToggle(groupId, sourceId) {
      return _handleToggle('level', groupId, sourceId);
    },
    addNewGroup: function addNewGroup(groupId) {
      return _addNewGroup('level', groupId);
    },
    removeGroup: function removeGroup(groupId) {
      return _removeGroup('level', groupId);
    }
  })));
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */
var SyncGroupViewerConnect = function SyncGroupViewerConnect() {
  var dispatch = useDispatch(); // TODO
  // Improve the selector to prevent re-renders
  // For example dusting anination syncgroups should not re-render

  var viewState = useSelector(syncGroupGetViewState);
  var syncGroupAddGroup = React.useCallback(function (payload) {
    dispatch(actions.syncGroupAddGroup(payload));
  }, [dispatch]);
  var syncGroupRemoveGroup = React.useCallback(function (payload) {
    dispatch(actions.syncGroupRemoveGroup(payload));
  }, [dispatch]);
  var syncGroupAddTarget = React.useCallback(function (payload) {
    dispatch(actions.syncGroupAddTarget(payload));
  }, [dispatch]);
  var syncGroupRemoveTarget = React.useCallback(function (payload) {
    dispatch(actions.syncGroupRemoveTarget(payload));
  }, [dispatch]);
  var isOpenInStore = useSelector(function (store) {
    return getisDialogOpen(store, 'syncGroups');
  });
  var onClose = React.useCallback(function () {
    return dispatch(uiActions.setToggleOpenDialog({
      type: 'syncGroups',
      setOpen: false
    }));
  }, [dispatch]);
  var uiOrder = useSelector(function (store) {
    return getDialogOrder(store, 'syncGroups');
  });
  var uiIsOrderedOnTop = useSelector(function (store) {
    return getDialogIsOrderedOnTop(store, 'syncGroups');
  });
  var registerDialog = React.useCallback(function () {
    return dispatch(uiActions.registerDialog({
      type: 'syncGroups',
      setOpen: false
    }));
  }, [dispatch]);
  var unregisterDialog = React.useCallback(function () {
    return dispatch(uiActions.unregisterDialog({
      type: 'syncGroups'
    }));
  }, [dispatch]);
  var onOrderDialog = React.useCallback(function () {
    if (!uiIsOrderedOnTop) {
      dispatch(uiActions.orderDialog({
        type: 'syncGroups'
      }));
    }
  }, [dispatch, uiIsOrderedOnTop]);
  React.useEffect(function () {
    registerDialog();
    return function () {
      unregisterDialog();
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(SyncGroupViewer, {
    onClose: onClose,
    isOpen: isOpenInStore,
    syncGroupViewState: viewState,
    syncGroupAddTarget: syncGroupAddTarget,
    syncGroupRemoveTarget: syncGroupRemoveTarget,
    syncGroupAddGroup: syncGroupAddGroup,
    syncGroupRemoveGroup: syncGroupRemoveGroup,
    order: uiOrder,
    onMouseDown: onOrderDialog
  });
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */
var store = createStore({
  initialState: {},
  extensions: [getSagaExtension({})]
});

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */
var baseLayer = {
  name: 'arcGisSat',
  title: 'arcGisSat',
  type: 'twms',
  layerType: LayerType.baseLayer,
  enabled: true,
  id: 'base-layer-0'
};
var baseLayerGrey = {
  id: 'base-layer-1',
  name: 'WorldMap_Light_Grey_Canvas',
  type: 'twms',
  layerType: LayerType.baseLayer
};
var baseLayerOpenStreetMapNL = {
  id: 'base-layer-2',
  name: 'OpenStreetMap_NL',
  type: 'twms',
  layerType: LayerType.baseLayer,
  enabled: true
};
var baseLayerArcGisCanvas = {
  id: 'base-layer-3',
  name: 'arcGisCanvas',
  type: 'twms',
  layerType: LayerType.baseLayer,
  enabled: true
};
var baseLayerWorldMap = {
  id: 'base-layer-4',
  name: 'WorldMap',
  type: 'twms',
  layerType: LayerType.baseLayer,
  enabled: true
};
var baseLayerArcGisSat = {
  name: 'arcGisSat',
  title: 'arcGisSat',
  type: 'twms',
  layerType: LayerType.baseLayer,
  enabled: true,
  id: 'base-layer-5'
};
var overLayer = {
  service: 'https://geoservices.knmi.nl/wms?DATASET=baselayers&',
  name: 'countryborders',
  format: 'image/png',
  layerType: LayerType.overLayer,
  enabled: true,
  id: 'over-layer-1'
};
var overLayer2 = {
  service: 'https://geoservices.knmi.nl/wms?DATASET=baselayers&',
  name: 'countryborders',
  format: 'image/png',
  layerType: LayerType.overLayer,
  enabled: true,
  id: 'over-layer-2'
};
var radarLayer = {
  service: 'https://geoservices.knmi.nl/wms?dataset=RADAR&',
  name: 'RAD_NL25_PCP_CM',
  format: 'image/png',
  enabled: true,
  style: 'knmiradar/nearest',
  id: 'layer-1',
  layerType: LayerType.mapLayer
};
var simplePolygonGeoJSON = {
  type: 'FeatureCollection',
  features: [{
    type: 'Feature',
    properties: {
      stroke: '#8F8',
      'stroke-width': 4,
      'stroke-opacity': 1,
      fill: '#33ccFF',
      'fill-opacity': 0.5
    },
    geometry: {
      type: 'Polygon',
      coordinates: [[[-4.21875, 54.16243396806779], [-0.3515625, 45.583289756006316], [14.0625, 49.38237278700955], [11.953125, 58.07787626787517], [1.40625, 57.70414723434193], [-4.21875, 54.16243396806779]]]
    }
  }]
};

var testLayers = /*#__PURE__*/Object.freeze({
  __proto__: null,
  baseLayer: baseLayer,
  baseLayerGrey: baseLayerGrey,
  baseLayerOpenStreetMapNL: baseLayerOpenStreetMapNL,
  baseLayerArcGisCanvas: baseLayerArcGisCanvas,
  baseLayerWorldMap: baseLayerWorldMap,
  baseLayerArcGisSat: baseLayerArcGisSat,
  overLayer: overLayer,
  overLayer2: overLayer2,
  radarLayer: radarLayer,
  simplePolygonGeoJSON: simplePolygonGeoJSON
});

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */
/**
 * A Provider component which provides the GeoWeb theme
 * @param children
 * @returns
 */

var CoreThemeProvider = function CoreThemeProvider(_ref) {
  var children = _ref.children,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? lightTheme : _ref$theme;
  return /*#__PURE__*/React__default.createElement(ThemeWrapper, {
    theme: theme
  }, children);
};
/**
 * A Provider component which provides the GeoWeb theme and store for the core.
 * Note: Should only be used with core components, as the provided store is only for core.
 * @param children
 * @returns
 */

var CoreThemeStoreProvider = function CoreThemeStoreProvider(_ref2) {
  var children = _ref2.children,
      _ref2$theme = _ref2.theme,
      theme = _ref2$theme === void 0 ? lightTheme : _ref2$theme,
      store = _ref2.store;
  return /*#__PURE__*/React__default.createElement(Provider, {
    store: store
  }, /*#__PURE__*/React__default.createElement(DynamicModuleLoader, {
    modules: coreModuleConfig
  }, /*#__PURE__*/React__default.createElement(CoreThemeProvider, {
    theme: theme
  }, children)));
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2022 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2022 - Finnish Meteorological Institute (FMI)
 * */
var MapWarningProperties = function MapWarningProperties(_ref) {
  var selectedFeatureProperties = _ref.selectedFeatureProperties;
  return /*#__PURE__*/React__default.createElement("div", {
    "data-testid": "map-warning-properties",
    style: {
      width: '100%',
      height: '15%',
      marginTop: '30px',
      marginLeft: '100px',
      position: 'relative',
      zIndex: 10000,
      backgroundColor: '#CCCCCCC0',
      padding: '0px 20px 20px',
      overflow: 'auto',
      fontSize: '11px'
    }
  }, /*#__PURE__*/React__default.createElement("h1", {
    "data-testid": "map-warning-properties-title"
  }, selectedFeatureProperties.areaDesc), selectedFeatureProperties.areaDesc && /*#__PURE__*/React__default.createElement("pre", {
    "data-testid": "map-warning-properties-row"
  }, "event: ", selectedFeatureProperties.languages[2].event), selectedFeatureProperties.onset && /*#__PURE__*/React__default.createElement("pre", {
    "data-testid": "map-warning-properties-row"
  }, "Sent:", ' ', moment.utc(selectedFeatureProperties.onset).format('DD MMM YYYY, HH:mm'), ' ', "UTC"), selectedFeatureProperties.expires && /*#__PURE__*/React__default.createElement("pre", {
    "data-testid": "map-warning-properties-row"
  }, "Expires:", ' ', moment.utc(selectedFeatureProperties.expires).format('DD MMM YYYY, HH:mm'), ' ', "UTC"), selectedFeatureProperties.languages[2].senderName && /*#__PURE__*/React__default.createElement("pre", {
    "data-testid": "map-warning-properties-row"
  }, "Sender: ", selectedFeatureProperties.languages[2].senderName), selectedFeatureProperties.identifier && /*#__PURE__*/React__default.createElement("pre", {
    "data-testid": "map-warning-properties-row"
  }, "Identifier: ", selectedFeatureProperties.identifier));
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */
var mapActions = Object.assign(Object.assign(Object.assign({}, layerActions), mapActions$1), serviceActions);

export { ConfigurableMapConnect, CoreThemeProvider, CoreThemeStoreProvider, HarmonieTempAndPrecipPreset, LayerManagerConnect, LayerManagerMapButtonConnect, Legend, LegendConnect, LegendMapButtonConnect, MapControls, MapView, MapViewConnect, MapViewLayer, MapWarningProperties, MultiDimensionSelectMapButtonsConnect, MultiMapMultiDimensionSelectConnect as MultiMapDimensionSelectConnect, MultiMapViewConnect, ReactMapView, ReactMapViewLayer, SyncGroupViewerConnect, index as SyncGroups, TimeSliderConnect, ZoomControlConnect, ZoomControls, componentsLookUp, coreModuleConfig, dateFormat, defaultBbox, defaultConfigurations, filterBaseLayers, filterLayers, filterMapLayers, filterMapPresets, filterNonTimeDimensions, filterServices, generateLayerId, generateMapId, generateTimesliderId, getFirstTimeStepForLayerId, getInitialPresets, getLastTimeStepForLayerId, getNextTimeStepForLayerId, getPreviousTimeStepForLayerId, getWMJSDimensionForLayerAndDimension, getWMJSMapById, getWMJSTimeDimensionForLayerId, getWMLayerById, layerActions, reducer$5 as layerReducer, mapActions, moduleConfig as mapModuleConfig, selectors as mapSelectors, types$2 as mapTypes, utils as mapUtils, publicLayers, publicServices, registerWMJSMap, registerWMLayer, store, genericActions as syncGroupActions, synchronizationGroupConfig as synchronizationGroupModuleConfig, synchronizationGroupConfig as synchronizationGroupsConfig, testLayers, uiActions, uiModuleConfig, selectors$1 as uiSelectors, types as uiTypes, useStyles$2 as useStyles };
